import {SessionMonthSummary,RumpusMapping,ReservePackageField,ReserveBank,SessionSortBoard,ProducerBadge,TileComments,QuickDeliveryBox,PointsMonthEditor,CreditMonthField,currentCreditMonth,EmailSettings,Productivity,useCommentDeepLink} from "./features.jsx";
var e = (e, t) => () => (t || (e((t = {
  exports: {}
}).exports, t), e = null), t.exports);
(function () {
  let e = document.createElement(`link`).relList;
  if (e && e.supports && e.supports(`modulepreload`)) return;
  for (let e of document.querySelectorAll(`link[rel="modulepreload"]`)) n(e);
  new MutationObserver(e => {
    for (let t of e) if (t.type === `childList`) for (let e of t.addedNodes) e.tagName === `LINK` && e.rel === `modulepreload` && n(e);
  }).observe(document, {
    childList: !0,
    subtree: !0
  });
  function t(e) {
    let t = {};
    return (e.integrity && (t.integrity = e.integrity), e.referrerPolicy && (t.referrerPolicy = e.referrerPolicy), t.credentials = e.crossOrigin === `use-credentials` ? `include` : e.crossOrigin === `anonymous` ? `omit` : `same-origin`, t);
  }
  function n(e) {
    if (e.ep) return;
    e.ep = !0;
    let n = t(e);
    fetch(e.href, n);
  }
})();
var t = e(e => {
  var t = Symbol.for(`react.transitional.element`), n = Symbol.for(`react.portal`), r = Symbol.for(`react.fragment`), i = Symbol.for(`react.strict_mode`), a = Symbol.for(`react.profiler`), o = Symbol.for(`react.consumer`), s = Symbol.for(`react.context`), c = Symbol.for(`react.forward_ref`), l = Symbol.for(`react.suspense`), u = Symbol.for(`react.memo`), d = Symbol.for(`react.lazy`), f = Symbol.for(`react.activity`), p = Symbol.iterator;
  function m(e) {
    return typeof e != `object` || !e ? null : (e = p && e[p] || e[`@@iterator`], typeof e == `function` ? e : null);
  }
  var h = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  }, g = Object.assign, _ = {};
  function v(e, t, n) {
    (this.props = e, this.context = t, this.refs = _, this.updater = n || h);
  }
  (v.prototype.isReactComponent = {}, v.prototype.setState = function (e, t) {
    if (typeof e != `object` && typeof e != `function` && e != null) throw Error(`takes an object of state variables to update or a function which returns an object of state variables.`);
    this.updater.enqueueSetState(this, e, t, `setState`);
  }, v.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, `forceUpdate`);
  });
  function y() {}
  y.prototype = v.prototype;
  function b(e, t, n) {
    (this.props = e, this.context = t, this.refs = _, this.updater = n || h);
  }
  var x = b.prototype = new y();
  (x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0);
  var S = Array.isArray;
  function C() {}
  var w = {
    H: null,
    A: null,
    T: null,
    S: null
  }, T = Object.prototype.hasOwnProperty;
  function E(e, n, r) {
    var i = r.ref;
    return {
      $$typeof: t,
      type: e,
      key: n,
      ref: i === void 0 ? null : i,
      props: r
    };
  }
  function D(e, t) {
    return E(e.type, t, e.props);
  }
  function O(e) {
    return typeof e == `object` && !!e && e.$$typeof === t;
  }
  function k(e) {
    var t = {
      "=": `=0`,
      ":": `=2`
    };
    return `$` + e.replace(/[=:]/g, function (e) {
      return t[e];
    });
  }
  var ee = /\/+/g;
  function te(e, t) {
    return typeof e == `object` && e && e.key != null ? k(`` + e.key) : t.toString(36);
  }
  function ne(e) {
    switch (e.status) {
      case `fulfilled`:
        return e.value;
      case `rejected`:
        throw e.reason;
      default:
        switch ((typeof e.status == `string` ? e.then(C, C) : (e.status = `pending`, e.then(function (t) {
              e.status === `pending` && (e.status = `fulfilled`, e.value = t);
            }, function (t) {
              e.status === `pending` && (e.status = `rejected`, e.reason = t);
            })), e.status)) {
          case `fulfilled`:
            return e.value;
          case `rejected`:
            throw e.reason;
        }
    }
    throw e;
  }
  function A(e, r, i, a, o) {
    var s = typeof e;
    (s === `undefined` || s === `boolean`) && (e = null);
    var c = !1;
    if (e === null) c = !0; else switch (s) {
      case `bigint`:
      case `string`:
      case `number`:
        c = !0;
        break;
      case `object`:
        switch (e.$$typeof) {
          case t:
          case n:
            c = !0;
            break;
          case d:
            return (c = e._init, A(c(e._payload), r, i, a, o));
        }
    }
    if (c) return (o = o(e), c = a === `` ? `.` + te(e, 0) : a, S(o) ? (i = ``, c != null && (i = c.replace(ee, `$&/`) + `/`), A(o, r, i, ``, function (e) {
      return e;
    })) : o != null && (O(o) && (o = D(o, i + (o.key == null || e && e.key === o.key ? `` : (`` + o.key).replace(ee, `$&/`) + `/`) + c)), r.push(o)), 1);
    c = 0;
    var l = a === `` ? `.` : a + `:`;
    if (S(e)) for (var u = 0; u < e.length; u++) (a = e[u], s = l + te(a, u), c += A(a, r, i, s, o)); else if ((u = m(e), typeof u == `function`)) for ((e = u.call(e), u = 0); !(a = e.next()).done; ) (a = a.value, s = l + te(a, u++), c += A(a, r, i, s, o)); else if (s === `object`) {
      if (typeof e.then == `function`) return A(ne(e), r, i, a, o);
      throw (r = String(e), Error(`Objects are not valid as a React child (found: ` + (r === `[object Object]` ? `object with keys {` + Object.keys(e).join(`, `) + `}` : r) + `). If you meant to render a collection of children, use an array instead.`));
    }
    return c;
  }
  function re(e, t, n) {
    if (e == null) return e;
    var r = [], i = 0;
    return (A(e, r, ``, ``, function (e) {
      return t.call(n, e, i++);
    }), r);
  }
  function ie(e) {
    if (e._status === -1) {
      var t = e._result;
      (t = t(), t.then(function (t) {
        (e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
      }, function (t) {
        (e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
      }), e._status === -1 && (e._status = 0, e._result = t));
    }
    if (e._status === 1) return e._result.default;
    throw e._result;
  }
  var j = typeof reportError == `function` ? reportError : function (e) {
    if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
      var t = new window.ErrorEvent(`error`, {
        bubbles: !0,
        cancelable: !0,
        message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == `object` && typeof process.emit == `function`) {
      process.emit(`uncaughtException`, e);
      return;
    }
    console.error(e);
  }, M = {
    map: re,
    forEach: function (e, t, n) {
      re(e, function () {
        t.apply(this, arguments);
      }, n);
    },
    count: function (e) {
      var t = 0;
      return (re(e, function () {
        t++;
      }), t);
    },
    toArray: function (e) {
      return re(e, function (e) {
        return e;
      }) || [];
    },
    only: function (e) {
      if (!O(e)) throw Error(`React.Children.only expected to receive a single React element child.`);
      return e;
    }
  };
  (e.Activity = f, e.Children = M, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function (e) {
      return w.H.useMemoCache(e);
    }
  }, e.cache = function (e) {
    return function () {
      return e.apply(null, arguments);
    };
  }, e.cacheSignal = function () {
    return null;
  }, e.cloneElement = function (e, t, n) {
    if (e == null) throw Error(`The argument must be a React element, but you passed ` + e + `.`);
    var r = g({}, e.props), i = e.key;
    if (t != null) for (a in (t.key !== void 0 && (i = `` + t.key), t)) !T.call(t, a) || a === `key` || a === `__self` || a === `__source` || a === `ref` && t.ref === void 0 || (r[a] = t[a]);
    var a = arguments.length - 2;
    if (a === 1) r.children = n; else if (1 < a) {
      for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
      r.children = o;
    }
    return E(e.type, i, r);
  }, e.createContext = function (e) {
    return (e = {
      $$typeof: s,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, e.Provider = e, e.Consumer = {
      $$typeof: o,
      _context: e
    }, e);
  }, e.createElement = function (e, t, n) {
    var r, i = {}, a = null;
    if (t != null) for (r in (t.key !== void 0 && (a = `` + t.key), t)) T.call(t, r) && r !== `key` && r !== `__self` && r !== `__source` && (i[r] = t[r]);
    var o = arguments.length - 2;
    if (o === 1) i.children = n; else if (1 < o) {
      for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
      i.children = s;
    }
    if (e && e.defaultProps) for (r in (o = e.defaultProps, o)) i[r] === void 0 && (i[r] = o[r]);
    return E(e, a, i);
  }, e.createRef = function () {
    return {
      current: null
    };
  }, e.forwardRef = function (e) {
    return {
      $$typeof: c,
      render: e
    };
  }, e.isValidElement = O, e.lazy = function (e) {
    return {
      $$typeof: d,
      _payload: {
        _status: -1,
        _result: e
      },
      _init: ie
    };
  }, e.memo = function (e, t) {
    return {
      $$typeof: u,
      type: e,
      compare: t === void 0 ? null : t
    };
  }, e.startTransition = function (e) {
    var t = w.T, n = {};
    w.T = n;
    try {
      var r = e(), i = w.S;
      (i !== null && i(n, r), typeof r == `object` && r && typeof r.then == `function` && r.then(C, j));
    } catch (e) {
      j(e);
    } finally {
      (t !== null && n.types !== null && (t.types = n.types), w.T = t);
    }
  }, e.unstable_useCacheRefresh = function () {
    return w.H.useCacheRefresh();
  }, e.use = function (e) {
    return w.H.use(e);
  }, e.useActionState = function (e, t, n) {
    return w.H.useActionState(e, t, n);
  }, e.useCallback = function (e, t) {
    return w.H.useCallback(e, t);
  }, e.useContext = function (e) {
    return w.H.useContext(e);
  }, e.useDebugValue = function () {}, e.useDeferredValue = function (e, t) {
    return w.H.useDeferredValue(e, t);
  }, e.useEffect = function (e, t) {
    return w.H.useEffect(e, t);
  }, e.useEffectEvent = function (e) {
    return w.H.useEffectEvent(e);
  }, e.useId = function () {
    return w.H.useId();
  }, e.useImperativeHandle = function (e, t, n) {
    return w.H.useImperativeHandle(e, t, n);
  }, e.useInsertionEffect = function (e, t) {
    return w.H.useInsertionEffect(e, t);
  }, e.useLayoutEffect = function (e, t) {
    return w.H.useLayoutEffect(e, t);
  }, e.useMemo = function (e, t) {
    return w.H.useMemo(e, t);
  }, e.useOptimistic = function (e, t) {
    return w.H.useOptimistic(e, t);
  }, e.useReducer = function (e, t, n) {
    return w.H.useReducer(e, t, n);
  }, e.useRef = function (e) {
    return w.H.useRef(e);
  }, e.useState = function (e) {
    return w.H.useState(e);
  }, e.useSyncExternalStore = function (e, t, n) {
    return w.H.useSyncExternalStore(e, t, n);
  }, e.useTransition = function () {
    return w.H.useTransition();
  }, e.version = `19.2.6`);
}), n = e((e, n) => {
  n.exports = t();
}), r = e(e => {
  function t(e, t) {
    var n = e.length;
    e.push(t);
    a: for (; 0 < n; ) {
      var r = n - 1 >>> 1, a = e[r];
      if (0 < i(a, t)) (e[r] = t, e[n] = a, n = r); else break a;
    }
  }
  function n(e) {
    return e.length === 0 ? null : e[0];
  }
  function r(e) {
    if (e.length === 0) return null;
    var t = e[0], n = e.pop();
    if (n !== t) {
      e[0] = n;
      a: for (var r = 0, a = e.length, o = a >>> 1; r < o; ) {
        var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
        if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s); else if (l < a && 0 > i(u, n)) (e[r] = u, e[l] = n, r = l); else break a;
      }
    }
    return t;
  }
  function i(e, t) {
    var n = e.sortIndex - t.sortIndex;
    return n === 0 ? e.id - t.id : n;
  }
  if ((e.unstable_now = void 0, typeof performance == `object` && typeof performance.now == `function`)) {
    var a = performance;
    e.unstable_now = function () {
      return a.now();
    };
  } else {
    var o = Date, s = o.now();
    e.unstable_now = function () {
      return o.now() - s;
    };
  }
  var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == `function` ? setTimeout : null, v = typeof clearTimeout == `function` ? clearTimeout : null, y = typeof setImmediate < `u` ? setImmediate : null;
  function b(e) {
    for (var i = n(l); i !== null; ) {
      if (i.callback === null) r(l); else if (i.startTime <= e) (r(l), i.sortIndex = i.expirationTime, t(c, i)); else break;
      i = n(l);
    }
  }
  function x(e) {
    if ((h = !1, b(e), !m)) {
      if (n(c) !== null) (m = !0, S || (S = !0, O())); else {
        var t = n(l);
        t !== null && te(x, t.startTime - e);
      }
    }
  }
  var S = !1, C = -1, w = 5, T = -1;
  function E() {
    return g ? !0 : !(e.unstable_now() - T < w);
  }
  function D() {
    if ((g = !1, S)) {
      var t = e.unstable_now();
      T = t;
      var i = !0;
      try {
        a: {
          (m = !1, h && (h = !1, v(C), C = -1), p = !0);
          var a = f;
          try {
            b: {
              for ((b(t), d = n(c)); d !== null && !(d.expirationTime > t && E()); ) {
                var o = d.callback;
                if (typeof o == `function`) {
                  (d.callback = null, f = d.priorityLevel);
                  var s = o(d.expirationTime <= t);
                  if ((t = e.unstable_now(), typeof s == `function`)) {
                    (d.callback = s, b(t), i = !0);
                    break b;
                  }
                  (d === n(c) && r(c), b(t));
                } else r(c);
                d = n(c);
              }
              if (d !== null) i = !0; else {
                var u = n(l);
                (u !== null && te(x, u.startTime - t), i = !1);
              }
            }
            break a;
          } finally {
            (d = null, f = a, p = !1);
          }
          i = void 0;
        }
      } finally {
        i ? O() : S = !1;
      }
    }
  }
  var O;
  if (typeof y == `function`) O = function () {
    y(D);
  }; else if (typeof MessageChannel < `u`) {
    var k = new MessageChannel(), ee = k.port2;
    (k.port1.onmessage = D, O = function () {
      ee.postMessage(null);
    });
  } else O = function () {
    _(D, 0);
  };
  function te(t, n) {
    C = _(function () {
      t(e.unstable_now());
    }, n);
  }
  (e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (e) {
    e.callback = null;
  }, e.unstable_forceFrameRate = function (e) {
    0 > e || 125 < e ? console.error(`forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported`) : w = 0 < e ? Math.floor(1e3 / e) : 5;
  }, e.unstable_getCurrentPriorityLevel = function () {
    return f;
  }, e.unstable_next = function (e) {
    switch (f) {
      case 1:
      case 2:
      case 3:
        var t = 3;
        break;
      default:
        t = f;
    }
    var n = f;
    f = t;
    try {
      return e();
    } finally {
      f = n;
    }
  }, e.unstable_requestPaint = function () {
    g = !0;
  }, e.unstable_runWithPriority = function (e, t) {
    switch (e) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        e = 3;
    }
    var n = f;
    f = e;
    try {
      return t();
    } finally {
      f = n;
    }
  }, e.unstable_scheduleCallback = function (r, i, a) {
    var o = e.unstable_now();
    switch ((typeof a == `object` && a ? (a = a.delay, a = typeof a == `number` && 0 < a ? o + a : o) : a = o, r)) {
      case 1:
        var s = -1;
        break;
      case 2:
        s = 250;
        break;
      case 5:
        s = 1073741823;
        break;
      case 4:
        s = 1e4;
        break;
      default:
        s = 5e3;
    }
    return (s = a + s, r = {
      id: u++,
      callback: i,
      priorityLevel: r,
      startTime: a,
      expirationTime: s,
      sortIndex: -1
    }, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, te(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, O()))), r);
  }, e.unstable_shouldYield = E, e.unstable_wrapCallback = function (e) {
    var t = f;
    return function () {
      var n = f;
      f = t;
      try {
        return e.apply(this, arguments);
      } finally {
        f = n;
      }
    };
  });
}), i = e((e, t) => {
  t.exports = r();
}), a = e(e => {
  var t = n();
  function r(e) {
    var t = `https://react.dev/errors/` + e;
    if (1 < arguments.length) {
      t += `?args[]=` + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++) t += `&args[]=` + encodeURIComponent(arguments[n]);
    }
    return `Minified React error #` + e + `; visit ` + t + ` for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`;
  }
  function i() {}
  var a = {
    d: {
      f: i,
      r: function () {
        throw Error(r(522));
      },
      D: i,
      C: i,
      L: i,
      m: i,
      X: i,
      S: i,
      M: i
    },
    p: 0,
    findDOMNode: null
  }, o = Symbol.for(`react.portal`);
  function s(e, t, n) {
    var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: o,
      key: r == null ? null : `` + r,
      children: e,
      containerInfo: t,
      implementation: n
    };
  }
  var c = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function l(e, t) {
    if (e === `font`) return ``;
    if (typeof t == `string`) return t === `use-credentials` ? t : ``;
  }
  (e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = a, e.createPortal = function (e, t) {
    var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(r(299));
    return s(e, t, null, n);
  }, e.flushSync = function (e) {
    var t = c.T, n = a.p;
    try {
      if ((c.T = null, a.p = 2, e)) return e();
    } finally {
      (c.T = t, a.p = n, a.d.f());
    }
  }, e.preconnect = function (e, t) {
    typeof e == `string` && (t ? (t = t.crossOrigin, t = typeof t == `string` ? t === `use-credentials` ? t : `` : void 0) : t = null, a.d.C(e, t));
  }, e.prefetchDNS = function (e) {
    typeof e == `string` && a.d.D(e);
  }, e.preinit = function (e, t) {
    if (typeof e == `string` && t && typeof t.as == `string`) {
      var n = t.as, r = l(n, t.crossOrigin), i = typeof t.integrity == `string` ? t.integrity : void 0, o = typeof t.fetchPriority == `string` ? t.fetchPriority : void 0;
      n === `style` ? a.d.S(e, typeof t.precedence == `string` ? t.precedence : void 0, {
        crossOrigin: r,
        integrity: i,
        fetchPriority: o
      }) : n === `script` && a.d.X(e, {
        crossOrigin: r,
        integrity: i,
        fetchPriority: o,
        nonce: typeof t.nonce == `string` ? t.nonce : void 0
      });
    }
  }, e.preinitModule = function (e, t) {
    if (typeof e == `string`) {
      if (typeof t == `object` && t) {
        if (t.as == null || t.as === `script`) {
          var n = l(t.as, t.crossOrigin);
          a.d.M(e, {
            crossOrigin: n,
            integrity: typeof t.integrity == `string` ? t.integrity : void 0,
            nonce: typeof t.nonce == `string` ? t.nonce : void 0
          });
        }
      } else t ?? a.d.M(e);
    }
  }, e.preload = function (e, t) {
    if (typeof e == `string` && typeof t == `object` && t && typeof t.as == `string`) {
      var n = t.as, r = l(n, t.crossOrigin);
      a.d.L(e, n, {
        crossOrigin: r,
        integrity: typeof t.integrity == `string` ? t.integrity : void 0,
        nonce: typeof t.nonce == `string` ? t.nonce : void 0,
        type: typeof t.type == `string` ? t.type : void 0,
        fetchPriority: typeof t.fetchPriority == `string` ? t.fetchPriority : void 0,
        referrerPolicy: typeof t.referrerPolicy == `string` ? t.referrerPolicy : void 0,
        imageSrcSet: typeof t.imageSrcSet == `string` ? t.imageSrcSet : void 0,
        imageSizes: typeof t.imageSizes == `string` ? t.imageSizes : void 0,
        media: typeof t.media == `string` ? t.media : void 0
      });
    }
  }, e.preloadModule = function (e, t) {
    if (typeof e == `string`) {
      if (t) {
        var n = l(t.as, t.crossOrigin);
        a.d.m(e, {
          as: typeof t.as == `string` && t.as !== `script` ? t.as : void 0,
          crossOrigin: n,
          integrity: typeof t.integrity == `string` ? t.integrity : void 0
        });
      } else a.d.m(e);
    }
  }, e.requestFormReset = function (e) {
    a.d.r(e);
  }, e.unstable_batchedUpdates = function (e, t) {
    return e(t);
  }, e.useFormState = function (e, t, n) {
    return c.H.useFormState(e, t, n);
  }, e.useFormStatus = function () {
    return c.H.useHostTransitionStatus();
  }, e.version = `19.2.6`);
}), o = e((e, t) => {
  function n() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > `u` || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != `function`)) try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
    } catch (e) {
      console.error(e);
    }
  }
  (n(), t.exports = a());
}), s = e(e => {
  var t = i(), r = n(), a = o();
  function s(e) {
    var t = `https://react.dev/errors/` + e;
    if (1 < arguments.length) {
      t += `?args[]=` + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++) t += `&args[]=` + encodeURIComponent(arguments[n]);
    }
    return `Minified React error #` + e + `; visit ` + t + ` for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`;
  }
  function c(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function l(e) {
    var t = e, n = e;
    if (e.alternate) for (; t.return; ) t = t.return; else {
      e = t;
      do (t = e, t.flags & 4098 && (n = t.return), e = t.return); while (e);
    }
    return t.tag === 3 ? n : null;
  }
  function u(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if ((t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null)) return t.dehydrated;
    }
    return null;
  }
  function d(e) {
    if (e.tag === 31) {
      var t = e.memoizedState;
      if ((t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null)) return t.dehydrated;
    }
    return null;
  }
  function f(e) {
    if (l(e) !== e) throw Error(s(188));
  }
  function p(e) {
    var t = e.alternate;
    if (!t) {
      if ((t = l(e), t === null)) throw Error(s(188));
      return t === e ? e : null;
    }
    for (var n = e, r = t; ; ) {
      var i = n.return;
      if (i === null) break;
      var a = i.alternate;
      if (a === null) {
        if ((r = i.return, r !== null)) {
          n = r;
          continue;
        }
        break;
      }
      if (i.child === a.child) {
        for (a = i.child; a; ) {
          if (a === n) return (f(i), e);
          if (a === r) return (f(i), t);
          a = a.sibling;
        }
        throw Error(s(188));
      }
      if (n.return !== r.return) (n = i, r = a); else {
        for (var o = !1, c = i.child; c; ) {
          if (c === n) {
            (o = !0, n = i, r = a);
            break;
          }
          if (c === r) {
            (o = !0, r = i, n = a);
            break;
          }
          c = c.sibling;
        }
        if (!o) {
          for (c = a.child; c; ) {
            if (c === n) {
              (o = !0, n = a, r = i);
              break;
            }
            if (c === r) {
              (o = !0, r = a, n = i);
              break;
            }
            c = c.sibling;
          }
          if (!o) throw Error(s(189));
        }
      }
      if (n.alternate !== r) throw Error(s(190));
    }
    if (n.tag !== 3) throw Error(s(188));
    return n.stateNode.current === n ? e : t;
  }
  function m(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e;
    for (e = e.child; e !== null; ) {
      if ((t = m(e), t !== null)) return t;
      e = e.sibling;
    }
    return null;
  }
  var h = Object.assign, g = Symbol.for(`react.element`), _ = Symbol.for(`react.transitional.element`), v = Symbol.for(`react.portal`), y = Symbol.for(`react.fragment`), b = Symbol.for(`react.strict_mode`), x = Symbol.for(`react.profiler`), S = Symbol.for(`react.consumer`), C = Symbol.for(`react.context`), w = Symbol.for(`react.forward_ref`), T = Symbol.for(`react.suspense`), E = Symbol.for(`react.suspense_list`), D = Symbol.for(`react.memo`), O = Symbol.for(`react.lazy`), k = Symbol.for(`react.activity`), ee = Symbol.for(`react.memo_cache_sentinel`), te = Symbol.iterator;
  function ne(e) {
    return typeof e != `object` || !e ? null : (e = te && e[te] || e[`@@iterator`], typeof e == `function` ? e : null);
  }
  var A = Symbol.for(`react.client.reference`);
  function re(e) {
    if (e == null) return null;
    if (typeof e == `function`) return e.$$typeof === A ? null : e.displayName || e.name || null;
    if (typeof e == `string`) return e;
    switch (e) {
      case y:
        return `Fragment`;
      case x:
        return `Profiler`;
      case b:
        return `StrictMode`;
      case T:
        return `Suspense`;
      case E:
        return `SuspenseList`;
      case k:
        return `Activity`;
    }
    if (typeof e == `object`) switch (e.$$typeof) {
      case v:
        return `Portal`;
      case C:
        return e.displayName || `Context`;
      case S:
        return (e._context.displayName || `Context`) + `.Consumer`;
      case w:
        var t = e.render;
        return (e = e.displayName, e ||= (e = t.displayName || t.name || ``, e === `` ? `ForwardRef` : `ForwardRef(` + e + `)`), e);
      case D:
        return (t = e.displayName || null, t === null ? re(e.type) || `Memo` : t);
      case O:
        (t = e._payload, e = e._init);
        try {
          return re(e(t));
        } catch {}
    }
    return null;
  }
  var ie = Array.isArray, j = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, M = a.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, N = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, P = [], F = -1;
  function I(e) {
    return {
      current: e
    };
  }
  function L(e) {
    0 > F || (e.current = P[F], P[F] = null, F--);
  }
  function R(e, t) {
    (F++, P[F] = e.current, e.current = t);
  }
  var ae = I(null), oe = I(null), se = I(null), ce = I(null);
  function le(e, t) {
    switch ((R(se, t), R(oe, e), R(ae, null), t.nodeType)) {
      case 9:
      case 11:
        e = (e = t.documentElement) && (e = e.namespaceURI) ? Vd(e) : 0;
        break;
      default:
        if ((e = t.tagName, t = t.namespaceURI)) (t = Vd(t), e = Hd(t, e)); else switch (e) {
          case `svg`:
            e = 1;
            break;
          case `math`:
            e = 2;
            break;
          default:
            e = 0;
        }
    }
    (L(ae), R(ae, e));
  }
  function ue() {
    (L(ae), L(oe), L(se));
  }
  function de(e) {
    e.memoizedState !== null && R(ce, e);
    var t = ae.current, n = Hd(t, e.type);
    t !== n && (R(oe, e), R(ae, n));
  }
  function fe(e) {
    (oe.current === e && (L(ae), L(oe)), ce.current === e && (L(ce), Qf._currentValue = N));
  }
  var pe, me;
  function he(e) {
    if (pe === void 0) try {
      throw Error();
    } catch (e) {
      var t = e.stack.trim().match(/\n( *(at )?)/);
      (pe = t && t[1] || ``, me = -1 < e.stack.indexOf(`
    at`) ? ` (<anonymous>)` : -1 < e.stack.indexOf(`@`) ? `@unknown:0:0` : ``);
    }
    return `
` + pe + e + me;
  }
  var ge = !1;
  function _e(e, t) {
    if (!e || ge) return ``;
    ge = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var r = {
        DetermineComponentFrameRoot: function () {
          try {
            if (t) {
              var n = function () {
                throw Error();
              };
              if ((Object.defineProperty(n.prototype, "props", {
                set: function () {
                  throw Error();
                }
              }), typeof Reflect == `object` && Reflect.construct)) {
                try {
                  Reflect.construct(n, []);
                } catch (e) {
                  var r = e;
                }
                Reflect.construct(e, [], n);
              } else {
                try {
                  n.call();
                } catch (e) {
                  r = e;
                }
                e.call(n.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (e) {
                r = e;
              }
              (n = e()) && typeof n.catch == `function` && n.catch(function () {});
            }
          } catch (e) {
            if (e && r && typeof e.stack == `string`) return [e.stack, r.stack];
          }
          return [null, null];
        }
      };
      r.DetermineComponentFrameRoot.displayName = `DetermineComponentFrameRoot`;
      var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, `name`);
      i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", {
        value: `DetermineComponentFrameRoot`
      });
      var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
      if (o && s) {
        var c = o.split(`
`), l = s.split(`
`);
        for (i = r = 0; r < c.length && !c[r].includes(`DetermineComponentFrameRoot`); ) r++;
        for (; i < l.length && !l[i].includes(`DetermineComponentFrameRoot`); ) i++;
        if (r === c.length || i === l.length) for ((r = c.length - 1, i = l.length - 1); 1 <= r && 0 <= i && c[r] !== l[i]; ) i--;
        for (; 1 <= r && 0 <= i; (r--, i--)) if (c[r] !== l[i]) {
          if (r !== 1 || i !== 1) do if ((r--, i--, 0 > i || c[r] !== l[i])) {
            var u = `
` + c[r].replace(` at new `, ` at `);
            return (e.displayName && u.includes(`<anonymous>`) && (u = u.replace(`<anonymous>`, e.displayName)), u);
          } while (1 <= r && 0 <= i);
          break;
        }
      }
    } finally {
      (ge = !1, Error.prepareStackTrace = n);
    }
    return (n = e ? e.displayName || e.name : ``) ? he(n) : ``;
  }
  function ve(e, t) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return he(e.type);
      case 16:
        return he(`Lazy`);
      case 13:
        return e.child !== t && t !== null ? he(`Suspense Fallback`) : he(`Suspense`);
      case 19:
        return he(`SuspenseList`);
      case 0:
      case 15:
        return _e(e.type, !1);
      case 11:
        return _e(e.type.render, !1);
      case 1:
        return _e(e.type, !0);
      case 31:
        return he(`Activity`);
      default:
        return ``;
    }
  }
  function z(e) {
    try {
      var t = ``, n = null;
      do (t += ve(e, n), n = e, e = e.return); while (e);
      return t;
    } catch (e) {
      return `
Error generating stack: ` + e.message + `
` + e.stack;
    }
  }
  var ye = Object.prototype.hasOwnProperty, be = t.unstable_scheduleCallback, xe = t.unstable_cancelCallback, Se = t.unstable_shouldYield, Ce = t.unstable_requestPaint, we = t.unstable_now, Te = t.unstable_getCurrentPriorityLevel, Ee = t.unstable_ImmediatePriority, De = t.unstable_UserBlockingPriority, Oe = t.unstable_NormalPriority, ke = t.unstable_LowPriority, Ae = t.unstable_IdlePriority, je = t.log, Me = t.unstable_setDisableYieldValue, Ne = null, Pe = null;
  function Fe(e) {
    if ((typeof je == `function` && Me(e), Pe && typeof Pe.setStrictMode == `function`)) try {
      Pe.setStrictMode(Ne, e);
    } catch {}
  }
  var Ie = Math.clz32 ? Math.clz32 : ze, Le = Math.log, Re = Math.LN2;
  function ze(e) {
    return (e >>>= 0, e === 0 ? 32 : 31 - (Le(e) / Re | 0) | 0);
  }
  var Be = 256, Ve = 262144, He = 4194304;
  function Ue(e) {
    var t = e & 42;
    if (t !== 0) return t;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function We(e, t, n) {
    var r = e.pendingLanes;
    if (r === 0) return 0;
    var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
    e = e.warmLanes;
    var s = r & 134217727;
    return (s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = Ue(n))) : i = Ue(o) : i = Ue(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = Ue(n))) : i = Ue(o)) : i = Ue(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i);
  }
  function Ge(e, t) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
  }
  function B(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Ke() {
    var e = He;
    return (He <<= 1, !(He & 62914560) && (He = 4194304), e);
  }
  function qe(e) {
    for (var t = [], n = 0; 31 > n; n++) t.push(e);
    return t;
  }
  function Je(e, t) {
    (e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0));
  }
  function Ye(e, t, n, r, i, a) {
    var o = e.pendingLanes;
    (e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0);
    var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
    for (n = o & ~n; 0 < n; ) {
      var u = 31 - Ie(n), d = 1 << u;
      (s[u] = 0, c[u] = -1);
      var f = l[u];
      if (f !== null) for ((l[u] = null, u = 0); u < f.length; u++) {
        var p = f[u];
        p !== null && (p.lane &= -536870913);
      }
      n &= ~d;
    }
    (r !== 0 && Xe(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t)));
  }
  function Xe(e, t, n) {
    (e.pendingLanes |= t, e.suspendedLanes &= ~t);
    var r = 31 - Ie(t);
    (e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930);
  }
  function Ze(e, t) {
    var n = e.entangledLanes |= t;
    for (e = e.entanglements; n; ) {
      var r = 31 - Ie(n), i = 1 << r;
      (i & t | e[r] & t && (e[r] |= t), n &= ~i);
    }
  }
  function Qe(e, t) {
    var n = t & -t;
    return (n = n & 42 ? 1 : $e(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0);
  }
  function $e(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function et(e) {
    return (e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2);
  }
  function tt() {
    var e = M.p;
    return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e;
  }
  function nt(e, t) {
    var n = M.p;
    try {
      return (M.p = e, t());
    } finally {
      M.p = n;
    }
  }
  var rt = Math.random().toString(36).slice(2), it = `__reactFiber$` + rt, at = `__reactProps$` + rt, ot = `__reactContainer$` + rt, st = `__reactEvents$` + rt, ct = `__reactListeners$` + rt, V = `__reactHandles$` + rt, lt = `__reactResources$` + rt, ut = `__reactMarker$` + rt;
  function dt(e) {
    (delete e[it], delete e[at], delete e[st], delete e[ct], delete e[V]);
  }
  function ft(e) {
    var t = e[it];
    if (t) return t;
    for (var n = e.parentNode; n; ) {
      if (t = n[ot] || n[it]) {
        if ((n = t.alternate, t.child !== null || n !== null && n.child !== null)) for (e = df(e); e !== null; ) {
          if (n = e[it]) return n;
          e = df(e);
        }
        return t;
      }
      (e = n, n = e.parentNode);
    }
    return null;
  }
  function pt(e) {
    if (e = e[it] || e[ot]) {
      var t = e.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
    }
    return null;
  }
  function mt(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
    throw Error(s(33));
  }
  function H(e) {
    var t = e[lt];
    return (t ||= e[lt] = {
      hoistableStyles: new Map(),
      hoistableScripts: new Map()
    }, t);
  }
  function U(e) {
    e[ut] = !0;
  }
  var W = new Set(), ht = {};
  function gt(e, t) {
    (G(e, t), G(e + `Capture`, t));
  }
  function G(e, t) {
    for ((ht[e] = t, e = 0); e < t.length; e++) W.add(t[e]);
  }
  var _t = RegExp(`^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$`), vt = {}, yt = {};
  function bt(e) {
    return ye.call(yt, e) ? !0 : ye.call(vt, e) ? !1 : _t.test(e) ? yt[e] = !0 : (vt[e] = !0, !1);
  }
  function xt(e, t, n) {
    if (bt(t)) {
      if (n === null) e.removeAttribute(t); else {
        switch (typeof n) {
          case `undefined`:
          case `function`:
          case `symbol`:
            e.removeAttribute(t);
            return;
          case `boolean`:
            var r = t.toLowerCase().slice(0, 5);
            if (r !== `data-` && r !== `aria-`) {
              e.removeAttribute(t);
              return;
            }
        }
        e.setAttribute(t, `` + n);
      }
    }
  }
  function St(e, t, n) {
    if (n === null) e.removeAttribute(t); else {
      switch (typeof n) {
        case `undefined`:
        case `function`:
        case `symbol`:
        case `boolean`:
          e.removeAttribute(t);
          return;
      }
      e.setAttribute(t, `` + n);
    }
  }
  function Ct(e, t, n, r) {
    if (r === null) e.removeAttribute(n); else {
      switch (typeof r) {
        case `undefined`:
        case `function`:
        case `symbol`:
        case `boolean`:
          e.removeAttribute(n);
          return;
      }
      e.setAttributeNS(t, n, `` + r);
    }
  }
  function wt(e) {
    switch (typeof e) {
      case `bigint`:
      case `boolean`:
      case `number`:
      case `string`:
      case `undefined`:
        return e;
      case `object`:
        return e;
      default:
        return ``;
    }
  }
  function Tt(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === `input` && (t === `checkbox` || t === `radio`);
  }
  function Et(e, t, n) {
    var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
    if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == `function` && typeof r.set == `function`) {
      var i = r.get, a = r.set;
      return (Object.defineProperty(e, t, {
        configurable: !0,
        get: function () {
          return i.call(this);
        },
        set: function (e) {
          (n = `` + e, a.call(this, e));
        }
      }), Object.defineProperty(e, t, {
        enumerable: r.enumerable
      }), {
        getValue: function () {
          return n;
        },
        setValue: function (e) {
          n = `` + e;
        },
        stopTracking: function () {
          (e._valueTracker = null, delete e[t]);
        }
      });
    }
  }
  function Dt(e) {
    if (!e._valueTracker) {
      var t = Tt(e) ? `checked` : `value`;
      e._valueTracker = Et(e, t, `` + e[t]);
    }
  }
  function Ot(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var n = t.getValue(), r = ``;
    return (e && (r = Tt(e) ? e.checked ? `true` : `false` : e.value), e = r, e !== n && (t.setValue(e), !0));
  }
  function kt(e) {
    if ((e ||= typeof document < `u` ? document : void 0, e === void 0)) return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var At = /[\n"\\]/g;
  function jt(e) {
    return e.replace(At, function (e) {
      return `\\` + e.charCodeAt(0).toString(16) + ` `;
    });
  }
  function Mt(e, t, n, r, i, a, o, s) {
    (e.name = ``, o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean` ? e.type = o : e.removeAttribute(`type`), t == null ? o !== `submit` && o !== `reset` || e.removeAttribute(`value`) : o === `number` ? (t === 0 && e.value === `` || e.value != t) && (e.value = `` + wt(t)) : e.value !== `` + wt(t) && (e.value = `` + wt(t)), t == null ? n == null ? r != null && e.removeAttribute(`value`) : Pt(e, o, wt(n)) : Pt(e, o, wt(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != `function` && typeof i != `symbol`), s != null && typeof s != `function` && typeof s != `symbol` && typeof s != `boolean` ? e.name = `` + wt(s) : e.removeAttribute(`name`));
  }
  function Nt(e, t, n, r, i, a, o, s) {
    if ((a != null && typeof a != `function` && typeof a != `symbol` && typeof a != `boolean` && (e.type = a), t != null || n != null)) {
      if (!(a !== `submit` && a !== `reset` || t != null)) {
        Dt(e);
        return;
      }
      (n = n == null ? `` : `` + wt(n), t = t == null ? n : `` + wt(t), s || t === e.value || (e.value = t), e.defaultValue = t);
    }
    (r ??= i, r = typeof r != `function` && typeof r != `symbol` && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != `function` && typeof o != `symbol` && typeof o != `boolean` && (e.name = o), Dt(e));
  }
  function Pt(e, t, n) {
    t === `number` && kt(e.ownerDocument) === e || e.defaultValue === `` + n || (e.defaultValue = `` + n);
  }
  function Ft(e, t, n, r) {
    if ((e = e.options, t)) {
      t = {};
      for (var i = 0; i < n.length; i++) t[`$` + n[i]] = !0;
      for (n = 0; n < e.length; n++) (i = t.hasOwnProperty(`$` + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0));
    } else {
      for ((n = `` + wt(n), t = null, i = 0); i < e.length; i++) {
        if (e[i].value === n) {
          (e[i].selected = !0, r && (e[i].defaultSelected = !0));
          return;
        }
        t !== null || e[i].disabled || (t = e[i]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function It(e, t, n) {
    if (t != null && (t = `` + wt(t), t !== e.value && (e.value = t), n == null)) {
      e.defaultValue !== t && (e.defaultValue = t);
      return;
    }
    e.defaultValue = n == null ? `` : `` + wt(n);
  }
  function Lt(e, t, n, r) {
    if (t == null) {
      if (r != null) {
        if (n != null) throw Error(s(92));
        if (ie(r)) {
          if (1 < r.length) throw Error(s(93));
          r = r[0];
        }
        n = r;
      }
      (n ??= ``, t = n);
    }
    (n = wt(t), e.defaultValue = n, r = e.textContent, r === n && r !== `` && r !== null && (e.value = r), Dt(e));
  }
  function Rt(e, t) {
    if (t) {
      var n = e.firstChild;
      if (n && n === e.lastChild && n.nodeType === 3) {
        n.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var zt = new Set(`animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp`.split(` `));
  function Bt(e, t, n) {
    var r = t.indexOf(`--`) === 0;
    n == null || typeof n == `boolean` || n === `` ? r ? e.setProperty(t, ``) : t === `float` ? e.cssFloat = `` : e[t] = `` : r ? e.setProperty(t, n) : typeof n != `number` || n === 0 || zt.has(t) ? t === `float` ? e.cssFloat = n : e[t] = (`` + n).trim() : e[t] = n + `px`;
  }
  function Vt(e, t, n) {
    if (t != null && typeof t != `object`) throw Error(s(62));
    if ((e = e.style, n != null)) {
      for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf(`--`) === 0 ? e.setProperty(r, ``) : r === `float` ? e.cssFloat = `` : e[r] = ``);
      for (var i in t) (r = t[i], t.hasOwnProperty(i) && n[i] !== r && Bt(e, i, r));
    } else for (var a in t) t.hasOwnProperty(a) && Bt(e, a, t[a]);
  }
  function Ht(e) {
    if (e.indexOf(`-`) === -1) return !1;
    switch (e) {
      case `annotation-xml`:
      case `color-profile`:
      case `font-face`:
      case `font-face-src`:
      case `font-face-uri`:
      case `font-face-format`:
      case `font-face-name`:
      case `missing-glyph`:
        return !1;
      default:
        return !0;
    }
  }
  var Ut = new Map([[`acceptCharset`, `accept-charset`], [`htmlFor`, `for`], [`httpEquiv`, `http-equiv`], [`crossOrigin`, `crossorigin`], [`accentHeight`, `accent-height`], [`alignmentBaseline`, `alignment-baseline`], [`arabicForm`, `arabic-form`], [`baselineShift`, `baseline-shift`], [`capHeight`, `cap-height`], [`clipPath`, `clip-path`], [`clipRule`, `clip-rule`], [`colorInterpolation`, `color-interpolation`], [`colorInterpolationFilters`, `color-interpolation-filters`], [`colorProfile`, `color-profile`], [`colorRendering`, `color-rendering`], [`dominantBaseline`, `dominant-baseline`], [`enableBackground`, `enable-background`], [`fillOpacity`, `fill-opacity`], [`fillRule`, `fill-rule`], [`floodColor`, `flood-color`], [`floodOpacity`, `flood-opacity`], [`fontFamily`, `font-family`], [`fontSize`, `font-size`], [`fontSizeAdjust`, `font-size-adjust`], [`fontStretch`, `font-stretch`], [`fontStyle`, `font-style`], [`fontVariant`, `font-variant`], [`fontWeight`, `font-weight`], [`glyphName`, `glyph-name`], [`glyphOrientationHorizontal`, `glyph-orientation-horizontal`], [`glyphOrientationVertical`, `glyph-orientation-vertical`], [`horizAdvX`, `horiz-adv-x`], [`horizOriginX`, `horiz-origin-x`], [`imageRendering`, `image-rendering`], [`letterSpacing`, `letter-spacing`], [`lightingColor`, `lighting-color`], [`markerEnd`, `marker-end`], [`markerMid`, `marker-mid`], [`markerStart`, `marker-start`], [`overlinePosition`, `overline-position`], [`overlineThickness`, `overline-thickness`], [`paintOrder`, `paint-order`], [`panose-1`, `panose-1`], [`pointerEvents`, `pointer-events`], [`renderingIntent`, `rendering-intent`], [`shapeRendering`, `shape-rendering`], [`stopColor`, `stop-color`], [`stopOpacity`, `stop-opacity`], [`strikethroughPosition`, `strikethrough-position`], [`strikethroughThickness`, `strikethrough-thickness`], [`strokeDasharray`, `stroke-dasharray`], [`strokeDashoffset`, `stroke-dashoffset`], [`strokeLinecap`, `stroke-linecap`], [`strokeLinejoin`, `stroke-linejoin`], [`strokeMiterlimit`, `stroke-miterlimit`], [`strokeOpacity`, `stroke-opacity`], [`strokeWidth`, `stroke-width`], [`textAnchor`, `text-anchor`], [`textDecoration`, `text-decoration`], [`textRendering`, `text-rendering`], [`transformOrigin`, `transform-origin`], [`underlinePosition`, `underline-position`], [`underlineThickness`, `underline-thickness`], [`unicodeBidi`, `unicode-bidi`], [`unicodeRange`, `unicode-range`], [`unitsPerEm`, `units-per-em`], [`vAlphabetic`, `v-alphabetic`], [`vHanging`, `v-hanging`], [`vIdeographic`, `v-ideographic`], [`vMathematical`, `v-mathematical`], [`vectorEffect`, `vector-effect`], [`vertAdvY`, `vert-adv-y`], [`vertOriginX`, `vert-origin-x`], [`vertOriginY`, `vert-origin-y`], [`wordSpacing`, `word-spacing`], [`writingMode`, `writing-mode`], [`xmlnsXlink`, `xmlns:xlink`], [`xHeight`, `x-height`]]), Wt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Gt(e) {
    return Wt.test(`` + e) ? `javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')` : e;
  }
  function Kt() {}
  var qt = null;
  function Jt(e) {
    return (e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e);
  }
  var Yt = null, Xt = null;
  function Zt(e) {
    var t = pt(e);
    if (t && (e = t.stateNode)) {
      var n = e[at] || null;
      a: switch ((e = t.stateNode, t.type)) {
        case `input`:
          if ((Mt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === `radio` && t != null)) {
            for (n = e; n.parentNode; ) n = n.parentNode;
            for ((n = n.querySelectorAll(`input[name="` + jt(`` + t) + `"][type="radio"]`), t = 0); t < n.length; t++) {
              var r = n[t];
              if (r !== e && r.form === e.form) {
                var i = r[at] || null;
                if (!i) throw Error(s(90));
                Mt(r, i.value, i.defaultValue, i.defaultValue, i.checked, i.defaultChecked, i.type, i.name);
              }
            }
            for (t = 0; t < n.length; t++) (r = n[t], r.form === e.form && Ot(r));
          }
          break a;
        case `textarea`:
          It(e, n.value, n.defaultValue);
          break a;
        case `select`:
          (t = n.value, t != null && Ft(e, !!n.multiple, t, !1));
      }
    }
  }
  var Qt = !1;
  function $t(e, t, n) {
    if (Qt) return e(t, n);
    Qt = !0;
    try {
      return e(t);
    } finally {
      if ((Qt = !1, (Yt !== null || Xt !== null) && (yu(), Yt && (t = Yt, e = Xt, Xt = Yt = null, Zt(t), e)))) for (t = 0; t < e.length; t++) Zt(e[t]);
    }
  }
  function en(e, t) {
    var n = e.stateNode;
    if (n === null) return null;
    var r = n[at] || null;
    if (r === null) return null;
    n = r[t];
    a: switch (t) {
      case `onClick`:
      case `onClickCapture`:
      case `onDoubleClick`:
      case `onDoubleClickCapture`:
      case `onMouseDown`:
      case `onMouseDownCapture`:
      case `onMouseMove`:
      case `onMouseMoveCapture`:
      case `onMouseUp`:
      case `onMouseUpCapture`:
      case `onMouseEnter`:
        ((r = !r.disabled) || (e = e.type, r = e !== `button` && e !== `input` && e !== `select` && e !== `textarea`), e = !r);
        break a;
      default:
        e = !1;
    }
    if (e) return null;
    if (n && typeof n != `function`) throw Error(s(231, t, typeof n));
    return n;
  }
  var tn = !(typeof window > `u` || window.document === void 0 || window.document.createElement === void 0), nn = !1;
  if (tn) try {
    var rn = {};
    (Object.defineProperty(rn, "passive", {
      get: function () {
        nn = !0;
      }
    }), window.addEventListener(`test`, rn, rn), window.removeEventListener(`test`, rn, rn));
  } catch {
    nn = !1;
  }
  var an = null, on = null, sn = null;
  function cn() {
    if (sn) return sn;
    var e, t = on, n = t.length, r, i = (`value` in an) ? an.value : an.textContent, a = i.length;
    for (e = 0; e < n && t[e] === i[e]; e++) ;
    var o = n - e;
    for (r = 1; r <= o && t[n - r] === i[a - r]; r++) ;
    return sn = i.slice(e, 1 < r ? 1 - r : void 0);
  }
  function ln(e) {
    var t = e.keyCode;
    return ((`charCode` in e) ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0);
  }
  function un() {
    return !0;
  }
  function dn() {
    return !1;
  }
  function fn(e) {
    function t(t, n, r, i, a) {
      for (var o in (this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e)) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
      return (this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? un : dn, this.isPropagationStopped = dn, this);
    }
    return (h(t.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != `unknown` && (e.returnValue = !1), this.isDefaultPrevented = un);
      },
      stopPropagation: function () {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != `unknown` && (e.cancelBubble = !0), this.isPropagationStopped = un);
      },
      persist: function () {},
      isPersistent: un
    }), t);
  }
  var pn = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, mn = fn(pn), hn = h({}, pn, {
    view: 0,
    detail: 0
  }), gn = fn(hn), _n, vn, yn, bn = h({}, hn, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: jn,
    button: 0,
    buttons: 0,
    relatedTarget: function (e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function (e) {
      return (`movementX` in e) ? e.movementX : (e !== yn && (yn && e.type === `mousemove` ? (_n = e.screenX - yn.screenX, vn = e.screenY - yn.screenY) : vn = _n = 0, yn = e), _n);
    },
    movementY: function (e) {
      return (`movementY` in e) ? e.movementY : vn;
    }
  }), xn = fn(bn), Sn = fn(h({}, bn, {
    dataTransfer: 0
  })), Cn = fn(h({}, hn, {
    relatedTarget: 0
  })), wn = fn(h({}, pn, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  })), Tn = fn(h({}, pn, {
    clipboardData: function (e) {
      return (`clipboardData` in e) ? e.clipboardData : window.clipboardData;
    }
  })), En = fn(h({}, pn, {
    data: 0
  })), Dn = {
    Esc: `Escape`,
    Spacebar: ` `,
    Left: `ArrowLeft`,
    Up: `ArrowUp`,
    Right: `ArrowRight`,
    Down: `ArrowDown`,
    Del: `Delete`,
    Win: `OS`,
    Menu: `ContextMenu`,
    Apps: `ContextMenu`,
    Scroll: `ScrollLock`,
    MozPrintableKey: `Unidentified`
  }, On = {
    8: `Backspace`,
    9: `Tab`,
    12: `Clear`,
    13: `Enter`,
    16: `Shift`,
    17: `Control`,
    18: `Alt`,
    19: `Pause`,
    20: `CapsLock`,
    27: `Escape`,
    32: ` `,
    33: `PageUp`,
    34: `PageDown`,
    35: `End`,
    36: `Home`,
    37: `ArrowLeft`,
    38: `ArrowUp`,
    39: `ArrowRight`,
    40: `ArrowDown`,
    45: `Insert`,
    46: `Delete`,
    112: `F1`,
    113: `F2`,
    114: `F3`,
    115: `F4`,
    116: `F5`,
    117: `F6`,
    118: `F7`,
    119: `F8`,
    120: `F9`,
    121: `F10`,
    122: `F11`,
    123: `F12`,
    144: `NumLock`,
    145: `ScrollLock`,
    224: `Meta`
  }, kn = {
    Alt: `altKey`,
    Control: `ctrlKey`,
    Meta: `metaKey`,
    Shift: `shiftKey`
  };
  function An(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = kn[e]) ? !!t[e] : !1;
  }
  function jn() {
    return An;
  }
  var Mn = fn(h({}, hn, {
    key: function (e) {
      if (e.key) {
        var t = Dn[e.key] || e.key;
        if (t !== `Unidentified`) return t;
      }
      return e.type === `keypress` ? (e = ln(e), e === 13 ? `Enter` : String.fromCharCode(e)) : e.type === `keydown` || e.type === `keyup` ? On[e.keyCode] || `Unidentified` : ``;
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: jn,
    charCode: function (e) {
      return e.type === `keypress` ? ln(e) : 0;
    },
    keyCode: function (e) {
      return e.type === `keydown` || e.type === `keyup` ? e.keyCode : 0;
    },
    which: function (e) {
      return e.type === `keypress` ? ln(e) : e.type === `keydown` || e.type === `keyup` ? e.keyCode : 0;
    }
  })), Nn = fn(h({}, bn, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  })), Pn = fn(h({}, hn, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: jn
  })), Fn = fn(h({}, pn, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  })), In = fn(h({}, bn, {
    deltaX: function (e) {
      return (`deltaX` in e) ? e.deltaX : (`wheelDeltaX` in e) ? -e.wheelDeltaX : 0;
    },
    deltaY: function (e) {
      return (`deltaY` in e) ? e.deltaY : (`wheelDeltaY` in e) ? -e.wheelDeltaY : (`wheelDelta` in e) ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  })), Ln = fn(h({}, pn, {
    newState: 0,
    oldState: 0
  })), Rn = [9, 13, 27, 32], zn = tn && (`CompositionEvent` in window), Bn = null;
  tn && (`documentMode` in document) && (Bn = document.documentMode);
  var Vn = tn && (`TextEvent` in window) && !Bn, Hn = tn && (!zn || Bn && 8 < Bn && 11 >= Bn), Un = ` `, Wn = !1;
  function Gn(e, t) {
    switch (e) {
      case `keyup`:
        return Rn.indexOf(t.keyCode) !== -1;
      case `keydown`:
        return t.keyCode !== 229;
      case `keypress`:
      case `mousedown`:
      case `focusout`:
        return !0;
      default:
        return !1;
    }
  }
  function Kn(e) {
    return (e = e.detail, typeof e == `object` && (`data` in e) ? e.data : null);
  }
  var qn = !1;
  function Jn(e, t) {
    switch (e) {
      case `compositionend`:
        return Kn(t);
      case `keypress`:
        return t.which === 32 ? (Wn = !0, Un) : null;
      case `textInput`:
        return (e = t.data, e === Un && Wn ? null : e);
      default:
        return null;
    }
  }
  function Yn(e, t) {
    if (qn) return e === `compositionend` || !zn && Gn(e, t) ? (e = cn(), sn = on = an = null, qn = !1, e) : null;
    switch (e) {
      case `paste`:
        return null;
      case `keypress`:
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length) return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case `compositionend`:
        return Hn && t.locale !== `ko` ? null : t.data;
      default:
        return null;
    }
  }
  var Xn = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Zn(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === `input` ? !!Xn[e.type] : t === `textarea`;
  }
  function Qn(e, t, n, r) {
    (Yt ? Xt ? Xt.push(r) : Xt = [r] : Yt = r, t = Td(t, `onChange`), 0 < t.length && (n = new mn(`onChange`, `change`, null, n, r), e.push({
      event: n,
      listeners: t
    })));
  }
  var $n = null, er = null;
  function tr(e) {
    vd(e, 0);
  }
  function nr(e) {
    if (Ot(mt(e))) return e;
  }
  function rr(e, t) {
    if (e === `change`) return t;
  }
  var ir = !1;
  if (tn) {
    var ar;
    if (tn) {
      var or = (`oninput` in document);
      if (!or) {
        var sr = document.createElement(`div`);
        (sr.setAttribute(`oninput`, `return;`), or = typeof sr.oninput == `function`);
      }
      ar = or;
    } else ar = !1;
    ir = ar && (!document.documentMode || 9 < document.documentMode);
  }
  function cr() {
    $n && ($n.detachEvent(`onpropertychange`, lr), er = $n = null);
  }
  function lr(e) {
    if (e.propertyName === `value` && nr(er)) {
      var t = [];
      (Qn(t, er, e, Jt(e)), $t(tr, t));
    }
  }
  function ur(e, t, n) {
    e === `focusin` ? (cr(), $n = t, er = n, $n.attachEvent(`onpropertychange`, lr)) : e === `focusout` && cr();
  }
  function dr(e) {
    if (e === `selectionchange` || e === `keyup` || e === `keydown`) return nr(er);
  }
  function fr(e, t) {
    if (e === `click`) return nr(t);
  }
  function pr(e, t) {
    if (e === `input` || e === `change`) return nr(t);
  }
  function mr(e, t) {
    return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
  }
  var hr = typeof Object.is == `function` ? Object.is : mr;
  function gr(e, t) {
    if (hr(e, t)) return !0;
    if (typeof e != `object` || !e || typeof t != `object` || !t) return !1;
    var n = Object.keys(e), r = Object.keys(t);
    if (n.length !== r.length) return !1;
    for (r = 0; r < n.length; r++) {
      var i = n[r];
      if (!ye.call(t, i) || !hr(e[i], t[i])) return !1;
    }
    return !0;
  }
  function _r(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function vr(e, t) {
    var n = _r(e);
    e = 0;
    for (var r; n; ) {
      if (n.nodeType === 3) {
        if ((r = e + n.textContent.length, e <= t && r >= t)) return {
          node: n,
          offset: t - e
        };
        e = r;
      }
      a: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break a;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = _r(n);
    }
  }
  function yr(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? yr(e, t.parentNode) : (`contains` in e) ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function br(e) {
    e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
    for (var t = kt(e.document); t instanceof e.HTMLIFrameElement; ) {
      try {
        var n = typeof t.contentWindow.location.href == `string`;
      } catch {
        n = !1;
      }
      if (n) e = t.contentWindow; else break;
      t = kt(e.document);
    }
    return t;
  }
  function xr(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === `input` && (e.type === `text` || e.type === `search` || e.type === `tel` || e.type === `url` || e.type === `password`) || t === `textarea` || e.contentEditable === `true`);
  }
  var Sr = tn && (`documentMode` in document) && 11 >= document.documentMode, Cr = null, wr = null, Tr = null, Er = !1;
  function Dr(e, t, n) {
    var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    Er || Cr == null || Cr !== kt(r) || (r = Cr, (`selectionStart` in r) && xr(r) ? r = {
      start: r.selectionStart,
      end: r.selectionEnd
    } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
      anchorNode: r.anchorNode,
      anchorOffset: r.anchorOffset,
      focusNode: r.focusNode,
      focusOffset: r.focusOffset
    }), Tr && gr(Tr, r) || (Tr = r, r = Td(wr, `onSelect`), 0 < r.length && (t = new mn(`onSelect`, `select`, null, t, n), e.push({
      event: t,
      listeners: r
    }), t.target = Cr)));
  }
  function Or(e, t) {
    var n = {};
    return (n[e.toLowerCase()] = t.toLowerCase(), n[`Webkit` + e] = `webkit` + t, n[`Moz` + e] = `moz` + t, n);
  }
  var kr = {
    animationend: Or(`Animation`, `AnimationEnd`),
    animationiteration: Or(`Animation`, `AnimationIteration`),
    animationstart: Or(`Animation`, `AnimationStart`),
    transitionrun: Or(`Transition`, `TransitionRun`),
    transitionstart: Or(`Transition`, `TransitionStart`),
    transitioncancel: Or(`Transition`, `TransitionCancel`),
    transitionend: Or(`Transition`, `TransitionEnd`)
  }, Ar = {}, jr = {};
  tn && (jr = document.createElement(`div`).style, (`AnimationEvent` in window) || (delete kr.animationend.animation, delete kr.animationiteration.animation, delete kr.animationstart.animation), (`TransitionEvent` in window) || delete kr.transitionend.transition);
  function Mr(e) {
    if (Ar[e]) return Ar[e];
    if (!kr[e]) return e;
    var t = kr[e], n;
    for (n in t) if (t.hasOwnProperty(n) && (n in jr)) return Ar[e] = t[n];
    return e;
  }
  var Nr = Mr(`animationend`), Pr = Mr(`animationiteration`), Fr = Mr(`animationstart`), Ir = Mr(`transitionrun`), Lr = Mr(`transitionstart`), Rr = Mr(`transitioncancel`), zr = Mr(`transitionend`), Br = new Map(), Vr = `abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel`.split(` `);
  Vr.push(`scrollEnd`);
  function Hr(e, t) {
    (Br.set(e, t), gt(t, [e]));
  }
  var Ur = typeof reportError == `function` ? reportError : function (e) {
    if (typeof window == `object` && typeof window.ErrorEvent == `function`) {
      var t = new window.ErrorEvent(`error`, {
        bubbles: !0,
        cancelable: !0,
        message: typeof e == `object` && e && typeof e.message == `string` ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == `object` && typeof process.emit == `function`) {
      process.emit(`uncaughtException`, e);
      return;
    }
    console.error(e);
  }, Wr = [], Gr = 0, Kr = 0;
  function qr() {
    for (var e = Gr, t = Kr = Gr = 0; t < e; ) {
      var n = Wr[t];
      Wr[t++] = null;
      var r = Wr[t];
      Wr[t++] = null;
      var i = Wr[t];
      Wr[t++] = null;
      var a = Wr[t];
      if ((Wr[t++] = null, r !== null && i !== null)) {
        var o = r.pending;
        (o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i);
      }
      a !== 0 && Zr(n, i, a);
    }
  }
  function Jr(e, t, n, r) {
    (Wr[Gr++] = e, Wr[Gr++] = t, Wr[Gr++] = n, Wr[Gr++] = r, Kr |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r));
  }
  function Yr(e, t, n, r) {
    return (Jr(e, t, n, r), Qr(e));
  }
  function Xr(e, t) {
    return (Jr(e, null, null, t), Qr(e));
  }
  function Zr(e, t, n) {
    e.lanes |= n;
    var r = e.alternate;
    r !== null && (r.lanes |= n);
    for (var i = !1, a = e.return; a !== null; ) (a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return);
    return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Ie(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
  }
  function Qr(e) {
    if (50 < uu) throw (uu = 0, du = null, Error(s(185)));
    for (var t = e.return; t !== null; ) (e = t, t = e.return);
    return e.tag === 3 ? e.stateNode : null;
  }
  var $r = {};
  function ei(e, t, n, r) {
    (this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null);
  }
  function ti(e, t, n, r) {
    return new ei(e, t, n, r);
  }
  function ni(e) {
    return (e = e.prototype, !(!e || !e.isReactComponent));
  }
  function ri(e, t) {
    var n = e.alternate;
    return (n === null ? (n = ti(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n);
  }
  function ii(e, t) {
    e.flags &= 65011714;
    var n = e.alternate;
    return (n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), e);
  }
  function ai(e, t, n, r, i, a) {
    var o = 0;
    if ((r = e, typeof e == `function`)) ni(e) && (o = 1); else if (typeof e == `string`) o = Uf(e, n, ae.current) ? 26 : e === `html` || e === `head` || e === `body` ? 27 : 5; else a: switch (e) {
      case k:
        return (e = ti(31, n, t, i), e.elementType = k, e.lanes = a, e);
      case y:
        return oi(n.children, i, a, t);
      case b:
        (o = 8, i |= 24);
        break;
      case x:
        return (e = ti(12, n, t, i | 2), e.elementType = x, e.lanes = a, e);
      case T:
        return (e = ti(13, n, t, i), e.elementType = T, e.lanes = a, e);
      case E:
        return (e = ti(19, n, t, i), e.elementType = E, e.lanes = a, e);
      default:
        if (typeof e == `object` && e) switch (e.$$typeof) {
          case C:
            o = 10;
            break a;
          case S:
            o = 9;
            break a;
          case w:
            o = 11;
            break a;
          case D:
            o = 14;
            break a;
          case O:
            (o = 16, r = null);
            break a;
        }
        (o = 29, n = Error(s(130, e === null ? `null` : typeof e, ``)), r = null);
    }
    return (t = ti(o, n, t, i), t.elementType = e, t.type = r, t.lanes = a, t);
  }
  function oi(e, t, n, r) {
    return (e = ti(7, e, r, t), e.lanes = n, e);
  }
  function si(e, t, n) {
    return (e = ti(6, e, null, t), e.lanes = n, e);
  }
  function ci(e) {
    var t = ti(18, null, null, 0);
    return (t.stateNode = e, t);
  }
  function li(e, t, n) {
    return (t = ti(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    }, t);
  }
  var ui = new WeakMap();
  function di(e, t) {
    if (typeof e == `object` && e) {
      var n = ui.get(e);
      return n === void 0 ? (t = {
        value: e,
        source: t,
        stack: z(t)
      }, ui.set(e, t), t) : n;
    }
    return {
      value: e,
      source: t,
      stack: z(t)
    };
  }
  var fi = [], pi = 0, mi = null, hi = 0, gi = [], _i = 0, vi = null, yi = 1, bi = ``;
  function xi(e, t) {
    (fi[pi++] = hi, fi[pi++] = mi, mi = e, hi = t);
  }
  function Si(e, t, n) {
    (gi[_i++] = yi, gi[_i++] = bi, gi[_i++] = vi, vi = e);
    var r = yi;
    e = bi;
    var i = 32 - Ie(r) - 1;
    (r &= ~(1 << i), n += 1);
    var a = 32 - Ie(t) + i;
    if (30 < a) {
      var o = i - i % 5;
      (a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, yi = 1 << 32 - Ie(t) + i | n << i | r, bi = a + e);
    } else (yi = 1 << a | n << i | r, bi = e);
  }
  function Ci(e) {
    e.return !== null && (xi(e, 1), Si(e, 1, 0));
  }
  function wi(e) {
    for (; e === mi; ) (mi = fi[--pi], fi[pi] = null, hi = fi[--pi], fi[pi] = null);
    for (; e === vi; ) (vi = gi[--_i], gi[_i] = null, bi = gi[--_i], gi[_i] = null, yi = gi[--_i], gi[_i] = null);
  }
  function Ti(e, t) {
    (gi[_i++] = yi, gi[_i++] = bi, gi[_i++] = vi, yi = t.id, bi = t.overflow, vi = e);
  }
  var Ei = null, Di = null, K = !1, Oi = null, ki = !1, Ai = Error(s(519));
  function ji(e) {
    throw (Li(di(Error(s(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? `text` : `HTML`, ``)), e)), Ai);
  }
  function Mi(e) {
    var t = e.stateNode, n = e.type, r = e.memoizedProps;
    switch ((t[it] = e, t[at] = r, n)) {
      case `dialog`:
        ($(`cancel`, t), $(`close`, t));
        break;
      case `iframe`:
      case `object`:
      case `embed`:
        $(`load`, t);
        break;
      case `video`:
      case `audio`:
        for (n = 0; n < gd.length; n++) $(gd[n], t);
        break;
      case `source`:
        $(`error`, t);
        break;
      case `img`:
      case `image`:
      case `link`:
        ($(`error`, t), $(`load`, t));
        break;
      case `details`:
        $(`toggle`, t);
        break;
      case `input`:
        ($(`invalid`, t), Nt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0));
        break;
      case `select`:
        $(`invalid`, t);
        break;
      case `textarea`:
        ($(`invalid`, t), Lt(t, r.value, r.defaultValue, r.children));
    }
    (n = r.children, typeof n != `string` && typeof n != `number` && typeof n != `bigint` || t.textContent === `` + n || !0 === r.suppressHydrationWarning || jd(t.textContent, n) ? (r.popover != null && ($(`beforetoggle`, t), $(`toggle`, t)), r.onScroll != null && $(`scroll`, t), r.onScrollEnd != null && $(`scrollend`, t), r.onClick != null && (t.onclick = Kt), t = !0) : t = !1, t || ji(e, !0));
  }
  function Ni(e) {
    for (Ei = e.return; Ei; ) switch (Ei.tag) {
      case 5:
      case 31:
      case 13:
        ki = !1;
        return;
      case 27:
      case 3:
        ki = !0;
        return;
      default:
        Ei = Ei.return;
    }
  }
  function Pi(e) {
    if (e !== Ei) return !1;
    if (!K) return (Ni(e), K = !0, !1);
    var t = e.tag, n;
    if (((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = n === `form` || n === `button` || Ud(e.type, e.memoizedProps)), n = !n), n && Di && ji(e), Ni(e), t === 13)) {
      if ((e = e.memoizedState, e = e === null ? null : e.dehydrated, !e)) throw Error(s(317));
      Di = uf(e);
    } else if (t === 31) {
      if ((e = e.memoizedState, e = e === null ? null : e.dehydrated, !e)) throw Error(s(317));
      Di = uf(e);
    } else t === 27 ? (t = Di, Zd(e.type) ? (e = lf, lf = null, Di = e) : Di = t) : Di = Ei ? cf(e.stateNode.nextSibling) : null;
    return !0;
  }
  function Fi() {
    (Di = Ei = null, K = !1);
  }
  function Ii() {
    var e = Oi;
    return (e !== null && (Xl === null ? Xl = e : Xl.push.apply(Xl, e), Oi = null), e);
  }
  function Li(e) {
    Oi === null ? Oi = [e] : Oi.push(e);
  }
  var Ri = I(null), zi = null, Bi = null;
  function Vi(e, t, n) {
    (R(Ri, t._currentValue), t._currentValue = n);
  }
  function Hi(e) {
    (e._currentValue = Ri.current, L(Ri));
  }
  function Ui(e, t, n) {
    for (; e !== null; ) {
      var r = e.alternate;
      if (((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n)) break;
      e = e.return;
    }
  }
  function Wi(e, t, n, r) {
    var i = e.child;
    for (i !== null && (i.return = e); i !== null; ) {
      var a = i.dependencies;
      if (a !== null) {
        var o = i.child;
        a = a.firstContext;
        a: for (; a !== null; ) {
          var c = a;
          a = i;
          for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
            (a.lanes |= n, c = a.alternate, c !== null && (c.lanes |= n), Ui(a.return, n, e), r || (o = null));
            break a;
          }
          a = c.next;
        }
      } else if (i.tag === 18) {
        if ((o = i.return, o === null)) throw Error(s(341));
        (o.lanes |= n, a = o.alternate, a !== null && (a.lanes |= n), Ui(o, n, e), o = null);
      } else o = i.child;
      if (o !== null) o.return = i; else for (o = i; o !== null; ) {
        if (o === e) {
          o = null;
          break;
        }
        if ((i = o.sibling, i !== null)) {
          (i.return = o.return, o = i);
          break;
        }
        o = o.return;
      }
      i = o;
    }
  }
  function Gi(e, t, n, r) {
    e = null;
    for (var i = t, a = !1; i !== null; ) {
      if (!a) {
        if (i.flags & 524288) a = !0; else if (i.flags & 262144) break;
      }
      if (i.tag === 10) {
        var o = i.alternate;
        if (o === null) throw Error(s(387));
        if ((o = o.memoizedProps, o !== null)) {
          var c = i.type;
          hr(i.pendingProps.value, o.value) || (e === null ? e = [c] : e.push(c));
        }
      } else if (i === ce.current) {
        if ((o = i.alternate, o === null)) throw Error(s(387));
        o.memoizedState.memoizedState !== i.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf));
      }
      i = i.return;
    }
    (e !== null && Wi(t, e, n, r), t.flags |= 262144);
  }
  function Ki(e) {
    for (e = e.firstContext; e !== null; ) {
      if (!hr(e.context._currentValue, e.memoizedValue)) return !0;
      e = e.next;
    }
    return !1;
  }
  function qi(e) {
    (zi = e, Bi = null, e = e.dependencies, e !== null && (e.firstContext = null));
  }
  function Ji(e) {
    return Xi(zi, e);
  }
  function Yi(e, t) {
    return (zi === null && qi(e), Xi(e, t));
  }
  function Xi(e, t) {
    var n = t._currentValue;
    if ((t = {
      context: t,
      memoizedValue: n,
      next: null
    }, Bi === null)) {
      if (e === null) throw Error(s(308));
      (Bi = t, e.dependencies = {
        lanes: 0,
        firstContext: t
      }, e.flags |= 524288);
    } else Bi = Bi.next = t;
    return n;
  }
  var Zi = typeof AbortController < `u` ? AbortController : function () {
    var e = [], t = this.signal = {
      aborted: !1,
      addEventListener: function (t, n) {
        e.push(n);
      }
    };
    this.abort = function () {
      (t.aborted = !0, e.forEach(function (e) {
        return e();
      }));
    };
  }, Qi = t.unstable_scheduleCallback, $i = t.unstable_NormalPriority, ea = {
    $$typeof: C,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function ta() {
    return {
      controller: new Zi(),
      data: new Map(),
      refCount: 0
    };
  }
  function na(e) {
    (e.refCount--, e.refCount === 0 && Qi($i, function () {
      e.controller.abort();
    }));
  }
  var ra = null, ia = 0, aa = 0, oa = null;
  function sa(e, t) {
    if (ra === null) {
      var n = ra = [];
      (ia = 0, aa = ud(), oa = {
        status: `pending`,
        value: void 0,
        then: function (e) {
          n.push(e);
        }
      });
    }
    return (ia++, t.then(ca, ca), t);
  }
  function ca() {
    if (--ia === 0 && ra !== null) {
      oa !== null && (oa.status = `fulfilled`);
      var e = ra;
      (ra = null, aa = 0, oa = null);
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
  }
  function la(e, t) {
    var n = [], r = {
      status: `pending`,
      value: null,
      reason: null,
      then: function (e) {
        n.push(e);
      }
    };
    return (e.then(function () {
      (r.status = `fulfilled`, r.value = t);
      for (var e = 0; e < n.length; e++) (0, n[e])(t);
    }, function (e) {
      for ((r.status = `rejected`, r.reason = e, e = 0); e < n.length; e++) (0, n[e])(void 0);
    }), r);
  }
  var ua = j.S;
  j.S = function (e, t) {
    ($l = we(), typeof t == `object` && t && typeof t.then == `function` && sa(e, t), ua !== null && ua(e, t));
  };
  var da = I(null);
  function fa() {
    var e = da.current;
    return e === null ? Ll.pooledCache : e;
  }
  function pa(e, t) {
    t === null ? R(da, da.current) : R(da, t.pool);
  }
  function ma() {
    var e = fa();
    return e === null ? null : {
      parent: ea._currentValue,
      pool: e
    };
  }
  var ha = Error(s(460)), ga = Error(s(474)), _a = Error(s(542)), va = {
    then: function () {}
  };
  function ya(e) {
    return (e = e.status, e === `fulfilled` || e === `rejected`);
  }
  function ba(e, t, n) {
    switch ((n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(Kt, Kt), t = n), t.status)) {
      case `fulfilled`:
        return t.value;
      case `rejected`:
        throw (e = t.reason, wa(e), e);
      default:
        if (typeof t.status == `string`) t.then(Kt, Kt); else {
          if ((e = Ll, e !== null && 100 < e.shellSuspendCounter)) throw Error(s(482));
          (e = t, e.status = `pending`, e.then(function (e) {
            if (t.status === `pending`) {
              var n = t;
              (n.status = `fulfilled`, n.value = e);
            }
          }, function (e) {
            if (t.status === `pending`) {
              var n = t;
              (n.status = `rejected`, n.reason = e);
            }
          }));
        }
        switch (t.status) {
          case `fulfilled`:
            return t.value;
          case `rejected`:
            throw (e = t.reason, wa(e), e);
        }
        throw (Sa = t, ha);
    }
  }
  function xa(e) {
    try {
      var t = e._init;
      return t(e._payload);
    } catch (e) {
      throw typeof e == `object` && e && typeof e.then == `function` ? (Sa = e, ha) : e;
    }
  }
  var Sa = null;
  function Ca() {
    if (Sa === null) throw Error(s(459));
    var e = Sa;
    return (Sa = null, e);
  }
  function wa(e) {
    if (e === ha || e === _a) throw Error(s(483));
  }
  var Ta = null, Ea = 0;
  function Da(e) {
    var t = Ea;
    return (Ea += 1, Ta === null && (Ta = []), ba(Ta, e, t));
  }
  function Oa(e, t) {
    (t = t.props.ref, e.ref = t === void 0 ? null : t);
  }
  function ka(e, t) {
    throw t.$$typeof === g ? Error(s(525)) : (e = Object.prototype.toString.call(t), Error(s(31, e === `[object Object]` ? `object with keys {` + Object.keys(t).join(`, `) + `}` : e)));
  }
  function Aa(e) {
    function t(t, n) {
      if (e) {
        var r = t.deletions;
        r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
      }
    }
    function n(n, r) {
      if (!e) return null;
      for (; r !== null; ) (t(n, r), r = r.sibling);
      return null;
    }
    function r(e) {
      for (var t = new Map(); e !== null; ) (e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling);
      return t;
    }
    function i(e, t) {
      return (e = ri(e, t), e.index = 0, e.sibling = null, e);
    }
    function a(t, n, r) {
      return (t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n));
    }
    function o(t) {
      return (e && t.alternate === null && (t.flags |= 67108866), t);
    }
    function c(e, t, n, r) {
      return t === null || t.tag !== 6 ? (t = si(n, e.mode, r), t.return = e, t) : (t = i(t, n), t.return = e, t);
    }
    function l(e, t, n, r) {
      var a = n.type;
      return a === y ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === a || typeof a == `object` && a && a.$$typeof === O && xa(a) === t.type) ? (t = i(t, n.props), Oa(t, n), t.return = e, t) : (t = ai(n.type, n.key, n.props, null, e.mode, r), Oa(t, n), t.return = e, t);
    }
    function u(e, t, n, r) {
      return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = li(n, e.mode, r), t.return = e, t) : (t = i(t, n.children || []), t.return = e, t);
    }
    function d(e, t, n, r, a) {
      return t === null || t.tag !== 7 ? (t = oi(n, e.mode, r, a), t.return = e, t) : (t = i(t, n), t.return = e, t);
    }
    function f(e, t, n) {
      if (typeof t == `string` && t !== `` || typeof t == `number` || typeof t == `bigint`) return (t = si(`` + t, e.mode, n), t.return = e, t);
      if (typeof t == `object` && t) {
        switch (t.$$typeof) {
          case _:
            return (n = ai(t.type, t.key, t.props, null, e.mode, n), Oa(n, t), n.return = e, n);
          case v:
            return (t = li(t, e.mode, n), t.return = e, t);
          case O:
            return (t = xa(t), f(e, t, n));
        }
        if (ie(t) || ne(t)) return (t = oi(t, e.mode, n, null), t.return = e, t);
        if (typeof t.then == `function`) return f(e, Da(t), n);
        if (t.$$typeof === C) return f(e, Yi(e, t), n);
        ka(e, t);
      }
      return null;
    }
    function p(e, t, n, r) {
      var i = t === null ? null : t.key;
      if (typeof n == `string` && n !== `` || typeof n == `number` || typeof n == `bigint`) return i === null ? c(e, t, `` + n, r) : null;
      if (typeof n == `object` && n) {
        switch (n.$$typeof) {
          case _:
            return n.key === i ? l(e, t, n, r) : null;
          case v:
            return n.key === i ? u(e, t, n, r) : null;
          case O:
            return (n = xa(n), p(e, t, n, r));
        }
        if (ie(n) || ne(n)) return i === null ? d(e, t, n, r, null) : null;
        if (typeof n.then == `function`) return p(e, t, Da(n), r);
        if (n.$$typeof === C) return p(e, t, Yi(e, n), r);
        ka(e, n);
      }
      return null;
    }
    function m(e, t, n, r, i) {
      if (typeof r == `string` && r !== `` || typeof r == `number` || typeof r == `bigint`) return (e = e.get(n) || null, c(t, e, `` + r, i));
      if (typeof r == `object` && r) {
        switch (r.$$typeof) {
          case _:
            return (e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i));
          case v:
            return (e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i));
          case O:
            return (r = xa(r), m(e, t, n, r, i));
        }
        if (ie(r) || ne(r)) return (e = e.get(n) || null, d(t, e, r, i, null));
        if (typeof r.then == `function`) return m(e, t, n, Da(r), i);
        if (r.$$typeof === C) return m(e, t, n, Yi(t, r), i);
        ka(t, r);
      }
      return null;
    }
    function h(i, o, s, c) {
      for (var l = null, u = null, d = o, h = o = 0, g = null; d !== null && h < s.length; h++) {
        d.index > h ? (g = d, d = null) : g = d.sibling;
        var _ = p(i, d, s[h], c);
        if (_ === null) {
          d === null && (d = g);
          break;
        }
        (e && d && _.alternate === null && t(i, d), o = a(_, o, h), u === null ? l = _ : u.sibling = _, u = _, d = g);
      }
      if (h === s.length) return (n(i, d), K && xi(i, h), l);
      if (d === null) {
        for (; h < s.length; h++) (d = f(i, s[h], c), d !== null && (o = a(d, o, h), u === null ? l = d : u.sibling = d, u = d));
        return (K && xi(i, h), l);
      }
      for (d = r(d); h < s.length; h++) (g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), o = a(g, o, h), u === null ? l = g : u.sibling = g, u = g));
      return (e && d.forEach(function (e) {
        return t(i, e);
      }), K && xi(i, h), l);
    }
    function g(i, o, c, l) {
      if (c == null) throw Error(s(151));
      for (var u = null, d = null, h = o, g = o = 0, _ = null, v = c.next(); h !== null && !v.done; (g++, v = c.next())) {
        h.index > g ? (_ = h, h = null) : _ = h.sibling;
        var y = p(i, h, v.value, l);
        if (y === null) {
          h === null && (h = _);
          break;
        }
        (e && h && y.alternate === null && t(i, h), o = a(y, o, g), d === null ? u = y : d.sibling = y, d = y, h = _);
      }
      if (v.done) return (n(i, h), K && xi(i, g), u);
      if (h === null) {
        for (; !v.done; (g++, v = c.next())) (v = f(i, v.value, l), v !== null && (o = a(v, o, g), d === null ? u = v : d.sibling = v, d = v));
        return (K && xi(i, g), u);
      }
      for (h = r(h); !v.done; (g++, v = c.next())) (v = m(h, i, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), o = a(v, o, g), d === null ? u = v : d.sibling = v, d = v));
      return (e && h.forEach(function (e) {
        return t(i, e);
      }), K && xi(i, g), u);
    }
    function b(e, r, a, c) {
      if ((typeof a == `object` && a && a.type === y && a.key === null && (a = a.props.children), typeof a == `object` && a)) {
        switch (a.$$typeof) {
          case _:
            a: {
              for (var l = a.key; r !== null; ) {
                if (r.key === l) {
                  if ((l = a.type, l === y)) {
                    if (r.tag === 7) {
                      (n(e, r.sibling), c = i(r, a.props.children), c.return = e, e = c);
                      break a;
                    }
                  } else if (r.elementType === l || typeof l == `object` && l && l.$$typeof === O && xa(l) === r.type) {
                    (n(e, r.sibling), c = i(r, a.props), Oa(c, a), c.return = e, e = c);
                    break a;
                  }
                  n(e, r);
                  break;
                }
                (t(e, r), r = r.sibling);
              }
              a.type === y ? (c = oi(a.props.children, e.mode, c, a.key), c.return = e, e = c) : (c = ai(a.type, a.key, a.props, null, e.mode, c), Oa(c, a), c.return = e, e = c);
            }
            return o(e);
          case v:
            a: {
              for (l = a.key; r !== null; ) {
                if (r.key === l) {
                  if (r.tag === 4 && r.stateNode.containerInfo === a.containerInfo && r.stateNode.implementation === a.implementation) {
                    (n(e, r.sibling), c = i(r, a.children || []), c.return = e, e = c);
                    break a;
                  }
                  n(e, r);
                  break;
                }
                (t(e, r), r = r.sibling);
              }
              (c = li(a, e.mode, c), c.return = e, e = c);
            }
            return o(e);
          case O:
            return (a = xa(a), b(e, r, a, c));
        }
        if (ie(a)) return h(e, r, a, c);
        if (ne(a)) {
          if ((l = ne(a), typeof l != `function`)) throw Error(s(150));
          return (a = l.call(a), g(e, r, a, c));
        }
        if (typeof a.then == `function`) return b(e, r, Da(a), c);
        if (a.$$typeof === C) return b(e, r, Yi(e, a), c);
        ka(e, a);
      }
      return typeof a == `string` && a !== `` || typeof a == `number` || typeof a == `bigint` ? (a = `` + a, r !== null && r.tag === 6 ? (n(e, r.sibling), c = i(r, a), c.return = e, e = c) : (n(e, r), c = si(a, e.mode, c), c.return = e, e = c), o(e)) : n(e, r);
    }
    return function (e, t, n, r) {
      try {
        Ea = 0;
        var i = b(e, t, n, r);
        return (Ta = null, i);
      } catch (t) {
        if (t === ha || t === _a) throw t;
        var a = ti(29, t, null, e.mode);
        return (a.lanes = r, a.return = e, a);
      }
    };
  }
  var ja = Aa(!0), Ma = Aa(!1), Na = !1;
  function Pa(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        lanes: 0,
        hiddenCallbacks: null
      },
      callbacks: null
    };
  }
  function Fa(e, t) {
    (e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
      baseState: e.baseState,
      firstBaseUpdate: e.firstBaseUpdate,
      lastBaseUpdate: e.lastBaseUpdate,
      shared: e.shared,
      callbacks: null
    }));
  }
  function Ia(e) {
    return {
      lane: e,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }
  function La(e, t, n) {
    var r = e.updateQueue;
    if (r === null) return null;
    if ((r = r.shared, J & 2)) {
      var i = r.pending;
      return (i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = Qr(e), Zr(e, null, n), t);
    }
    return (Jr(e, r, t, n), Qr(e));
  }
  function Ra(e, t, n) {
    if ((t = t.updateQueue, t !== null && (t = t.shared, n & 4194048))) {
      var r = t.lanes;
      (r &= e.pendingLanes, n |= r, t.lanes = n, Ze(e, n));
    }
  }
  function za(e, t) {
    var n = e.updateQueue, r = e.alternate;
    if (r !== null && (r = r.updateQueue, n === r)) {
      var i = null, a = null;
      if ((n = n.firstBaseUpdate, n !== null)) {
        do {
          var o = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          (a === null ? i = a = o : a = a.next = o, n = n.next);
        } while (n !== null);
        a === null ? i = a = t : a = a.next = t;
      } else i = a = t;
      (n = {
        baseState: r.baseState,
        firstBaseUpdate: i,
        lastBaseUpdate: a,
        shared: r.shared,
        callbacks: r.callbacks
      }, e.updateQueue = n);
      return;
    }
    (e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t);
  }
  var Ba = !1;
  function Va() {
    if (Ba) {
      var e = oa;
      if (e !== null) throw e;
    }
  }
  function Ha(e, t, n, r) {
    Ba = !1;
    var i = e.updateQueue;
    Na = !1;
    var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
    if (s !== null) {
      i.shared.pending = null;
      var c = s, l = c.next;
      (c.next = null, o === null ? a = l : o.next = l, o = c);
      var u = e.alternate;
      u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
    }
    if (a !== null) {
      var d = i.baseState;
      (o = 0, u = l = c = null, s = a);
      do {
        var f = s.lane & -536870913, p = f !== s.lane;
        if (p ? (X & f) === f : (r & f) === f) {
          (f !== 0 && f === aa && (Ba = !0), u !== null && (u = u.next = {
            lane: 0,
            tag: s.tag,
            payload: s.payload,
            callback: null,
            next: null
          }));
          a: {
            var m = e, g = s;
            f = t;
            var _ = n;
            switch (g.tag) {
              case 1:
                if ((m = g.payload, typeof m == `function`)) {
                  d = m.call(_, d, f);
                  break a;
                }
                d = m;
                break a;
              case 3:
                m.flags = m.flags & -65537 | 128;
              case 0:
                if ((m = g.payload, f = typeof m == `function` ? m.call(_, d, f) : m, f == null)) break a;
                d = h({}, d, f);
                break a;
              case 2:
                Na = !0;
            }
          }
          (f = s.callback, f !== null && (e.flags |= 64, p && (e.flags |= 8192), p = i.callbacks, p === null ? i.callbacks = [f] : p.push(f)));
        } else (p = {
          lane: f,
          tag: s.tag,
          payload: s.payload,
          callback: s.callback,
          next: null
        }, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f);
        if ((s = s.next, s === null)) {
          if ((s = i.shared.pending, s === null)) break;
          (p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null);
        }
      } while (1);
      (u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Wl |= o, e.lanes = o, e.memoizedState = d);
    }
  }
  function Ua(e, t) {
    if (typeof e != `function`) throw Error(s(191, e));
    e.call(t);
  }
  function Wa(e, t) {
    var n = e.callbacks;
    if (n !== null) for ((e.callbacks = null, e = 0); e < n.length; e++) Ua(n[e], t);
  }
  var Ga = I(null), Ka = I(0);
  function qa(e, t) {
    (e = Hl, R(Ka, e), R(Ga, t), Hl = e | t.baseLanes);
  }
  function Ja() {
    (R(Ka, Hl), R(Ga, Ga.current));
  }
  function Ya() {
    (Hl = Ka.current, L(Ga), L(Ka));
  }
  var Xa = I(null), Za = null;
  function Qa(e) {
    var t = e.alternate;
    (R(ro, ro.current & 1), R(Xa, e), Za === null && (t === null || Ga.current !== null || t.memoizedState !== null) && (Za = e));
  }
  function $a(e) {
    (R(ro, ro.current), R(Xa, e), Za === null && (Za = e));
  }
  function eo(e) {
    e.tag === 22 ? (R(ro, ro.current), R(Xa, e), Za === null && (Za = e)) : to(e);
  }
  function to() {
    (R(ro, ro.current), R(Xa, Xa.current));
  }
  function no(e) {
    (L(Xa), Za === e && (Za = null), L(ro));
  }
  var ro = I(0);
  function io(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === 13) {
        var n = t.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || af(n) || of(n))) return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === `forwards` || t.memoizedProps.revealOrder === `backwards` || t.memoizedProps.revealOrder === `unstable_legacy-backwards` || t.memoizedProps.revealOrder === `together`)) {
        if (t.flags & 128) return t;
      } else if (t.child !== null) {
        (t.child.return = t, t = t.child);
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      (t.sibling.return = t.return, t = t.sibling);
    }
    return null;
  }
  var ao = 0, q = null, oo = null, so = null, co = !1, lo = !1, uo = !1, fo = 0, po = 0, mo = null, ho = 0;
  function go() {
    throw Error(s(321));
  }
  function _o(e, t) {
    if (t === null) return !1;
    for (var n = 0; n < t.length && n < e.length; n++) if (!hr(e[n], t[n])) return !1;
    return !0;
  }
  function vo(e, t, n, r, i, a) {
    return (ao = a, q = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, j.H = e === null || e.memoizedState === null ? Fs : Is, uo = !1, a = n(r, i), uo = !1, lo && (a = bo(t, n, r, i)), yo(e), a);
  }
  function yo(e) {
    j.H = Ps;
    var t = oo !== null && oo.next !== null;
    if ((ao = 0, so = oo = q = null, co = !1, po = 0, mo = null, t)) throw Error(s(300));
    e === null || $s || (e = e.dependencies, e !== null && Ki(e) && ($s = !0));
  }
  function bo(e, t, n, r) {
    q = e;
    var i = 0;
    do {
      if ((lo && (mo = null), po = 0, lo = !1, 25 <= i)) throw Error(s(301));
      if ((i += 1, so = oo = null, e.updateQueue != null)) {
        var a = e.updateQueue;
        (a.lastEffect = null, a.events = null, a.stores = null, a.memoCache != null && (a.memoCache.index = 0));
      }
      (j.H = Ls, a = t(n, r));
    } while (lo);
    return a;
  }
  function xo() {
    var e = j.H, t = e.useState()[0];
    return (t = typeof t.then == `function` ? Oo(t) : t, e = e.useState()[0], (oo === null ? null : oo.memoizedState) !== e && (q.flags |= 1024), t);
  }
  function So() {
    var e = fo !== 0;
    return (fo = 0, e);
  }
  function Co(e, t, n) {
    (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n);
  }
  function wo(e) {
    if (co) {
      for (e = e.memoizedState; e !== null; ) {
        var t = e.queue;
        (t !== null && (t.pending = null), e = e.next);
      }
      co = !1;
    }
    (ao = 0, so = oo = q = null, lo = !1, po = fo = 0, mo = null);
  }
  function To() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return (so === null ? q.memoizedState = so = e : so = so.next = e, so);
  }
  function Eo() {
    if (oo === null) {
      var e = q.alternate;
      e = e === null ? null : e.memoizedState;
    } else e = oo.next;
    var t = so === null ? q.memoizedState : so.next;
    if (t !== null) (so = t, oo = e); else {
      if (e === null) throw q.alternate === null ? Error(s(467)) : Error(s(310));
      (oo = e, e = {
        memoizedState: oo.memoizedState,
        baseState: oo.baseState,
        baseQueue: oo.baseQueue,
        queue: oo.queue,
        next: null
      }, so === null ? q.memoizedState = so = e : so = so.next = e);
    }
    return so;
  }
  function Do() {
    return {
      lastEffect: null,
      events: null,
      stores: null,
      memoCache: null
    };
  }
  function Oo(e) {
    var t = po;
    return (po += 1, mo === null && (mo = []), e = ba(mo, e, t), t = q, (so === null ? t.memoizedState : so.next) === null && (t = t.alternate, j.H = t === null || t.memoizedState === null ? Fs : Is), e);
  }
  function ko(e) {
    if (typeof e == `object` && e) {
      if (typeof e.then == `function`) return Oo(e);
      if (e.$$typeof === C) return Ji(e);
    }
    throw Error(s(438, String(e)));
  }
  function Ao(e) {
    var t = null, n = q.updateQueue;
    if ((n !== null && (t = n.memoCache), t == null)) {
      var r = q.alternate;
      r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
        data: r.data.map(function (e) {
          return e.slice();
        }),
        index: 0
      })));
    }
    if ((t ??= {
      data: [],
      index: 0
    }, n === null && (n = Do(), q.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0)) for ((n = t.data[t.index] = Array(e), r = 0); r < e; r++) n[r] = ee;
    return (t.index++, n);
  }
  function jo(e, t) {
    return typeof t == `function` ? t(e) : t;
  }
  function Mo(e) {
    return No(Eo(), oo, e);
  }
  function No(e, t, n) {
    var r = e.queue;
    if (r === null) throw Error(s(311));
    r.lastRenderedReducer = n;
    var i = e.baseQueue, a = r.pending;
    if (a !== null) {
      if (i !== null) {
        var o = i.next;
        (i.next = a.next, a.next = o);
      }
      (t.baseQueue = i = a, r.pending = null);
    }
    if ((a = e.baseState, i === null)) e.memoizedState = a; else {
      t = i.next;
      var c = o = null, l = null, u = t, d = !1;
      do {
        var f = u.lane & -536870913;
        if (f === u.lane ? (ao & f) === f : (X & f) === f) {
          var p = u.revertLane;
          if (p === 0) (l !== null && (l = l.next = {
            lane: 0,
            revertLane: 0,
            gesture: null,
            action: u.action,
            hasEagerState: u.hasEagerState,
            eagerState: u.eagerState,
            next: null
          }), f === aa && (d = !0)); else if ((ao & p) === p) {
            (u = u.next, p === aa && (d = !0));
            continue;
          } else (f = {
            lane: 0,
            revertLane: u.revertLane,
            gesture: null,
            action: u.action,
            hasEagerState: u.hasEagerState,
            eagerState: u.eagerState,
            next: null
          }, l === null ? (c = l = f, o = a) : l = l.next = f, q.lanes |= p, Wl |= p);
          (f = u.action, uo && n(a, f), a = u.hasEagerState ? u.eagerState : n(a, f));
        } else (p = {
          lane: f,
          revertLane: u.revertLane,
          gesture: u.gesture,
          action: u.action,
          hasEagerState: u.hasEagerState,
          eagerState: u.eagerState,
          next: null
        }, l === null ? (c = l = p, o = a) : l = l.next = p, q.lanes |= f, Wl |= f);
        u = u.next;
      } while (u !== null && u !== t);
      if ((l === null ? o = a : l.next = c, !hr(a, e.memoizedState) && ($s = !0, d && (n = oa, n !== null)))) throw n;
      (e.memoizedState = a, e.baseState = o, e.baseQueue = l, r.lastRenderedState = a);
    }
    return (i === null && (r.lanes = 0), [e.memoizedState, r.dispatch]);
  }
  function Po(e) {
    var t = Eo(), n = t.queue;
    if (n === null) throw Error(s(311));
    n.lastRenderedReducer = e;
    var r = n.dispatch, i = n.pending, a = t.memoizedState;
    if (i !== null) {
      n.pending = null;
      var o = i = i.next;
      do (a = e(a, o.action), o = o.next); while (o !== i);
      (hr(a, t.memoizedState) || ($s = !0), t.memoizedState = a, t.baseQueue === null && (t.baseState = a), n.lastRenderedState = a);
    }
    return [a, r];
  }
  function Fo(e, t, n) {
    var r = q, i = Eo(), a = K;
    if (a) {
      if (n === void 0) throw Error(s(407));
      n = n();
    } else n = t();
    var o = !hr((oo || i).memoizedState, n);
    if ((o && (i.memoizedState = n, $s = !0), i = i.queue, os(Ro.bind(null, r, i, e), [e]), i.getSnapshot !== t || o || so !== null && so.memoizedState.tag & 1)) {
      if ((r.flags |= 2048, ts(9, {
        destroy: void 0
      }, Lo.bind(null, r, i, n, t), null), Ll === null)) throw Error(s(349));
      a || ao & 127 || Io(r, t, n);
    }
    return n;
  }
  function Io(e, t, n) {
    (e.flags |= 16384, e = {
      getSnapshot: t,
      value: n
    }, t = q.updateQueue, t === null ? (t = Do(), q.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e)));
  }
  function Lo(e, t, n, r) {
    (t.value = n, t.getSnapshot = r, zo(t) && Bo(e));
  }
  function Ro(e, t, n) {
    return n(function () {
      zo(t) && Bo(e);
    });
  }
  function zo(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var n = t();
      return !hr(e, n);
    } catch {
      return !0;
    }
  }
  function Bo(e) {
    var t = Xr(e, 2);
    t !== null && mu(t, e, 2);
  }
  function Vo(e) {
    var t = To();
    if (typeof e == `function`) {
      var n = e;
      if ((e = n(), uo)) {
        Fe(!0);
        try {
          n();
        } finally {
          Fe(!1);
        }
      }
    }
    return (t.memoizedState = t.baseState = e, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: jo,
      lastRenderedState: e
    }, t);
  }
  function Ho(e, t, n, r) {
    return (e.baseState = n, No(e, oo, typeof r == `function` ? r : jo));
  }
  function Uo(e, t, n, r, i) {
    if (js(e)) throw Error(s(485));
    if ((e = t.action, e !== null)) {
      var a = {
        payload: i,
        action: e,
        next: null,
        isTransition: !0,
        status: `pending`,
        value: null,
        reason: null,
        listeners: [],
        then: function (e) {
          a.listeners.push(e);
        }
      };
      (j.T === null ? a.isTransition = !1 : n(!0), r(a), n = t.pending, n === null ? (a.next = t.pending = a, Wo(t, a)) : (a.next = n.next, t.pending = n.next = a));
    }
  }
  function Wo(e, t) {
    var n = t.action, r = t.payload, i = e.state;
    if (t.isTransition) {
      var a = j.T, o = {};
      j.T = o;
      try {
        var s = n(i, r), c = j.S;
        (c !== null && c(o, s), Go(e, t, s));
      } catch (n) {
        qo(e, t, n);
      } finally {
        (a !== null && o.types !== null && (a.types = o.types), j.T = a);
      }
    } else try {
      (a = n(i, r), Go(e, t, a));
    } catch (n) {
      qo(e, t, n);
    }
  }
  function Go(e, t, n) {
    typeof n == `object` && n && typeof n.then == `function` ? n.then(function (n) {
      Ko(e, t, n);
    }, function (n) {
      return qo(e, t, n);
    }) : Ko(e, t, n);
  }
  function Ko(e, t, n) {
    (t.status = `fulfilled`, t.value = n, Jo(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Wo(e, n))));
  }
  function qo(e, t, n) {
    var r = e.pending;
    if ((e.pending = null, r !== null)) {
      r = r.next;
      do (t.status = `rejected`, t.reason = n, Jo(t), t = t.next); while (t !== r);
    }
    e.action = null;
  }
  function Jo(e) {
    e = e.listeners;
    for (var t = 0; t < e.length; t++) (0, e[t])();
  }
  function Yo(e, t) {
    return t;
  }
  function Xo(e, t) {
    if (K) {
      var n = Ll.formState;
      if (n !== null) {
        a: {
          var r = q;
          if (K) {
            if (Di) {
              b: {
                for (var i = Di, a = ki; i.nodeType !== 8; ) {
                  if (!a) {
                    i = null;
                    break b;
                  }
                  if ((i = cf(i.nextSibling), i === null)) {
                    i = null;
                    break b;
                  }
                }
                (a = i.data, i = a === `F!` || a === `F` ? i : null);
              }
              if (i) {
                (Di = cf(i.nextSibling), r = i.data === `F!`);
                break a;
              }
            }
            ji(r);
          }
          r = !1;
        }
        r && (t = n[0]);
      }
    }
    return (n = To(), n.memoizedState = n.baseState = t, r = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Yo,
      lastRenderedState: t
    }, n.queue = r, n = Os.bind(null, q, r), r.dispatch = n, r = Vo(!1), a = As.bind(null, q, !1, r.queue), r = To(), i = {
      state: t,
      dispatch: null,
      action: e,
      pending: null
    }, r.queue = i, n = Uo.bind(null, q, i, a, n), i.dispatch = n, r.memoizedState = e, [t, n, !1]);
  }
  function Zo(e) {
    return Qo(Eo(), oo, e);
  }
  function Qo(e, t, n) {
    if ((t = No(e, t, Yo)[0], e = Mo(jo)[0], typeof t == `object` && t && typeof t.then == `function`)) try {
      var r = Oo(t);
    } catch (e) {
      throw e === ha ? _a : e;
    } else r = t;
    t = Eo();
    var i = t.queue, a = i.dispatch;
    return (n !== t.memoizedState && (q.flags |= 2048, ts(9, {
      destroy: void 0
    }, $o.bind(null, i, n), null)), [r, a, e]);
  }
  function $o(e, t) {
    e.action = t;
  }
  function es(e) {
    var t = Eo(), n = oo;
    if (n !== null) return Qo(t, n, e);
    (Eo(), t = t.memoizedState, n = Eo());
    var r = n.queue.dispatch;
    return (n.memoizedState = e, [t, r, !1]);
  }
  function ts(e, t, n, r) {
    return (e = {
      tag: e,
      create: n,
      deps: r,
      inst: t,
      next: null
    }, t = q.updateQueue, t === null && (t = Do(), q.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e);
  }
  function ns() {
    return Eo().memoizedState;
  }
  function rs(e, t, n, r) {
    var i = To();
    (q.flags |= e, i.memoizedState = ts(1 | t, {
      destroy: void 0
    }, n, r === void 0 ? null : r));
  }
  function is(e, t, n, r) {
    var i = Eo();
    r = r === void 0 ? null : r;
    var a = i.memoizedState.inst;
    oo !== null && r !== null && _o(r, oo.memoizedState.deps) ? i.memoizedState = ts(t, a, n, r) : (q.flags |= e, i.memoizedState = ts(1 | t, a, n, r));
  }
  function as(e, t) {
    rs(8390656, 8, e, t);
  }
  function os(e, t) {
    is(2048, 8, e, t);
  }
  function ss(e) {
    q.flags |= 4;
    var t = q.updateQueue;
    if (t === null) (t = Do(), q.updateQueue = t, t.events = [e]); else {
      var n = t.events;
      n === null ? t.events = [e] : n.push(e);
    }
  }
  function cs(e) {
    var t = Eo().memoizedState;
    return (ss({
      ref: t,
      nextImpl: e
    }), function () {
      if (J & 2) throw Error(s(440));
      return t.impl.apply(void 0, arguments);
    });
  }
  function ls(e, t) {
    return is(4, 2, e, t);
  }
  function us(e, t) {
    return is(4, 4, e, t);
  }
  function ds(e, t) {
    if (typeof t == `function`) {
      e = e();
      var n = t(e);
      return function () {
        typeof n == `function` ? n() : t(null);
      };
    }
    if (t != null) return (e = e(), t.current = e, function () {
      t.current = null;
    });
  }
  function fs(e, t, n) {
    (n = n == null ? null : n.concat([e]), is(4, 4, ds.bind(null, t, e), n));
  }
  function ps() {}
  function ms(e, t) {
    var n = Eo();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    return t !== null && _o(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
  }
  function hs(e, t) {
    var n = Eo();
    t = t === void 0 ? null : t;
    var r = n.memoizedState;
    if (t !== null && _o(t, r[1])) return r[0];
    if ((r = e(), uo)) {
      Fe(!0);
      try {
        e();
      } finally {
        Fe(!1);
      }
    }
    return (n.memoizedState = [r, t], r);
  }
  function gs(e, t, n) {
    return n === void 0 || ao & 1073741824 && !(X & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = pu(), q.lanes |= e, Wl |= e, n);
  }
  function _s(e, t, n, r) {
    return hr(n, t) ? n : Ga.current === null ? !(ao & 42) || ao & 1073741824 && !(X & 261930) ? ($s = !0, e.memoizedState = n) : (e = pu(), q.lanes |= e, Wl |= e, t) : (e = gs(e, n, r), hr(e, t) || ($s = !0), e);
  }
  function vs(e, t, n, r, i) {
    var a = M.p;
    M.p = a !== 0 && 8 > a ? a : 8;
    var o = j.T, s = {};
    (j.T = s, As(e, !1, t, n));
    try {
      var c = i(), l = j.S;
      (l !== null && l(s, c), typeof c == `object` && c && typeof c.then == `function` ? ks(e, t, la(c, r), fu(e)) : ks(e, t, r, fu(e)));
    } catch (n) {
      ks(e, t, {
        then: function () {},
        status: `rejected`,
        reason: n
      }, fu());
    } finally {
      (M.p = a, o !== null && s.types !== null && (o.types = s.types), j.T = o);
    }
  }
  function ys() {}
  function bs(e, t, n, r) {
    if (e.tag !== 5) throw Error(s(476));
    var i = xs(e).queue;
    vs(e, i, t, N, n === null ? ys : function () {
      return (Ss(e), n(r));
    });
  }
  function xs(e) {
    var t = e.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: N,
      baseState: N,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: jo,
        lastRenderedState: N
      },
      next: null
    };
    var n = {};
    return (t.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: jo,
        lastRenderedState: n
      },
      next: null
    }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t);
  }
  function Ss(e) {
    var t = xs(e);
    (t.next === null && (t = e.alternate.memoizedState), ks(e, t.next.queue, {}, fu()));
  }
  function Cs() {
    return Ji(Qf);
  }
  function ws() {
    return Eo().memoizedState;
  }
  function Ts() {
    return Eo().memoizedState;
  }
  function Es(e) {
    for (var t = e.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var n = fu();
          e = Ia(n);
          var r = La(t, e, n);
          (r !== null && (mu(r, t, n), Ra(r, t, n)), t = {
            cache: ta()
          }, e.payload = t);
          return;
      }
      t = t.return;
    }
  }
  function Ds(e, t, n) {
    var r = fu();
    (n = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, js(e) ? Ms(t, n) : (n = Yr(e, t, n, r), n !== null && (mu(n, e, r), Ns(n, t, r))));
  }
  function Os(e, t, n) {
    ks(e, t, n, fu());
  }
  function ks(e, t, n, r) {
    var i = {
      lane: r,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (js(e)) Ms(t, i); else {
      var a = e.alternate;
      if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
        var o = t.lastRenderedState, s = a(o, n);
        if ((i.hasEagerState = !0, i.eagerState = s, hr(s, o))) return (Jr(e, t, i, 0), Ll === null && qr(), !1);
      } catch {}
      if ((n = Yr(e, t, i, r), n !== null)) return (mu(n, e, r), Ns(n, t, r), !0);
    }
    return !1;
  }
  function As(e, t, n, r) {
    if ((r = {
      lane: 2,
      revertLane: ud(),
      gesture: null,
      action: r,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, js(e))) {
      if (t) throw Error(s(479));
    } else (t = Yr(e, n, r, 2), t !== null && mu(t, e, 2));
  }
  function js(e) {
    var t = e.alternate;
    return e === q || t !== null && t === q;
  }
  function Ms(e, t) {
    lo = co = !0;
    var n = e.pending;
    (n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t);
  }
  function Ns(e, t, n) {
    if (n & 4194048) {
      var r = t.lanes;
      (r &= e.pendingLanes, n |= r, t.lanes = n, Ze(e, n));
    }
  }
  var Ps = {
    readContext: Ji,
    use: ko,
    useCallback: go,
    useContext: go,
    useEffect: go,
    useImperativeHandle: go,
    useLayoutEffect: go,
    useInsertionEffect: go,
    useMemo: go,
    useReducer: go,
    useRef: go,
    useState: go,
    useDebugValue: go,
    useDeferredValue: go,
    useTransition: go,
    useSyncExternalStore: go,
    useId: go,
    useHostTransitionStatus: go,
    useFormState: go,
    useActionState: go,
    useOptimistic: go,
    useMemoCache: go,
    useCacheRefresh: go
  };
  Ps.useEffectEvent = go;
  var Fs = {
    readContext: Ji,
    use: ko,
    useCallback: function (e, t) {
      return (To().memoizedState = [e, t === void 0 ? null : t], e);
    },
    useContext: Ji,
    useEffect: as,
    useImperativeHandle: function (e, t, n) {
      (n = n == null ? null : n.concat([e]), rs(4194308, 4, ds.bind(null, t, e), n));
    },
    useLayoutEffect: function (e, t) {
      return rs(4194308, 4, e, t);
    },
    useInsertionEffect: function (e, t) {
      rs(4, 2, e, t);
    },
    useMemo: function (e, t) {
      var n = To();
      t = t === void 0 ? null : t;
      var r = e();
      if (uo) {
        Fe(!0);
        try {
          e();
        } finally {
          Fe(!1);
        }
      }
      return (n.memoizedState = [r, t], r);
    },
    useReducer: function (e, t, n) {
      var r = To();
      if (n !== void 0) {
        var i = n(t);
        if (uo) {
          Fe(!0);
          try {
            n(t);
          } finally {
            Fe(!1);
          }
        }
      } else i = t;
      return (r.memoizedState = r.baseState = i, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: i
      }, r.queue = e, e = e.dispatch = Ds.bind(null, q, e), [r.memoizedState, e]);
    },
    useRef: function (e) {
      var t = To();
      return (e = {
        current: e
      }, t.memoizedState = e);
    },
    useState: function (e) {
      e = Vo(e);
      var t = e.queue, n = Os.bind(null, q, t);
      return (t.dispatch = n, [e.memoizedState, n]);
    },
    useDebugValue: ps,
    useDeferredValue: function (e, t) {
      return gs(To(), e, t);
    },
    useTransition: function () {
      var e = Vo(!1);
      return (e = vs.bind(null, q, e.queue, !0, !1), To().memoizedState = e, [!1, e]);
    },
    useSyncExternalStore: function (e, t, n) {
      var r = q, i = To();
      if (K) {
        if (n === void 0) throw Error(s(407));
        n = n();
      } else {
        if ((n = t(), Ll === null)) throw Error(s(349));
        X & 127 || Io(r, t, n);
      }
      i.memoizedState = n;
      var a = {
        value: n,
        getSnapshot: t
      };
      return (i.queue = a, as(Ro.bind(null, r, a, e), [e]), r.flags |= 2048, ts(9, {
        destroy: void 0
      }, Lo.bind(null, r, a, n, t), null), n);
    },
    useId: function () {
      var e = To(), t = Ll.identifierPrefix;
      if (K) {
        var n = bi, r = yi;
        (n = (r & ~(1 << 32 - Ie(r) - 1)).toString(32) + n, t = `_` + t + `R_` + n, n = fo++, 0 < n && (t += `H` + n.toString(32)), t += `_`);
      } else (n = ho++, t = `_` + t + `r_` + n.toString(32) + `_`);
      return e.memoizedState = t;
    },
    useHostTransitionStatus: Cs,
    useFormState: Xo,
    useActionState: Xo,
    useOptimistic: function (e) {
      var t = To();
      t.memoizedState = t.baseState = e;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return (t.queue = n, t = As.bind(null, q, !0, n), n.dispatch = t, [e, t]);
    },
    useMemoCache: Ao,
    useCacheRefresh: function () {
      return To().memoizedState = Es.bind(null, q);
    },
    useEffectEvent: function (e) {
      var t = To(), n = {
        impl: e
      };
      return (t.memoizedState = n, function () {
        if (J & 2) throw Error(s(440));
        return n.impl.apply(void 0, arguments);
      });
    }
  }, Is = {
    readContext: Ji,
    use: ko,
    useCallback: ms,
    useContext: Ji,
    useEffect: os,
    useImperativeHandle: fs,
    useInsertionEffect: ls,
    useLayoutEffect: us,
    useMemo: hs,
    useReducer: Mo,
    useRef: ns,
    useState: function () {
      return Mo(jo);
    },
    useDebugValue: ps,
    useDeferredValue: function (e, t) {
      return _s(Eo(), oo.memoizedState, e, t);
    },
    useTransition: function () {
      var e = Mo(jo)[0], t = Eo().memoizedState;
      return [typeof e == `boolean` ? e : Oo(e), t];
    },
    useSyncExternalStore: Fo,
    useId: ws,
    useHostTransitionStatus: Cs,
    useFormState: Zo,
    useActionState: Zo,
    useOptimistic: function (e, t) {
      return Ho(Eo(), oo, e, t);
    },
    useMemoCache: Ao,
    useCacheRefresh: Ts
  };
  Is.useEffectEvent = cs;
  var Ls = {
    readContext: Ji,
    use: ko,
    useCallback: ms,
    useContext: Ji,
    useEffect: os,
    useImperativeHandle: fs,
    useInsertionEffect: ls,
    useLayoutEffect: us,
    useMemo: hs,
    useReducer: Po,
    useRef: ns,
    useState: function () {
      return Po(jo);
    },
    useDebugValue: ps,
    useDeferredValue: function (e, t) {
      var n = Eo();
      return oo === null ? gs(n, e, t) : _s(n, oo.memoizedState, e, t);
    },
    useTransition: function () {
      var e = Po(jo)[0], t = Eo().memoizedState;
      return [typeof e == `boolean` ? e : Oo(e), t];
    },
    useSyncExternalStore: Fo,
    useId: ws,
    useHostTransitionStatus: Cs,
    useFormState: es,
    useActionState: es,
    useOptimistic: function (e, t) {
      var n = Eo();
      return oo === null ? (n.baseState = e, [e, n.queue.dispatch]) : Ho(n, oo, e, t);
    },
    useMemoCache: Ao,
    useCacheRefresh: Ts
  };
  Ls.useEffectEvent = cs;
  function Rs(e, t, n, r) {
    (t = e.memoizedState, n = n(r, t), n = n == null ? t : h({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n));
  }
  var zs = {
    enqueueSetState: function (e, t, n) {
      e = e._reactInternals;
      var r = fu(), i = Ia(r);
      (i.payload = t, n != null && (i.callback = n), t = La(e, i, r), t !== null && (mu(t, e, r), Ra(t, e, r)));
    },
    enqueueReplaceState: function (e, t, n) {
      e = e._reactInternals;
      var r = fu(), i = Ia(r);
      (i.tag = 1, i.payload = t, n != null && (i.callback = n), t = La(e, i, r), t !== null && (mu(t, e, r), Ra(t, e, r)));
    },
    enqueueForceUpdate: function (e, t) {
      e = e._reactInternals;
      var n = fu(), r = Ia(n);
      (r.tag = 2, t != null && (r.callback = t), t = La(e, r, n), t !== null && (mu(t, e, n), Ra(t, e, n)));
    }
  };
  function Bs(e, t, n, r, i, a, o) {
    return (e = e.stateNode, typeof e.shouldComponentUpdate == `function` ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !gr(n, r) || !gr(i, a) : !0);
  }
  function Vs(e, t, n, r) {
    (e = t.state, typeof t.componentWillReceiveProps == `function` && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == `function` && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && zs.enqueueReplaceState(t, t.state, null));
  }
  function Hs(e, t) {
    var n = t;
    if ((`ref` in t)) for (var r in (n = {}, t)) r !== `ref` && (n[r] = t[r]);
    if (e = e.defaultProps) for (var i in (n === t && (n = h({}, n)), e)) n[i] === void 0 && (n[i] = e[i]);
    return n;
  }
  function Us(e) {
    Ur(e);
  }
  function Ws(e) {
    console.error(e);
  }
  function Gs(e) {
    Ur(e);
  }
  function Ks(e, t) {
    try {
      var n = e.onUncaughtError;
      n(t.value, {
        componentStack: t.stack
      });
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function qs(e, t, n) {
    try {
      var r = e.onCaughtError;
      r(n.value, {
        componentStack: n.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function Js(e, t, n) {
    return (n = Ia(n), n.tag = 3, n.payload = {
      element: null
    }, n.callback = function () {
      Ks(e, t);
    }, n);
  }
  function Ys(e) {
    return (e = Ia(e), e.tag = 3, e);
  }
  function Xs(e, t, n, r) {
    var i = n.type.getDerivedStateFromError;
    if (typeof i == `function`) {
      var a = r.value;
      (e.payload = function () {
        return i(a);
      }, e.callback = function () {
        qs(t, n, r);
      });
    }
    var o = n.stateNode;
    o !== null && typeof o.componentDidCatch == `function` && (e.callback = function () {
      (qs(t, n, r), typeof i != `function` && (nu === null ? nu = new Set([this]) : nu.add(this)));
      var e = r.stack;
      this.componentDidCatch(r.value, {
        componentStack: e === null ? `` : e
      });
    });
  }
  function Zs(e, t, n, r, i) {
    if ((n.flags |= 32768, typeof r == `object` && r && typeof r.then == `function`)) {
      if ((t = n.alternate, t !== null && Gi(t, n, i, !0), n = Xa.current, n !== null)) {
        switch (n.tag) {
          case 31:
          case 13:
            return (Za === null ? Eu() : n.alternate === null && Ul === 0 && (Ul = 3), n.flags &= -257, n.flags |= 65536, n.lanes = i, r === va ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Wu(e, r, i)), !1);
          case 22:
            return (n.flags |= 65536, r === va ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: new Set([r])
            }, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Wu(e, r, i)), !1);
        }
        throw Error(s(435, n.tag));
      }
      return (Wu(e, r, i), Eu(), !1);
    }
    if (K) return (t = Xa.current, t === null ? (r !== Ai && (t = Error(s(423), {
      cause: r
    }), Li(di(t, n))), e = e.current.alternate, e.flags |= 65536, i &= -i, e.lanes |= i, r = di(r, n), i = Js(e.stateNode, r, i), za(e, i), Ul !== 4 && (Ul = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = i, r !== Ai && (e = Error(s(422), {
      cause: r
    }), Li(di(e, n)))), !1);
    var a = Error(s(520), {
      cause: r
    });
    if ((a = di(a, n), Yl === null ? Yl = [a] : Yl.push(a), Ul !== 4 && (Ul = 2), t === null)) return !0;
    (r = di(r, n), n = t);
    do {
      switch (n.tag) {
        case 3:
          return (n.flags |= 65536, e = i & -i, n.lanes |= e, e = Js(n.stateNode, r, e), za(n, e), !1);
        case 1:
          if ((t = n.type, a = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == `function` || a !== null && typeof a.componentDidCatch == `function` && (nu === null || !nu.has(a))))) return (n.flags |= 65536, i &= -i, n.lanes |= i, i = Ys(i), Xs(i, e, n, r), za(n, i), !1);
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var Qs = Error(s(461)), $s = !1;
  function ec(e, t, n, r) {
    t.child = e === null ? Ma(t, null, n, r) : ja(t, e.child, n, r);
  }
  function tc(e, t, n, r, i) {
    n = n.render;
    var a = t.ref;
    if ((`ref` in r)) {
      var o = {};
      for (var s in r) s !== `ref` && (o[s] = r[s]);
    } else o = r;
    return (qi(t), r = vo(e, t, n, o, a, i), s = So(), e !== null && !$s ? (Co(e, t, i), Tc(e, t, i)) : (K && s && Ci(t), t.flags |= 1, ec(e, t, r, i), t.child));
  }
  function nc(e, t, n, r, i) {
    if (e === null) {
      var a = n.type;
      return typeof a == `function` && !ni(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, rc(e, t, a, r, i)) : (e = ai(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
    }
    if ((a = e.child, !Ec(e, i))) {
      var o = a.memoizedProps;
      if ((n = n.compare, n = n === null ? gr : n, n(o, r) && e.ref === t.ref)) return Tc(e, t, i);
    }
    return (t.flags |= 1, e = ri(a, r), e.ref = t.ref, e.return = t, t.child = e);
  }
  function rc(e, t, n, r, i) {
    if (e !== null) {
      var a = e.memoizedProps;
      if (gr(a, r) && e.ref === t.ref) {
        if (($s = !1, t.pendingProps = r = a, Ec(e, i))) e.flags & 131072 && ($s = !0); else return (t.lanes = e.lanes, Tc(e, t, i));
      }
    }
    return dc(e, t, n, r, i);
  }
  function ic(e, t, n, r) {
    var i = r.children, a = e === null ? null : e.memoizedState;
    if ((e === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), r.mode === `hidden`)) {
      if (t.flags & 128) {
        if ((a = a === null ? n : a.baseLanes | n, e !== null)) {
          for ((r = t.child = e.child, i = 0); r !== null; ) (i = i | r.lanes | r.childLanes, r = r.sibling);
          r = i & ~a;
        } else (r = 0, t.child = null);
        return oc(e, t, a, n, r);
      }
      if (n & 536870912) (t.memoizedState = {
        baseLanes: 0,
        cachePool: null
      }, e !== null && pa(t, a === null ? null : a.cachePool), a === null ? Ja() : qa(t, a), eo(t)); else return (r = t.lanes = 536870912, oc(e, t, a === null ? n : a.baseLanes | n, n, r));
    } else a === null ? (e !== null && pa(t, null), Ja(), to(t)) : (pa(t, a.cachePool), qa(t, a), to(t), t.memoizedState = null);
    return (ec(e, t, i, n), t.child);
  }
  function ac(e, t) {
    return (e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling);
  }
  function oc(e, t, n, r, i) {
    var a = fa();
    return (a = a === null ? null : {
      parent: ea._currentValue,
      pool: a
    }, t.memoizedState = {
      baseLanes: n,
      cachePool: a
    }, e !== null && pa(t, null), Ja(), eo(t), e !== null && Gi(e, t, r, !0), t.childLanes = i, null);
  }
  function sc(e, t) {
    return (t = bc({
      mode: t.mode,
      children: t.children
    }, e.mode), t.ref = e.ref, e.child = t, t.return = e, t);
  }
  function cc(e, t, n) {
    return (ja(t, e.child, null, n), e = sc(t, t.pendingProps), e.flags |= 2, no(t), t.memoizedState = null, e);
  }
  function lc(e, t, n) {
    var r = t.pendingProps, i = !!(t.flags & 128);
    if ((t.flags &= -129, e === null)) {
      if (K) {
        if (r.mode === `hidden`) return (e = sc(t, r), t.lanes = 536870912, ac(null, e));
        if (($a(t), (e = Di) ? (e = rf(e, ki), e = e !== null && e.data === `&` ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: vi === null ? null : {
            id: yi,
            overflow: bi
          },
          retryLane: 536870912,
          hydrationErrors: null
        }, n = ci(e), n.return = t, t.child = n, Ei = t, Di = null)) : e = null, e === null)) throw ji(t);
        return (t.lanes = 536870912, null);
      }
      return sc(t, r);
    }
    var a = e.memoizedState;
    if (a !== null) {
      var o = a.dehydrated;
      if (($a(t), i)) {
        if (t.flags & 256) (t.flags &= -257, t = cc(e, t, n)); else if (t.memoizedState !== null) (t.child = e.child, t.flags |= 128, t = null); else throw Error(s(558));
      } else if (($s || Gi(e, t, n, !1), i = (n & e.childLanes) !== 0, $s || i)) {
        if ((r = Ll, r !== null && (o = Qe(r, n), o !== 0 && o !== a.retryLane))) throw (a.retryLane = o, Xr(e, o), mu(r, e, o), Qs);
        (Eu(), t = cc(e, t, n));
      } else (e = a.treeContext, Di = cf(o.nextSibling), Ei = t, K = !0, Oi = null, ki = !1, e !== null && Ti(t, e), t = sc(t, r), t.flags |= 4096);
      return t;
    }
    return (e = ri(e.child, {
      mode: r.mode,
      children: r.children
    }), e.ref = t.ref, t.child = e, e.return = t, e);
  }
  function uc(e, t) {
    var n = t.ref;
    if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816); else {
      if (typeof n != `function` && typeof n != `object`) throw Error(s(284));
      (e === null || e.ref !== n) && (t.flags |= 4194816);
    }
  }
  function dc(e, t, n, r, i) {
    return (qi(t), n = vo(e, t, n, r, void 0, i), r = So(), e !== null && !$s ? (Co(e, t, i), Tc(e, t, i)) : (K && r && Ci(t), t.flags |= 1, ec(e, t, n, i), t.child));
  }
  function fc(e, t, n, r, i, a) {
    return (qi(t), t.updateQueue = null, n = bo(t, r, n, i), yo(e), r = So(), e !== null && !$s ? (Co(e, t, a), Tc(e, t, a)) : (K && r && Ci(t), t.flags |= 1, ec(e, t, n, a), t.child));
  }
  function pc(e, t, n, r, i) {
    if ((qi(t), t.stateNode === null)) {
      var a = $r, o = n.contextType;
      (typeof o == `object` && o && (a = Ji(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = zs, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Pa(t), o = n.contextType, a.context = typeof o == `object` && o ? Ji(o) : $r, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == `function` && (Rs(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == `function` || typeof a.getSnapshotBeforeUpdate == `function` || typeof a.UNSAFE_componentWillMount != `function` && typeof a.componentWillMount != `function` || (o = a.state, typeof a.componentWillMount == `function` && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == `function` && a.UNSAFE_componentWillMount(), o !== a.state && zs.enqueueReplaceState(a, a.state, null), Ha(t, r, a, i), Va(), a.state = t.memoizedState), typeof a.componentDidMount == `function` && (t.flags |= 4194308), r = !0);
    } else if (e === null) {
      a = t.stateNode;
      var s = t.memoizedProps, c = Hs(n, s);
      a.props = c;
      var l = a.context, u = n.contextType;
      (o = $r, typeof u == `object` && u && (o = Ji(u)));
      var d = n.getDerivedStateFromProps;
      (u = typeof d == `function` || typeof a.getSnapshotBeforeUpdate == `function`, s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != `function` && typeof a.componentWillReceiveProps != `function` || (s || l !== o) && Vs(t, a, r, o), Na = !1);
      var f = t.memoizedState;
      (a.state = f, Ha(t, r, a, i), Va(), l = t.memoizedState, s || f !== l || Na ? (typeof d == `function` && (Rs(t, n, d, r), l = t.memoizedState), (c = Na || Bs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != `function` && typeof a.componentWillMount != `function` || (typeof a.componentWillMount == `function` && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == `function` && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == `function` && (t.flags |= 4194308)) : (typeof a.componentDidMount == `function` && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == `function` && (t.flags |= 4194308), r = !1));
    } else {
      (a = t.stateNode, Fa(e, t), o = t.memoizedProps, u = Hs(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = $r, typeof l == `object` && l && (c = Ji(l)), s = n.getDerivedStateFromProps, (l = typeof s == `function` || typeof a.getSnapshotBeforeUpdate == `function`) || typeof a.UNSAFE_componentWillReceiveProps != `function` && typeof a.componentWillReceiveProps != `function` || (o !== d || f !== c) && Vs(t, a, r, c), Na = !1, f = t.memoizedState, a.state = f, Ha(t, r, a, i), Va());
      var p = t.memoizedState;
      o !== d || f !== p || Na || e !== null && e.dependencies !== null && Ki(e.dependencies) ? (typeof s == `function` && (Rs(t, n, s, r), p = t.memoizedState), (u = Na || Bs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && Ki(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != `function` && typeof a.componentWillUpdate != `function` || (typeof a.componentWillUpdate == `function` && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == `function` && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == `function` && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == `function` && (t.flags |= 1024)) : (typeof a.componentDidUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != `function` || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
    }
    return (a = r, uc(e, t), r = !!(t.flags & 128), a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != `function` ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = ja(t, e.child, null, i), t.child = ja(t, null, n, i)) : ec(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Tc(e, t, i), e);
  }
  function mc(e, t, n, r) {
    return (Fi(), t.flags |= 256, ec(e, t, n, r), t.child);
  }
  var hc = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function gc(e) {
    return {
      baseLanes: e,
      cachePool: ma()
    };
  }
  function _c(e, t, n) {
    return (e = e === null ? 0 : e.childLanes & ~n, t && (e |= ql), e);
  }
  function vc(e, t, n) {
    var r = t.pendingProps, i = !1, a = !!(t.flags & 128), o;
    if (((o = a) || (o = e !== null && e.memoizedState === null ? !1 : !!(ro.current & 2)), o && (i = !0, t.flags &= -129), o = !!(t.flags & 32), t.flags &= -33, e === null)) {
      if (K) {
        if ((i ? Qa(t) : to(t), (e = Di) ? (e = rf(e, ki), e = e !== null && e.data !== `&` ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: vi === null ? null : {
            id: yi,
            overflow: bi
          },
          retryLane: 536870912,
          hydrationErrors: null
        }, n = ci(e), n.return = t, t.child = n, Ei = t, Di = null)) : e = null, e === null)) throw ji(t);
        return (of(e) ? t.lanes = 32 : t.lanes = 536870912, null);
      }
      var c = r.children;
      return (r = r.fallback, i ? (to(t), i = t.mode, c = bc({
        mode: `hidden`,
        children: c
      }, i), r = oi(r, i, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = gc(n), r.childLanes = _c(e, o, n), t.memoizedState = hc, ac(null, r)) : (Qa(t), yc(t, c)));
    }
    var l = e.memoizedState;
    if (l !== null && (c = l.dehydrated, c !== null)) {
      if (a) t.flags & 256 ? (Qa(t), t.flags &= -257, t = xc(e, t, n)) : t.memoizedState === null ? (to(t), c = r.fallback, i = t.mode, r = bc({
        mode: `visible`,
        children: r.children
      }, i), c = oi(c, i, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, ja(t, e.child, null, n), r = t.child, r.memoizedState = gc(n), r.childLanes = _c(e, o, n), t.memoizedState = hc, t = ac(null, r)) : (to(t), t.child = e.child, t.flags |= 128, t = null); else if ((Qa(t), of(c))) {
        if ((o = c.nextSibling && c.nextSibling.dataset, o)) var u = o.dgst;
        (o = u, r = Error(s(419)), r.stack = ``, r.digest = o, Li({
          value: r,
          source: null,
          stack: null
        }), t = xc(e, t, n));
      } else if (($s || Gi(e, t, n, !1), o = (n & e.childLanes) !== 0, $s || o)) {
        if ((o = Ll, o !== null && (r = Qe(o, n), r !== 0 && r !== l.retryLane))) throw (l.retryLane = r, Xr(e, r), mu(o, e, r), Qs);
        (af(c) || Eu(), t = xc(e, t, n));
      } else af(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, Di = cf(c.nextSibling), Ei = t, K = !0, Oi = null, ki = !1, e !== null && Ti(t, e), t = yc(t, r.children), t.flags |= 4096);
      return t;
    }
    return i ? (to(t), c = r.fallback, i = t.mode, l = e.child, u = l.sibling, r = ri(l, {
      mode: `hidden`,
      children: r.children
    }), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = oi(c, i, n, null), c.flags |= 2) : c = ri(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, ac(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = gc(n) : (i = c.cachePool, i === null ? i = ma() : (l = ea._currentValue, i = i.parent === l ? i : {
      parent: l,
      pool: l
    }), c = {
      baseLanes: c.baseLanes | n,
      cachePool: i
    }), r.memoizedState = c, r.childLanes = _c(e, o, n), t.memoizedState = hc, ac(e.child, r)) : (Qa(t), n = e.child, e = n.sibling, n = ri(n, {
      mode: `visible`,
      children: r.children
    }), n.return = t, n.sibling = null, e !== null && (o = t.deletions, o === null ? (t.deletions = [e], t.flags |= 16) : o.push(e)), t.child = n, t.memoizedState = null, n);
  }
  function yc(e, t) {
    return (t = bc({
      mode: `visible`,
      children: t
    }, e.mode), t.return = e, e.child = t);
  }
  function bc(e, t) {
    return (e = ti(22, e, null, t), e.lanes = 0, e);
  }
  function xc(e, t, n) {
    return (ja(t, e.child, null, n), e = yc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e);
  }
  function Sc(e, t, n) {
    e.lanes |= t;
    var r = e.alternate;
    (r !== null && (r.lanes |= t), Ui(e.return, t, n));
  }
  function Cc(e, t, n, r, i, a) {
    var o = e.memoizedState;
    o === null ? e.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: r,
      tail: n,
      tailMode: i,
      treeForkCount: a
    } : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
  }
  function wc(e, t, n) {
    var r = t.pendingProps, i = r.revealOrder, a = r.tail;
    r = r.children;
    var o = ro.current, s = !!(o & 2);
    if ((s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, R(ro, o), ec(e, t, r, n), r = K ? hi : 0, !s && e !== null && e.flags & 128)) a: for (e = t.child; e !== null; ) {
      if (e.tag === 13) e.memoizedState !== null && Sc(e, n, t); else if (e.tag === 19) Sc(e, n, t); else if (e.child !== null) {
        (e.child.return = e, e = e.child);
        continue;
      }
      if (e === t) break a;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) break a;
        e = e.return;
      }
      (e.sibling.return = e.return, e = e.sibling);
    }
    switch (i) {
      case `forwards`:
        for ((n = t.child, i = null); n !== null; ) (e = n.alternate, e !== null && io(e) === null && (i = n), n = n.sibling);
        (n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Cc(t, !1, i, n, a, r));
        break;
      case `backwards`:
      case `unstable_legacy-backwards`:
        for ((n = null, i = t.child, t.child = null); i !== null; ) {
          if ((e = i.alternate, e !== null && io(e) === null)) {
            t.child = i;
            break;
          }
          (e = i.sibling, i.sibling = n, n = i, i = e);
        }
        Cc(t, !0, n, null, a, r);
        break;
      case `together`:
        Cc(t, !1, null, null, void 0, r);
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function Tc(e, t, n) {
    if ((e !== null && (t.dependencies = e.dependencies), Wl |= t.lanes, (n & t.childLanes) === 0)) {
      if (e !== null) {
        if ((Gi(e, t, n, !1), (n & t.childLanes) === 0)) return null;
      } else return null;
    }
    if (e !== null && t.child !== e.child) throw Error(s(153));
    if (t.child !== null) {
      for ((e = t.child, n = ri(e, e.pendingProps), t.child = n, n.return = t); e.sibling !== null; ) (e = e.sibling, n = n.sibling = ri(e, e.pendingProps), n.return = t);
      n.sibling = null;
    }
    return t.child;
  }
  function Ec(e, t) {
    return (e.lanes & t) !== 0 || (e = e.dependencies, !!(e !== null && Ki(e)));
  }
  function Dc(e, t, n) {
    switch (t.tag) {
      case 3:
        (le(t, t.stateNode.containerInfo), Vi(t, ea, e.memoizedState.cache), Fi());
        break;
      case 27:
      case 5:
        de(t);
        break;
      case 4:
        le(t, t.stateNode.containerInfo);
        break;
      case 10:
        Vi(t, t.type, t.memoizedProps.value);
        break;
      case 31:
        if (t.memoizedState !== null) return (t.flags |= 128, $a(t), null);
        break;
      case 13:
        var r = t.memoizedState;
        if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (Qa(t), e = Tc(e, t, n), e === null ? null : e.sibling) : vc(e, t, n) : (Qa(t), t.flags |= 128, null);
        Qa(t);
        break;
      case 19:
        var i = !!(e.flags & 128);
        if ((r = (n & t.childLanes) !== 0, r ||= (Gi(e, t, n, !1), (n & t.childLanes) !== 0), i)) {
          if (r) return wc(e, t, n);
          t.flags |= 128;
        }
        if ((i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), R(ro, ro.current), r)) break;
        return null;
      case 22:
        return (t.lanes = 0, ic(e, t, n, t.pendingProps));
      case 24:
        Vi(t, ea, e.memoizedState.cache);
    }
    return Tc(e, t, n);
  }
  function Oc(e, t, n) {
    if (e !== null) {
      if (e.memoizedProps !== t.pendingProps) $s = !0; else {
        if (!Ec(e, n) && !(t.flags & 128)) return ($s = !1, Dc(e, t, n));
        $s = !!(e.flags & 131072);
      }
    } else ($s = !1, K && t.flags & 1048576 && Si(t, hi, t.index));
    switch ((t.lanes = 0, t.tag)) {
      case 16:
        a: {
          var r = t.pendingProps;
          if ((e = xa(t.elementType), t.type = e, typeof e == `function`)) ni(e) ? (r = Hs(e, r), t.tag = 1, t = pc(null, t, e, r, n)) : (t.tag = 0, t = dc(null, t, e, r, n)); else {
            if (e != null) {
              var i = e.$$typeof;
              if (i === w) {
                (t.tag = 11, t = tc(null, t, e, r, n));
                break a;
              }
              if (i === D) {
                (t.tag = 14, t = nc(null, t, e, r, n));
                break a;
              }
            }
            throw (t = re(e) || e, Error(s(306, t, ``)));
          }
        }
        return t;
      case 0:
        return dc(e, t, t.type, t.pendingProps, n);
      case 1:
        return (r = t.type, i = Hs(r, t.pendingProps), pc(e, t, r, i, n));
      case 3:
        a: {
          if ((le(t, t.stateNode.containerInfo), e === null)) throw Error(s(387));
          r = t.pendingProps;
          var a = t.memoizedState;
          (i = a.element, Fa(e, t), Ha(t, r, null, n));
          var o = t.memoizedState;
          if ((r = o.cache, Vi(t, ea, r), r !== a.cache && Wi(t, [ea], n, !0), Va(), r = o.element, a.isDehydrated)) {
            if ((a = {
              element: r,
              isDehydrated: !1,
              cache: o.cache
            }, t.updateQueue.baseState = a, t.memoizedState = a, t.flags & 256)) {
              t = mc(e, t, r, n);
              break a;
            }
            if (r !== i) {
              (i = di(Error(s(424)), t), Li(i), t = mc(e, t, r, n));
              break a;
            }
            switch ((e = t.stateNode.containerInfo, e.nodeType)) {
              case 9:
                e = e.body;
                break;
              default:
                e = e.nodeName === `HTML` ? e.ownerDocument.body : e;
            }
            for ((Di = cf(e.firstChild), Ei = t, K = !0, Oi = null, ki = !0, n = Ma(t, null, r, n), t.child = n); n; ) (n.flags = n.flags & -3 | 4096, n = n.sibling);
          } else {
            if ((Fi(), r === i)) {
              t = Tc(e, t, n);
              break a;
            }
            ec(e, t, r, n);
          }
          t = t.child;
        }
        return t;
      case 26:
        return (uc(e, t), e === null ? (n = kf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : K || (n = t.type, e = t.pendingProps, r = Bd(se.current).createElement(n), r[it] = t, r[at] = e, Pd(r, n, e), U(r), t.stateNode = r) : t.memoizedState = kf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null);
      case 27:
        return (de(t), e === null && K && (r = t.stateNode = ff(t.type, t.pendingProps, se.current), Ei = t, ki = !0, i = Di, Zd(t.type) ? (lf = i, Di = cf(r.firstChild)) : Di = i), ec(e, t, t.pendingProps.children, n), uc(e, t), e === null && (t.flags |= 4194304), t.child);
      case 5:
        return (e === null && K && ((i = r = Di) && (r = tf(r, t.type, t.pendingProps, ki), r === null ? i = !1 : (t.stateNode = r, Ei = t, Di = cf(r.firstChild), ki = !1, i = !0)), i || ji(t)), de(t), i = t.type, a = t.pendingProps, o = e === null ? null : e.memoizedProps, r = a.children, Ud(i, a) ? r = null : o !== null && Ud(i, o) && (t.flags |= 32), t.memoizedState !== null && (i = vo(e, t, xo, null, null, n), Qf._currentValue = i), uc(e, t), ec(e, t, r, n), t.child);
      case 6:
        return (e === null && K && ((e = n = Di) && (n = nf(n, t.pendingProps, ki), n === null ? e = !1 : (t.stateNode = n, Ei = t, Di = null, e = !0)), e || ji(t)), null);
      case 13:
        return vc(e, t, n);
      case 4:
        return (le(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = ja(t, null, r, n) : ec(e, t, r, n), t.child);
      case 11:
        return tc(e, t, t.type, t.pendingProps, n);
      case 7:
        return (ec(e, t, t.pendingProps, n), t.child);
      case 8:
        return (ec(e, t, t.pendingProps.children, n), t.child);
      case 12:
        return (ec(e, t, t.pendingProps.children, n), t.child);
      case 10:
        return (r = t.pendingProps, Vi(t, t.type, r.value), ec(e, t, r.children, n), t.child);
      case 9:
        return (i = t.type._context, r = t.pendingProps.children, qi(t), i = Ji(i), r = r(i), t.flags |= 1, ec(e, t, r, n), t.child);
      case 14:
        return nc(e, t, t.type, t.pendingProps, n);
      case 15:
        return rc(e, t, t.type, t.pendingProps, n);
      case 19:
        return wc(e, t, n);
      case 31:
        return lc(e, t, n);
      case 22:
        return ic(e, t, n, t.pendingProps);
      case 24:
        return (qi(t), r = Ji(ea), e === null ? (i = fa(), i === null && (i = Ll, a = ta(), i.pooledCache = a, a.refCount++, a !== null && (i.pooledCacheLanes |= n), i = a), t.memoizedState = {
          parent: r,
          cache: i
        }, Pa(t), Vi(t, ea, i)) : ((e.lanes & n) !== 0 && (Fa(e, t), Ha(t, null, null, n), Va()), i = e.memoizedState, a = t.memoizedState, i.parent === r ? (r = a.cache, Vi(t, ea, r), r !== i.cache && Wi(t, [ea], n, !0)) : (i = {
          parent: r,
          cache: r
        }, t.memoizedState = i, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = i), Vi(t, ea, r))), ec(e, t, t.pendingProps.children, n), t.child);
      case 29:
        throw t.pendingProps;
    }
    throw Error(s(156, t.tag));
  }
  function kc(e) {
    e.flags |= 4;
  }
  function Ac(e, t, n, r, i) {
    if (((t = !!(e.mode & 32)) && (t = !1), t)) {
      if ((e.flags |= 16777216, (i & 335544128) === i)) {
        if (e.stateNode.complete) e.flags |= 8192; else if (Cu()) e.flags |= 8192; else throw (Sa = va, ga);
      }
    } else e.flags &= -16777217;
  }
  function jc(e, t) {
    if (t.type !== `stylesheet` || t.state.loading & 4) e.flags &= -16777217; else if ((e.flags |= 16777216, !Wf(t))) {
      if (Cu()) e.flags |= 8192; else throw (Sa = va, ga);
    }
  }
  function Mc(e, t) {
    (t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : Ke(), e.lanes |= t, Jl |= t));
  }
  function Nc(e, t) {
    if (!K) switch (e.tailMode) {
      case `hidden`:
        t = e.tail;
        for (var n = null; t !== null; ) (t.alternate !== null && (n = t), t = t.sibling);
        n === null ? e.tail = null : n.sibling = null;
        break;
      case `collapsed`:
        n = e.tail;
        for (var r = null; n !== null; ) (n.alternate !== null && (r = n), n = n.sibling);
        r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
    }
  }
  function Pc(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
    if (t) for (var i = e.child; i !== null; ) (n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling); else for (i = e.child; i !== null; ) (n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling);
    return (e.subtreeFlags |= r, e.childLanes = n, t);
  }
  function Fc(e, t, n) {
    var r = t.pendingProps;
    switch ((wi(t), t.tag)) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return (Pc(t), null);
      case 1:
        return (Pc(t), null);
      case 3:
        return (n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Hi(ea), ue(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Pi(t) ? kc(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Ii())), Pc(t), null);
      case 26:
        var i = t.type, a = t.memoizedState;
        return (e === null ? (kc(t), a === null ? (Pc(t), Ac(t, i, null, r, n)) : (Pc(t), jc(t, a))) : a ? a === e.memoizedState ? (Pc(t), t.flags &= -16777217) : (kc(t), Pc(t), jc(t, a)) : (e = e.memoizedProps, e !== r && kc(t), Pc(t), Ac(t, i, e, r, n)), null);
      case 27:
        if ((fe(t), n = se.current, i = t.type, e !== null && t.stateNode != null)) e.memoizedProps !== r && kc(t); else {
          if (!r) {
            if (t.stateNode === null) throw Error(s(166));
            return (Pc(t), null);
          }
          (e = ae.current, Pi(t) ? Mi(t, e) : (e = ff(i, r, n), t.stateNode = e, kc(t)));
        }
        return (Pc(t), null);
      case 5:
        if ((fe(t), i = t.type, e !== null && t.stateNode != null)) e.memoizedProps !== r && kc(t); else {
          if (!r) {
            if (t.stateNode === null) throw Error(s(166));
            return (Pc(t), null);
          }
          if ((a = ae.current, Pi(t))) Mi(t, a); else {
            var o = Bd(se.current);
            switch (a) {
              case 1:
                a = o.createElementNS(`http://www.w3.org/2000/svg`, i);
                break;
              case 2:
                a = o.createElementNS(`http://www.w3.org/1998/Math/MathML`, i);
                break;
              default:
                switch (i) {
                  case `svg`:
                    a = o.createElementNS(`http://www.w3.org/2000/svg`, i);
                    break;
                  case `math`:
                    a = o.createElementNS(`http://www.w3.org/1998/Math/MathML`, i);
                    break;
                  case `script`:
                    (a = o.createElement(`div`), a.innerHTML = `<script><\/script>`, a = a.removeChild(a.firstChild));
                    break;
                  case `select`:
                    (a = typeof r.is == `string` ? o.createElement(`select`, {
                      is: r.is
                    }) : o.createElement(`select`), r.multiple ? a.multiple = !0 : r.size && (a.size = r.size));
                    break;
                  default:
                    a = typeof r.is == `string` ? o.createElement(i, {
                      is: r.is
                    }) : o.createElement(i);
                }
            }
            (a[it] = t, a[at] = r);
            a: for (o = t.child; o !== null; ) {
              if (o.tag === 5 || o.tag === 6) a.appendChild(o.stateNode); else if (o.tag !== 4 && o.tag !== 27 && o.child !== null) {
                (o.child.return = o, o = o.child);
                continue;
              }
              if (o === t) break a;
              for (; o.sibling === null; ) {
                if (o.return === null || o.return === t) break a;
                o = o.return;
              }
              (o.sibling.return = o.return, o = o.sibling);
            }
            t.stateNode = a;
            a: switch ((Pd(a, i, r), i)) {
              case `button`:
              case `input`:
              case `select`:
              case `textarea`:
                r = !!r.autoFocus;
                break a;
              case `img`:
                r = !0;
                break a;
              default:
                r = !1;
            }
            r && kc(t);
          }
        }
        return (Pc(t), Ac(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null);
      case 6:
        if (e && t.stateNode != null) e.memoizedProps !== r && kc(t); else {
          if (typeof r != `string` && t.stateNode === null) throw Error(s(166));
          if ((e = se.current, Pi(t))) {
            if ((e = t.stateNode, n = t.memoizedProps, r = null, i = Ei, i !== null)) switch (i.tag) {
              case 27:
              case 5:
                r = i.memoizedProps;
            }
            (e[it] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || jd(e.nodeValue, n)), e || ji(t, !0));
          } else (e = Bd(e).createTextNode(r), e[it] = t, t.stateNode = e);
        }
        return (Pc(t), null);
      case 31:
        if ((n = t.memoizedState, e === null || e.memoizedState !== null)) {
          if ((r = Pi(t), n !== null)) {
            if (e === null) {
              if (!r) throw Error(s(318));
              if ((e = t.memoizedState, e = e === null ? null : e.dehydrated, !e)) throw Error(s(557));
              e[it] = t;
            } else (Fi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4);
            (Pc(t), e = !1);
          } else (n = Ii(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0);
          if (!e) return t.flags & 256 ? (no(t), t) : (no(t), null);
          if (t.flags & 128) throw Error(s(558));
        }
        return (Pc(t), null);
      case 13:
        if ((r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null)) {
          if ((i = Pi(t), r !== null && r.dehydrated !== null)) {
            if (e === null) {
              if (!i) throw Error(s(318));
              if ((i = t.memoizedState, i = i === null ? null : i.dehydrated, !i)) throw Error(s(317));
              i[it] = t;
            } else (Fi(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4);
            (Pc(t), i = !1);
          } else (i = Ii(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = i), i = !0);
          if (!i) return t.flags & 256 ? (no(t), t) : (no(t), null);
        }
        return (no(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, i = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (i = r.alternate.memoizedState.cachePool.pool), a = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (a = r.memoizedState.cachePool.pool), a !== i && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Mc(t, t.updateQueue), Pc(t), null));
      case 4:
        return (ue(), e === null && xd(t.stateNode.containerInfo), Pc(t), null);
      case 10:
        return (Hi(t.type), Pc(t), null);
      case 19:
        if ((L(ro), r = t.memoizedState, r === null)) return (Pc(t), null);
        if ((i = !!(t.flags & 128), a = r.rendering, a === null)) {
          if (i) Nc(r, !1); else {
            if (Ul !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
              if ((a = io(e), a !== null)) {
                for ((t.flags |= 128, Nc(r, !1), e = a.updateQueue, t.updateQueue = e, Mc(t, e), t.subtreeFlags = 0, e = n, n = t.child); n !== null; ) (ii(n, e), n = n.sibling);
                return (R(ro, ro.current & 1 | 2), K && xi(t, r.treeForkCount), t.child);
              }
              e = e.sibling;
            }
            r.tail !== null && we() > eu && (t.flags |= 128, i = !0, Nc(r, !1), t.lanes = 4194304);
          }
        } else {
          if (!i) {
            if ((e = io(a), e !== null)) {
              if ((t.flags |= 128, i = !0, e = e.updateQueue, t.updateQueue = e, Mc(t, e), Nc(r, !0), r.tail === null && r.tailMode === `hidden` && !a.alternate && !K)) return (Pc(t), null);
            } else 2 * we() - r.renderingStartTime > eu && n !== 536870912 && (t.flags |= 128, i = !0, Nc(r, !1), t.lanes = 4194304);
          }
          r.isBackwards ? (a.sibling = t.child, t.child = a) : (e = r.last, e === null ? t.child = a : e.sibling = a, r.last = a);
        }
        return r.tail === null ? (Pc(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = we(), e.sibling = null, n = ro.current, R(ro, i ? n & 1 | 2 : n & 1), K && xi(t, r.treeForkCount), e);
      case 22:
      case 23:
        return (no(t), Ya(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (Pc(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Pc(t), n = t.updateQueue, n !== null && Mc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && L(da), null);
      case 24:
        return (n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Hi(ea), Pc(t), null);
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(s(156, t.tag));
  }
  function Ic(e, t) {
    switch ((wi(t), t.tag)) {
      case 1:
        return (e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null);
      case 3:
        return (Hi(ea), ue(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null);
      case 26:
      case 27:
      case 5:
        return (fe(t), null);
      case 31:
        if (t.memoizedState !== null) {
          if ((no(t), t.alternate === null)) throw Error(s(340));
          Fi();
        }
        return (e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null);
      case 13:
        if ((no(t), e = t.memoizedState, e !== null && e.dehydrated !== null)) {
          if (t.alternate === null) throw Error(s(340));
          Fi();
        }
        return (e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null);
      case 19:
        return (L(ro), null);
      case 4:
        return (ue(), null);
      case 10:
        return (Hi(t.type), null);
      case 22:
      case 23:
        return (no(t), Ya(), e !== null && L(da), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null);
      case 24:
        return (Hi(ea), null);
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Lc(e, t) {
    switch ((wi(t), t.tag)) {
      case 3:
        (Hi(ea), ue());
        break;
      case 26:
      case 27:
      case 5:
        fe(t);
        break;
      case 4:
        ue();
        break;
      case 31:
        t.memoizedState !== null && no(t);
        break;
      case 13:
        no(t);
        break;
      case 19:
        L(ro);
        break;
      case 10:
        Hi(t.type);
        break;
      case 22:
      case 23:
        (no(t), Ya(), e !== null && L(da));
        break;
      case 24:
        Hi(ea);
    }
  }
  function Rc(e, t) {
    try {
      var n = t.updateQueue, r = n === null ? null : n.lastEffect;
      if (r !== null) {
        var i = r.next;
        n = i;
        do {
          if ((n.tag & e) === e) {
            r = void 0;
            var a = n.create, o = n.inst;
            (r = a(), o.destroy = r);
          }
          n = n.next;
        } while (n !== i);
      }
    } catch (e) {
      Q(t, t.return, e);
    }
  }
  function zc(e, t, n) {
    try {
      var r = t.updateQueue, i = r === null ? null : r.lastEffect;
      if (i !== null) {
        var a = i.next;
        r = a;
        do {
          if ((r.tag & e) === e) {
            var o = r.inst, s = o.destroy;
            if (s !== void 0) {
              (o.destroy = void 0, i = t);
              var c = n, l = s;
              try {
                l();
              } catch (e) {
                Q(i, c, e);
              }
            }
          }
          r = r.next;
        } while (r !== a);
      }
    } catch (e) {
      Q(t, t.return, e);
    }
  }
  function Bc(e) {
    var t = e.updateQueue;
    if (t !== null) {
      var n = e.stateNode;
      try {
        Wa(t, n);
      } catch (t) {
        Q(e, e.return, t);
      }
    }
  }
  function Vc(e, t, n) {
    (n.props = Hs(e.type, e.memoizedProps), n.state = e.memoizedState);
    try {
      n.componentWillUnmount();
    } catch (n) {
      Q(e, t, n);
    }
  }
  function Hc(e, t) {
    try {
      var n = e.ref;
      if (n !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var r = e.stateNode;
            break;
          case 30:
            r = e.stateNode;
            break;
          default:
            r = e.stateNode;
        }
        typeof n == `function` ? e.refCleanup = n(r) : n.current = r;
      }
    } catch (n) {
      Q(e, t, n);
    }
  }
  function Uc(e, t) {
    var n = e.ref, r = e.refCleanup;
    if (n !== null) {
      if (typeof r == `function`) try {
        r();
      } catch (n) {
        Q(e, t, n);
      } finally {
        (e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null));
      } else if (typeof n == `function`) try {
        n(null);
      } catch (n) {
        Q(e, t, n);
      } else n.current = null;
    }
  }
  function Wc(e) {
    var t = e.type, n = e.memoizedProps, r = e.stateNode;
    try {
      a: switch (t) {
        case `button`:
        case `input`:
        case `select`:
        case `textarea`:
          n.autoFocus && r.focus();
          break a;
        case `img`:
          n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
      }
    } catch (t) {
      Q(e, e.return, t);
    }
  }
  function Gc(e, t, n) {
    try {
      var r = e.stateNode;
      (Fd(r, e.type, n, t), r[at] = t);
    } catch (t) {
      Q(e, e.return, t);
    }
  }
  function Kc(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Zd(e.type) || e.tag === 4;
  }
  function qc(e) {
    a: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || Kc(e.return)) return null;
        e = e.return;
      }
      for ((e.sibling.return = e.return, e = e.sibling); e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.tag === 27 && Zd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
        (e.child.return = e, e = e.child);
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function Jc(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) (e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === `HTML` ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Kt))); else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for ((Jc(e, t, n), e = e.sibling); e !== null; ) (Jc(e, t, n), e = e.sibling);
  }
  function Yc(e, t, n) {
    var r = e.tag;
    if (r === 5 || r === 6) (e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e)); else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for ((Yc(e, t, n), e = e.sibling); e !== null; ) (Yc(e, t, n), e = e.sibling);
  }
  function Xc(e) {
    var t = e.stateNode, n = e.memoizedProps;
    try {
      for (var r = e.type, i = t.attributes; i.length; ) t.removeAttributeNode(i[0]);
      (Pd(t, r, n), t[it] = e, t[at] = n);
    } catch (t) {
      Q(e, e.return, t);
    }
  }
  var Zc = !1, Qc = !1, $c = !1, el = typeof WeakSet == `function` ? WeakSet : Set, tl = null;
  function nl(e, t) {
    if ((e = e.containerInfo, Rd = sp, e = br(e), xr(e))) {
      if ((`selectionStart` in e)) var n = {
        start: e.selectionStart,
        end: e.selectionEnd
      }; else a: {
        n = (n = e.ownerDocument) && n.defaultView || window;
        var r = n.getSelection && n.getSelection();
        if (r && r.rangeCount !== 0) {
          n = r.anchorNode;
          var i = r.anchorOffset, a = r.focusNode;
          r = r.focusOffset;
          try {
            (n.nodeType, a.nodeType);
          } catch {
            n = null;
            break a;
          }
          var o = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
          b: for (; ; ) {
            for (var m; (f !== n || i !== 0 && f.nodeType !== 3 || (c = o + i), f !== a || r !== 0 && f.nodeType !== 3 || (l = o + r), f.nodeType === 3 && (o += f.nodeValue.length), (m = f.firstChild) !== null); ) (p = f, f = m);
            for (; ; ) {
              if (f === e) break b;
              if ((p === n && ++u === i && (c = o), p === a && ++d === r && (l = o), (m = f.nextSibling) !== null)) break;
              (f = p, p = f.parentNode);
            }
            f = m;
          }
          n = c === -1 || l === -1 ? null : {
            start: c,
            end: l
          };
        } else n = null;
      }
      n ||= {
        start: 0,
        end: 0
      };
    } else n = null;
    for ((zd = {
      focusedElem: e,
      selectionRange: n
    }, sp = !1, tl = t); tl !== null; ) if ((t = tl, e = t.child, t.subtreeFlags & 1028 && e !== null)) (e.return = t, tl = e); else for (; tl !== null; ) {
      switch ((t = tl, a = t.alternate, e = t.flags, t.tag)) {
        case 0:
          if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) (i = e[n], i.ref.impl = i.nextImpl);
          break;
        case 11:
        case 15:
          break;
        case 1:
          if (e & 1024 && a !== null) {
            (e = void 0, n = t, i = a.memoizedProps, a = a.memoizedState, r = n.stateNode);
            try {
              var h = Hs(n.type, i);
              (e = r.getSnapshotBeforeUpdate(h, a), r.__reactInternalSnapshotBeforeUpdate = e);
            } catch (e) {
              Q(n, n.return, e);
            }
          }
          break;
        case 3:
          if (e & 1024) {
            if ((e = t.stateNode.containerInfo, n = e.nodeType, n === 9)) ef(e); else if (n === 1) switch (e.nodeName) {
              case `HEAD`:
              case `HTML`:
              case `BODY`:
                ef(e);
                break;
              default:
                e.textContent = ``;
            }
          }
          break;
        case 5:
        case 26:
        case 27:
        case 6:
        case 4:
        case 17:
          break;
        default:
          if (e & 1024) throw Error(s(163));
      }
      if ((e = t.sibling, e !== null)) {
        (e.return = t.return, tl = e);
        break;
      }
      tl = t.return;
    }
  }
  function rl(e, t, n) {
    var r = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        (vl(e, n), r & 4 && Rc(5, n));
        break;
      case 1:
        if ((vl(e, n), r & 4)) {
          if ((e = n.stateNode, t === null)) try {
            e.componentDidMount();
          } catch (e) {
            Q(n, n.return, e);
          } else {
            var i = Hs(n.type, t.memoizedProps);
            t = t.memoizedState;
            try {
              e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
            } catch (e) {
              Q(n, n.return, e);
            }
          }
        }
        (r & 64 && Bc(n), r & 512 && Hc(n, n.return));
        break;
      case 3:
        if ((vl(e, n), r & 64 && (e = n.updateQueue, e !== null))) {
          if ((t = null, n.child !== null)) switch (n.child.tag) {
            case 27:
            case 5:
              t = n.child.stateNode;
              break;
            case 1:
              t = n.child.stateNode;
          }
          try {
            Wa(e, t);
          } catch (e) {
            Q(n, n.return, e);
          }
        }
        break;
      case 27:
        t === null && r & 4 && Xc(n);
      case 26:
      case 5:
        (vl(e, n), t === null && r & 4 && Wc(n), r & 512 && Hc(n, n.return));
        break;
      case 12:
        vl(e, n);
        break;
      case 31:
        (vl(e, n), r & 4 && ll(e, n));
        break;
      case 13:
        (vl(e, n), r & 4 && ul(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = qu.bind(null, n), sf(e, n)))));
        break;
      case 22:
        if ((r = n.memoizedState !== null || Zc, !r)) {
          (t = t !== null && t.memoizedState !== null || Qc, i = Zc);
          var a = Qc;
          (Zc = r, (Qc = t) && !a ? bl(e, n, !!(n.subtreeFlags & 8772)) : vl(e, n), Zc = i, Qc = a);
        }
        break;
      case 30:
        break;
      default:
        vl(e, n);
    }
  }
  function il(e) {
    var t = e.alternate;
    (t !== null && (e.alternate = null, il(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && dt(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null);
  }
  var al = null, ol = !1;
  function sl(e, t, n) {
    for (n = n.child; n !== null; ) (cl(e, t, n), n = n.sibling);
  }
  function cl(e, t, n) {
    if (Pe && typeof Pe.onCommitFiberUnmount == `function`) try {
      Pe.onCommitFiberUnmount(Ne, n);
    } catch {}
    switch (n.tag) {
      case 26:
        (Qc || Uc(n, t), sl(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n)));
        break;
      case 27:
        Qc || Uc(n, t);
        var r = al, i = ol;
        (Zd(n.type) && (al = n.stateNode, ol = !1), sl(e, t, n), pf(n.stateNode), al = r, ol = i);
        break;
      case 5:
        Qc || Uc(n, t);
      case 6:
        if ((r = al, i = ol, al = null, sl(e, t, n), al = r, ol = i, al !== null)) {
          if (ol) try {
            (al.nodeType === 9 ? al.body : al.nodeName === `HTML` ? al.ownerDocument.body : al).removeChild(n.stateNode);
          } catch (e) {
            Q(n, t, e);
          } else try {
            al.removeChild(n.stateNode);
          } catch (e) {
            Q(n, t, e);
          }
        }
        break;
      case 18:
        al !== null && (ol ? (e = al, Qd(e.nodeType === 9 ? e.body : e.nodeName === `HTML` ? e.ownerDocument.body : e, n.stateNode), Np(e)) : Qd(al, n.stateNode));
        break;
      case 4:
        (r = al, i = ol, al = n.stateNode.containerInfo, ol = !0, sl(e, t, n), al = r, ol = i);
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        (zc(2, n, t), Qc || zc(4, n, t), sl(e, t, n));
        break;
      case 1:
        (Qc || (Uc(n, t), r = n.stateNode, typeof r.componentWillUnmount == `function` && Vc(n, t, r)), sl(e, t, n));
        break;
      case 21:
        sl(e, t, n);
        break;
      case 22:
        (Qc = (r = Qc) || n.memoizedState !== null, sl(e, t, n), Qc = r);
        break;
      default:
        sl(e, t, n);
    }
  }
  function ll(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
      e = e.dehydrated;
      try {
        Np(e);
      } catch (e) {
        Q(t, t.return, e);
      }
    }
  }
  function ul(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
      Np(e);
    } catch (e) {
      Q(t, t.return, e);
    }
  }
  function dl(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var t = e.stateNode;
        return (t === null && (t = e.stateNode = new el()), t);
      case 22:
        return (e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new el()), t);
      default:
        throw Error(s(435, e.tag));
    }
  }
  function fl(e, t) {
    var n = dl(e);
    t.forEach(function (t) {
      if (!n.has(t)) {
        n.add(t);
        var r = Ju.bind(null, e, t);
        t.then(r, r);
      }
    });
  }
  function pl(e, t) {
    var n = t.deletions;
    if (n !== null) for (var r = 0; r < n.length; r++) {
      var i = n[r], a = e, o = t, c = o;
      a: for (; c !== null; ) {
        switch (c.tag) {
          case 27:
            if (Zd(c.type)) {
              (al = c.stateNode, ol = !1);
              break a;
            }
            break;
          case 5:
            (al = c.stateNode, ol = !1);
            break a;
          case 3:
          case 4:
            (al = c.stateNode.containerInfo, ol = !0);
            break a;
        }
        c = c.return;
      }
      if (al === null) throw Error(s(160));
      (cl(a, o, i), al = null, ol = !1, a = i.alternate, a !== null && (a.return = null), i.return = null);
    }
    if (t.subtreeFlags & 13886) for (t = t.child; t !== null; ) (hl(t, e), t = t.sibling);
  }
  var ml = null;
  function hl(e, t) {
    var n = e.alternate, r = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        (pl(t, e), gl(e), r & 4 && (zc(3, e, e.return), Rc(3, e), zc(5, e, e.return)));
        break;
      case 1:
        (pl(t, e), gl(e), r & 512 && (Qc || n === null || Uc(n, n.return)), r & 64 && Zc && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r)))));
        break;
      case 26:
        var i = ml;
        if ((pl(t, e), gl(e), r & 512 && (Qc || n === null || Uc(n, n.return)), r & 4)) {
          var a = n === null ? null : n.memoizedState;
          if ((r = e.memoizedState, n === null)) {
            if (r === null) {
              if (e.stateNode === null) {
                a: {
                  (r = e.type, n = e.memoizedProps, i = i.ownerDocument || i);
                  b: switch (r) {
                    case `title`:
                      (a = i.getElementsByTagName(`title`)[0], (!a || a[ut] || a[it] || a.namespaceURI === `http://www.w3.org/2000/svg` || a.hasAttribute(`itemprop`)) && (a = i.createElement(r), i.head.insertBefore(a, i.querySelector(`head > title`))), Pd(a, r, n), a[it] = e, U(a), r = a);
                      break a;
                    case `link`:
                      var o = Vf(`link`, `href`, i).get(r + (n.href || ``));
                      if (o) {
                        for (var c = 0; c < o.length; c++) if ((a = o[c], a.getAttribute(`href`) === (n.href == null || n.href === `` ? null : n.href) && a.getAttribute(`rel`) === (n.rel == null ? null : n.rel) && a.getAttribute(`title`) === (n.title == null ? null : n.title) && a.getAttribute(`crossorigin`) === (n.crossOrigin == null ? null : n.crossOrigin))) {
                          o.splice(c, 1);
                          break b;
                        }
                      }
                      (a = i.createElement(r), Pd(a, r, n), i.head.appendChild(a));
                      break;
                    case `meta`:
                      if (o = Vf(`meta`, `content`, i).get(r + (n.content || ``))) {
                        for (c = 0; c < o.length; c++) if ((a = o[c], a.getAttribute(`content`) === (n.content == null ? null : `` + n.content) && a.getAttribute(`name`) === (n.name == null ? null : n.name) && a.getAttribute(`property`) === (n.property == null ? null : n.property) && a.getAttribute(`http-equiv`) === (n.httpEquiv == null ? null : n.httpEquiv) && a.getAttribute(`charset`) === (n.charSet == null ? null : n.charSet))) {
                          o.splice(c, 1);
                          break b;
                        }
                      }
                      (a = i.createElement(r), Pd(a, r, n), i.head.appendChild(a));
                      break;
                    default:
                      throw Error(s(468, r));
                  }
                  (a[it] = e, U(a), r = a);
                }
                e.stateNode = r;
              } else Hf(i, e.type, e.stateNode);
            } else e.stateNode = If(i, r, e.memoizedProps);
          } else a === r ? r === null && e.stateNode !== null && Gc(e, e.memoizedProps, n.memoizedProps) : (a === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : a.count--, r === null ? Hf(i, e.type, e.stateNode) : If(i, r, e.memoizedProps));
        }
        break;
      case 27:
        (pl(t, e), gl(e), r & 512 && (Qc || n === null || Uc(n, n.return)), n !== null && r & 4 && Gc(e, e.memoizedProps, n.memoizedProps));
        break;
      case 5:
        if ((pl(t, e), gl(e), r & 512 && (Qc || n === null || Uc(n, n.return)), e.flags & 32)) {
          i = e.stateNode;
          try {
            Rt(i, ``);
          } catch (t) {
            Q(e, e.return, t);
          }
        }
        (r & 4 && e.stateNode != null && (i = e.memoizedProps, Gc(e, i, n === null ? i : n.memoizedProps)), r & 1024 && ($c = !0));
        break;
      case 6:
        if ((pl(t, e), gl(e), r & 4)) {
          if (e.stateNode === null) throw Error(s(162));
          (r = e.memoizedProps, n = e.stateNode);
          try {
            n.nodeValue = r;
          } catch (t) {
            Q(e, e.return, t);
          }
        }
        break;
      case 3:
        if ((Bf = null, i = ml, ml = gf(t.containerInfo), pl(t, e), ml = i, gl(e), r & 4 && n !== null && n.memoizedState.isDehydrated)) try {
          Np(t.containerInfo);
        } catch (t) {
          Q(e, e.return, t);
        }
        $c && ($c = !1, _l(e));
        break;
      case 4:
        (r = ml, ml = gf(e.stateNode.containerInfo), pl(t, e), gl(e), ml = r);
        break;
      case 12:
        (pl(t, e), gl(e));
        break;
      case 31:
        (pl(t, e), gl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, fl(e, r))));
        break;
      case 13:
        (pl(t, e), gl(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (Ql = we()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, fl(e, r))));
        break;
      case 22:
        i = e.memoizedState !== null;
        var l = n !== null && n.memoizedState !== null, u = Zc, d = Qc;
        if ((Zc = u || i, Qc = d || l, pl(t, e), Qc = d, Zc = u, gl(e), r & 8192)) a: for ((t = e.stateNode, t._visibility = i ? t._visibility & -2 : t._visibility | 1, i && (n === null || l || Zc || Qc || yl(e)), n = null, t = e); ; ) {
          if (t.tag === 5 || t.tag === 26) {
            if (n === null) {
              l = n = t;
              try {
                if ((a = l.stateNode, i)) (o = a.style, typeof o.setProperty == `function` ? o.setProperty(`display`, `none`, `important`) : o.display = `none`); else {
                  c = l.stateNode;
                  var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty(`display`) ? f.display : null;
                  c.style.display = p == null || typeof p == `boolean` ? `` : (`` + p).trim();
                }
              } catch (e) {
                Q(l, l.return, e);
              }
            }
          } else if (t.tag === 6) {
            if (n === null) {
              l = t;
              try {
                l.stateNode.nodeValue = i ? `` : l.memoizedProps;
              } catch (e) {
                Q(l, l.return, e);
              }
            }
          } else if (t.tag === 18) {
            if (n === null) {
              l = t;
              try {
                var m = l.stateNode;
                i ? $d(m, !0) : $d(l.stateNode, !1);
              } catch (e) {
                Q(l, l.return, e);
              }
            }
          } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
            (t.child.return = t, t = t.child);
            continue;
          }
          if (t === e) break a;
          for (; t.sibling === null; ) {
            if (t.return === null || t.return === e) break a;
            (n === t && (n = null), t = t.return);
          }
          (n === t && (n = null), t.sibling.return = t.return, t = t.sibling);
        }
        r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, fl(e, n))));
        break;
      case 19:
        (pl(t, e), gl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, fl(e, r))));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        (pl(t, e), gl(e));
    }
  }
  function gl(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        for (var n, r = e.return; r !== null; ) {
          if (Kc(r)) {
            n = r;
            break;
          }
          r = r.return;
        }
        if (n == null) throw Error(s(160));
        switch (n.tag) {
          case 27:
            var i = n.stateNode;
            Yc(e, qc(e), i);
            break;
          case 5:
            var a = n.stateNode;
            (n.flags & 32 && (Rt(a, ``), n.flags &= -33), Yc(e, qc(e), a));
            break;
          case 3:
          case 4:
            var o = n.stateNode.containerInfo;
            Jc(e, qc(e), o);
            break;
          default:
            throw Error(s(161));
        }
      } catch (t) {
        Q(e, e.return, t);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function _l(e) {
    if (e.subtreeFlags & 1024) for (e = e.child; e !== null; ) {
      var t = e;
      (_l(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling);
    }
  }
  function vl(e, t) {
    if (t.subtreeFlags & 8772) for (t = t.child; t !== null; ) (rl(e, t.alternate, t), t = t.sibling);
  }
  function yl(e) {
    for (e = e.child; e !== null; ) {
      var t = e;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          (zc(4, t, t.return), yl(t));
          break;
        case 1:
          Uc(t, t.return);
          var n = t.stateNode;
          (typeof n.componentWillUnmount == `function` && Vc(t, t.return, n), yl(t));
          break;
        case 27:
          pf(t.stateNode);
        case 26:
        case 5:
          (Uc(t, t.return), yl(t));
          break;
        case 22:
          t.memoizedState === null && yl(t);
          break;
        case 30:
          yl(t);
          break;
        default:
          yl(t);
      }
      e = e.sibling;
    }
  }
  function bl(e, t, n) {
    for ((n &&= !!(t.subtreeFlags & 8772), t = t.child); t !== null; ) {
      var r = t.alternate, i = e, a = t, o = a.flags;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          (bl(i, a, n), Rc(4, a));
          break;
        case 1:
          if ((bl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == `function`)) try {
            i.componentDidMount();
          } catch (e) {
            Q(r, r.return, e);
          }
          if ((r = a, i = r.updateQueue, i !== null)) {
            var s = r.stateNode;
            try {
              var c = i.shared.hiddenCallbacks;
              if (c !== null) for ((i.shared.hiddenCallbacks = null, i = 0); i < c.length; i++) Ua(c[i], s);
            } catch (e) {
              Q(r, r.return, e);
            }
          }
          (n && o & 64 && Bc(a), Hc(a, a.return));
          break;
        case 27:
          Xc(a);
        case 26:
        case 5:
          (bl(i, a, n), n && r === null && o & 4 && Wc(a), Hc(a, a.return));
          break;
        case 12:
          bl(i, a, n);
          break;
        case 31:
          (bl(i, a, n), n && o & 4 && ll(i, a));
          break;
        case 13:
          (bl(i, a, n), n && o & 4 && ul(i, a));
          break;
        case 22:
          (a.memoizedState === null && bl(i, a, n), Hc(a, a.return));
          break;
        case 30:
          break;
        default:
          bl(i, a, n);
      }
      t = t.sibling;
    }
  }
  function xl(e, t) {
    var n = null;
    (e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && na(n)));
  }
  function Sl(e, t) {
    (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && na(e)));
  }
  function Cl(e, t, n, r) {
    if (t.subtreeFlags & 10256) for (t = t.child; t !== null; ) (wl(e, t, n, r), t = t.sibling);
  }
  function wl(e, t, n, r) {
    var i = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        (Cl(e, t, n, r), i & 2048 && Rc(9, t));
        break;
      case 1:
        Cl(e, t, n, r);
        break;
      case 3:
        (Cl(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && na(e))));
        break;
      case 12:
        if (i & 2048) {
          (Cl(e, t, n, r), e = t.stateNode);
          try {
            var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
            typeof s == `function` && s(o, t.alternate === null ? `mount` : `update`, e.passiveEffectDuration, -0);
          } catch (e) {
            Q(t, t.return, e);
          }
        } else Cl(e, t, n, r);
        break;
      case 31:
        Cl(e, t, n, r);
        break;
      case 13:
        Cl(e, t, n, r);
        break;
      case 23:
        break;
      case 22:
        (a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? Cl(e, t, n, r) : (a._visibility |= 2, Tl(e, t, n, r, !!(t.subtreeFlags & 10256) || !1)) : a._visibility & 2 ? Cl(e, t, n, r) : El(e, t), i & 2048 && xl(o, t));
        break;
      case 24:
        (Cl(e, t, n, r), i & 2048 && Sl(t.alternate, t));
        break;
      default:
        Cl(e, t, n, r);
    }
  }
  function Tl(e, t, n, r, i) {
    for ((i &&= !!(t.subtreeFlags & 10256) || !1, t = t.child); t !== null; ) {
      var a = e, o = t, s = n, c = r, l = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          (Tl(a, o, s, c, i), Rc(8, o));
          break;
        case 23:
          break;
        case 22:
          var u = o.stateNode;
          (o.memoizedState === null ? (u._visibility |= 2, Tl(a, o, s, c, i)) : u._visibility & 2 ? Tl(a, o, s, c, i) : El(a, o), i && l & 2048 && xl(o.alternate, o));
          break;
        case 24:
          (Tl(a, o, s, c, i), i && l & 2048 && Sl(o.alternate, o));
          break;
        default:
          Tl(a, o, s, c, i);
      }
      t = t.sibling;
    }
  }
  function El(e, t) {
    if (t.subtreeFlags & 10256) for (t = t.child; t !== null; ) {
      var n = e, r = t, i = r.flags;
      switch (r.tag) {
        case 22:
          (El(n, r), i & 2048 && xl(r.alternate, r));
          break;
        case 24:
          (El(n, r), i & 2048 && Sl(r.alternate, r));
          break;
        default:
          El(n, r);
      }
      t = t.sibling;
    }
  }
  var Dl = 8192;
  function Ol(e, t, n) {
    if (e.subtreeFlags & Dl) for (e = e.child; e !== null; ) (kl(e, t, n), e = e.sibling);
  }
  function kl(e, t, n) {
    switch (e.tag) {
      case 26:
        (Ol(e, t, n), e.flags & Dl && e.memoizedState !== null && Gf(n, ml, e.memoizedState, e.memoizedProps));
        break;
      case 5:
        Ol(e, t, n);
        break;
      case 3:
      case 4:
        var r = ml;
        (ml = gf(e.stateNode.containerInfo), Ol(e, t, n), ml = r);
        break;
      case 22:
        e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Dl, Dl = 16777216, Ol(e, t, n), Dl = r) : Ol(e, t, n));
        break;
      default:
        Ol(e, t, n);
    }
  }
  function Al(e) {
    var t = e.alternate;
    if (t !== null && (e = t.child, e !== null)) {
      t.child = null;
      do (t = e.sibling, e.sibling = null, e = t); while (e !== null);
    }
  }
  function jl(e) {
    var t = e.deletions;
    if (e.flags & 16) {
      if (t !== null) for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (tl = r, Pl(r, e));
      }
      Al(e);
    }
    if (e.subtreeFlags & 10256) for (e = e.child; e !== null; ) (Ml(e), e = e.sibling);
  }
  function Ml(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        (jl(e), e.flags & 2048 && zc(9, e, e.return));
        break;
      case 3:
        jl(e);
        break;
      case 12:
        jl(e);
        break;
      case 22:
        var t = e.stateNode;
        e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Nl(e)) : jl(e);
        break;
      default:
        jl(e);
    }
  }
  function Nl(e) {
    var t = e.deletions;
    if (e.flags & 16) {
      if (t !== null) for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (tl = r, Pl(r, e));
      }
      Al(e);
    }
    for (e = e.child; e !== null; ) {
      switch ((t = e, t.tag)) {
        case 0:
        case 11:
        case 15:
          (zc(8, t, t.return), Nl(t));
          break;
        case 22:
          (n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Nl(t)));
          break;
        default:
          Nl(t);
      }
      e = e.sibling;
    }
  }
  function Pl(e, t) {
    for (; tl !== null; ) {
      var n = tl;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          zc(8, n, t);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var r = n.memoizedState.cachePool.pool;
            r != null && r.refCount++;
          }
          break;
        case 24:
          na(n.memoizedState.cache);
      }
      if ((r = n.child, r !== null)) (r.return = n, tl = r); else a: for (n = e; tl !== null; ) {
        r = tl;
        var i = r.sibling, a = r.return;
        if ((il(r), r === n)) {
          tl = null;
          break a;
        }
        if (i !== null) {
          (i.return = a, tl = i);
          break a;
        }
        tl = a;
      }
    }
  }
  var Fl = {
    getCacheForType: function (e) {
      var t = Ji(ea), n = t.data.get(e);
      return (n === void 0 && (n = e(), t.data.set(e, n)), n);
    },
    cacheSignal: function () {
      return Ji(ea).controller.signal;
    }
  }, Il = typeof WeakMap == `function` ? WeakMap : Map, J = 0, Ll = null, Y = null, X = 0, Z = 0, Rl = null, zl = !1, Bl = !1, Vl = !1, Hl = 0, Ul = 0, Wl = 0, Gl = 0, Kl = 0, ql = 0, Jl = 0, Yl = null, Xl = null, Zl = !1, Ql = 0, $l = 0, eu = 1 / 0, tu = null, nu = null, ru = 0, iu = null, au = null, ou = 0, su = 0, cu = null, lu = null, uu = 0, du = null;
  function fu() {
    return J & 2 && X !== 0 ? X & -X : j.T === null ? tt() : ud();
  }
  function pu() {
    if (ql === 0) {
      if (!(X & 536870912) || K) {
        var e = Ve;
        (Ve <<= 1, !(Ve & 3932160) && (Ve = 262144), ql = e);
      } else ql = 536870912;
    }
    return (e = Xa.current, e !== null && (e.flags |= 32), ql);
  }
  function mu(e, t, n) {
    ((e === Ll && (Z === 2 || Z === 9) || e.cancelPendingCommit !== null) && (xu(e, 0), vu(e, X, ql, !1)), Je(e, n), (!(J & 2) || e !== Ll) && (e === Ll && (!(J & 2) && (Gl |= n), Ul === 4 && vu(e, X, ql, !1)), nd(e)));
  }
  function hu(e, t, n) {
    if (J & 6) throw Error(s(327));
    var r = !n && !(t & 127) && (t & e.expiredLanes) === 0 || Ge(e, t), i = r ? ku(e, t) : Du(e, t, !0), a = r;
    do {
      if (i === 0) {
        Bl && !r && vu(e, t, 0, !1);
        break;
      }
      if ((n = e.current.alternate, a && !_u(n))) {
        (i = Du(e, t, !1), a = !1);
        continue;
      }
      if (i === 2) {
        if ((a = t, e.errorRecoveryDisabledLanes & a)) var o = 0; else (o = e.pendingLanes & -536870913, o = o === 0 ? o & 536870912 ? 536870912 : 0 : o);
        if (o !== 0) {
          t = o;
          a: {
            var c = e;
            i = Yl;
            var l = c.current.memoizedState.isDehydrated;
            if ((l && (xu(c, o).flags |= 256), o = Du(c, o, !1), o !== 2)) {
              if (Vl && !l) {
                (c.errorRecoveryDisabledLanes |= a, Gl |= a, i = 4);
                break a;
              }
              (a = Xl, Xl = i, a !== null && (Xl === null ? Xl = a : Xl.push.apply(Xl, a)));
            }
            i = o;
          }
          if ((a = !1, i !== 2)) continue;
        }
      }
      if (i === 1) {
        (xu(e, 0), vu(e, t, 0, !0));
        break;
      }
      a: {
        switch ((r = e, a = i, a)) {
          case 0:
          case 1:
            throw Error(s(345));
          case 4:
            if ((t & 4194048) !== t) break;
          case 6:
            vu(r, t, ql, !zl);
            break a;
          case 2:
            Xl = null;
            break;
          case 3:
          case 5:
            break;
          default:
            throw Error(s(329));
        }
        if ((t & 62914560) === t && (i = Ql + 300 - we(), 10 < i)) {
          if ((vu(r, t, ql, !zl), We(r, 0, !0) !== 0)) break a;
          (ou = t, r.timeoutHandle = Kd(gu.bind(null, r, n, Xl, tu, Zl, t, ql, Gl, Jl, zl, a, `Throttled`, -0, 0), i));
          break a;
        }
        gu(r, n, Xl, tu, Zl, t, ql, Gl, Jl, zl, a, null, -0, 0);
      }
      break;
    } while (1);
    nd(e);
  }
  function gu(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
    if ((e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408)) {
      (d = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Kt
      }, kl(t, a, d));
      var m = (a & 62914560) === a ? Ql - we() : (a & 4194048) === a ? $l - we() : 0;
      if ((m = qf(d, m), m !== null)) {
        (ou = a, e.cancelPendingCommit = m(Iu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), vu(e, a, o, !l));
        return;
      }
    }
    Iu(e, t, a, n, r, i, o, s, c);
  }
  function _u(e) {
    for (var t = e; ; ) {
      var n = t.tag;
      if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
        var i = n[r], a = i.getSnapshot;
        i = i.value;
        try {
          if (!hr(a(), i)) return !1;
        } catch {
          return !1;
        }
      }
      if ((n = t.child, t.subtreeFlags & 16384 && n !== null)) (n.return = t, t = n); else {
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        (t.sibling.return = t.return, t = t.sibling);
      }
    }
    return !0;
  }
  function vu(e, t, n, r) {
    (t &= ~Kl, t &= ~Gl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes);
    for (var i = t; 0 < i; ) {
      var a = 31 - Ie(i), o = 1 << a;
      (r[a] = -1, i &= ~o);
    }
    n !== 0 && Xe(e, n, t);
  }
  function yu() {
    return J & 6 ? !0 : (rd(0, !1), !1);
  }
  function bu() {
    if (Y !== null) {
      if (Z === 0) var e = Y.return; else (e = Y, Bi = zi = null, wo(e), Ta = null, Ea = 0, e = Y);
      for (; e !== null; ) (Lc(e.alternate, e), e = e.return);
      Y = null;
    }
  }
  function xu(e, t) {
    var n = e.timeoutHandle;
    (n !== -1 && (e.timeoutHandle = -1, qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), ou = 0, bu(), Ll = e, Y = n = ri(e.current, null), X = t, Z = 0, Rl = null, zl = !1, Bl = Ge(e, t), Vl = !1, Jl = ql = Kl = Gl = Wl = Ul = 0, Xl = Yl = null, Zl = !1, t & 8 && (t |= t & 32));
    var r = e.entangledLanes;
    if (r !== 0) for ((e = e.entanglements, r &= t); 0 < r; ) {
      var i = 31 - Ie(r), a = 1 << i;
      (t |= e[i], r &= ~a);
    }
    return (Hl = t, qr(), n);
  }
  function Su(e, t) {
    (q = null, j.H = Ps, t === ha || t === _a ? (t = Ca(), Z = 3) : t === ga ? (t = Ca(), Z = 4) : Z = t === Qs ? 8 : typeof t == `object` && t && typeof t.then == `function` ? 6 : 1, Rl = t, Y === null && (Ul = 1, Ks(e, di(t, e.current))));
  }
  function Cu() {
    var e = Xa.current;
    return e === null ? !0 : (X & 4194048) === X ? Za === null : (X & 62914560) === X || X & 536870912 ? e === Za : !1;
  }
  function wu() {
    var e = j.H;
    return (j.H = Ps, e === null ? Ps : e);
  }
  function Tu() {
    var e = j.A;
    return (j.A = Fl, e);
  }
  function Eu() {
    (Ul = 4, zl || (X & 4194048) !== X && Xa.current !== null || (Bl = !0), !(Wl & 134217727) && !(Gl & 134217727) || Ll === null || vu(Ll, X, ql, !1));
  }
  function Du(e, t, n) {
    var r = J;
    J |= 2;
    var i = wu(), a = Tu();
    ((Ll !== e || X !== t) && (tu = null, xu(e, t)), t = !1);
    var o = Ul;
    a: do try {
      if (Z !== 0 && Y !== null) {
        var s = Y, c = Rl;
        switch (Z) {
          case 8:
            (bu(), o = 6);
            break a;
          case 3:
          case 2:
          case 9:
          case 6:
            Xa.current === null && (t = !0);
            var l = Z;
            if ((Z = 0, Rl = null, Nu(e, s, c, l), n && Bl)) {
              o = 0;
              break a;
            }
            break;
          default:
            (l = Z, Z = 0, Rl = null, Nu(e, s, c, l));
        }
      }
      (Ou(), o = Ul);
      break;
    } catch (t) {
      Su(e, t);
    } while (1);
    return (t && e.shellSuspendCounter++, Bi = zi = null, J = r, j.H = i, j.A = a, Y === null && (Ll = null, X = 0, qr()), o);
  }
  function Ou() {
    for (; Y !== null; ) ju(Y);
  }
  function ku(e, t) {
    var n = J;
    J |= 2;
    var r = wu(), i = Tu();
    Ll !== e || X !== t ? (tu = null, eu = we() + 500, xu(e, t)) : Bl = Ge(e, t);
    a: do try {
      if (Z !== 0 && Y !== null) {
        t = Y;
        var a = Rl;
        b: switch (Z) {
          case 1:
            (Z = 0, Rl = null, Nu(e, t, a, 1));
            break;
          case 2:
          case 9:
            if (ya(a)) {
              (Z = 0, Rl = null, Mu(t));
              break;
            }
            (t = function () {
              (Z !== 2 && Z !== 9 || Ll !== e || (Z = 7), nd(e));
            }, a.then(t, t));
            break a;
          case 3:
            Z = 7;
            break a;
          case 4:
            Z = 5;
            break a;
          case 7:
            ya(a) ? (Z = 0, Rl = null, Mu(t)) : (Z = 0, Rl = null, Nu(e, t, a, 7));
            break;
          case 5:
            var o = null;
            switch (Y.tag) {
              case 26:
                o = Y.memoizedState;
              case 5:
              case 27:
                var c = Y;
                if (o ? Wf(o) : c.stateNode.complete) {
                  (Z = 0, Rl = null);
                  var l = c.sibling;
                  if (l !== null) Y = l; else {
                    var u = c.return;
                    u === null ? Y = null : (Y = u, Pu(u));
                  }
                  break b;
                }
            }
            (Z = 0, Rl = null, Nu(e, t, a, 5));
            break;
          case 6:
            (Z = 0, Rl = null, Nu(e, t, a, 6));
            break;
          case 8:
            (bu(), Ul = 6);
            break a;
          default:
            throw Error(s(462));
        }
      }
      Au();
      break;
    } catch (t) {
      Su(e, t);
    } while (1);
    return (Bi = zi = null, j.H = r, j.A = i, J = n, Y === null ? (Ll = null, X = 0, qr(), Ul) : 0);
  }
  function Au() {
    for (; Y !== null && !Se(); ) ju(Y);
  }
  function ju(e) {
    var t = Oc(e.alternate, e, Hl);
    (e.memoizedProps = e.pendingProps, t === null ? Pu(e) : Y = t);
  }
  function Mu(e) {
    var t = e, n = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = fc(n, t, t.pendingProps, t.type, void 0, X);
        break;
      case 11:
        t = fc(n, t, t.pendingProps, t.type.render, t.ref, X);
        break;
      case 5:
        wo(t);
      default:
        (Lc(n, t), t = Y = ii(t, Hl), t = Oc(n, t, Hl));
    }
    (e.memoizedProps = e.pendingProps, t === null ? Pu(e) : Y = t);
  }
  function Nu(e, t, n, r) {
    (Bi = zi = null, wo(t), Ta = null, Ea = 0);
    var i = t.return;
    try {
      if (Zs(e, i, t, n, X)) {
        (Ul = 1, Ks(e, di(n, e.current)), Y = null);
        return;
      }
    } catch (t) {
      if (i !== null) throw (Y = i, t);
      (Ul = 1, Ks(e, di(n, e.current)), Y = null);
      return;
    }
    t.flags & 32768 ? (K || r === 1 ? e = !0 : Bl || X & 536870912 ? e = !1 : (zl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Xa.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Fu(t, e)) : Pu(t);
  }
  function Pu(e) {
    var t = e;
    do {
      if (t.flags & 32768) {
        Fu(t, zl);
        return;
      }
      e = t.return;
      var n = Fc(t.alternate, t, Hl);
      if (n !== null) {
        Y = n;
        return;
      }
      if ((t = t.sibling, t !== null)) {
        Y = t;
        return;
      }
      Y = t = e;
    } while (t !== null);
    Ul === 0 && (Ul = 5);
  }
  function Fu(e, t) {
    do {
      var n = Ic(e.alternate, e);
      if (n !== null) {
        (n.flags &= 32767, Y = n);
        return;
      }
      if ((n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null))) {
        Y = e;
        return;
      }
      Y = e = n;
    } while (e !== null);
    (Ul = 6, Y = null);
  }
  function Iu(e, t, n, r, i, a, o, c, l) {
    e.cancelPendingCommit = null;
    do Vu(); while (ru !== 0);
    if (J & 6) throw Error(s(327));
    if (t !== null) {
      if (t === e.current) throw Error(s(177));
      if ((a = t.lanes | t.childLanes, a |= Kr, Ye(e, n, a, o, c, l), e === Ll && (Y = Ll = null, X = 0), au = t, iu = e, ou = n, su = a, cu = i, lu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Yu(Oe, function () {
        return (Hu(), null);
      })) : (e.callbackNode = null, e.callbackPriority = 0), r = !!(t.flags & 13878), t.subtreeFlags & 13878 || r)) {
        (r = j.T, j.T = null, i = M.p, M.p = 2, o = J, J |= 4);
        try {
          nl(e, t, n);
        } finally {
          (J = o, M.p = i, j.T = r);
        }
      }
      (ru = 1, Lu(), Ru(), zu());
    }
  }
  function Lu() {
    if (ru === 1) {
      ru = 0;
      var e = iu, t = au, n = !!(t.flags & 13878);
      if (t.subtreeFlags & 13878 || n) {
        (n = j.T, j.T = null);
        var r = M.p;
        M.p = 2;
        var i = J;
        J |= 4;
        try {
          hl(t, e);
          var a = zd, o = br(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
          if (o !== s && s && s.ownerDocument && yr(s.ownerDocument.documentElement, s)) {
            if (c !== null && xr(s)) {
              var l = c.start, u = c.end;
              if ((u === void 0 && (u = l), (`selectionStart` in s))) (s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length)); else {
                var d = s.ownerDocument || document, f = d && d.defaultView || window;
                if (f.getSelection) {
                  var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
                  !p.extend && h > g && (o = g, g = h, h = o);
                  var _ = vr(s, h), v = vr(s, g);
                  if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
                    var y = d.createRange();
                    (y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y)));
                  }
                }
              }
            }
            for ((d = [], p = s); p = p.parentNode; ) p.nodeType === 1 && d.push({
              element: p,
              left: p.scrollLeft,
              top: p.scrollTop
            });
            for ((typeof s.focus == `function` && s.focus(), s = 0); s < d.length; s++) {
              var b = d[s];
              (b.element.scrollLeft = b.left, b.element.scrollTop = b.top);
            }
          }
          (sp = !!Rd, zd = Rd = null);
        } finally {
          (J = i, M.p = r, j.T = n);
        }
      }
      (e.current = t, ru = 2);
    }
  }
  function Ru() {
    if (ru === 2) {
      ru = 0;
      var e = iu, t = au, n = !!(t.flags & 8772);
      if (t.subtreeFlags & 8772 || n) {
        (n = j.T, j.T = null);
        var r = M.p;
        M.p = 2;
        var i = J;
        J |= 4;
        try {
          rl(e, t.alternate, t);
        } finally {
          (J = i, M.p = r, j.T = n);
        }
      }
      ru = 3;
    }
  }
  function zu() {
    if (ru === 4 || ru === 3) {
      (ru = 0, Ce());
      var e = iu, t = au, n = ou, r = lu;
      t.subtreeFlags & 10256 || t.flags & 10256 ? ru = 5 : (ru = 0, au = iu = null, Bu(e, e.pendingLanes));
      var i = e.pendingLanes;
      if ((i === 0 && (nu = null), et(n), t = t.stateNode, Pe && typeof Pe.onCommitFiberRoot == `function`)) try {
        Pe.onCommitFiberRoot(Ne, t, void 0, (t.current.flags & 128) == 128);
      } catch {}
      if (r !== null) {
        (t = j.T, i = M.p, M.p = 2, j.T = null);
        try {
          for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
            var s = r[o];
            a(s.value, {
              componentStack: s.stack
            });
          }
        } finally {
          (j.T = t, M.p = i);
        }
      }
      (ou & 3 && Vu(), nd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === du ? uu++ : (uu = 0, du = e) : uu = 0, rd(0, !1));
    }
  }
  function Bu(e, t) {
    (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, na(t)));
  }
  function Vu() {
    return (Lu(), Ru(), zu(), Hu());
  }
  function Hu() {
    if (ru !== 5) return !1;
    var e = iu, t = su;
    su = 0;
    var n = et(ou), r = j.T, i = M.p;
    try {
      (M.p = 32 > n ? 32 : n, j.T = null, n = cu, cu = null);
      var a = iu, o = ou;
      if ((ru = 0, au = iu = null, ou = 0, J & 6)) throw Error(s(331));
      var c = J;
      if ((J |= 4, Ml(a.current), wl(a, a.current, o, n), J = c, rd(0, !1), Pe && typeof Pe.onPostCommitFiberRoot == `function`)) try {
        Pe.onPostCommitFiberRoot(Ne, a);
      } catch {}
      return !0;
    } finally {
      (M.p = i, j.T = r, Bu(e, t));
    }
  }
  function Uu(e, t, n) {
    (t = di(n, t), t = Js(e.stateNode, t, 2), e = La(e, t, 2), e !== null && (Je(e, 2), nd(e)));
  }
  function Q(e, t, n) {
    if (e.tag === 3) Uu(e, e, n); else for (; t !== null; ) {
      if (t.tag === 3) {
        Uu(t, e, n);
        break;
      }
      if (t.tag === 1) {
        var r = t.stateNode;
        if (typeof t.type.getDerivedStateFromError == `function` || typeof r.componentDidCatch == `function` && (nu === null || !nu.has(r))) {
          (e = di(n, e), n = Ys(2), r = La(t, n, 2), r !== null && (Xs(n, r, t, e), Je(r, 2), nd(r)));
          break;
        }
      }
      t = t.return;
    }
  }
  function Wu(e, t, n) {
    var r = e.pingCache;
    if (r === null) {
      r = e.pingCache = new Il();
      var i = new Set();
      r.set(t, i);
    } else (i = r.get(t), i === void 0 && (i = new Set(), r.set(t, i)));
    i.has(n) || (Vl = !0, i.add(n), e = Gu.bind(null, e, t, n), t.then(e, e));
  }
  function Gu(e, t, n) {
    var r = e.pingCache;
    (r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, Ll === e && (X & n) === n && (Ul === 4 || Ul === 3 && (X & 62914560) === X && 300 > we() - Ql ? !(J & 2) && xu(e, 0) : Kl |= n, Jl === X && (Jl = 0)), nd(e));
  }
  function Ku(e, t) {
    (t === 0 && (t = Ke()), e = Xr(e, t), e !== null && (Je(e, t), nd(e)));
  }
  function qu(e) {
    var t = e.memoizedState, n = 0;
    (t !== null && (n = t.retryLane), Ku(e, n));
  }
  function Ju(e, t) {
    var n = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var r = e.stateNode, i = e.memoizedState;
        i !== null && (n = i.retryLane);
        break;
      case 19:
        r = e.stateNode;
        break;
      case 22:
        r = e.stateNode._retryCache;
        break;
      default:
        throw Error(s(314));
    }
    (r !== null && r.delete(t), Ku(e, n));
  }
  function Yu(e, t) {
    return be(e, t);
  }
  var Xu = null, Zu = null, Qu = !1, $u = !1, ed = !1, td = 0;
  function nd(e) {
    (e !== Zu && e.next === null && (Zu === null ? Xu = Zu = e : Zu = Zu.next = e), $u = !0, Qu || (Qu = !0, ld()));
  }
  function rd(e, t) {
    if (!ed && $u) {
      ed = !0;
      do for (var n = !1, r = Xu; r !== null; ) {
        if (!t) {
          if (e !== 0) {
            var i = r.pendingLanes;
            if (i === 0) var a = 0; else {
              var o = r.suspendedLanes, s = r.pingedLanes;
              (a = (1 << 31 - Ie(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0);
            }
            a !== 0 && (n = !0, cd(r, a));
          } else (a = X, a = We(r, r === Ll ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || Ge(r, a) || (n = !0, cd(r, a)));
        }
        r = r.next;
      } while (n);
      ed = !1;
    }
  }
  function id() {
    ad();
  }
  function ad() {
    $u = Qu = !1;
    var e = 0;
    td !== 0 && Gd() && (e = td);
    for (var t = we(), n = null, r = Xu; r !== null; ) {
      var i = r.next, a = od(r, t);
      (a === 0 ? (r.next = null, n === null ? Xu = i : n.next = i, i === null && (Zu = n)) : (n = r, (e !== 0 || a & 3) && ($u = !0)), r = i);
    }
    (ru !== 0 && ru !== 5 || rd(e, !1), td !== 0 && (td = 0));
  }
  function od(e, t) {
    for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a; ) {
      var o = 31 - Ie(a), s = 1 << o, c = i[o];
      (c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = B(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s);
    }
    if ((t = Ll, n = X, n = We(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Z === 2 || Z === 9) || e.cancelPendingCommit !== null)) return (r !== null && r !== null && xe(r), e.callbackNode = null, e.callbackPriority = 0);
    if (!(n & 3) || Ge(e, n)) {
      if ((t = n & -n, t === e.callbackPriority)) return t;
      switch ((r !== null && xe(r), et(n))) {
        case 2:
        case 8:
          n = De;
          break;
        case 32:
          n = Oe;
          break;
        case 268435456:
          n = Ae;
          break;
        default:
          n = Oe;
      }
      return (r = sd.bind(null, e), n = be(n, r), e.callbackPriority = t, e.callbackNode = n, t);
    }
    return (r !== null && r !== null && xe(r), e.callbackPriority = 2, e.callbackNode = null, 2);
  }
  function sd(e, t) {
    if (ru !== 0 && ru !== 5) return (e.callbackNode = null, e.callbackPriority = 0, null);
    var n = e.callbackNode;
    if (Vu() && e.callbackNode !== n) return null;
    var r = X;
    return (r = We(e, e === Ll ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (hu(e, r, t), od(e, we()), e.callbackNode != null && e.callbackNode === n ? sd.bind(null, e) : null));
  }
  function cd(e, t) {
    if (Vu()) return null;
    hu(e, t, !0);
  }
  function ld() {
    Yd(function () {
      J & 6 ? be(Ee, id) : ad();
    });
  }
  function ud() {
    if (td === 0) {
      var e = aa;
      (e === 0 && (e = Be, Be <<= 1, !(Be & 261888) && (Be = 256)), td = e);
    }
    return td;
  }
  function dd(e) {
    return e == null || typeof e == `symbol` || typeof e == `boolean` ? null : typeof e == `function` ? e : Gt(`` + e);
  }
  function fd(e, t) {
    var n = t.ownerDocument.createElement(`input`);
    return (n.name = t.name, n.value = t.value, e.id && n.setAttribute(`form`, e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e);
  }
  function pd(e, t, n, r, i) {
    if (t === `submit` && n && n.stateNode === i) {
      var a = dd((i[at] || null).action), o = r.submitter;
      o && (t = (t = o[at] || null) ? dd(t.formAction) : o.getAttribute(`formAction`), t !== null && (a = t, o = null));
      var s = new mn(`action`, `action`, null, r, i);
      e.push({
        event: s,
        listeners: [{
          instance: null,
          listener: function () {
            if (r.defaultPrevented) {
              if (td !== 0) {
                var e = o ? fd(i, o) : new FormData(i);
                bs(n, {
                  pending: !0,
                  data: e,
                  method: i.method,
                  action: a
                }, null, e);
              }
            } else typeof a == `function` && (s.preventDefault(), e = o ? fd(i, o) : new FormData(i), bs(n, {
              pending: !0,
              data: e,
              method: i.method,
              action: a
            }, a, e));
          },
          currentTarget: i
        }]
      });
    }
  }
  for (var md = 0; md < Vr.length; md++) {
    var hd = Vr[md];
    Hr(hd.toLowerCase(), `on` + (hd[0].toUpperCase() + hd.slice(1)));
  }
  (Hr(Nr, `onAnimationEnd`), Hr(Pr, `onAnimationIteration`), Hr(Fr, `onAnimationStart`), Hr(`dblclick`, `onDoubleClick`), Hr(`focusin`, `onFocus`), Hr(`focusout`, `onBlur`), Hr(Ir, `onTransitionRun`), Hr(Lr, `onTransitionStart`), Hr(Rr, `onTransitionCancel`), Hr(zr, `onTransitionEnd`), G(`onMouseEnter`, [`mouseout`, `mouseover`]), G(`onMouseLeave`, [`mouseout`, `mouseover`]), G(`onPointerEnter`, [`pointerout`, `pointerover`]), G(`onPointerLeave`, [`pointerout`, `pointerover`]), gt(`onChange`, `change click focusin focusout input keydown keyup selectionchange`.split(` `)), gt(`onSelect`, `focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange`.split(` `)), gt(`onBeforeInput`, [`compositionend`, `keypress`, `textInput`, `paste`]), gt(`onCompositionEnd`, `compositionend focusout keydown keypress keyup mousedown`.split(` `)), gt(`onCompositionStart`, `compositionstart focusout keydown keypress keyup mousedown`.split(` `)), gt(`onCompositionUpdate`, `compositionupdate focusout keydown keypress keyup mousedown`.split(` `)));
  var gd = `abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting`.split(` `), _d = new Set(`beforetoggle cancel close invalid load scroll scrollend toggle`.split(` `).concat(gd));
  function vd(e, t) {
    t = !!(t & 4);
    for (var n = 0; n < e.length; n++) {
      var r = e[n], i = r.event;
      r = r.listeners;
      a: {
        var a = void 0;
        if (t) for (var o = r.length - 1; 0 <= o; o--) {
          var s = r[o], c = s.instance, l = s.currentTarget;
          if ((s = s.listener, c !== a && i.isPropagationStopped())) break a;
          (a = s, i.currentTarget = l);
          try {
            a(i);
          } catch (e) {
            Ur(e);
          }
          (i.currentTarget = null, a = c);
        } else for (o = 0; o < r.length; o++) {
          if ((s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped())) break a;
          (a = s, i.currentTarget = l);
          try {
            a(i);
          } catch (e) {
            Ur(e);
          }
          (i.currentTarget = null, a = c);
        }
      }
    }
  }
  function $(e, t) {
    var n = t[st];
    n === void 0 && (n = t[st] = new Set());
    var r = e + `__bubble`;
    n.has(r) || (Sd(t, e, 2, !1), n.add(r));
  }
  function yd(e, t, n) {
    var r = 0;
    (t && (r |= 4), Sd(n, e, r, t));
  }
  var bd = `_reactListening` + Math.random().toString(36).slice(2);
  function xd(e) {
    if (!e[bd]) {
      (e[bd] = !0, W.forEach(function (t) {
        t !== `selectionchange` && (_d.has(t) || yd(t, !1, e), yd(t, !0, e));
      }));
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[bd] || (t[bd] = !0, yd(`selectionchange`, !1, t));
    }
  }
  function Sd(e, t, n, r) {
    switch (mp(t)) {
      case 2:
        var i = cp;
        break;
      case 8:
        i = lp;
        break;
      default:
        i = up;
    }
    (n = i.bind(null, t, n, e), i = void 0, !nn || t !== `touchstart` && t !== `touchmove` && t !== `wheel` || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
      capture: !0,
      passive: i
    }) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, {
      passive: i
    }));
  }
  function Cd(e, t, n, r, i) {
    var a = r;
    if (!(t & 1) && !(t & 2) && r !== null) a: for (; ; ) {
      if (r === null) return;
      var o = r.tag;
      if (o === 3 || o === 4) {
        var s = r.stateNode.containerInfo;
        if (s === i) break;
        if (o === 4) for (o = r.return; o !== null; ) {
          var c = o.tag;
          if ((c === 3 || c === 4) && o.stateNode.containerInfo === i) return;
          o = o.return;
        }
        for (; s !== null; ) {
          if ((o = ft(s), o === null)) return;
          if ((c = o.tag, c === 5 || c === 6 || c === 26 || c === 27)) {
            r = a = o;
            continue a;
          }
          s = s.parentNode;
        }
      }
      r = r.return;
    }
    $t(function () {
      var r = a, i = Jt(n), o = [];
      a: {
        var s = Br.get(e);
        if (s !== void 0) {
          var c = mn, u = e;
          switch (e) {
            case `keypress`:
              if (ln(n) === 0) break a;
            case `keydown`:
            case `keyup`:
              c = Mn;
              break;
            case `focusin`:
              (u = `focus`, c = Cn);
              break;
            case `focusout`:
              (u = `blur`, c = Cn);
              break;
            case `beforeblur`:
            case `afterblur`:
              c = Cn;
              break;
            case `click`:
              if (n.button === 2) break a;
            case `auxclick`:
            case `dblclick`:
            case `mousedown`:
            case `mousemove`:
            case `mouseup`:
            case `mouseout`:
            case `mouseover`:
            case `contextmenu`:
              c = xn;
              break;
            case `drag`:
            case `dragend`:
            case `dragenter`:
            case `dragexit`:
            case `dragleave`:
            case `dragover`:
            case `dragstart`:
            case `drop`:
              c = Sn;
              break;
            case `touchcancel`:
            case `touchend`:
            case `touchmove`:
            case `touchstart`:
              c = Pn;
              break;
            case Nr:
            case Pr:
            case Fr:
              c = wn;
              break;
            case zr:
              c = Fn;
              break;
            case `scroll`:
            case `scrollend`:
              c = gn;
              break;
            case `wheel`:
              c = In;
              break;
            case `copy`:
            case `cut`:
            case `paste`:
              c = Tn;
              break;
            case `gotpointercapture`:
            case `lostpointercapture`:
            case `pointercancel`:
            case `pointerdown`:
            case `pointermove`:
            case `pointerout`:
            case `pointerover`:
            case `pointerup`:
              c = Nn;
              break;
            case `toggle`:
            case `beforetoggle`:
              c = Ln;
          }
          var d = !!(t & 4), f = !d && (e === `scroll` || e === `scrollend`), p = d ? s === null ? null : s + `Capture` : s;
          d = [];
          for (var m = r, h; m !== null; ) {
            var g = m;
            if ((h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = en(m, p), g != null && d.push(wd(m, g, h))), f)) break;
            m = m.return;
          }
          0 < d.length && (s = new c(s, u, null, n, i), o.push({
            event: s,
            listeners: d
          }));
        }
      }
      if (!(t & 7)) {
        a: {
          if ((s = e === `mouseover` || e === `pointerover`, c = e === `mouseout` || e === `pointerout`, s && n !== qt && (u = n.relatedTarget || n.fromElement) && (ft(u) || u[ot]))) break a;
          if ((c || s) && (s = i.window === i ? i : (s = i.ownerDocument) ? s.defaultView || s.parentWindow : window, c ? (u = n.relatedTarget || n.toElement, c = r, u = u ? ft(u) : null, u !== null && (f = l(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (c = null, u = r), c !== u)) {
            if ((d = xn, g = `onMouseLeave`, p = `onMouseEnter`, m = `mouse`, (e === `pointerout` || e === `pointerover`) && (d = Nn, g = `onPointerLeave`, p = `onPointerEnter`, m = `pointer`), f = c == null ? s : mt(c), h = u == null ? s : mt(u), s = new d(g, m + `leave`, c, n, i), s.target = f, s.relatedTarget = h, g = null, ft(i) === r && (d = new d(p, m + `enter`, u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, c && u)) b: {
              for ((d = Ed, p = c, m = u, h = 0, g = p); g; g = d(g)) h++;
              g = 0;
              for (var _ = m; _; _ = d(_)) g++;
              for (; 0 < h - g; ) (p = d(p), h--);
              for (; 0 < g - h; ) (m = d(m), g--);
              for (; h--; ) {
                if (p === m || m !== null && p === m.alternate) {
                  d = p;
                  break b;
                }
                (p = d(p), m = d(m));
              }
              d = null;
            } else d = null;
            (c !== null && Dd(o, s, c, d, !1), u !== null && f !== null && Dd(o, f, u, d, !0));
          }
        }
        a: {
          if ((s = r ? mt(r) : window, c = s.nodeName && s.nodeName.toLowerCase(), c === `select` || c === `input` && s.type === `file`)) var v = rr; else if (Zn(s)) {
            if (ir) v = pr; else {
              v = dr;
              var y = ur;
            }
          } else (c = s.nodeName, !c || c.toLowerCase() !== `input` || s.type !== `checkbox` && s.type !== `radio` ? r && Ht(r.elementType) && (v = rr) : v = fr);
          if (v &&= v(e, r)) {
            Qn(o, v, n, i);
            break a;
          }
          (y && y(e, s, r), e === `focusout` && r && s.type === `number` && r.memoizedProps.value != null && Pt(s, `number`, s.value));
        }
        switch ((y = r ? mt(r) : window, e)) {
          case `focusin`:
            (Zn(y) || y.contentEditable === `true`) && (Cr = y, wr = r, Tr = null);
            break;
          case `focusout`:
            Tr = wr = Cr = null;
            break;
          case `mousedown`:
            Er = !0;
            break;
          case `contextmenu`:
          case `mouseup`:
          case `dragend`:
            (Er = !1, Dr(o, n, i));
            break;
          case `selectionchange`:
            if (Sr) break;
          case `keydown`:
          case `keyup`:
            Dr(o, n, i);
        }
        var b;
        if (zn) b: {
          switch (e) {
            case `compositionstart`:
              var x = `onCompositionStart`;
              break b;
            case `compositionend`:
              x = `onCompositionEnd`;
              break b;
            case `compositionupdate`:
              x = `onCompositionUpdate`;
              break b;
          }
          x = void 0;
        } else qn ? Gn(e, n) && (x = `onCompositionEnd`) : e === `keydown` && n.keyCode === 229 && (x = `onCompositionStart`);
        (x && (Hn && n.locale !== `ko` && (qn || x !== `onCompositionStart` ? x === `onCompositionEnd` && qn && (b = cn()) : (an = i, on = (`value` in an) ? an.value : an.textContent, qn = !0)), y = Td(r, x), 0 < y.length && (x = new En(x, e, null, n, i), o.push({
          event: x,
          listeners: y
        }), b ? x.data = b : (b = Kn(n), b !== null && (x.data = b)))), (b = Vn ? Jn(e, n) : Yn(e, n)) && (x = Td(r, `onBeforeInput`), 0 < x.length && (y = new En(`onBeforeInput`, `beforeinput`, null, n, i), o.push({
          event: y,
          listeners: x
        }), y.data = b)), pd(o, e, r, n, i));
      }
      vd(o, t);
    });
  }
  function wd(e, t, n) {
    return {
      instance: e,
      listener: t,
      currentTarget: n
    };
  }
  function Td(e, t) {
    for (var n = t + `Capture`, r = []; e !== null; ) {
      var i = e, a = i.stateNode;
      if ((i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = en(e, n), i != null && r.unshift(wd(e, i, a)), i = en(e, t), i != null && r.push(wd(e, i, a))), e.tag === 3)) return r;
      e = e.return;
    }
    return [];
  }
  function Ed(e) {
    if (e === null) return null;
    do e = e.return; while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function Dd(e, t, n, r, i) {
    for (var a = t._reactName, o = []; n !== null && n !== r; ) {
      var s = n, c = s.alternate, l = s.stateNode;
      if ((s = s.tag, c !== null && c === r)) break;
      (s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = en(n, a), l != null && o.unshift(wd(n, l, c))) : i || (l = en(n, a), l != null && o.push(wd(n, l, c)))), n = n.return);
    }
    o.length !== 0 && e.push({
      event: t,
      listeners: o
    });
  }
  var Od = /\r\n?/g, kd = /\u0000|\uFFFD/g;
  function Ad(e) {
    return (typeof e == `string` ? e : `` + e).replace(Od, `
`).replace(kd, ``);
  }
  function jd(e, t) {
    return (t = Ad(t), Ad(e) === t);
  }
  function Md(e, t, n, r, i, a) {
    switch (n) {
      case `children`:
        typeof r == `string` ? t === `body` || t === `textarea` && r === `` || Rt(e, r) : (typeof r == `number` || typeof r == `bigint`) && t !== `body` && Rt(e, `` + r);
        break;
      case `className`:
        St(e, `class`, r);
        break;
      case `tabIndex`:
        St(e, `tabindex`, r);
        break;
      case `dir`:
      case `role`:
      case `viewBox`:
      case `width`:
      case `height`:
        St(e, n, r);
        break;
      case `style`:
        Vt(e, r, a);
        break;
      case `data`:
        if (t !== `object`) {
          St(e, `data`, r);
          break;
        }
      case `src`:
      case `href`:
        if (r === `` && (t !== `a` || n !== `href`)) {
          e.removeAttribute(n);
          break;
        }
        if (r == null || typeof r == `function` || typeof r == `symbol` || typeof r == `boolean`) {
          e.removeAttribute(n);
          break;
        }
        (r = Gt(`` + r), e.setAttribute(n, r));
        break;
      case `action`:
      case `formAction`:
        if (typeof r == `function`) {
          e.setAttribute(n, `javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')`);
          break;
        }
        if ((typeof a == `function` && (n === `formAction` ? (t !== `input` && Md(e, t, `name`, i.name, i, null), Md(e, t, `formEncType`, i.formEncType, i, null), Md(e, t, `formMethod`, i.formMethod, i, null), Md(e, t, `formTarget`, i.formTarget, i, null)) : (Md(e, t, `encType`, i.encType, i, null), Md(e, t, `method`, i.method, i, null), Md(e, t, `target`, i.target, i, null))), r == null || typeof r == `symbol` || typeof r == `boolean`)) {
          e.removeAttribute(n);
          break;
        }
        (r = Gt(`` + r), e.setAttribute(n, r));
        break;
      case `onClick`:
        r != null && (e.onclick = Kt);
        break;
      case `onScroll`:
        r != null && $(`scroll`, e);
        break;
      case `onScrollEnd`:
        r != null && $(`scrollend`, e);
        break;
      case `dangerouslySetInnerHTML`:
        if (r != null) {
          if (typeof r != `object` || !((`__html` in r))) throw Error(s(61));
          if ((n = r.__html, n != null)) {
            if (i.children != null) throw Error(s(60));
            e.innerHTML = n;
          }
        }
        break;
      case `multiple`:
        e.multiple = r && typeof r != `function` && typeof r != `symbol`;
        break;
      case `muted`:
        e.muted = r && typeof r != `function` && typeof r != `symbol`;
        break;
      case `suppressContentEditableWarning`:
      case `suppressHydrationWarning`:
      case `defaultValue`:
      case `defaultChecked`:
      case `innerHTML`:
      case `ref`:
        break;
      case `autoFocus`:
        break;
      case `xlinkHref`:
        if (r == null || typeof r == `function` || typeof r == `boolean` || typeof r == `symbol`) {
          e.removeAttribute(`xlink:href`);
          break;
        }
        (n = Gt(`` + r), e.setAttributeNS(`http://www.w3.org/1999/xlink`, `xlink:href`, n));
        break;
      case `contentEditable`:
      case `spellCheck`:
      case `draggable`:
      case `value`:
      case `autoReverse`:
      case `externalResourcesRequired`:
      case `focusable`:
      case `preserveAlpha`:
        r != null && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, `` + r) : e.removeAttribute(n);
        break;
      case `inert`:
      case `allowFullScreen`:
      case `async`:
      case `autoPlay`:
      case `controls`:
      case `default`:
      case `defer`:
      case `disabled`:
      case `disablePictureInPicture`:
      case `disableRemotePlayback`:
      case `formNoValidate`:
      case `hidden`:
      case `loop`:
      case `noModule`:
      case `noValidate`:
      case `open`:
      case `playsInline`:
      case `readOnly`:
      case `required`:
      case `reversed`:
      case `scoped`:
      case `seamless`:
      case `itemScope`:
        r && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, ``) : e.removeAttribute(n);
        break;
      case `capture`:
      case `download`:
        !0 === r ? e.setAttribute(n, ``) : !1 !== r && r != null && typeof r != `function` && typeof r != `symbol` ? e.setAttribute(n, r) : e.removeAttribute(n);
        break;
      case `cols`:
      case `rows`:
      case `size`:
      case `span`:
        r != null && typeof r != `function` && typeof r != `symbol` && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
        break;
      case `rowSpan`:
      case `start`:
        r == null || typeof r == `function` || typeof r == `symbol` || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
        break;
      case `popover`:
        ($(`beforetoggle`, e), $(`toggle`, e), xt(e, `popover`, r));
        break;
      case `xlinkActuate`:
        Ct(e, `http://www.w3.org/1999/xlink`, `xlink:actuate`, r);
        break;
      case `xlinkArcrole`:
        Ct(e, `http://www.w3.org/1999/xlink`, `xlink:arcrole`, r);
        break;
      case `xlinkRole`:
        Ct(e, `http://www.w3.org/1999/xlink`, `xlink:role`, r);
        break;
      case `xlinkShow`:
        Ct(e, `http://www.w3.org/1999/xlink`, `xlink:show`, r);
        break;
      case `xlinkTitle`:
        Ct(e, `http://www.w3.org/1999/xlink`, `xlink:title`, r);
        break;
      case `xlinkType`:
        Ct(e, `http://www.w3.org/1999/xlink`, `xlink:type`, r);
        break;
      case `xmlBase`:
        Ct(e, `http://www.w3.org/XML/1998/namespace`, `xml:base`, r);
        break;
      case `xmlLang`:
        Ct(e, `http://www.w3.org/XML/1998/namespace`, `xml:lang`, r);
        break;
      case `xmlSpace`:
        Ct(e, `http://www.w3.org/XML/1998/namespace`, `xml:space`, r);
        break;
      case `is`:
        xt(e, `is`, r);
        break;
      case `innerText`:
      case `textContent`:
        break;
      default:
        (!(2 < n.length) || n[0] !== `o` && n[0] !== `O` || n[1] !== `n` && n[1] !== `N`) && (n = Ut.get(n) || n, xt(e, n, r));
    }
  }
  function Nd(e, t, n, r, i, a) {
    switch (n) {
      case `style`:
        Vt(e, r, a);
        break;
      case `dangerouslySetInnerHTML`:
        if (r != null) {
          if (typeof r != `object` || !((`__html` in r))) throw Error(s(61));
          if ((n = r.__html, n != null)) {
            if (i.children != null) throw Error(s(60));
            e.innerHTML = n;
          }
        }
        break;
      case `children`:
        typeof r == `string` ? Rt(e, r) : (typeof r == `number` || typeof r == `bigint`) && Rt(e, `` + r);
        break;
      case `onScroll`:
        r != null && $(`scroll`, e);
        break;
      case `onScrollEnd`:
        r != null && $(`scrollend`, e);
        break;
      case `onClick`:
        r != null && (e.onclick = Kt);
        break;
      case `suppressContentEditableWarning`:
      case `suppressHydrationWarning`:
      case `innerHTML`:
      case `ref`:
        break;
      case `innerText`:
      case `textContent`:
        break;
      default:
        if (!ht.hasOwnProperty(n)) a: {
          if (n[0] === `o` && n[1] === `n` && (i = n.endsWith(`Capture`), t = n.slice(2, i ? n.length - 7 : void 0), a = e[at] || null, a = a == null ? null : a[n], typeof a == `function` && e.removeEventListener(t, a, i), typeof r == `function`)) {
            (typeof a != `function` && a !== null && ((n in e) ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, i));
            break a;
          }
          (n in e) ? e[n] = r : !0 === r ? e.setAttribute(n, ``) : xt(e, n, r);
        }
    }
  }
  function Pd(e, t, n) {
    switch (t) {
      case `div`:
      case `span`:
      case `svg`:
      case `path`:
      case `a`:
      case `g`:
      case `p`:
      case `li`:
        break;
      case `img`:
        ($(`error`, e), $(`load`, e));
        var r = !1, i = !1, a;
        for (a in n) if (n.hasOwnProperty(a)) {
          var o = n[a];
          if (o != null) switch (a) {
            case `src`:
              r = !0;
              break;
            case `srcSet`:
              i = !0;
              break;
            case `children`:
            case `dangerouslySetInnerHTML`:
              throw Error(s(137, t));
            default:
              Md(e, t, a, o, n, null);
          }
        }
        (i && Md(e, t, `srcSet`, n.srcSet, n, null), r && Md(e, t, `src`, n.src, n, null));
        return;
      case `input`:
        $(`invalid`, e);
        var c = a = o = i = null, l = null, u = null;
        for (r in n) if (n.hasOwnProperty(r)) {
          var d = n[r];
          if (d != null) switch (r) {
            case `name`:
              i = d;
              break;
            case `type`:
              o = d;
              break;
            case `checked`:
              l = d;
              break;
            case `defaultChecked`:
              u = d;
              break;
            case `value`:
              a = d;
              break;
            case `defaultValue`:
              c = d;
              break;
            case `children`:
            case `dangerouslySetInnerHTML`:
              if (d != null) throw Error(s(137, t));
              break;
            default:
              Md(e, t, r, d, n, null);
          }
        }
        Nt(e, a, c, l, u, o, i, !1);
        return;
      case `select`:
        for (i in ($(`invalid`, e), r = o = a = null, n)) if (n.hasOwnProperty(i) && (c = n[i], c != null)) switch (i) {
          case `value`:
            a = c;
            break;
          case `defaultValue`:
            o = c;
            break;
          case `multiple`:
            r = c;
          default:
            Md(e, t, i, c, n, null);
        }
        (t = a, n = o, e.multiple = !!r, t == null ? n != null && Ft(e, !!r, n, !0) : Ft(e, !!r, t, !1));
        return;
      case `textarea`:
        for (o in ($(`invalid`, e), a = i = r = null, n)) if (n.hasOwnProperty(o) && (c = n[o], c != null)) switch (o) {
          case `value`:
            r = c;
            break;
          case `defaultValue`:
            i = c;
            break;
          case `children`:
            a = c;
            break;
          case `dangerouslySetInnerHTML`:
            if (c != null) throw Error(s(91));
            break;
          default:
            Md(e, t, o, c, n, null);
        }
        Lt(e, r, i, a);
        return;
      case `option`:
        for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
          case `selected`:
            e.selected = r && typeof r != `function` && typeof r != `symbol`;
            break;
          default:
            Md(e, t, l, r, n, null);
        }
        return;
      case `dialog`:
        ($(`beforetoggle`, e), $(`toggle`, e), $(`cancel`, e), $(`close`, e));
        break;
      case `iframe`:
      case `object`:
        $(`load`, e);
        break;
      case `video`:
      case `audio`:
        for (r = 0; r < gd.length; r++) $(gd[r], e);
        break;
      case `image`:
        ($(`error`, e), $(`load`, e));
        break;
      case `details`:
        $(`toggle`, e);
        break;
      case `embed`:
      case `source`:
      case `link`:
        ($(`error`, e), $(`load`, e));
      case `area`:
      case `base`:
      case `br`:
      case `col`:
      case `hr`:
      case `keygen`:
      case `meta`:
      case `param`:
      case `track`:
      case `wbr`:
      case `menuitem`:
        for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
          case `children`:
          case `dangerouslySetInnerHTML`:
            throw Error(s(137, t));
          default:
            Md(e, t, u, r, n, null);
        }
        return;
      default:
        if (Ht(t)) {
          for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Nd(e, t, d, r, n, void 0));
          return;
        }
    }
    for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && Md(e, t, c, r, n, null));
  }
  function Fd(e, t, n, r) {
    switch (t) {
      case `div`:
      case `span`:
      case `svg`:
      case `path`:
      case `a`:
      case `g`:
      case `p`:
      case `li`:
        break;
      case `input`:
        var i = null, a = null, o = null, c = null, l = null, u = null, d = null;
        for (m in n) {
          var f = n[m];
          if (n.hasOwnProperty(m) && f != null) switch (m) {
            case `checked`:
              break;
            case `value`:
              break;
            case `defaultValue`:
              l = f;
            default:
              r.hasOwnProperty(m) || Md(e, t, m, null, r, f);
          }
        }
        for (var p in r) {
          var m = r[p];
          if ((f = n[p], r.hasOwnProperty(p) && (m != null || f != null))) switch (p) {
            case `type`:
              a = m;
              break;
            case `name`:
              i = m;
              break;
            case `checked`:
              u = m;
              break;
            case `defaultChecked`:
              d = m;
              break;
            case `value`:
              o = m;
              break;
            case `defaultValue`:
              c = m;
              break;
            case `children`:
            case `dangerouslySetInnerHTML`:
              if (m != null) throw Error(s(137, t));
              break;
            default:
              m !== f && Md(e, t, p, m, r, f);
          }
        }
        Mt(e, o, c, l, u, d, a, i);
        return;
      case `select`:
        for (a in (m = o = c = p = null, n)) if ((l = n[a], n.hasOwnProperty(a) && l != null)) switch (a) {
          case `value`:
            break;
          case `multiple`:
            m = l;
          default:
            r.hasOwnProperty(a) || Md(e, t, a, null, r, l);
        }
        for (i in r) if ((a = r[i], l = n[i], r.hasOwnProperty(i) && (a != null || l != null))) switch (i) {
          case `value`:
            p = a;
            break;
          case `defaultValue`:
            c = a;
            break;
          case `multiple`:
            o = a;
          default:
            a !== l && Md(e, t, i, a, r, l);
        }
        (t = c, n = o, r = m, p == null ? !!r != !!n && (t == null ? Ft(e, !!n, n ? [] : ``, !1) : Ft(e, !!n, t, !0)) : Ft(e, !!n, p, !1));
        return;
      case `textarea`:
        for (c in (m = p = null, n)) if ((i = n[c], n.hasOwnProperty(c) && i != null && !r.hasOwnProperty(c))) switch (c) {
          case `value`:
            break;
          case `children`:
            break;
          default:
            Md(e, t, c, null, r, i);
        }
        for (o in r) if ((i = r[o], a = n[o], r.hasOwnProperty(o) && (i != null || a != null))) switch (o) {
          case `value`:
            p = i;
            break;
          case `defaultValue`:
            m = i;
            break;
          case `children`:
            break;
          case `dangerouslySetInnerHTML`:
            if (i != null) throw Error(s(91));
            break;
          default:
            i !== a && Md(e, t, o, i, r, a);
        }
        It(e, p, m);
        return;
      case `option`:
        for (var h in n) if ((p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h))) switch (h) {
          case `selected`:
            e.selected = !1;
            break;
          default:
            Md(e, t, h, null, r, p);
        }
        for (l in r) if ((p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null))) switch (l) {
          case `selected`:
            e.selected = p && typeof p != `function` && typeof p != `symbol`;
            break;
          default:
            Md(e, t, l, p, r, m);
        }
        return;
      case `img`:
      case `link`:
      case `area`:
      case `base`:
      case `br`:
      case `col`:
      case `embed`:
      case `hr`:
      case `keygen`:
      case `meta`:
      case `param`:
      case `source`:
      case `track`:
      case `wbr`:
      case `menuitem`:
        for (var g in n) (p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && Md(e, t, g, null, r, p));
        for (u in r) if ((p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null))) switch (u) {
          case `children`:
          case `dangerouslySetInnerHTML`:
            if (p != null) throw Error(s(137, t));
            break;
          default:
            Md(e, t, u, p, r, m);
        }
        return;
      default:
        if (Ht(t)) {
          for (var _ in n) (p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Nd(e, t, _, void 0, r, p));
          for (d in r) (p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Nd(e, t, d, p, r, m));
          return;
        }
    }
    for (var v in n) (p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && Md(e, t, v, null, r, p));
    for (f in r) (p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || Md(e, t, f, p, r, m));
  }
  function Id(e) {
    switch (e) {
      case `css`:
      case `script`:
      case `font`:
      case `img`:
      case `image`:
      case `input`:
      case `link`:
        return !0;
      default:
        return !1;
    }
  }
  function Ld() {
    if (typeof performance.getEntriesByType == `function`) {
      for (var e = 0, t = 0, n = performance.getEntriesByType(`resource`), r = 0; r < n.length; r++) {
        var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
        if (a && s && Id(o)) {
          for ((o = 0, s = i.responseEnd, r += 1); r < n.length; r++) {
            var c = n[r], l = c.startTime;
            if (l > s) break;
            var u = c.transferSize, d = c.initiatorType;
            u && Id(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
          }
          if ((--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e)) break;
        }
      }
      if (0 < e) return t / e / 1e6;
    }
    return navigator.connection && (e = navigator.connection.downlink, typeof e == `number`) ? e : 5;
  }
  var Rd = null, zd = null;
  function Bd(e) {
    return e.nodeType === 9 ? e : e.ownerDocument;
  }
  function Vd(e) {
    switch (e) {
      case `http://www.w3.org/2000/svg`:
        return 1;
      case `http://www.w3.org/1998/Math/MathML`:
        return 2;
      default:
        return 0;
    }
  }
  function Hd(e, t) {
    if (e === 0) switch (t) {
      case `svg`:
        return 1;
      case `math`:
        return 2;
      default:
        return 0;
    }
    return e === 1 && t === `foreignObject` ? 0 : e;
  }
  function Ud(e, t) {
    return e === `textarea` || e === `noscript` || typeof t.children == `string` || typeof t.children == `number` || typeof t.children == `bigint` || typeof t.dangerouslySetInnerHTML == `object` && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Wd = null;
  function Gd() {
    var e = window.event;
    return e && e.type === `popstate` ? e !== Wd && (Wd = e, !0) : (Wd = null, !1);
  }
  var Kd = typeof setTimeout == `function` ? setTimeout : void 0, qd = typeof clearTimeout == `function` ? clearTimeout : void 0, Jd = typeof Promise == `function` ? Promise : void 0, Yd = typeof queueMicrotask == `function` ? queueMicrotask : Jd === void 0 ? Kd : function (e) {
    return Jd.resolve(null).then(e).catch(Xd);
  };
  function Xd(e) {
    setTimeout(function () {
      throw e;
    });
  }
  function Zd(e) {
    return e === `head`;
  }
  function Qd(e, t) {
    var n = t, r = 0;
    do {
      var i = n.nextSibling;
      if ((e.removeChild(n), i && i.nodeType === 8)) {
        if ((n = i.data, n === `/$` || n === `/&`)) {
          if (r === 0) {
            (e.removeChild(i), Np(t));
            return;
          }
          r--;
        } else if (n === `$` || n === `$?` || n === `$~` || n === `$!` || n === `&`) r++; else if (n === `html`) pf(e.ownerDocument.documentElement); else if (n === `head`) {
          (n = e.ownerDocument.head, pf(n));
          for (var a = n.firstChild; a; ) {
            var o = a.nextSibling, s = a.nodeName;
            (a[ut] || s === `SCRIPT` || s === `STYLE` || s === `LINK` && a.rel.toLowerCase() === `stylesheet` || n.removeChild(a), a = o);
          }
        } else n === `body` && pf(e.ownerDocument.body);
      }
      n = i;
    } while (n);
    Np(t);
  }
  function $d(e, t) {
    var n = e;
    e = 0;
    do {
      var r = n.nextSibling;
      if ((n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = `none`) : (n.style.display = n._stashedDisplay || ``, n.getAttribute(`style`) === `` && n.removeAttribute(`style`)) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = ``) : n.nodeValue = n._stashedText || ``), r && r.nodeType === 8)) {
        if ((n = r.data, n === `/$`)) {
          if (e === 0) break;
          e--;
        } else n !== `$` && n !== `$?` && n !== `$~` && n !== `$!` || e++;
      }
      n = r;
    } while (n);
  }
  function ef(e) {
    var t = e.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var n = t;
      switch ((t = t.nextSibling, n.nodeName)) {
        case `HTML`:
        case `HEAD`:
        case `BODY`:
          (ef(n), dt(n));
          continue;
        case `SCRIPT`:
        case `STYLE`:
          continue;
        case `LINK`:
          if (n.rel.toLowerCase() === `stylesheet`) continue;
      }
      e.removeChild(n);
    }
  }
  function tf(e, t, n, r) {
    for (; e.nodeType === 1; ) {
      var i = n;
      if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!r && (e.nodeName !== `INPUT` || e.type !== `hidden`)) break;
      } else if (!r) {
        if (t === `input` && e.type === `hidden`) {
          var a = i.name == null ? null : `` + i.name;
          if (i.type === `hidden` && e.getAttribute(`name`) === a) return e;
        } else return e;
      } else if (!e[ut]) switch (t) {
        case `meta`:
          if (!e.hasAttribute(`itemprop`)) break;
          return e;
        case `link`:
          if ((a = e.getAttribute(`rel`), a === `stylesheet` && e.hasAttribute(`data-precedence`) || a !== i.rel || e.getAttribute(`href`) !== (i.href == null || i.href === `` ? null : i.href) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute(`title`) !== (i.title == null ? null : i.title))) break;
          return e;
        case `style`:
          if (e.hasAttribute(`data-precedence`)) break;
          return e;
        case `script`:
          if ((a = e.getAttribute(`src`), (a !== (i.src == null ? null : i.src) || e.getAttribute(`type`) !== (i.type == null ? null : i.type) || e.getAttribute(`crossorigin`) !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute(`async`) && !e.hasAttribute(`itemprop`))) break;
          return e;
        default:
          return e;
      }
      if ((e = cf(e.nextSibling), e === null)) break;
    }
    return null;
  }
  function nf(e, t, n) {
    if (t === ``) return null;
    for (; e.nodeType !== 3; ) if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !n || (e = cf(e.nextSibling), e === null)) return null;
    return e;
  }
  function rf(e, t) {
    for (; e.nodeType !== 8; ) if ((e.nodeType !== 1 || e.nodeName !== `INPUT` || e.type !== `hidden`) && !t || (e = cf(e.nextSibling), e === null)) return null;
    return e;
  }
  function af(e) {
    return e.data === `$?` || e.data === `$~`;
  }
  function of(e) {
    return e.data === `$!` || e.data === `$?` && e.ownerDocument.readyState !== `loading`;
  }
  function sf(e, t) {
    var n = e.ownerDocument;
    if (e.data === `$~`) e._reactRetry = t; else if (e.data !== `$?` || n.readyState !== `loading`) t(); else {
      var r = function () {
        (t(), n.removeEventListener(`DOMContentLoaded`, r));
      };
      (n.addEventListener(`DOMContentLoaded`, r), e._reactRetry = r);
    }
  }
  function cf(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if ((t = e.data, t === `$` || t === `$!` || t === `$?` || t === `$~` || t === `&` || t === `F!` || t === `F`)) break;
        if (t === `/$` || t === `/&`) return null;
      }
    }
    return e;
  }
  var lf = null;
  function uf(e) {
    e = e.nextSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === `/$` || n === `/&`) {
          if (t === 0) return cf(e.nextSibling);
          t--;
        } else n !== `$` && n !== `$!` && n !== `$?` && n !== `$~` && n !== `&` || t++;
      }
      e = e.nextSibling;
    }
    return null;
  }
  function df(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === `$` || n === `$!` || n === `$?` || n === `$~` || n === `&`) {
          if (t === 0) return e;
          t--;
        } else n !== `/$` && n !== `/&` || t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function ff(e, t, n) {
    switch ((t = Bd(n), e)) {
      case `html`:
        if ((e = t.documentElement, !e)) throw Error(s(452));
        return e;
      case `head`:
        if ((e = t.head, !e)) throw Error(s(453));
        return e;
      case `body`:
        if ((e = t.body, !e)) throw Error(s(454));
        return e;
      default:
        throw Error(s(451));
    }
  }
  function pf(e) {
    for (var t = e.attributes; t.length; ) e.removeAttributeNode(t[0]);
    dt(e);
  }
  var mf = new Map(), hf = new Set();
  function gf(e) {
    return typeof e.getRootNode == `function` ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
  }
  var _f = M.d;
  M.d = {
    f: vf,
    r: yf,
    D: Sf,
    C: Cf,
    L: wf,
    m: Tf,
    X: Df,
    S: Ef,
    M: Of
  };
  function vf() {
    var e = _f.f(), t = yu();
    return e || t;
  }
  function yf(e) {
    var t = pt(e);
    t !== null && t.tag === 5 && t.type === `form` ? Ss(t) : _f.r(e);
  }
  var bf = typeof document > `u` ? null : document;
  function xf(e, t, n) {
    var r = bf;
    if (r && typeof t == `string` && t) {
      var i = jt(t);
      (i = `link[rel="` + e + `"][href="` + i + `"]`, typeof n == `string` && (i += `[crossorigin="` + n + `"]`), hf.has(i) || (hf.add(i), e = {
        rel: e,
        crossOrigin: n,
        href: t
      }, r.querySelector(i) === null && (t = r.createElement(`link`), Pd(t, `link`, e), U(t), r.head.appendChild(t))));
    }
  }
  function Sf(e) {
    (_f.D(e), xf(`dns-prefetch`, e, null));
  }
  function Cf(e, t) {
    (_f.C(e, t), xf(`preconnect`, e, t));
  }
  function wf(e, t, n) {
    _f.L(e, t, n);
    var r = bf;
    if (r && e && t) {
      var i = `link[rel="preload"][as="` + jt(t) + `"]`;
      t === `image` && n && n.imageSrcSet ? (i += `[imagesrcset="` + jt(n.imageSrcSet) + `"]`, typeof n.imageSizes == `string` && (i += `[imagesizes="` + jt(n.imageSizes) + `"]`)) : i += `[href="` + jt(e) + `"]`;
      var a = i;
      switch (t) {
        case `style`:
          a = Af(e);
          break;
        case `script`:
          a = Pf(e);
      }
      mf.has(a) || (e = h({
        rel: `preload`,
        href: t === `image` && n && n.imageSrcSet ? void 0 : e,
        as: t
      }, n), mf.set(a, e), r.querySelector(i) !== null || t === `style` && r.querySelector(jf(a)) || t === `script` && r.querySelector(Ff(a)) || (t = r.createElement(`link`), Pd(t, `link`, e), U(t), r.head.appendChild(t)));
    }
  }
  function Tf(e, t) {
    _f.m(e, t);
    var n = bf;
    if (n && e) {
      var r = t && typeof t.as == `string` ? t.as : `script`, i = `link[rel="modulepreload"][as="` + jt(r) + `"][href="` + jt(e) + `"]`, a = i;
      switch (r) {
        case `audioworklet`:
        case `paintworklet`:
        case `serviceworker`:
        case `sharedworker`:
        case `worker`:
        case `script`:
          a = Pf(e);
      }
      if (!mf.has(a) && (e = h({
        rel: `modulepreload`,
        href: e
      }, t), mf.set(a, e), n.querySelector(i) === null)) {
        switch (r) {
          case `audioworklet`:
          case `paintworklet`:
          case `serviceworker`:
          case `sharedworker`:
          case `worker`:
          case `script`:
            if (n.querySelector(Ff(a))) return;
        }
        (r = n.createElement(`link`), Pd(r, `link`, e), U(r), n.head.appendChild(r));
      }
    }
  }
  function Ef(e, t, n) {
    _f.S(e, t, n);
    var r = bf;
    if (r && e) {
      var i = H(r).hoistableStyles, a = Af(e);
      t ||= `default`;
      var o = i.get(a);
      if (!o) {
        var s = {
          loading: 0,
          preload: null
        };
        if (o = r.querySelector(jf(a))) s.loading = 5; else {
          (e = h({
            rel: `stylesheet`,
            href: e,
            "data-precedence": t
          }, n), (n = mf.get(a)) && Rf(e, n));
          var c = o = r.createElement(`link`);
          (U(c), Pd(c, `link`, e), c._p = new Promise(function (e, t) {
            (c.onload = e, c.onerror = t);
          }), c.addEventListener(`load`, function () {
            s.loading |= 1;
          }), c.addEventListener(`error`, function () {
            s.loading |= 2;
          }), s.loading |= 4, Lf(o, t, r));
        }
        (o = {
          type: `stylesheet`,
          instance: o,
          count: 1,
          state: s
        }, i.set(a, o));
      }
    }
  }
  function Df(e, t) {
    _f.X(e, t);
    var n = bf;
    if (n && e) {
      var r = H(n).hoistableScripts, i = Pf(e), a = r.get(i);
      a || (a = n.querySelector(Ff(i)), a || (e = h({
        src: e,
        async: !0
      }, t), (t = mf.get(i)) && zf(e, t), a = n.createElement(`script`), U(a), Pd(a, `link`, e), n.head.appendChild(a)), a = {
        type: `script`,
        instance: a,
        count: 1,
        state: null
      }, r.set(i, a));
    }
  }
  function Of(e, t) {
    _f.M(e, t);
    var n = bf;
    if (n && e) {
      var r = H(n).hoistableScripts, i = Pf(e), a = r.get(i);
      a || (a = n.querySelector(Ff(i)), a || (e = h({
        src: e,
        async: !0,
        type: `module`
      }, t), (t = mf.get(i)) && zf(e, t), a = n.createElement(`script`), U(a), Pd(a, `link`, e), n.head.appendChild(a)), a = {
        type: `script`,
        instance: a,
        count: 1,
        state: null
      }, r.set(i, a));
    }
  }
  function kf(e, t, n, r) {
    var i = (i = se.current) ? gf(i) : null;
    if (!i) throw Error(s(446));
    switch (e) {
      case `meta`:
      case `title`:
        return null;
      case `style`:
        return typeof n.precedence == `string` && typeof n.href == `string` ? (t = Af(n.href), n = H(i).hoistableStyles, r = n.get(t), r || (r = {
          type: `style`,
          instance: null,
          count: 0,
          state: null
        }, n.set(t, r)), r) : {
          type: `void`,
          instance: null,
          count: 0,
          state: null
        };
      case `link`:
        if (n.rel === `stylesheet` && typeof n.href == `string` && typeof n.precedence == `string`) {
          e = Af(n.href);
          var a = H(i).hoistableStyles, o = a.get(e);
          if ((o || (i = i.ownerDocument || i, o = {
            type: `stylesheet`,
            instance: null,
            count: 0,
            state: {
              loading: 0,
              preload: null
            }
          }, a.set(e, o), (a = i.querySelector(jf(e))) && !a._p && (o.instance = a, o.state.loading = 5), mf.has(e) || (n = {
            rel: `preload`,
            as: `style`,
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, mf.set(e, n), a || Nf(i, e, n, o.state))), t && r === null)) throw Error(s(528, ``));
          return o;
        }
        if (t && r !== null) throw Error(s(529, ``));
        return null;
      case `script`:
        return (t = n.async, n = n.src, typeof n == `string` && t && typeof t != `function` && typeof t != `symbol` ? (t = Pf(n), n = H(i).hoistableScripts, r = n.get(t), r || (r = {
          type: `script`,
          instance: null,
          count: 0,
          state: null
        }, n.set(t, r)), r) : {
          type: `void`,
          instance: null,
          count: 0,
          state: null
        });
      default:
        throw Error(s(444, e));
    }
  }
  function Af(e) {
    return `href="` + jt(e) + `"`;
  }
  function jf(e) {
    return `link[rel="stylesheet"][` + e + `]`;
  }
  function Mf(e) {
    return h({}, e, {
      "data-precedence": e.precedence,
      precedence: null
    });
  }
  function Nf(e, t, n, r) {
    e.querySelector(`link[rel="preload"][as="style"][` + t + `]`) ? r.loading = 1 : (t = e.createElement(`link`), r.preload = t, t.addEventListener(`load`, function () {
      return r.loading |= 1;
    }), t.addEventListener(`error`, function () {
      return r.loading |= 2;
    }), Pd(t, `link`, n), U(t), e.head.appendChild(t));
  }
  function Pf(e) {
    return `[src="` + jt(e) + `"]`;
  }
  function Ff(e) {
    return `script[async]` + e;
  }
  function If(e, t, n) {
    if ((t.count++, t.instance === null)) switch (t.type) {
      case `style`:
        var r = e.querySelector(`style[data-href~="` + jt(n.href) + `"]`);
        if (r) return (t.instance = r, U(r), r);
        var i = h({}, n, {
          "data-href": n.href,
          "data-precedence": n.precedence,
          href: null,
          precedence: null
        });
        return (r = (e.ownerDocument || e).createElement(`style`), U(r), Pd(r, `style`, i), Lf(r, n.precedence, e), t.instance = r);
      case `stylesheet`:
        i = Af(n.href);
        var a = e.querySelector(jf(i));
        if (a) return (t.state.loading |= 4, t.instance = a, U(a), a);
        (r = Mf(n), (i = mf.get(i)) && Rf(r, i), a = (e.ownerDocument || e).createElement(`link`), U(a));
        var o = a;
        return (o._p = new Promise(function (e, t) {
          (o.onload = e, o.onerror = t);
        }), Pd(a, `link`, r), t.state.loading |= 4, Lf(a, n.precedence, e), t.instance = a);
      case `script`:
        return (a = Pf(n.src), (i = e.querySelector(Ff(a))) ? (t.instance = i, U(i), i) : (r = n, (i = mf.get(a)) && (r = h({}, n), zf(r, i)), e = e.ownerDocument || e, i = e.createElement(`script`), U(i), Pd(i, `link`, r), e.head.appendChild(i), t.instance = i));
      case `void`:
        return null;
      default:
        throw Error(s(443, t.type));
    } else t.type === `stylesheet` && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
    return t.instance;
  }
  function Lf(e, t, n) {
    for (var r = n.querySelectorAll(`link[rel="stylesheet"][data-precedence],style[data-precedence]`), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
      var s = r[o];
      if (s.dataset.precedence === t) a = s; else if (a !== i) break;
    }
    a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
  }
  function Rf(e, t) {
    (e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title);
  }
  function zf(e, t) {
    (e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity);
  }
  var Bf = null;
  function Vf(e, t, n) {
    if (Bf === null) {
      var r = new Map(), i = Bf = new Map();
      i.set(n, r);
    } else (i = Bf, r = i.get(n), r || (r = new Map(), i.set(n, r)));
    if (r.has(e)) return r;
    for ((r.set(e, null), n = n.getElementsByTagName(e), i = 0); i < n.length; i++) {
      var a = n[i];
      if (!(a[ut] || a[it] || e === `link` && a.getAttribute(`rel`) === `stylesheet`) && a.namespaceURI !== `http://www.w3.org/2000/svg`) {
        var o = a.getAttribute(t) || ``;
        o = e + o;
        var s = r.get(o);
        s ? s.push(a) : r.set(o, [a]);
      }
    }
    return r;
  }
  function Hf(e, t, n) {
    (e = e.ownerDocument || e, e.head.insertBefore(n, t === `title` ? e.querySelector(`head > title`) : null));
  }
  function Uf(e, t, n) {
    if (n === 1 || t.itemProp != null) return !1;
    switch (e) {
      case `meta`:
      case `title`:
        return !0;
      case `style`:
        if (typeof t.precedence != `string` || typeof t.href != `string` || t.href === ``) break;
        return !0;
      case `link`:
        if (typeof t.rel != `string` || typeof t.href != `string` || t.href === `` || t.onLoad || t.onError) break;
        switch (t.rel) {
          case `stylesheet`:
            return (e = t.disabled, typeof t.precedence == `string` && e == null);
          default:
            return !0;
        }
      case `script`:
        if (t.async && typeof t.async != `function` && typeof t.async != `symbol` && !t.onLoad && !t.onError && t.src && typeof t.src == `string`) return !0;
    }
    return !1;
  }
  function Wf(e) {
    return !(e.type === `stylesheet` && !(e.state.loading & 3));
  }
  function Gf(e, t, n, r) {
    if (n.type === `stylesheet` && (typeof r.media != `string` || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
      if (n.instance === null) {
        var i = Af(r.href), a = t.querySelector(jf(i));
        if (a) {
          (t = a._p, typeof t == `object` && t && typeof t.then == `function` && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, U(a));
          return;
        }
        (a = t.ownerDocument || t, r = Mf(r), (i = mf.get(i)) && Rf(r, i), a = a.createElement(`link`), U(a));
        var o = a;
        (o._p = new Promise(function (e, t) {
          (o.onload = e, o.onerror = t);
        }), Pd(a, `link`, r), n.instance = a);
      }
      (e.stylesheets === null && (e.stylesheets = new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener(`load`, n), t.addEventListener(`error`, n)));
    }
  }
  var Kf = 0;
  function qf(e, t) {
    return (e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function (n) {
      var r = setTimeout(function () {
        if ((e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
          var t = e.unsuspend;
          (e.unsuspend = null, t());
        }
      }, 6e4 + t);
      0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
      var i = setTimeout(function () {
        if ((e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend))) {
          var t = e.unsuspend;
          (e.unsuspend = null, t());
        }
      }, (e.imgBytes > Kf ? 50 : 800) + t);
      return (e.unsuspend = n, function () {
        (e.unsuspend = null, clearTimeout(r), clearTimeout(i));
      });
    } : null);
  }
  function Jf() {
    if ((this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages))) {
      if (this.stylesheets) Xf(this, this.stylesheets); else if (this.unsuspend) {
        var e = this.unsuspend;
        (this.unsuspend = null, e());
      }
    }
  }
  var Yf = null;
  function Xf(e, t) {
    (e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = new Map(), t.forEach(Zf, e), Yf = null, Jf.call(e)));
  }
  function Zf(e, t) {
    if (!(t.state.loading & 4)) {
      var n = Yf.get(e);
      if (n) var r = n.get(null); else {
        (n = new Map(), Yf.set(e, n));
        for (var i = e.querySelectorAll(`link[data-precedence],style[data-precedence]`), a = 0; a < i.length; a++) {
          var o = i[a];
          (o.nodeName === `LINK` || o.getAttribute(`media`) !== `not all`) && (n.set(o.dataset.precedence, o), r = o);
        }
        r && n.set(null, r);
      }
      (i = t.instance, o = i.getAttribute(`data-precedence`), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener(`load`, r), i.addEventListener(`error`, r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4);
    }
  }
  var Qf = {
    $$typeof: C,
    Provider: null,
    Consumer: null,
    _currentValue: N,
    _currentValue2: N,
    _threadCount: 0
  };
  function $f(e, t, n, r, i, a, o, s, c) {
    (this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = qe(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = qe(0), this.hiddenUpdates = qe(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = new Map());
  }
  function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
    return (e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = ti(3, null, null, t), e.current = a, a.stateNode = e, t = ta(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
      element: r,
      isDehydrated: n,
      cache: t
    }, Pa(a), e);
  }
  function tp(e) {
    return e ? (e = $r, e) : $r;
  }
  function np(e, t, n, r, i, a) {
    (i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = Ia(t), r.payload = {
      element: n
    }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = La(e, r, t), n !== null && (mu(n, e, t), Ra(n, e, t)));
  }
  function rp(e, t) {
    if ((e = e.memoizedState, e !== null && e.dehydrated !== null)) {
      var n = e.retryLane;
      e.retryLane = n !== 0 && n < t ? n : t;
    }
  }
  function ip(e, t) {
    (rp(e, t), (e = e.alternate) && rp(e, t));
  }
  function ap(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = Xr(e, 67108864);
      (t !== null && mu(t, e, 67108864), ip(e, 67108864));
    }
  }
  function op(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = fu();
      t = $e(t);
      var n = Xr(e, t);
      (n !== null && mu(n, e, t), ip(e, t));
    }
  }
  var sp = !0;
  function cp(e, t, n, r) {
    var i = j.T;
    j.T = null;
    var a = M.p;
    try {
      (M.p = 2, up(e, t, n, r));
    } finally {
      (M.p = a, j.T = i);
    }
  }
  function lp(e, t, n, r) {
    var i = j.T;
    j.T = null;
    var a = M.p;
    try {
      (M.p = 8, up(e, t, n, r));
    } finally {
      (M.p = a, j.T = i);
    }
  }
  function up(e, t, n, r) {
    if (sp) {
      var i = dp(r);
      if (i === null) (Cd(e, t, r, fp, n), Cp(e, r)); else if (Tp(i, e, t, n, r)) r.stopPropagation(); else if ((Cp(e, r), t & 4 && -1 < Sp.indexOf(e))) {
        for (; i !== null; ) {
          var a = pt(i);
          if (a !== null) switch (a.tag) {
            case 3:
              if ((a = a.stateNode, a.current.memoizedState.isDehydrated)) {
                var o = Ue(a.pendingLanes);
                if (o !== 0) {
                  var s = a;
                  for ((s.pendingLanes |= 2, s.entangledLanes |= 2); o; ) {
                    var c = 1 << 31 - Ie(o);
                    (s.entanglements[1] |= c, o &= ~c);
                  }
                  (nd(a), !(J & 6) && (eu = we() + 500, rd(0, !1)));
                }
              }
              break;
            case 31:
            case 13:
              (s = Xr(a, 2), s !== null && mu(s, a, 2), yu(), ip(a, 2));
          }
          if ((a = dp(r), a === null && Cd(e, t, r, fp, n), a === i)) break;
          i = a;
        }
        i !== null && r.stopPropagation();
      } else Cd(e, t, r, null, n);
    }
  }
  function dp(e) {
    return (e = Jt(e), pp(e));
  }
  var fp = null;
  function pp(e) {
    if ((fp = null, e = ft(e), e !== null)) {
      var t = l(e);
      if (t === null) e = null; else {
        var n = t.tag;
        if (n === 13) {
          if ((e = u(t), e !== null)) return e;
          e = null;
        } else if (n === 31) {
          if ((e = d(t), e !== null)) return e;
          e = null;
        } else if (n === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
          e = null;
        } else t !== e && (e = null);
      }
    }
    return (fp = e, null);
  }
  function mp(e) {
    switch (e) {
      case `beforetoggle`:
      case `cancel`:
      case `click`:
      case `close`:
      case `contextmenu`:
      case `copy`:
      case `cut`:
      case `auxclick`:
      case `dblclick`:
      case `dragend`:
      case `dragstart`:
      case `drop`:
      case `focusin`:
      case `focusout`:
      case `input`:
      case `invalid`:
      case `keydown`:
      case `keypress`:
      case `keyup`:
      case `mousedown`:
      case `mouseup`:
      case `paste`:
      case `pause`:
      case `play`:
      case `pointercancel`:
      case `pointerdown`:
      case `pointerup`:
      case `ratechange`:
      case `reset`:
      case `resize`:
      case `seeked`:
      case `submit`:
      case `toggle`:
      case `touchcancel`:
      case `touchend`:
      case `touchstart`:
      case `volumechange`:
      case `change`:
      case `selectionchange`:
      case `textInput`:
      case `compositionstart`:
      case `compositionend`:
      case `compositionupdate`:
      case `beforeblur`:
      case `afterblur`:
      case `beforeinput`:
      case `blur`:
      case `fullscreenchange`:
      case `focus`:
      case `hashchange`:
      case `popstate`:
      case `select`:
      case `selectstart`:
        return 2;
      case `drag`:
      case `dragenter`:
      case `dragexit`:
      case `dragleave`:
      case `dragover`:
      case `mousemove`:
      case `mouseout`:
      case `mouseover`:
      case `pointermove`:
      case `pointerout`:
      case `pointerover`:
      case `scroll`:
      case `touchmove`:
      case `wheel`:
      case `mouseenter`:
      case `mouseleave`:
      case `pointerenter`:
      case `pointerleave`:
        return 8;
      case `message`:
        switch (Te()) {
          case Ee:
            return 2;
          case De:
            return 8;
          case Oe:
          case ke:
            return 32;
          case Ae:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hp = !1, gp = null, _p = null, vp = null, yp = new Map(), bp = new Map(), xp = [], Sp = `mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset`.split(` `);
  function Cp(e, t) {
    switch (e) {
      case `focusin`:
      case `focusout`:
        gp = null;
        break;
      case `dragenter`:
      case `dragleave`:
        _p = null;
        break;
      case `mouseover`:
      case `mouseout`:
        vp = null;
        break;
      case `pointerover`:
      case `pointerout`:
        yp.delete(t.pointerId);
        break;
      case `gotpointercapture`:
      case `lostpointercapture`:
        bp.delete(t.pointerId);
    }
  }
  function wp(e, t, n, r, i, a) {
    return e === null || e.nativeEvent !== a ? (e = {
      blockedOn: t,
      domEventName: n,
      eventSystemFlags: r,
      nativeEvent: a,
      targetContainers: [i]
    }, t !== null && (t = pt(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
  }
  function Tp(e, t, n, r, i) {
    switch (t) {
      case `focusin`:
        return (gp = wp(gp, e, t, n, r, i), !0);
      case `dragenter`:
        return (_p = wp(_p, e, t, n, r, i), !0);
      case `mouseover`:
        return (vp = wp(vp, e, t, n, r, i), !0);
      case `pointerover`:
        var a = i.pointerId;
        return (yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0);
      case `gotpointercapture`:
        return (a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0);
    }
    return !1;
  }
  function Ep(e) {
    var t = ft(e.target);
    if (t !== null) {
      var n = l(t);
      if (n !== null) {
        if ((t = n.tag, t === 13)) {
          if ((t = u(n), t !== null)) {
            (e.blockedOn = t, nt(e.priority, function () {
              op(n);
            }));
            return;
          }
        } else if (t === 31) {
          if ((t = d(n), t !== null)) {
            (e.blockedOn = t, nt(e.priority, function () {
              op(n);
            }));
            return;
          }
        } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function Dp(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length; ) {
      var n = dp(e.nativeEvent);
      if (n === null) {
        n = e.nativeEvent;
        var r = new n.constructor(n.type, n);
        (qt = r, n.target.dispatchEvent(r), qt = null);
      } else return (t = pt(n), t !== null && ap(t), e.blockedOn = n, !1);
      t.shift();
    }
    return !0;
  }
  function Op(e, t, n) {
    Dp(e) && n.delete(t);
  }
  function kp() {
    (hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op));
  }
  function Ap(e, n) {
    e.blockedOn === n && (e.blockedOn = null, hp || (hp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kp)));
  }
  var jp = null;
  function Mp(e) {
    jp !== e && (jp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function () {
      jp === e && (jp = null);
      for (var t = 0; t < e.length; t += 3) {
        var n = e[t], r = e[t + 1], i = e[t + 2];
        if (typeof r != `function`) {
          if (pp(r || n) === null) continue;
          break;
        }
        var a = pt(n);
        a !== null && (e.splice(t, 3), t -= 3, bs(a, {
          pending: !0,
          data: i,
          method: n.method,
          action: r
        }, r, i));
      }
    }));
  }
  function Np(e) {
    function t(t) {
      return Ap(t, e);
    }
    (gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t));
    for (var n = 0; n < xp.length; n++) {
      var r = xp[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
    for (; 0 < xp.length && (n = xp[0], n.blockedOn === null); ) (Ep(n), n.blockedOn === null && xp.shift());
    if ((n = (e.ownerDocument || e).$$reactFormReplay, n != null)) for (r = 0; r < n.length; r += 3) {
      var i = n[r], a = n[r + 1], o = i[at] || null;
      if (typeof a == `function`) o || Mp(n); else if (o) {
        var s = null;
        if (a && a.hasAttribute(`formAction`)) {
          if ((i = a, o = a[at] || null)) s = o.formAction; else if (pp(i) !== null) continue;
        } else s = o.action;
        (typeof s == `function` ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n));
      }
    }
  }
  function Pp() {
    function e(e) {
      e.canIntercept && e.info === `react-transition` && e.intercept({
        handler: function () {
          return new Promise(function (e) {
            return i = e;
          });
        },
        focusReset: `manual`,
        scroll: `manual`
      });
    }
    function t() {
      (i !== null && (i(), i = null), r || setTimeout(n, 20));
    }
    function n() {
      if (!r && !navigation.transition) {
        var e = navigation.currentEntry;
        e && e.url != null && navigation.navigate(e.url, {
          state: e.getState(),
          info: `react-transition`,
          history: `replace`
        });
      }
    }
    if (typeof navigation == `object`) {
      var r = !1, i = null;
      return (navigation.addEventListener(`navigate`, e), navigation.addEventListener(`navigatesuccess`, t), navigation.addEventListener(`navigateerror`, t), setTimeout(n, 100), function () {
        (r = !0, navigation.removeEventListener(`navigate`, e), navigation.removeEventListener(`navigatesuccess`, t), navigation.removeEventListener(`navigateerror`, t), i !== null && (i(), i = null));
      });
    }
  }
  function Fp(e) {
    this._internalRoot = e;
  }
  (Ip.prototype.render = Fp.prototype.render = function (e) {
    var t = this._internalRoot;
    if (t === null) throw Error(s(409));
    var n = t.current;
    np(n, fu(), e, t, null, null);
  }, Ip.prototype.unmount = Fp.prototype.unmount = function () {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      (np(e.current, 2, null, e, null, null), yu(), t[ot] = null);
    }
  });
  function Ip(e) {
    this._internalRoot = e;
  }
  Ip.prototype.unstable_scheduleHydration = function (e) {
    if (e) {
      var t = tt();
      e = {
        blockedOn: null,
        target: e,
        priority: t
      };
      for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++) ;
      (xp.splice(n, 0, e), n === 0 && Ep(e));
    }
  };
  var Lp = r.version;
  if (Lp !== `19.2.6`) throw Error(s(527, Lp, `19.2.6`));
  M.findDOMNode = function (e) {
    var t = e._reactInternals;
    if (t === void 0) throw typeof e.render == `function` ? Error(s(188)) : (e = Object.keys(e).join(`,`), Error(s(268, e)));
    return (e = p(t), e = e === null ? null : m(e), e = e === null ? null : e.stateNode, e);
  };
  var Rp = {
    bundleType: 0,
    version: `19.2.6`,
    rendererPackageName: `react-dom`,
    currentDispatcherRef: j,
    reconcilerVersion: `19.2.6`
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < `u`) {
    var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!zp.isDisabled && zp.supportsFiber) try {
      (Ne = zp.inject(Rp), Pe = zp);
    } catch {}
  }
  e.createRoot = function (e, t) {
    if (!c(e)) throw Error(s(299));
    var n = !1, r = ``, i = Us, a = Ws, o = Gs;
    return (t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (i = t.onUncaughtError), t.onCaughtError !== void 0 && (a = t.onCaughtError), t.onRecoverableError !== void 0 && (o = t.onRecoverableError)), t = ep(e, 1, !1, null, null, n, r, null, i, a, o, Pp), e[ot] = t.current, xd(e), new Fp(t));
  };
}), c = e((e, t) => {
  function n() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > `u` || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != `function`)) try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
    } catch (e) {
      console.error(e);
    }
  }
  (n(), t.exports = s());
}), l = (...e) => e.filter((e, t, n) => !!e && e.trim() !== `` && n.indexOf(e) === t).join(` `).trim(), u = e => e.replace(/([a-z0-9])([A-Z])/g, `$1-$2`).toLowerCase(), d = e => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), f = e => {
  let t = d(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, p = {
  xmlns: `http://www.w3.org/2000/svg`,
  width: 24,
  height: 24,
  viewBox: `0 0 24 24`,
  fill: `none`,
  stroke: `currentColor`,
  strokeWidth: 2,
  strokeLinecap: `round`,
  strokeLinejoin: `round`
}, m = e => {
  for (let t in e) if (t.startsWith(`aria-`) || t === `role` || t === `title`) return !0;
  return !1;
}, h = n(), g = (0, h.createContext)({}), _ = () => (0, h.useContext)(g), v = (0, h.forwardRef)(({color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: i = ``, children: a, iconNode: o, ...s}, c) => {
  let {size: u = 24, strokeWidth: d = 2, absoluteStrokeWidth: f = !1, color: g = `currentColor`, className: v = ``} = _() ?? ({}), y = r ?? f ? Number(n ?? d) * 24 / Number(t ?? u) : n ?? d;
  return (0, h.createElement)(`svg`, {
    ref: c,
    ...p,
    width: (t ?? u) ?? p.width,
    height: (t ?? u) ?? p.height,
    stroke: e ?? g,
    strokeWidth: y,
    className: l(`lucide`, v, i),
    ...!a && !m(s) && ({
      "aria-hidden": `true`
    }),
    ...s
  }, [...o.map(([e, t]) => (0, h.createElement)(e, t)), ...Array.isArray(a) ? a : [a]]);
}), y = (e, t) => {
  let n = (0, h.forwardRef)(({className: n, ...r}, i) => (0, h.createElement)(v, {
    ref: i,
    iconNode: t,
    className: l(`lucide-${u(f(e))}`, `lucide-${e}`, n),
    ...r
  }));
  return (n.displayName = f(e), n);
}, b = y(`archive`, [[`rect`, {
  width: `20`,
  height: `5`,
  x: `2`,
  y: `3`,
  rx: `1`,
  key: `1wp1u1`
}], [`path`, {
  d: `M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8`,
  key: `1s80jp`
}], [`path`, {
  d: `M10 12h4`,
  key: `a56b0p`
}]]), x = y(`bell`, [[`path`, {
  d: `M10.268 21a2 2 0 0 0 3.464 0`,
  key: `vwvbt9`
}], [`path`, {
  d: `M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326`,
  key: `11g9vi`
}]]), S = y(`book-open`, [[`path`, {
  d: `M12 5v16`,
  key: `1f6ucr`
}], [`path`, {
  d: `M20.001 19A2 2 0 0022 17V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2z`,
  key: `1fyvmf`
}]]), C = y(`building-2`, [[`path`, {
  d: `M10 12h4`,
  key: `a56b0p`
}], [`path`, {
  d: `M10 8h4`,
  key: `1sr2af`
}], [`path`, {
  d: `M14 21v-3a2 2 0 0 0-4 0v3`,
  key: `1rgiei`
}], [`path`, {
  d: `M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2`,
  key: `secmi2`
}], [`path`, {
  d: `M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16`,
  key: `16ra0t`
}]]), w = y(`calendar-clock`, [[`path`, {
  d: `M16 14v2.2l1.6 1`,
  key: `fo4ql5`
}], [`path`, {
  d: `M16 2v3`,
  key: `otl347`
}], [`path`, {
  d: `M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338`,
  key: `7hb8p4`
}], [`path`, {
  d: `M3 9h5.859`,
  key: `numkqi`
}], [`path`, {
  d: `M8 2v3`,
  key: `1ioesn`
}], [`circle`, {
  cx: `16`,
  cy: `16`,
  r: `6`,
  key: `qoo3c4`
}]]), T = y(`calendar-days`, [[`path`, {
  d: `M8 2v3`,
  key: `1ioesn`
}], [`path`, {
  d: `M16 2v3`,
  key: `otl347`
}], [`rect`, {
  x: `3`,
  y: `3`,
  width: `18`,
  height: `18`,
  rx: `2`,
  key: `h1oib`
}], [`path`, {
  d: `M3 9h18`,
  key: `1pudct`
}], [`path`, {
  d: `M8 13h.01`,
  key: `1sbv64`
}], [`path`, {
  d: `M12 13h.01`,
  key: `y0uutt`
}], [`path`, {
  d: `M16 13h.01`,
  key: `wip0gl`
}], [`path`, {
  d: `M8 17h.01`,
  key: `p3bg7i`
}], [`path`, {
  d: `M12 17h.01`,
  key: `p32p05`
}], [`path`, {
  d: `M16 17h.01`,
  key: `ql8jdd`
}]]), E = y(`chart-column`, [[`path`, {
  d: `M3 3v16a2 2 0 0 0 2 2h16`,
  key: `c24i48`
}], [`path`, {
  d: `M18 17V9`,
  key: `2bz60n`
}], [`path`, {
  d: `M13 17V5`,
  key: `1frdt8`
}], [`path`, {
  d: `M8 17v-3`,
  key: `17ska0`
}]]), D = y(`check`, [[`path`, {
  d: `M20 6 9 17l-5-5`,
  key: `1gmf2c`
}]]), O = y(`chevron-down`, [[`path`, {
  d: `m6 9 6 6 6-6`,
  key: `qrunsl`
}]]), k = y(`chevron-right`, [[`path`, {
  d: `m9 18 6-6-6-6`,
  key: `mthhwq`
}]]), ee = y(`circle-check`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}], [`path`, {
  d: `m9 12 2 2 4-4`,
  key: `dzmm74`
}]]), te = y(`circle-pause`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}], [`line`, {
  x1: `10`,
  x2: `10`,
  y1: `15`,
  y2: `9`,
  key: `c1nkhi`
}], [`line`, {
  x1: `14`,
  x2: `14`,
  y1: `15`,
  y2: `9`,
  key: `h65svq`
}]]), ne = y(`circle-play`, [[`path`, {
  d: `M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z`,
  key: `kmsa83`
}], [`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}]]), A = y(`circle-question-mark`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}], [`path`, {
  d: `M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3`,
  key: `1u773s`
}], [`path`, {
  d: `M12 17h.01`,
  key: `p32p05`
}]]), re = y(`circle-x`, [[`circle`, {
  cx: `12`,
  cy: `12`,
  r: `10`,
  key: `1mglay`
}], [`path`, {
  d: `m15 9-6 6`,
  key: `1uzhvr`
}], [`path`, {
  d: `m9 9 6 6`,
  key: `z0biqf`
}]]), ie = y(`clipboard-list`, [[`rect`, {
  width: `8`,
  height: `4`,
  x: `8`,
  y: `2`,
  rx: `1`,
  ry: `1`,
  key: `tgr4d6`
}], [`path`, {
  d: `M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2`,
  key: `116196`
}], [`path`, {
  d: `M12 11h4`,
  key: `1jrz19`
}], [`path`, {
  d: `M12 16h4`,
  key: `n85exb`
}], [`path`, {
  d: `M8 11h.01`,
  key: `1dfujw`
}], [`path`, {
  d: `M8 16h.01`,
  key: `18s6g9`
}]]), j = y(`cloud-download`, [[`path`, {
  d: `M12 13v8l-4-4`,
  key: `1f5nwf`
}], [`path`, {
  d: `m12 21 4-4`,
  key: `1lfcce`
}], [`path`, {
  d: `M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284`,
  key: `ui1hmy`
}]]), M = y(`copy`, [[`rect`, {
  width: `14`,
  height: `14`,
  x: `8`,
  y: `8`,
  rx: `2`,
  ry: `2`,
  key: `17jyea`
}], [`path`, {
  d: `M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2`,
  key: `zix9uf`
}]]), N = y(`database`, [[`ellipse`, {
  cx: `12`,
  cy: `5`,
  rx: `9`,
  ry: `3`,
  key: `msslwz`
}], [`path`, {
  d: `M3 5V19A9 3 0 0 0 21 19V5`,
  key: `1wlel7`
}], [`path`, {
  d: `M3 12A9 3 0 0 0 21 12`,
  key: `mv7ke4`
}]]), P = y(`download`, [[`path`, {
  d: `M12 15V3`,
  key: `m9g1x1`
}], [`path`, {
  d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
  key: `ih7n3h`
}], [`path`, {
  d: `m7 10 5 5 5-5`,
  key: `brsn70`
}]]), F = y(`file-archive`, [[`path`, {
  d: `M13.659 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v11.5`,
  key: `4pqfef`
}], [`path`, {
  d: `M14 2v5a1 1 0 0 0 1 1h5`,
  key: `wfsgrz`
}], [`path`, {
  d: `M8 12v-1`,
  key: `1ej8lb`
}], [`path`, {
  d: `M8 18v-2`,
  key: `qcmpov`
}], [`path`, {
  d: `M8 7V6`,
  key: `1nbb54`
}], [`circle`, {
  cx: `8`,
  cy: `20`,
  r: `2`,
  key: `ckkr5m`
}]]), I = y(`file-check-corner`, [[`path`, {
  d: `M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6`,
  key: `g5mvt7`
}], [`path`, {
  d: `M14 2v5a1 1 0 0 0 1 1h5`,
  key: `wfsgrz`
}], [`path`, {
  d: `m14 20 2 2 4-4`,
  key: `15kota`
}]]), L = y(`file-down`, [[`path`, {
  d: `M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z`,
  key: `1oefj6`
}], [`path`, {
  d: `M14 2v5a1 1 0 0 0 1 1h5`,
  key: `wfsgrz`
}], [`path`, {
  d: `M12 18v-6`,
  key: `17g6i2`
}], [`path`, {
  d: `m9 15 3 3 3-3`,
  key: `1npd3o`
}]]), R = y(`file-plus-corner`, [[`path`, {
  d: `M11.35 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5.35`,
  key: `17jvcc`
}], [`path`, {
  d: `M14 2v5a1 1 0 0 0 1 1h5`,
  key: `wfsgrz`
}], [`path`, {
  d: `M14 19h6`,
  key: `bvotb8`
}], [`path`, {
  d: `M17 16v6`,
  key: `18yu1i`
}]]), ae = y(`file-text`, [[`path`, {
  d: `M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z`,
  key: `1oefj6`
}], [`path`, {
  d: `M14 2v5a1 1 0 0 0 1 1h5`,
  key: `wfsgrz`
}], [`path`, {
  d: `M10 9H8`,
  key: `b1mrlr`
}], [`path`, {
  d: `M16 13H8`,
  key: `t4e002`
}], [`path`, {
  d: `M16 17H8`,
  key: `z1uh3a`
}]]), oe = y(`flag`, [[`path`, {
  d: `M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528`,
  key: `1jaruq`
}]]), se = y(`gauge`, [[`path`, {
  d: `m12 14 4-4`,
  key: `9kzdfg`
}], [`path`, {
  d: `M3.34 19a10 10 0 1 1 17.32 0`,
  key: `19p75a`
}]]), ce = y(`hard-drive`, [[`path`, {
  d: `M10 16h.01`,
  key: `1bzywj`
}], [`path`, {
  d: `M2.212 11.577a2 2 0 0 0-.212.896V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.527a2 2 0 0 0-.212-.896L18.55 5.11A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z`,
  key: `18tbho`
}], [`path`, {
  d: `M21.946 12.013H2.054`,
  key: `zqlbp7`
}], [`path`, {
  d: `M6 16h.01`,
  key: `1pmjb7`
}]]), le = y(`heart-pulse`, [[`path`, {
  d: `M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5`,
  key: `mvr1a0`
}], [`path`, {
  d: `M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27`,
  key: `auskq0`
}]]), ue = y(`landmark`, [[`path`, {
  d: `M10 18v-7`,
  key: `wt116b`
}], [`path`, {
  d: `M11.119 2.205a2 2 0 0 1 1.762 0l7.84 3.846A.5.5 0 0 1 20.5 7h-17a.5.5 0 0 1-.22-.949z`,
  key: `yxxwt6`
}], [`path`, {
  d: `M14 18v-7`,
  key: `vav6t3`
}], [`path`, {
  d: `M18 18v-7`,
  key: `aexdmj`
}], [`path`, {
  d: `M3 22h18`,
  key: `8prr45`
}], [`path`, {
  d: `M6 18v-7`,
  key: `1ivflk`
}]]), de = y(`loader-circle`, [[`path`, {
  d: `M21 12a9 9 0 1 1-6.219-8.56`,
  key: `13zald`
}]]), fe = y(`lock-keyhole`, [[`circle`, {
  cx: `12`,
  cy: `16`,
  r: `1`,
  key: `1au0dj`
}], [`rect`, {
  x: `3`,
  y: `10`,
  width: `18`,
  height: `12`,
  rx: `2`,
  key: `6s8ecr`
}], [`path`, {
  d: `M7 10V7a5 5 0 0 1 10 0v3`,
  key: `1pqi11`
}]]), pe = y(`log-out`, [[`path`, {
  d: `m16 17 5-5-5-5`,
  key: `1bji2h`
}], [`path`, {
  d: `M21 12H9`,
  key: `dn1m92`
}], [`path`, {
  d: `M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4`,
  key: `1uf3rs`
}]]), me = y(`mail`, [[`path`, {
  d: `m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7`,
  key: `132q7q`
}], [`rect`, {
  x: `2`,
  y: `4`,
  width: `20`,
  height: `16`,
  rx: `2`,
  key: `izxlao`
}]]), he = y(`menu`, [[`path`, {
  d: `M4 5h16`,
  key: `1tepv9`
}], [`path`, {
  d: `M4 12h16`,
  key: `1lakjw`
}], [`path`, {
  d: `M4 19h16`,
  key: `1djgab`
}]]), ge = y(`message-square-plus`, [[`path`, {
  d: `M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z`,
  key: `18887p`
}], [`path`, {
  d: `M12 8v6`,
  key: `1ib9pf`
}], [`path`, {
  d: `M9 11h6`,
  key: `1fldmi`
}]]), _e = y(`message-square-text`, [[`path`, {
  d: `M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z`,
  key: `18887p`
}], [`path`, {
  d: `M7 11h10`,
  key: `1twpyw`
}], [`path`, {
  d: `M7 15h6`,
  key: `d9of3u`
}], [`path`, {
  d: `M7 7h8`,
  key: `af5zfr`
}]]), ve = y(`mic-vocal`, [[`path`, {
  d: `m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12`,
  key: `80a601`
}], [`path`, {
  d: `M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5`,
  key: `j0ngtp`
}], [`circle`, {
  cx: `16`,
  cy: `7`,
  r: `5`,
  key: `d08jfb`
}]]), z = y(`package-check`, [[`path`, {
  d: `M12 22V12`,
  key: `d0xqtd`
}], [`path`, {
  d: `m16 17 2 2 4-4`,
  key: `uh5qu3`
}], [`path`, {
  d: `M21 11.127V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.32-.753`,
  key: `kpkbpo`
}], [`path`, {
  d: `M3.29 7 12 12l8.71-5`,
  key: `19ckod`
}], [`path`, {
  d: `m7.5 4.27 8.997 5.148`,
  key: `9yrvtv`
}]]), ye = y(`paperclip`, [[`path`, {
  d: `m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551`,
  key: `1miecu`
}]]), be = y(`pencil`, [[`path`, {
  d: `M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z`,
  key: `1a8usu`
}], [`path`, {
  d: `m15 5 4 4`,
  key: `1mk7zo`
}]]), xe = y(`plus`, [[`path`, {
  d: `M5 12h14`,
  key: `1ays0h`
}], [`path`, {
  d: `M12 5v14`,
  key: `s699le`
}]]), Se = y(`refresh-ccw`, [[`path`, {
  d: `M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
  key: `14sxne`
}], [`path`, {
  d: `M3 3v5h5`,
  key: `1xhq8a`
}], [`path`, {
  d: `M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16`,
  key: `1hlbsb`
}], [`path`, {
  d: `M16 16h5v5`,
  key: `ccwih5`
}]]), Ce = y(`rotate-ccw-clock`, [[`path`, {
  d: `M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
  key: `1357e3`
}], [`path`, {
  d: `M3 3v5h5`,
  key: `1xhq8a`
}], [`path`, {
  d: `M12 7v5l4 2`,
  key: `1fdv2h`
}]]), we = y(`rotate-ccw`, [[`path`, {
  d: `M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
  key: `1357e3`
}], [`path`, {
  d: `M3 3v5h5`,
  key: `1xhq8a`
}]]), Te = y(`save`, [[`path`, {
  d: `M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z`,
  key: `1c8476`
}], [`path`, {
  d: `M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7`,
  key: `1ydtos`
}], [`path`, {
  d: `M7 3v4a1 1 0 0 0 1 1h7`,
  key: `t51u73`
}]]), Ee = y(`search`, [[`path`, {
  d: `m21 21-4.34-4.34`,
  key: `14j7rj`
}], [`circle`, {
  cx: `11`,
  cy: `11`,
  r: `8`,
  key: `4ej97u`
}]]), De = y(`send`, [[`path`, {
  d: `M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z`,
  key: `1ffxy3`
}], [`path`, {
  d: `m21.854 2.147-10.94 10.939`,
  key: `12cjpa`
}]]), Oe = y(`settings`, [[`path`, {
  d: `M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915`,
  key: `1i5ecw`
}], [`circle`, {
  cx: `12`,
  cy: `12`,
  r: `3`,
  key: `1v7zrd`
}]]), ke = y(`shield-check`, [[`path`, {
  d: `M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z`,
  key: `oel41y`
}], [`path`, {
  d: `m9 12 2 2 4-4`,
  key: `dzmm74`
}]]), Ae = y(`smartphone`, [[`rect`, {
  width: `14`,
  height: `20`,
  x: `5`,
  y: `2`,
  rx: `2`,
  ry: `2`,
  key: `1yt0o3`
}], [`path`, {
  d: `M12 18h.01`,
  key: `mhygvu`
}]]), je = y(`trash-2`, [[`path`, {
  d: `M10 11v6`,
  key: `nco0om`
}], [`path`, {
  d: `M14 11v6`,
  key: `outv1u`
}], [`path`, {
  d: `M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6`,
  key: `miytrc`
}], [`path`, {
  d: `M3 6h18`,
  key: `d0wm0j`
}], [`path`, {
  d: `M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2`,
  key: `e791ji`
}]]), Me = y(`triangle-alert`, [[`path`, {
  d: `m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3`,
  key: `wmoenq`
}], [`path`, {
  d: `M12 9v4`,
  key: `juzpu7`
}], [`path`, {
  d: `M12 17h.01`,
  key: `p32p05`
}]]), Ne = y(`truck`, [[`path`, {
  d: `M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2`,
  key: `wrbu53`
}], [`path`, {
  d: `M15 18H9`,
  key: `1lyqi6`
}], [`path`, {
  d: `M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14`,
  key: `lysw3i`
}], [`circle`, {
  cx: `17`,
  cy: `18`,
  r: `2`,
  key: `332jqn`
}], [`circle`, {
  cx: `7`,
  cy: `18`,
  r: `2`,
  key: `19iecd`
}]]), Pe = y(`upload`, [[`path`, {
  d: `M12 3v12`,
  key: `1x0j5s`
}], [`path`, {
  d: `m17 8-5-5-5 5`,
  key: `7q97r8`
}], [`path`, {
  d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
  key: `ih7n3h`
}]]), Fe = y(`users-round`, [[`path`, {
  d: `M18 21a8 8 0 0 0-16 0`,
  key: `3ypg7q`
}], [`circle`, {
  cx: `10`,
  cy: `8`,
  r: `5`,
  key: `o932ke`
}], [`path`, {
  d: `M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3`,
  key: `10s06x`
}]]), Ie = y(`wifi`, [[`path`, {
  d: `M12 20h.01`,
  key: `zekei9`
}], [`path`, {
  d: `M2 8.82a15 15 0 0 1 20 0`,
  key: `dnpr2z`
}], [`path`, {
  d: `M5 12.859a10 10 0 0 1 14 0`,
  key: `1x1e6c`
}], [`path`, {
  d: `M8.5 16.429a5 5 0 0 1 7 0`,
  key: `1bycff`
}]]), Le = y(`x`, [[`path`, {
  d: `M18 6 6 18`,
  key: `1bl5f8`
}], [`path`, {
  d: `m6 6 12 12`,
  key: `d8bk6v`
}]]), Re = y(`zap`, [[`path`, {
  d: `M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z`,
  key: `1v7up4`
}]]), ze = c(), Be = new URL(import.meta.url).pathname, Ve = `/assets/`, He = Be.includes(Ve) ? Be.slice(0, Be.indexOf(Ve)) : ``;
function Ue(e) {
  return (/^[a-z][a-z\d+.-]*:/i).test(e) || e.startsWith(`//`) ? e : `${He}${e.startsWith(`/`) ? e : `/${e}`}`;
}
var We = class extends Error {
  status;
  code;
  details;
  currentVersion;
  constructor(e, t) {
    (super(t.error || `Request failed (${e})`), this.status = e, this.code = t.code, this.details = t.details, this.currentVersion = t.currentVersion);
  }
};
async function Ge(e, t = {}) {
  let n = new Headers(t.headers);
  (!(t.body instanceof FormData) && t.body != null && n.set(`Content-Type`, `application/json`), (t.method || `GET`).toUpperCase() !== `GET` && n.set(`X-OAB-CSRF`, `1`));
  let r = await fetch(Ue(e), {
    ...t,
    headers: n,
    credentials: `same-origin`
  });
  if (!r.ok) {
    let e;
    try {
      e = await r.json();
    } catch {
      e = {
        error: r.statusText || `Request failed.`
      };
    }
    throw new We(r.status, e);
  }
  if (r.status !== 204) return r.json();
}
var B = {
  put:(e,t)=>Ge(e,{method:"PUT",body:JSON.stringify(t)}),
  get: e => Ge(e),
  post: (e, t) => Ge(e, {
    method: `POST`,
    body: t instanceof FormData ? t : JSON.stringify(t ?? ({}))
  }),
  patch: (e, t) => Ge(e, {
    method: `PATCH`,
    body: JSON.stringify(t)
  }),
  delete: e => Ge(e, {
    method: `DELETE`
  }),
  upload: (e, t) => {
    let n = new FormData();
    return (n.set(`file`, t), Ge(e, {
      method: `POST`,
      body: n
    }));
  }
}, Ke = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
function qe(e) {
  let t = (Array.isArray(e) ? e : e == null ? [] : [e]).flatMap(e => String(e).split(/[;,\n\r]+/)).map(e => e.trim().toLowerCase()).filter(Boolean);
  return [...new Set(t)];
}
function Je(e) {
  return qe(e).filter(e => !Ke.test(e));
}
function Ye(e, t) {
  let n = qe(e);
  return n.length ? n : qe(t);
}
var Xe = new Intl.DateTimeFormat(`en-CA`, {
  timeZone: `America/New_York`,
  year: `numeric`,
  month: `2-digit`,
  day: `2-digit`,
  hour: `2-digit`,
  minute: `2-digit`,
  second: `2-digit`,
  hourCycle: `h23`
});
function Ze(e) {
  let t = Xe.formatToParts(e), n = e => Number(t.find(t => t.type === e)?.value || 0);
  return {
    year: n(`year`),
    month: n(`month`),
    day: n(`day`),
    hour: n(`hour`),
    minute: n(`minute`),
    second: n(`second`)
  };
}
function Qe(e) {
  let t = Ze(e);
  return Date.UTC(t.year, t.month - 1, t.day, t.hour, t.minute, t.second) - Math.floor(e.getTime() / 1e3) * 1e3;
}
function $e(e) {
  let t = e.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
  if (!t) throw Error(`Choose a valid Eastern date and time.`);
  let [, n, r, i, a, o, s = `00`] = t, [c, l, u, d, f, p] = [n, r, i, a, o, s].map(Number), m = Date.UTC(c, l - 1, u, d, f, p), h = new Date(m);
  if (h.getUTCFullYear() !== c || h.getUTCMonth() !== l - 1 || h.getUTCDate() !== u || d > 23 || f > 59 || p > 59) throw Error(`Choose a valid Eastern date and time.`);
  let g = m - Qe(new Date(m));
  g = m - Qe(new Date(g));
  let _ = new Date(g), v = Ze(_);
  if (v.year !== c || v.month !== l || v.day !== u || v.hour !== d || v.minute !== f || v.second !== p) throw Error(`That Eastern time does not exist because of daylight saving time. Choose another time.`);
  return _.toISOString();
}
function et(e, t = !1) {
  return Number.isFinite(e) && Number.isInteger(e * 2) && (t ? e >= 0 : e > 0);
}
var tt = [`NOT_STARTED`, `IN_PRODUCTION`, `WAITING_ON_VO`, `WAITING_ON_CLIENT`, `READY_FOR_REVIEW`, `READY_TO_DELIVER`, `ON_HOLD`, `CANCELLED`], nt = {
  NOT_STARTED: `Not Started`,
  IN_PRODUCTION: `In Production`,
  WAITING_ON_VO: `Waiting on VO`,
  WAITING_ON_CLIENT: `Waiting on Client`,
  READY_FOR_REVIEW: `Ready for Review`,
  READY_TO_DELIVER: `Ready to Deliver`,
  ON_HOLD: `On Hold`,
  CANCELLED: `Cancelled`
}, rt = e => e ? new Intl.DateTimeFormat(`en-US`, {
  timeZone: `America/New_York`,
  month: `short`,
  day: `numeric`,
  year: `numeric`,
  hour: `numeric`,
  minute: `2-digit`
}).format(new Date(e)) : `—`, it = e => {
  if (!e) return ``;
  let t = new Date(e), n = new Intl.DateTimeFormat(`en-CA`, {
    timeZone: `America/New_York`,
    year: `numeric`,
    month: `2-digit`,
    day: `2-digit`,
    hour: `2-digit`,
    minute: `2-digit`,
    hourCycle: `h23`
  }).formatToParts(t), r = e => n.find(t => t.type === e)?.value || ``;
  return `${r(`year`)}-${r(`month`)}-${r(`day`)}T${r(`hour`)}:${r(`minute`)}`;
}, at = e => {
  if (e == null) return `—`;
  let t = [`B`, `KB`, `MB`, `GB`, `TB`], n = e, r = 0;
  for (; n >= 1024 && r < t.length - 1; ) (n /= 1024, r += 1);
  return `${n.toFixed(+!!r)} ${t[r]}`;
}, ot = e => e.toLowerCase().replace(/_/g, `-`), st = e => e.split(/\s+/).map(e => e[0]).join(``).slice(0, 2).toUpperCase(), ct = e(e => {
  var t = Symbol.for(`react.transitional.element`), n = Symbol.for(`react.fragment`);
  function r(e, n, r) {
    var i = null;
    if ((r !== void 0 && (i = `` + r), n.key !== void 0 && (i = `` + n.key), (`key` in n))) for (var a in (r = {}, n)) a !== `key` && (r[a] = n[a]); else r = n;
    return (n = r.ref, {
      $$typeof: t,
      type: e,
      key: i,
      ref: n === void 0 ? null : n,
      props: r
    });
  }
  (e.Fragment = n, e.jsx = r, e.jsxs = r);
}), V = e((e, t) => {
  t.exports = ct();
})(), lt = 0, ut = ``;
function dt() {
  return (lt === 0 && (ut = document.body.style.overflow), lt += 1, document.body.style.overflow = `hidden`, () => {
    (lt = Math.max(0, lt - 1), lt === 0 && (document.body.style.overflow = ut));
  });
}
function ft({open: e, onClose: t, title: n, subtitle: r, children: i, wide: a = !1, extraWide: o = !1, footer: s}) {
  let c = (0, h.useRef)(t);
  return ((0, h.useEffect)(() => {
    c.current = t;
  }, [t]), (0, h.useEffect)(() => {
    if (!e) return;
    let t = e => {
      e.key === `Escape` && c.current();
    };
    document.addEventListener(`keydown`, t);
    let n = dt();
    return () => {
      (document.removeEventListener(`keydown`, t), n());
    };
  }, [e]), e ? (0, V.jsx)(`div`, {
    className: `modal-backdrop`,
    role: `presentation`,
    onMouseDown: e => {
      e.target === e.currentTarget && t();
    },
    children: (0, V.jsxs)(`section`, {
      className: `modal ${o ? `modal-extra-wide` : a ? `modal-wide` : ``}`,
      role: `dialog`,
      "aria-modal": `true`,
      "aria-label": n,
      children: [(0, V.jsxs)(`header`, {
        className: `modal-header`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: n
          }), r && (0, V.jsx)(`p`, {
            children: r
          })]
        }), (0, V.jsx)(`button`, {
          className: `icon-button`,
          onClick: t,
          "aria-label": `Close`,
          children: (0, V.jsx)(Le, {
            size: 20
          })
        })]
      }), (0, V.jsx)(`div`, {
        className: `modal-body`,
        children: i
      }), s && (0, V.jsx)(`footer`, {
        className: `modal-footer`,
        children: s
      })]
    })
  }) : null);
}
function pt({label: e = `Loading OAB…`}) {
  return (0, V.jsxs)(`div`, {
    className: `loading-state`,
    children: [(0, V.jsx)(de, {
      className: `spin`,
      size: 30
    }), (0, V.jsx)(`span`, {
      children: e
    })]
  });
}
function mt({title: e, body: t, action: n}) {
  return (0, V.jsxs)(`div`, {
    className: `empty-state`,
    children: [(0, V.jsx)(ee, {
      size: 30
    }), (0, V.jsx)(`h3`, {
      children: e
    }), (0, V.jsx)(`p`, {
      children: t
    }), n]
  });
}
function H({text: e, topic: t}) {
  let n = (0, h.useRef)(null), [r, i] = (0, h.useState)(`above`);
  function a() {
    let e = n.current?.getBoundingClientRect();
    e && i(e.top < 130 ? `below` : `above`);
  }
  function o(n) {
    (n.preventDefault(), n.stopPropagation(), window.dispatchEvent(new CustomEvent(`oab-open-manual`, {
      detail: {
        query: t || e
      }
    })));
  }
  return (0, V.jsxs)(`span`, {
    ref: n,
    className: `help-tip`,
    "data-placement": r,
    tabIndex: 0,
    onMouseEnter: a,
    onFocus: a,
    children: [(0, V.jsx)(A, {
      size: 15
    }), (0, V.jsxs)(`span`, {
      className: `help-tip-popover`,
      children: [(0, V.jsx)(`span`, {
        children: e
      }), (0, V.jsx)(`button`, {
        type: `button`,
        onClick: o,
        children: `Learn More in Software Manual →`
      })]
    })]
  });
}
function U({value: e, onChange: t, min: n = 0, ariaLabel: r, disabled: i = !1}) {
  let [a, o] = (0, h.useState)(String(e)), s = (0, h.useRef)(!1);
  return ((0, h.useEffect)(() => {
    s.current || o(String(e));
  }, [e]), (0, V.jsx)(`input`, {
    type: `text`,
    inputMode: `decimal`,
    "aria-label": r,
    value: a,
    disabled: i,
    onFocus: () => {
      (s.current = !0, Number(a) === 0 && o(``));
    },
    onChange: e => {
      let r = e.target.value.replace(`,`, `.`).replace(/^0+(?=\d)/, ``);
      if (!(/^\d*(?:\.\d?)?$/).test(r)) return;
      o(r);
      let i = Number(r);
      r !== `` && Number.isFinite(i) && t(Math.max(n, i));
    },
    onBlur: () => {
      s.current = !1;
      let e = Math.max(n, Number(a) || 0);
      (t(e), o(String(e)));
    }
  }));
}
function W({label: e, value: t, note: n, tone: r = `normal`}) {
  return (0, V.jsxs)(`article`, {
    className: `metric metric-${r}`,
    children: [(0, V.jsx)(`small`, {
      children: e
    }), (0, V.jsx)(`strong`, {
      children: t
    }), n && (0, V.jsx)(`span`, {
      children: n
    })]
  });
}
function ht({completed: e, total: t, percent: n}) {
  return (0, V.jsxs)(`div`, {
    className: `progress-wrap`,
    children: [(0, V.jsxs)(`div`, {
      className: `progress-label`,
      children: [(0, V.jsxs)(`b`, {
        children: [e, ` of `, t, ` pts complete`]
      }), (0, V.jsxs)(`span`, {
        children: [n, `%`]
      })]
    }), (0, V.jsx)(`div`, {
      className: `progress-track`,
      children: (0, V.jsx)(`div`, {
        className: `progress-fill ${n === 100 ? `complete` : ``}`,
        style: {
          width: `${n}%`
        }
      })
    })]
  });
}
function gt({allocation: e, compact: t = !1}) {
  return (0, V.jsxs)(`span`, {
    className: `allocation-badge ${t ? `compact` : ``}`,
    style: {
      "--producer-color": e.producerColor
    },
    title: `${e.producerName}: ${e.points} points${e.completedAt ? `, completed ${rt(e.completedAt)}` : ``}`,
    children: [(0, V.jsx)(`i`, {
      children: st(e.producerName)
    }), (0, V.jsxs)(`span`, {
      children: [e.producerName, !t && ` · ${e.points} pts`]
    }), e.completedAt && (0, V.jsx)(ee, {
      size: 13
    })]
  });
}
function G({children: e}) {
  return (0, V.jsxs)(`div`, {
    className: `warning-box`,
    children: [(0, V.jsx)(Me, {
      size: 18
    }), (0, V.jsx)(`div`, {
      children: e
    })]
  });
}
function _t({message: e, tone: t = `good`, onClose: n}) {
  return ((0, h.useEffect)(() => {
    let e = setTimeout(n, 5e3);
    return () => clearTimeout(e);
  }, [n]), (0, V.jsxs)(`div`, {
    className: `toast toast-${t}`,
    role: `status`,
    children: [t === `good` ? (0, V.jsx)(ee, {
      size: 18
    }) : (0, V.jsx)(Me, {
      size: 18
    }), (0, V.jsx)(`span`, {
      children: e
    }), (0, V.jsx)(`button`, {
      onClick: n,
      "aria-label": `Dismiss`,
      children: (0, V.jsx)(Le, {
        size: 16
      })
    })]
  }));
}
var vt = [[`UPDATE`, `Update (one or two word change; production remains the same)`, .5], [`SHOTGUN`, `Shotgun (station name and positioner ONLY)`, 1.5], [`SWEEPER`, `Sweeper (up to 30 words)`, 2], [`JINGLE_MIX`, `Jingle Mix (voice over jingle music only)`, 1.5], [`MUSIC_HOOK_SWEEPER`, `Music Hook Sweeper (up to 3 hooks / 30 words max)`, 4], [`MINI_PROMO`, `Mini Promo (up to 45 words)`, 5], [`PROMO`, `Promo (up to 60 seconds)`, 10], [`SPOT_PRODUCTION_30_60`, `30 or 60 sec Spot Production Only`, 10], [`SPOT_PRODUCTION_15`, `15 sec Spot Production Only`, 5], [`VO_TALENT_30`, `30 sec VO Talent`, 5], [`VO_TALENT_60`, `60 sec VO Talent`, 10], [`VO_TALENT_15`, `15 sec VO Talent`, 2.5], [`STUDIO_TIME`, `Studio Time (covers everything else / per hour)`, 10], [`BEAT_MESH_SWEEPER`, `Beat Mesh Sweeper`, 4], [`DRY_SWEEPER_SHOTGUN`, `Dry Produced Sweeper or Shotgun (filters, etc.; no music or SFX)`, .5], [`EXTENDED_PROMO`, `Extended length Promo (61–90 seconds)`, 15], [`PROMO_REVISION`, `Promo Revision (up to 25% change)`, 3], [`RUSH_MINI_PROMO`, `Rush (Same Day) Mini Promo`, 7.5], [`RUSH_PROMO`, `Rush (Same Day) Promo`, 15], [`RUSH_SHOTGUN`, `Rush (Same Day) Shotgun`, 3], [`RUSH_SWEEPER`, `Rush (Same Day) Sweeper`, 3], [`SWEEPER_REVISION`, `Sweeper Revision`, 1]], yt = vt.map(([e, t, n]) => [e, t, n, e === `STUDIO_TIME`]);
function bt({assignment: e, editingPresence: t, user: n, producers: r, onClose: i, onRefresh: a, onChanged: o, onOpenNew: s, notify: c}) {
  const [duplicateCreditMonth,setDuplicateCreditMonth]=h.useState(currentCreditMonth);
 const [duplicateSessionMonth,setDuplicateSessionMonth]=h.useState(currentCreditMonth);
  let [l, u] = (0, h.useState)(!1), [d, f] = (0, h.useState)(`overview`), [p, m] = (0, h.useState)(!1), [g, _] = (0, h.useState)(``), [v, y] = (0, h.useState)(0), [x, S] = (0, h.useState)(null), [C, T] = (0, h.useState)(``), [E, O] = (0, h.useState)(!1), [k, ee] = (0, h.useState)(0), [A, ie] = (0, h.useState)({}), [j, N] = (0, h.useState)({}), [F, I] = (0, h.useState)(``), [L, ae] = (0, h.useState)({}), [se, ce] = (0, h.useState)(!1), [le, ue] = (0, h.useState)(``), [de, pe] = (0, h.useState)(`CLIENT_DELAY`), [he, _e] = (0, h.useState)(``), [ye, xe] = (0, h.useState)(``), [Se, Ee] = (0, h.useState)({
    status: `NOT_NEEDED`,
    talent: ``,
    orderedAt: ``,
    expectedAt: ``,
    receivedAt: ``,
    notes: ``
  }), [Oe, ke] = (0, h.useState)(``), [Ae, je] = (0, h.useState)(!1), [Me, Fe] = (0, h.useState)(null), [Ie, Re] = (0, h.useState)(``), [ze, Be] = (0, h.useState)(!1), [Ve, He] = (0, h.useState)(``), [We, Ge] = (0, h.useState)(``), [Ke, Ye] = (0, h.useState)({}), [Xe, Ze] = (0, h.useState)({}), [Qe, tt] = (0, h.useState)(!1), [ot, st] = (0, h.useState)(``), [ct, lt] = (0, h.useState)(``), [ut, dt] = (0, h.useState)(!1), [mt, W] = (0, h.useState)(!1), [_t, vt] = (0, h.useState)(!1), [bt, xt] = (0, h.useState)([{
    name: ``,
    emails: ``
  }]), [St, Ct] = (0, h.useState)(!1), [wt, Tt] = (0, h.useState)(`STATION_PROFILE`), [Et, Dt] = (0, h.useState)(``), [Ot, kt] = (0, h.useState)(!1), At = (0, h.useRef)(null);
  (0, h.useEffect)(() => {
    e && (f(`overview`), _(e.title), y(0), ee(e.masterPoints), ie(Object.fromEntries(e.allocations.map(e => [e.producerId, e.points]))), N(Object.fromEntries((e.orderLines || []).map(e => [e.menuCode, e.quantity]))), I(``), ae({}), ue(it(e.currentDueAt)), _e(``), xe(e.scriptHtml), Ee({
      status: e.voStatus == null ? `` : e.voStatus === `RECEIVED` || e.voStatus === `NOT_NEEDED` ? `RECEIVED` : `NEEDED`,
      talent: e.voTalent || ``,
      orderedAt: e.voOrderedAt ? it(e.voOrderedAt) : ``,
      expectedAt: e.voExpectedAt ? it(e.voExpectedAt) : ``,
      receivedAt: e.voReceivedAt ? it(e.voReceivedAt) : ``,
      notes: e.voNotes || ``
    }), Ge(it(e.currentDueAt)), Ye(Object.fromEntries(e.allocations.map(e => [e.producerId, !1]))), Ze({}), He(``), st(`${e.title}-COPY`), lt(it(e.currentDueAt)), vt(!!e.coneOfSilence), xt(e.confidentialContacts?.length ? e.confidentialContacts.map(e => ({
      name: e.name,
      emails: e.emails.join(`, `)
    })) : [{
      name: ``,
      emails: ``
    }]), Tt(e.completionNotifyMode), Dt(e.completionNotifyEmails.join(`
`)), Ct(!1), kt(!1));
  }, [e]);
  let jt = r.filter(t => t.active || e?.allocations.some(e => e.producerId === t.id)), Mt = (0, h.useMemo)(() => Object.values(A).reduce((e, t) => e + (Number(t) || 0), 0), [A]), Nt = !!e?.orderLines?.length, Pt = (0, h.useMemo)(() => Number(yt.reduce((e, [t, , n]) => e + (j[t] || 0) * n, 0).toFixed(1)), [j]), Ft = e?.id, It = e?.title;
  if (((0, h.useEffect)(() => {
    Nt && ee(Pt);
  }, [Nt, Pt]), (0, h.useEffect)(() => {
    if (!p || !Ft || It == null) return;
    let e = g.trim();
    if (!e || e === It) {
      y(0);
      return;
    }
    let t = !1, n = window.setTimeout(async () => {
      try {
        let n = await B.get(`/api/assignments/duplicate-title?title=${encodeURIComponent(e)}&excludeId=${Ft}`);
        t || y(n.count);
      } catch {
        t || y(0);
      }
    }, 300);
    return () => {
      (t = !0, window.clearTimeout(n));
    };
  }, [p, g, Ft, It]), !e)) return null;
  async function Lt(t, n) {
    u(!0);
    try {
      return (await B.post(`/api/assignments/${e.id}/actions`, {
        ...t,
        action: t.action,
        version: e.version
      }), c(n), await o(), await a(e.id), !0);
    } catch (e) {
      return (c(e instanceof Error ? e.message : `The assignment could not be changed.`, `error`), !1);
    } finally {
      u(!1);
    }
  }
  async function Rt() {
    !x || !C.trim() || await Lt({
      action: x,
      reason: C
    }, x === `hold` ? `Assignment put On Hold. Overdue escalation is paused.` : x === `resume` ? `Assignment resumed.` : `Assignment cancelled and retained in history.`) && (S(null), T(``));
  }
  async function zt() {
    if (!et(k)) return c(`Master Points must be greater than zero in half-point increments.`, `error`);
    if (Object.values(A).some(e => !et(e, !0))) return c(`Producer points must use half-point increments.`, `error`);
    if (Mt > k) return c(`Producer allocations cannot exceed Master Points.`, `error`);
    if (e.allocations.filter(e => e.completedAt && (A[e.producerId] || 0) !== e.points).some(e => !L[e.producerId])) return c(`Choose Keep Complete or Reopen for every completed producer whose points changed.`, `error`);
    if (Nt && yt.some(([e, , , t]) => t && j[e] > 0 && Math.round(j[e] * 20) !== j[e] * 20)) return c(`Studio Time must use 0.05-hour increments.`, `error`);
    await Lt({
      action: `update-points`,
      masterPoints: k,
      allocations: Object.entries(A).filter(([, e]) => e > 0).map(([e, t]) => ({
        producerId: e,
        points: t
      })),
      reason: F,
      completionDecisions: L,
      ...Nt ? {
        orderLines: yt.filter(([e]) => (j[e] || 0) > 0).map(([e]) => ({
          menuCode: e,
          quantity: j[e]
        }))
      } : {}
    }, `Points updated with history preserved.`) && O(!1);
  }
  async function Bt() {
    if (!he.trim()) return c(`A due-date change reason is required.`, `error`);
    let e;
    try {
      e = $e(le);
    } catch (e) {
      c(e instanceof Error ? e.message : `Choose a valid Eastern deadline.`, `error`);
      return;
    }
    await Lt({
      action: `change-due-date`,
      dueAt: e,
      reasonCode: de,
      reason: he
    }, `Current Due Date changed; Original Due Date was preserved.`) && ce(!1);
  }
  async function Vt() {
    await Lt({
      action: `update-content`,
      scriptHtml: ye
    }, `Script saved.`);
  }
  async function Ht() {
    try {
      await Lt({
        action: `update-vo`,
        status: Se.status,
        talent: Se.talent || null,
        orderedAt: Se.orderedAt ? $e(Se.orderedAt) : null,
        expectedAt: Se.expectedAt ? $e(Se.expectedAt) : null,
        receivedAt: Se.receivedAt ? $e(Se.receivedAt) : null,
        notes: Se.notes || null
      }, `VO tracking updated.`);
    } catch (e) {
      c(e instanceof Error ? e.message : `Choose valid Eastern VO times.`, `error`);
    }
  }
  async function Ut() {
    if (Oe.trim()) {
      u(!0);
      try {
        (await B.post(`/api/assignments/${e.id}/comments`, {
          body: Oe,
          important: Ae
        }), ke(``), je(!1), c(Ae ? `Important comment posted and assigned producers notified.` : `Comment posted. Existing comments remain immutable.`), await a(e.id));
      } catch (e) {
        c(e instanceof Error ? e.message : `Could not post comment.`, `error`);
      } finally {
        u(!1);
      }
    }
  }
  async function Wt() {
    if (Me) {
      u(!0);
      try {
        let t = Ie ? `?attachmentId=${Ie}` : `?kind=ATTACHMENT&displayName=${encodeURIComponent(Me.name)}`;
        (await B.upload(`/api/assignments/${e.id}/files${t}`, Me), Fe(null), Re(``), c(Ie ? `New file version uploaded; the prior version remains available.` : `File attached.`), await a(e.id));
      } catch (e) {
        c(e instanceof Error ? e.message : `Upload failed.`, `error`);
      } finally {
        u(!1);
      }
    }
  }
  async function Gt() {
    let e = Object.entries(Ke).filter(([, e]) => e).map(([e]) => e);
    if (!Ve.trim() || !e.length) return c(`Enter a reason and select the affected producer(s).`, `error`);
    if (e.some(e => (Xe[e] || 0) > 0 && !et(Xe[e]))) return c(`Revision Points must use half-point increments.`, `error`);
    let t;
    try {
      t = We ? $e(We) : null;
    } catch (e) {
      c(e instanceof Error ? e.message : `Choose a valid Eastern revision deadline.`, `error`);
      return;
    }
    await Lt({
      action: `restore`,
      reason: Ve,
      producerIds: e,
      dueAt: t,
      revisionPoints: e.filter(e => (Xe[e] || 0) > 0).map(e => ({
        producerId: e,
        points: Xe[e]
      }))
    }, `Assignment restored for revision; affected producers were reopened.`) && Be(!1);
  }
  async function Kt() {
    let e = bt.filter(e => e.name.trim() || e.emails.trim()).map(e => ({
      name: e.name.trim(),
      emails: qe(e.emails)
    }));
    await Lt({
      action: `update-confidential`,
      coneOfSilence: _t,
      contacts: e
    }, _t ? `CONE OF SILENCE handling and confidential contacts saved.` : `CONE OF SILENCE disabled for this assignment.`) && W(!1);
  }
  async function qt() {
    let t = wt, n = qe(Et), r = Je(Et);
    if (r.length) return c(`Invalid completion email address${r.length === 1 ? `` : `es`}: ${r.join(`, `)}`, `error`);
    if (t === `CUSTOM` && !n.length) return c(`Enter at least one custom completion email address.`, `error`);
    await Lt({
      action: `update-completion-notification`,
      mode: t,
      emails: n
    }, t === `NONE` ? `Client completion email suppressed for this assignment.` : e.coneOfSilence ? `Completion notice will use this assignment's confidential contacts.` : t === `CUSTOM` ? `Assignment-specific completion recipients saved.` : `Completion notification reset to the Station Profile recipients.`) && Ct(!1);
  }
  async function Jt() {
    u(!0);
    try {
      let t = (await B.post(`/api/assignments/${e.id}/actions`, {
        action: e.coneOfSilence ? `confidential-deliver` : `master-deliver`,
        version: e.version
      })).completionEmail, n = e.coneOfSilence ? `CONFIDENTIAL DELIVERY recorded. Assignment moved to Archive.` : `Master Delivered. Assignment moved to Archive.`, r = `good`;
      (t?.queued ? n += ` Client completion email queued for ${t.recipients.length} recipient${t.recipients.length === 1 ? `` : `s`}.` : t?.error ? (n += ` The client email could not be queued, but delivery and DTS posting remain complete.`, r = `error`) : t?.reason && (n += ` ${t.reason}`), c(n, r), kt(!1), await o(), await a(e.id));
    } catch (e) {
      c(e instanceof Error ? e.message : `Master Delivery could not be completed.`, `error`);
    } finally {
      u(!1);
    }
  }
  async function Yt() {
    let t = g.trim();
    if (!t) return c(`Production title is required.`, `error`);
    if (t.length > 300) return c(`Production title cannot exceed 300 characters.`, `error`);
    await Lt({
      action: `rename`,
      title: t
    }, t === e.title ? `Production title is unchanged.` : `Production title renamed. Client, points, and history were preserved.`) && m(!1);
  }
  async function Xt() {
    if (!(!ot.trim() || !ct)) {
      u(!0);
      try {
        let t = await B.post(`/api/assignments/${e.id}/actions`, {
          action: `duplicate`,
          version: e.version,
          title: ot.trim(),
          dueAt: $e(ct),
          copyAttachments: ut,
          sessionMonth:duplicateSessionMonth,
          pointCreditMonth: duplicateCreditMonth+"-01"
        }), n = t.coneOfSilence ? `Confidential duplicate created. CONE OF SILENCE and confidential contacts carried over; normal Master Delivery remains blocked.` : `Duplicate assignment created with completion and history reset.`;
        (tt(!1), c(t.attachmentCopyError ? `${n} One or more attachment versions could not be copied; review its Files section.` : n, t.attachmentCopyError ? `error` : `good`), await o(), i(), await s(t.id));
      } catch (e) {
        c(e instanceof Error ? e.message : `Could not duplicate the assignment.`, `error`);
      } finally {
        u(!1);
      }
    }
  }
  let Zt = !!e.archivedAt || e.status === `CANCELLED`, Qt = e.revisionNumber > 0 ? e.clientUnlimited ? `Revision completion confirmation only. No point-account details are included.` : `Revision completion notice. No additional Master Points will be deducted or reported.` : e.clientUnlimited ? `Completion confirmation only. DTS point-account details are suppressed for this unlimited client.` : `Completion confirmation plus the updated DTS monthly point-status report.`;
  return (0, V.jsxs)(V.Fragment, {
    children: [(0, V.jsx)(`div`, {
      className: `drawer-backdrop`,
      onMouseDown: e => {
        e.target === e.currentTarget && i();
      },
      children: (0, V.jsxs)(`aside`, {
        className: `assignment-drawer`,
        "aria-label": `Assignment ${e.title}`,
        children: [(0, V.jsxs)(`header`, {
          className: `drawer-header`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`div`, {
              className: `drawer-title-row`,
              children: [(0, V.jsx)(`h2`, {
                children: e.title
              }), (0, V.jsx)(`button`, {
                className: `icon-button title-edit-button`,
                onClick: () => {
                  (_(e.title), y(0), m(!0));
                },
                title: `Rename assignment title`,
                "aria-label": `Rename assignment title`,
                children: (0, V.jsx)(be, {
                  size: 15
                })
              })]
            }), (0, V.jsxs)(`p`, {
              children: [`Revision #`, e.revisionNumber, ` · `, nt[e.status]]
            })]
          }), (0, V.jsx)(`button`, {
            className: `icon-button`,
            onClick: i,
            children: (0, V.jsx)(Le, {
              size: 21
            })
          })]
        }), !!t.length && (0, V.jsxs)(`div`, {
          className: `editing-presence-banner`,
          children: [(0, V.jsx)(`span`, {
            className: `presence-dot`
          }), (0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`b`, {
              children: [t.map(e => e.producerName).join(`, `), ` `, t.length === 1 ? `is` : `are`, ` currently editing this assignment.`]
            }), (0, V.jsx)(`small`, {
              children: `Live presence is advisory. Version checks still prevent silent overwrite.`
            })]
          })]
        }), (0, V.jsxs)(`div`, {
          className: `drawer-tabs`,
          children: [(0, V.jsx)(`button`, {
            className: d === `overview` ? `active` : ``,
            onClick: () => f(`overview`),
            children: `Overview`
          }), (0, V.jsx)(`button`, {
            className: d === `production` ? `active` : ``,
            onClick: () => f(`production`),
            children: `Production`
          }), (0, V.jsx)(`button`, {
            className: d === `activity` ? `active` : ``,
            onClick: () => f(`activity`),
            children: `Activity`
          })]
        }), (0, V.jsxs)(`div`, {
          className: `drawer-content`,
          children: [(0, V.jsxs)(`div`, {
            className: `drawer-actions`,
            children: [!Zt && (0, V.jsxs)(`button`, {
              className: `button ${e.urgent ? `danger` : `secondary`}`,
              onClick: () => Lt({
                action: `set-urgent`,
                urgent: !e.urgent
              }, e.urgent ? `Urgent emphasis removed.` : `Marked Urgent without changing the due date.`),
              children: [(0, V.jsx)(oe, {
                size: 15
              }), e.urgent ? `Clear Urgent` : `Urgent`]
            }), (0, V.jsxs)(`button`, {
              className: `button secondary`,
              onClick: () => { setDuplicateCreditMonth(currentCreditMonth());setDuplicateSessionMonth(currentCreditMonth()); tt(!0); },
              children: [(0, V.jsx)(M, {
                size: 15
              }), `Duplicate`]
            }), !Zt && (0, V.jsx)(`button`, {
              className: `button danger ${e.coneOfSilence ? `critical-flash` : ``}`,
              onClick: () => W(!0),
              children: e.coneOfSilence ? `CONE OF SILENCE` : `Enable CONE OF SILENCE`
            }), !Zt && e.onHold ? (0, V.jsxs)(`button`, {
              className: `button secondary`,
              onClick: () => S(`resume`),
              children: [(0, V.jsx)(ne, {
                size: 15
              }), `Resume`]
            }) : !Zt && (0, V.jsxs)(`button`, {
              className: `button secondary`,
              onClick: () => S(`hold`),
              children: [(0, V.jsx)(te, {
                size: 15
              }), `On Hold`]
            }), !Zt && (0, V.jsxs)(`button`, {
              className: `button danger-ghost`,
              onClick: () => S(`cancel`),
              children: [(0, V.jsx)(re, {
                size: 15
              }), `Cancel`]
            }), Zt && (0, V.jsxs)(`button`, {
              className: `button primary`,
              onClick: () => Be(!0),
              children: [(0, V.jsx)(we, {
                size: 15
              }), `Restore for Revision`]
            })]
          }), d === `overview` && (0, V.jsxs)(V.Fragment, {
            children: [h.createElement(SessionMonthSummary,{assignment:e}),h.createElement(PointsMonthEditor,{assignment:e,user:n,onSaved:async()=>{await o();await a(e.id)}}),(0, V.jsxs)(`div`, {
              className: `fact-grid`,
              children: [(0, V.jsxs)(`div`, {
                children: [(0, V.jsxs)(`small`, {
                  children: [`Master Points `, (0, V.jsx)(H, {
                    topic: `Master Points`,
                    text: `Client-facing value. Producer allocations plus UNASSIGNED must reconcile to this amount.`
                  })]
                }), (0, V.jsx)(`b`, {
                  children: e.masterPoints
                })]
              }), (0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`small`, {
                  children: `Revision Points`
                }), (0, V.jsx)(`b`, {
                  children: e.revisionPoints
                })]
              }), (0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`small`, {
                  children: `UNASSIGNED`
                }), (0, V.jsx)(`b`, {
                  className: e.unassignedPoints ? `danger-text` : ``,
                  children: e.unassignedPoints
                })]
              }), (0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`small`, {
                  children: `Original Due`
                }), (0, V.jsx)(`b`, {
                  children: rt(e.originalDueAt)
                })]
              }), (0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`small`, {
                  children: `Current Due`
                }), (0, V.jsx)(`b`, {
                  children: rt(e.currentDueAt)
                })]
              }), (0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`small`, {
                  children: `Acknowledged`
                }), (0, V.jsxs)(`b`, {
                  children: [e.allocations.filter(e => e.acknowledgedAt).length, `/`, e.allocations.length]
                })]
              })]
            }), (0, V.jsx)(ht, {
              completed: e.completedPoints,
              total: e.masterPoints,
              percent: e.progressPercent
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsx)(`div`, {
                className: `section-heading`,
                children: (0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: `Assignment State & VO Status`
                  }), (0, V.jsx)(`p`, {
                    children: `These independent workflow controls stay together in Overview.`
                  })]
                })
              }), !Zt && (0, V.jsxs)(`div`, {
                className: `inline-controls assignment-state-controls`,
                children: [(0, V.jsxs)(`label`, {
                  className: `field`,
                  children: [(0, V.jsx)(`span`, {
                    children: `Assignment State`
                  }), (0, V.jsx)(`select`, {
                    value: e.status,
                    onChange: e => Lt({
                      action: `set-status`,
                      status: e.target.value
                    }, `Assignment status updated.`),
                    disabled: l || e.onHold,
                    children: Object.entries(nt).filter(([e]) => ![`ON_HOLD`, `CANCELLED`, `WAITING_ON_VO`].includes(e)).map(([e, t]) => (0, V.jsx)(`option`, {
                      value: e,
                      children: t
                    }, e))
                  })]
                }), (0, V.jsxs)(`label`, {
                  className: `field`,
                  children: [(0, V.jsx)(`span`, {
                    children: `VO Status`
                  }), (0, V.jsxs)(`select`, {
                    value: e.voStatus == null ? `` : e.voStatus === `RECEIVED` || e.voStatus === `NOT_NEEDED` ? `RECEIVED` : `NEEDED`,
                    onChange: e => Lt({
                      action: `update-vo`,
                      status: e.target.value
                    }, `VO status updated.`),
                    disabled: l,
                    children: [(0, V.jsx)(`option`, {
                      value: ``,
                      children: `—`
                    }), (0, V.jsx)(`option`, {
                      value: `RECEIVED`,
                      children: `VO IS IN`
                    }), (0, V.jsx)(`option`, {
                      value: `NEEDED`,
                      children: `WAITING ON VO`
                    })]
                  })]
                })]
              })]
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: `Assigned Producers & Points`
                  }), (0, V.jsx)(`p`, {
                    children: `Completion and delivery are tracked separately per producer.`
                  })]
                }), !Zt && (0, V.jsx)(`button`, {
                  className: `button tertiary`,
                  onClick: () => O(e => !e),
                  children: `Edit Points`
                })]
              }), (0, V.jsx)(`div`, {
                className: `producer-work-list`,
                children: e.allocations.map(e => (0, V.jsxs)(`div`, {
                  className: `producer-work-row`,
                  children: [(0, V.jsx)(gt, {
                    allocation: e
                  }), (0, V.jsxs)(`div`, {
                    className: `producer-state`,
                    children: [(0, V.jsx)(`span`, {
                      children: e.acknowledgedAt ? `Seen` : `Not seen`
                    }), (0, V.jsxs)(`button`, {
                      className: `mini-toggle ${e.completedAt ? `on` : ``}`,
                      disabled: l || n.role !== `ADMIN` && n.producerId !== e.producerId,
                      onClick: () => Lt({
                        action: `producer-complete`,
                        producerId: e.producerId,
                        complete: !e.completedAt
                      }, e.completedAt ? `${e.producerName} reopened.` : `${e.producerName} marked complete.`),
                      children: [(0, V.jsx)(D, {
                        size: 13
                      }), e.completedAt ? `Complete` : `Mark complete`]
                    }), (0, V.jsxs)(`button`, {
                      className: `mini-toggle ${e.deliveredAt ? `on` : ``}`,
                      disabled: l || !e.completedAt || n.role !== `ADMIN` && n.producerId !== e.producerId,
                      onClick: () => Lt({
                        action: `producer-delivered`,
                        producerId: e.producerId,
                        delivered: !e.deliveredAt
                      }, e.deliveredAt ? `Producer delivery reopened.` : `Producer portion marked delivered.`),
                      children: [(0, V.jsx)(Ne, {
                        size: 13
                      }), e.deliveredAt ? `Delivered` : `Deliver`]
                    })]
                  })]
                }, e.id))
              }), E && (0, V.jsxs)(`div`, {
                className: `inline-editor`,
                children: [(0, V.jsx)(G, {
                  children: `OAB never redistributes points silently. If completed points change, choose Keep Complete or Reopen. Point Menu changes update Master Points from the same assignment record.`
                }), Nt && (0, V.jsxs)(`div`, {
                  className: `field full`,
                  children: [(0, V.jsxs)(`label`, {
                    children: [`DSV Point Menu `, (0, V.jsx)(H, {
                      topic: `DSV Point Menu`,
                      text: `Edit the official Point Menu quantities here. Master Points recalculates from these same lines; Studio Time uses 0.05-hour increments.`
                    })]
                  }), (0, V.jsx)(`div`, {
                    className: `point-menu-grid`,
                    children: yt.map(([e, t, n, r]) => (0, V.jsxs)(`div`, {
                      className: `point-menu-row`,
                      children: [(0, V.jsxs)(`span`, {
                        children: [(0, V.jsx)(`b`, {
                          children: t
                        }), (0, V.jsxs)(`small`, {
                          children: [n, ` pts `, r ? `per hour` : `each`]
                        })]
                      }), (0, V.jsx)(`input`, {
                        type: `number`,
                        min: `0`,
                        step: r ? `0.05` : `1`,
                        value: j[e] || ``,
                        onChange: t => N(n => ({
                          ...n,
                          [e]: Number(t.target.value || 0)
                        }))
                      }), (0, V.jsxs)(`b`, {
                        children: [Number(((j[e] || 0) * n).toFixed(1)), ` pts`]
                      })]
                    }, e))
                  })]
                }), (0, V.jsx)(`div`, {
                  className: `allocation-editor`,
                  children: jt.map(t => {
                    let n = e.allocations.find(e => e.producerId === t.id), r = !!(n?.completedAt && (A[t.id] || 0) !== n.points);
                    return (0, V.jsxs)(`div`, {
                      className: `allocation-edit-row extended`,
                      children: [(0, V.jsx)(`span`, {
                        className: `producer-color`,
                        style: {
                          background: t.color
                        }
                      }), (0, V.jsxs)(`span`, {
                        children: [t.name, t.active ? `` : ` (inactive)`]
                      }), (0, V.jsx)(U, {
                        value: A[t.id] || 0,
                        ariaLabel: `${t.name} points`,
                        onChange: e => ie(n => ({
                          ...n,
                          [t.id]: e
                        }))
                      }), r ? (0, V.jsxs)(`select`, {
                        value: L[t.id] || ``,
                        onChange: e => ae(n => ({
                          ...n,
                          [t.id]: e.target.value
                        })),
                        children: [(0, V.jsx)(`option`, {
                          value: ``,
                          children: `Choose…`
                        }), (0, V.jsx)(`option`, {
                          value: `KEEP_COMPLETE`,
                          children: `Keep Complete`
                        }), (A[t.id] || 0) > 0 && (0, V.jsx)(`option`, {
                          value: `REOPEN`,
                          children: `Reopen Producer`
                        })]
                      }) : (0, V.jsx)(`span`, {})]
                    }, t.id);
                  })
                }), (0, V.jsxs)(`div`, {
                  className: `reconcile ${Mt > k ? `bad` : `good`}`,
                  children: [(0, V.jsxs)(`label`, {
                    children: [`Master `, Nt ? (0, V.jsx)(`b`, {
                      children: k
                    }) : (0, V.jsx)(U, {
                      value: k,
                      min: 0,
                      ariaLabel: `Master Points`,
                      onChange: ee
                    })]
                  }), (0, V.jsxs)(`span`, {
                    children: [`Allocated: `, (0, V.jsx)(`b`, {
                      children: Mt
                    })]
                  }), (0, V.jsxs)(`span`, {
                    children: [`UNASSIGNED: `, (0, V.jsx)(`b`, {
                      children: k - Mt
                    })]
                  })]
                }), (0, V.jsxs)(`label`, {
                  className: `field`,
                  children: [(0, V.jsx)(`span`, {
                    children: `Point-change reason (optional)`
                  }), (0, V.jsx)(`textarea`, {
                    value: F,
                    onChange: e => I(e.target.value),
                    rows: 2
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `right-actions`,
                  children: [(0, V.jsx)(`button`, {
                    className: `button secondary`,
                    onClick: () => O(!1),
                    children: `Cancel`
                  }), (0, V.jsxs)(`button`, {
                    className: `button primary`,
                    onClick: zt,
                    children: [(0, V.jsx)(Te, {
                      size: 15
                    }), `Save Point Changes`]
                  })]
                })]
              })]
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsxs)(`h3`, {
                    children: [`Due Dates `, (0, V.jsx)(H, {
                      topic: `Original and Current Due Dates`,
                      text: `Original Due is permanent. Current Due is the live deadline and every change requires a reason.`
                    })]
                  }), (0, V.jsx)(`p`, {
                    children: `Original is permanent; Current is the live Eastern deadline.`
                  })]
                }), !Zt && (0, V.jsxs)(`button`, {
                  className: `button tertiary`,
                  onClick: () => ce(e => !e),
                  children: [(0, V.jsx)(w, {
                    size: 15
                  }), `Change Due Date`]
                })]
              }), se && (0, V.jsxs)(`div`, {
                className: `inline-editor form-grid`,
                children: [(0, V.jsxs)(`div`, {
                  className: `field`,
                  children: [(0, V.jsx)(`label`, {
                    children: `New Current Due Date`
                  }), (0, V.jsx)(`input`, {
                    type: `datetime-local`,
                    value: le,
                    onChange: e => ue(e.target.value)
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `field`,
                  children: [(0, V.jsx)(`label`, {
                    children: `Reason Type`
                  }), (0, V.jsxs)(`select`, {
                    value: de,
                    onChange: e => pe(e.target.value),
                    children: [(0, V.jsx)(`option`, {
                      value: `CLIENT_DELAY`,
                      children: `Client Change / Delay`
                    }), (0, V.jsx)(`option`, {
                      value: `INTERNAL_SCHEDULING`,
                      children: `Internal Scheduling`
                    }), (0, V.jsx)(`option`, {
                      value: `PRODUCTION_ISSUE`,
                      children: `Production Issue`
                    }), (0, V.jsx)(`option`, {
                      value: `MANAGEMENT_CHANGE`,
                      children: `Management Change`
                    }), (0, V.jsx)(`option`, {
                      value: `OTHER`,
                      children: `Other`
                    })]
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `field full`,
                  children: [(0, V.jsx)(`label`, {
                    children: `Reason (required)`
                  }), (0, V.jsx)(`textarea`, {
                    rows: 2,
                    value: he,
                    onChange: e => _e(e.target.value)
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `full right-actions`,
                  children: [(0, V.jsx)(`button`, {
                    className: `button secondary`,
                    onClick: () => ce(!1),
                    children: `Cancel`
                  }), (0, V.jsx)(`button`, {
                    className: `button primary`,
                    onClick: Bt,
                    children: `Save Due Date`
                  })]
                })]
              })]
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section completion-notification`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsxs)(`h3`, {
                    children: [`Completion Notification `, (0, V.jsx)(H, {
                      topic: `Client Completion & DTS Point-Status Email`,
                      text: `After successful Master Delivery, OAB emails the effective recipients. Finite accounts receive the updated DTS point status. Unlimited clients receive completion confirmation only, with no point-account report.`
                    })]
                  }), (0, V.jsx)(`p`, {
                    children: `Defaults come from the Station Profile and can be overridden or suppressed for this assignment.`
                  })]
                }), !Zt && (0, V.jsxs)(`button`, {
                  className: `button tertiary`,
                  onClick: () => {
                    (Tt(e.completionNotifyMode), Dt(e.completionNotifyEmails.join(`
`)), Ct(!0));
                  },
                  children: [(0, V.jsx)(me, {
                    size: 15
                  }), `Edit Recipients`]
                })]
              }), (0, V.jsxs)(`div`, {
                className: `completion-notify-grid`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`small`, {
                    children: `RECIPIENT SOURCE`
                  }), (0, V.jsx)(`b`, {
                    children: e.completionNotifyMode === `NONE` ? `Suppressed for this assignment` : e.coneOfSilence ? `CONE OF SILENCE contacts` : e.completionNotifyMode === `CUSTOM` ? `Assignment override` : `Station Profile`
                  })]
                }), (0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`small`, {
                    children: `EFFECTIVE RECIPIENTS`
                  }), (0, V.jsx)(`b`, {
                    children: e.effectiveCompletionRecipients.length ? e.effectiveCompletionRecipients.join(`, `) : `No recipients configured`
                  })]
                }), (0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`small`, {
                    children: `EMAIL CONTENT`
                  }), (0, V.jsx)(`b`, {
                    children: e.completionNotifyMode === `NONE` || !e.effectiveCompletionRecipients.length ? `No client email will be sent` : e.clientUnlimited ? `Completion confirmation only — no points report` : e.revisionNumber > 0 ? `Revision completion — no additional Master Points` : `Completion + DTS point-status report`
                  })]
                })]
              }), e.completionNotifyMode !== `NONE` && !e.effectiveCompletionRecipients.length && (0, V.jsx)(G, {
                children: `Master Delivery will still succeed, but no client completion email can be sent until recipients are added.`
              })]
            }), !Zt && (0, V.jsxs)(`section`, {
              className: `drawer-section master-delivery ${e.coneOfSilence ? `confidential-box` : ``}`,
              children: [(0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(z, {
                  size: 24
                }), (0, V.jsxs)(`div`, {
                  children: [(0, V.jsxs)(`h3`, {
                    children: [e.coneOfSilence ? `CONE OF SILENCE — Manual Confidential Delivery Required` : `Master Delivery`, ` `, (0, V.jsx)(H, {
                      topic: `Producer Completion, Delivery, and Master Delivery`,
                      text: `Producer completion and producer delivery are separate. Only Master Delivery closes and archives the whole assignment, and it is gated by zero UNASSIGNED plus all required producer work complete.`
                    })]
                  }), (0, V.jsx)(`p`, {
                    children: e.coneOfSilence ? `OAB does not transmit production files. Complete the confidential delivery outside OAB using DSV’s approved internal procedure, then use CONFIDENTIAL DELIVERY to record Master Delivery.` : `Only this action closes the assignment and moves it to Archive. UNASSIGNED must be zero and all producer portions must be complete.`
                  }), e.coneOfSilence && e.confidentialContacts?.map(e => (0, V.jsxs)(`p`, {
                    children: [(0, V.jsx)(`b`, {
                      children: e.name
                    }), ` · `, e.emails.join(`, `)]
                  }, e.id))]
                })]
              }), (0, V.jsxs)(`button`, {
                className: `button ${e.coneOfSilence ? `danger` : `good`}`,
                disabled: l,
                onClick: () => kt(!0),
                children: [(0, V.jsx)(b, {
                  size: 16
                }), e.coneOfSilence ? `CONFIDENTIAL DELIVERY` : `Master Delivered`]
              })]
            })]
          }), d === `production` && (0, V.jsxs)(V.Fragment, {
            children: [e.orderLines?.length ? (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsx)(`div`, {
                className: `section-heading`,
                children: (0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: `DSV Point Menu`
                  }), (0, V.jsx)(`p`, {
                    children: `Itemized point lines; total equals Master Points.`
                  })]
                })
              }), (0, V.jsx)(`div`, {
                className: `table-scroll`,
                children: (0, V.jsxs)(`table`, {
                  children: [(0, V.jsx)(`thead`, {
                    children: (0, V.jsxs)(`tr`, {
                      children: [(0, V.jsx)(`th`, {
                        children: `Item`
                      }), (0, V.jsx)(`th`, {
                        children: `Qty`
                      }), (0, V.jsx)(`th`, {
                        children: `Rate`
                      }), (0, V.jsx)(`th`, {
                        children: `Points`
                      })]
                    })
                  }), (0, V.jsx)(`tbody`, {
                    children: e.orderLines.map(e => (0, V.jsxs)(`tr`, {
                      children: [(0, V.jsx)(`td`, {
                        children: e.description
                      }), (0, V.jsx)(`td`, {
                        children: e.quantity
                      }), (0, V.jsx)(`td`, {
                        children: e.pointsPerUnit
                      }), (0, V.jsx)(`td`, {
                        children: e.totalPoints
                      })]
                    }, e.id))
                  })]
                })
              })]
            }) : null, (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsxs)(`h3`, {
                    children: [`VO Details `, (0, V.jsx)(H, {
                      topic: `Voice Talent and VO Tracking`,
                      text: `Set VO IS IN or WAITING ON VO beside Assignment State in Overview. Optional production details are stored here.`
                    })]
                  }), (0, V.jsx)(`p`, {
                    children: `VO status is controlled from Overview.`
                  })]
                }), (0, V.jsx)(ve, {
                  size: 20
                })]
              }), (0, V.jsxs)(`div`, {
                className: `form-grid`,
                children: [(0, V.jsxs)(`div`, {
                  className: `field`,
                  children: [(0, V.jsx)(`label`, {
                    children: `Talent`
                  }), (0, V.jsx)(`input`, {
                    value: Se.talent,
                    onChange: e => Ee(t => ({
                      ...t,
                      talent: e.target.value
                    }))
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `field`,
                  children: [(0, V.jsx)(`label`, {
                    children: `Ordered`
                  }), (0, V.jsx)(`input`, {
                    type: `datetime-local`,
                    value: Se.orderedAt,
                    onChange: e => Ee(t => ({
                      ...t,
                      orderedAt: e.target.value
                    }))
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `field`,
                  children: [(0, V.jsx)(`label`, {
                    children: `Expected`
                  }), (0, V.jsx)(`input`, {
                    type: `datetime-local`,
                    value: Se.expectedAt,
                    onChange: e => Ee(t => ({
                      ...t,
                      expectedAt: e.target.value
                    }))
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `field`,
                  children: [(0, V.jsx)(`label`, {
                    children: `Received`
                  }), (0, V.jsx)(`input`, {
                    type: `datetime-local`,
                    value: Se.receivedAt,
                    onChange: e => Ee(t => ({
                      ...t,
                      receivedAt: e.target.value
                    }))
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `field full`,
                  children: [(0, V.jsx)(`label`, {
                    children: `VO Notes`
                  }), (0, V.jsx)(`input`, {
                    value: Se.notes,
                    onChange: e => Ee(t => ({
                      ...t,
                      notes: e.target.value
                    }))
                  })]
                }), (0, V.jsx)(`div`, {
                  className: `full right-actions`,
                  children: (0, V.jsxs)(`button`, {
                    className: `button primary`,
                    onClick: Ht,
                    children: [(0, V.jsx)(Te, {
                      size: 15
                    }), `Save VO Details`]
                  })
                })]
              })]
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsx)(`div`, {
                className: `section-heading`,
                children: (0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: `Script`
                  }), (0, V.jsx)(`p`, {
                    children: `Rich text colors preserve producer ownership where recognized.`
                  })]
                })
              }), (0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsxs)(`span`, {
                  children: [`Script `, (0, V.jsx)(H, {
                    text: `Black/default and unrecognized text is treated as UNASSIGNED.`
                  })]
                }), (0, V.jsx)(`div`, {
                  ref: At,
                  className: `rich-editor tall`,
                  contentEditable: !0,
                  suppressContentEditableWarning: !0,
                  dangerouslySetInnerHTML: {
                    __html: ye
                  },
                  onInput: e => xe(e.currentTarget.innerHTML)
                })]
              }), (0, V.jsx)(`div`, {
                className: `right-actions`,
                children: (0, V.jsxs)(`button`, {
                  className: `button primary`,
                  onClick: Vt,
                  children: [(0, V.jsx)(Te, {
                    size: 15
                  }), `Save Script`]
                })
              })]
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: `Files & Permanent Versions`
                  }), (0, V.jsx)(`p`, {
                    children: `Uploading a replacement creates a new version; prior bytes remain available.`
                  })]
                }), (0, V.jsx)(R, {
                  size: 20
                })]
              }), (0, V.jsx)(`div`, {
                className: `file-list`,
                children: e.attachments.map(e => (0, V.jsxs)(`div`, {
                  className: `file-group`,
                  children: [(0, V.jsxs)(`div`, {
                    className: `file-group-title`,
                    children: [(0, V.jsx)(`b`, {
                      children: e.displayName
                    }), (0, V.jsxs)(`span`, {
                      children: [`Attachment · v`, e.currentVersion]
                    })]
                  }), e.versions.map(e => (0, V.jsxs)(`a`, {
                    className: `file-version`,
                    href: Ue(`/api/files/${e.id}`),
                    children: [(0, V.jsx)(P, {
                      size: 14
                    }), (0, V.jsxs)(`span`, {
                      children: [`v`, e.version, ` · `, e.filename]
                    }), (0, V.jsxs)(`small`, {
                      children: [at(e.bytes), ` · `, rt(e.uploadedAt), ` · `, e.uploadedByName]
                    })]
                  }, e.id))]
                }, e.id))
              }), (0, V.jsxs)(`div`, {
                className: `upload-row`,
                children: [(0, V.jsx)(`input`, {
                  type: `file`,
                  onChange: e => Fe(e.target.files?.[0] || null)
                }), (0, V.jsxs)(`select`, {
                  value: Ie,
                  onChange: e => Re(e.target.value),
                  children: [(0, V.jsx)(`option`, {
                    value: ``,
                    children: `Add as new attachment`
                  }), e.attachments.map(e => (0, V.jsxs)(`option`, {
                    value: e.id,
                    children: [`New version of: `, e.displayName]
                  }, e.id))]
                }), (0, V.jsxs)(`button`, {
                  className: `button primary`,
                  onClick: Wt,
                  disabled: !Me || l,
                  children: [(0, V.jsx)(Pe, {
                    size: 15
                  }), `Upload`]
                })]
              })]
            })]
          }), d === `activity` && (0, V.jsxs)(V.Fragment, {
            children: [(0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsxs)(`h3`, {
                    children: [`Comments & @Mentions `, (0, V.jsx)(H, {
                      topic: `Important Comments and Acknowledgment`,
                      text: `Important/Pinned Comments require individual acknowledgment from assigned producers only. Comments themselves are immutable.`
                    })]
                  }), (0, V.jsx)(`p`, {
                    children: `Comments cannot be edited or deleted after posting.`
                  })]
                }), (0, V.jsx)(ge, {
                  size: 20
                })]
              }), (0, V.jsx)(`div`, {
                className: `comment-list`,
                children: e.comments.map(t => (0, V.jsxs)(`div`, {
                  className: `comment ${t.important ? `important` : ``}`,
                  children: [(0, V.jsxs)(`div`, {
                    children: [(0, V.jsxs)(`b`, {
                      children: [t.important ? `IMPORTANT · ` : ``, t.authorName]
                    }), (0, V.jsx)(`span`, {
                      children: rt(t.createdAt)
                    })]
                  }), (0, V.jsx)(`p`, {
                    children: t.body
                  }), t.important && (0, V.jsxs)(`div`, {
                    className: `row-actions`,
                    children: [(0, V.jsx)(`small`, {
                      children: (t.acknowledgments || []).filter(e => e.acknowledgedAt).map(e => `✓ ${e.producerName}`).join(` · `) || `No acknowledgments yet`
                    }), e.allocations.some(e => e.producerId === n.producerId) && !(t.acknowledgments || []).some(e => e.producerId === n.producerId && e.acknowledgedAt) && (0, V.jsx)(`button`, {
                      className: `button tertiary`,
                      onClick: async () => {
                        (await B.post(`/api/assignments/${e.id}/comments/${t.id}/acknowledge`), c(`Important comment acknowledged.`), await a(e.id));
                      },
                      children: `Acknowledge`
                    })]
                  })]
                }, t.id))
              }), (0, V.jsxs)(`div`, {
                className: `comment-compose`,
                children: [(0, V.jsxs)(`label`, {
                  className: `check-line`,
                  children: [(0, V.jsx)(`input`, {
                    type: `checkbox`,
                    checked: Ae,
                    onChange: e => je(e.target.checked)
                  }), `Important / Pinned Comment`]
                }), (0, V.jsx)(`textarea`, {
                  rows: 3,
                  value: Oe,
                  onChange: e => ke(e.target.value),
                  placeholder: `Post a correction or use @Name to notify someone…`
                }), (0, V.jsxs)(`button`, {
                  className: `button primary`,
                  onClick: Ut,
                  disabled: !Oe.trim() || l,
                  children: [(0, V.jsx)(De, {
                    size: 15
                  }), `Post Comment`]
                })]
              })]
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: `Revision Work History`
                  }), (0, V.jsx)(`p`, {
                    children: `Revision Points remain separate from Master Points and preserve the producer snapshot recorded at the time.`
                  })]
                }), (0, V.jsx)(we, {
                  size: 20
                })]
              }), e.revisionWork.length ? (0, V.jsx)(`div`, {
                className: `revision-work-list`,
                children: e.revisionWork.map(e => (0, V.jsxs)(`div`, {
                  className: `revision-work-row`,
                  children: [(0, V.jsx)(`span`, {
                    className: `revision-producer-dot`,
                    style: {
                      backgroundColor: e.producerColor
                    },
                    "aria-hidden": `true`
                  }), (0, V.jsxs)(`div`, {
                    children: [(0, V.jsxs)(`b`, {
                      children: [`Revision #`, e.revisionNumber, ` · `, e.producerName]
                    }), (0, V.jsx)(`span`, {
                      children: rt(e.createdAt)
                    }), (0, V.jsx)(`p`, {
                      children: e.reason
                    })]
                  }), (0, V.jsxs)(`strong`, {
                    children: [e.points, ` pts`]
                  })]
                }, e.id))
              }) : (0, V.jsx)(`p`, {
                className: `muted-copy`,
                children: `No Revision Work has been recorded for this assignment.`
              })]
            }), (0, V.jsxs)(`section`, {
              className: `drawer-section`,
              children: [(0, V.jsxs)(`div`, {
                className: `section-heading`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: `Immutable Audit History`
                  }), (0, V.jsx)(`p`, {
                    children: `Corrections add events; history is never rewritten.`
                  })]
                }), (0, V.jsx)(Ce, {
                  size: 20
                })]
              }), (0, V.jsx)(`div`, {
                className: `timeline`,
                children: e.audit.map(e => (0, V.jsxs)(`div`, {
                  className: `timeline-event`,
                  children: [(0, V.jsx)(`i`, {}), (0, V.jsxs)(`div`, {
                    children: [(0, V.jsx)(`b`, {
                      children: e.eventType.replace(/_/g, ` `)
                    }), (0, V.jsxs)(`span`, {
                      children: [e.actorName || `System`, ` · `, rt(e.createdAt)]
                    }), e.reason && (0, V.jsx)(`p`, {
                      children: e.reason
                    }), (0, V.jsxs)(`details`, {
                      children: [(0, V.jsx)(`summary`, {
                        children: `Details`
                      }), (0, V.jsx)(`pre`, {
                        children: JSON.stringify(e.details, null, 2)
                      })]
                    })]
                  })]
                }, e.id))
              })]
            })]
          })]
        }), l && (0, V.jsx)(`div`, {
          className: `drawer-busy`,
          children: (0, V.jsx)(pt, {
            label: `Saving…`
          })
        })]
      })
    }), (0, V.jsxs)(ft, {
      open: p,
      onClose: () => m(!1),
      title: `Rename Assignment / Production Title`,
      subtitle: `Title text only. The assigned client, point accounting, files, and history remain unchanged.`,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => m(!1),
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: Yt,
          disabled: l || !g.trim(),
          children: `Save Title`
        })]
      }),
      children: [(0, V.jsxs)(`label`, {
        className: `field`,
        children: [(0, V.jsx)(`span`, {
          children: `Production Title`
        }), (0, V.jsx)(`input`, {
          value: g,
          maxLength: 300,
          onChange: e => _(e.target.value),
          autoFocus: !0
        })]
      }), v > 0 && (0, V.jsx)(G, {
        children: `A title matching this one already exists. You may continue, but check that this is not accidental.`
      }), (0, V.jsx)(`small`, {
        className: `muted-copy`,
        children: `Renaming never re-runs client inference or changes the Client / Agency or Station / Client assigned to this job.`
      })]
    }), (0, V.jsxs)(ft, {
      open: St,
      onClose: () => Ct(!1),
      title: `Completion Notification`,
      subtitle: `Station Profile defaults may be overridden or suppressed for this one assignment.`,
      wide: !0,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => Ct(!1),
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: qt,
          disabled: l,
          children: `Save Completion Notification`
        })]
      }),
      children: [e.coneOfSilence ? (0, V.jsxs)(`div`, {
        className: `form-stack`,
        children: [(0, V.jsxs)(G, {
          children: [(0, V.jsx)(`b`, {
            children: `CONE OF SILENCE recipient rule:`
          }), ` when enabled, completion notices use only the assignment-specific confidential contacts. Ordinary Station Profile or custom completion recipients are never used.`]
        }), (0, V.jsxs)(`label`, {
          className: `radio-card`,
          children: [(0, V.jsx)(`input`, {
            type: `radio`,
            name: `completion-mode`,
            checked: wt !== `NONE`,
            onChange: () => Tt(e.completionNotifyMode === `CUSTOM` ? `CUSTOM` : `STATION_PROFILE`)
          }), (0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`b`, {
              children: `Send to confidential contacts`
            }), (0, V.jsx)(`small`, {
              children: e.confidentialContacts?.flatMap(e => e.emails).join(`, `) || `No confidential email addresses are configured.`
            })]
          })]
        }), (0, V.jsxs)(`label`, {
          className: `radio-card`,
          children: [(0, V.jsx)(`input`, {
            type: `radio`,
            name: `completion-mode`,
            checked: wt === `NONE`,
            onChange: () => Tt(`NONE`)
          }), (0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`b`, {
              children: `Do not send a completion email for this assignment`
            }), (0, V.jsx)(`small`, {
              children: `Master Delivery and DTS posting still complete normally.`
            })]
          })]
        })]
      }) : (0, V.jsxs)(`div`, {
        className: `form-stack`,
        children: [(0, V.jsxs)(`label`, {
          className: `radio-card`,
          children: [(0, V.jsx)(`input`, {
            type: `radio`,
            name: `completion-mode`,
            checked: wt === `STATION_PROFILE`,
            onChange: () => Tt(`STATION_PROFILE`)
          }), (0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`b`, {
              children: `Use Station Profile recipients`
            }), (0, V.jsx)(`small`, {
              children: e.stationNotifyEmails.length ? e.stationNotifyEmails.join(`, `) : `No recipients are currently stored in the Station Profile.`
            })]
          })]
        }), (0, V.jsxs)(`label`, {
          className: `radio-card`,
          children: [(0, V.jsx)(`input`, {
            type: `radio`,
            name: `completion-mode`,
            checked: wt === `CUSTOM`,
            onChange: () => Tt(`CUSTOM`)
          }), (0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`b`, {
              children: `Use custom recipients for this assignment`
            }), (0, V.jsx)(`small`, {
              children: `This does not change the Station Profile.`
            })]
          })]
        }), wt === `CUSTOM` && (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Custom email addresses`
          }), (0, V.jsx)(`textarea`, {
            rows: 4,
            value: Et,
            placeholder: `programdirector@station.com
traffic@station.com`,
            onChange: e => Dt(e.target.value)
          }), (0, V.jsx)(`small`, {
            children: `Separate addresses with commas, semicolons, or new lines.`
          })]
        }), (0, V.jsxs)(`label`, {
          className: `radio-card`,
          children: [(0, V.jsx)(`input`, {
            type: `radio`,
            name: `completion-mode`,
            checked: wt === `NONE`,
            onChange: () => Tt(`NONE`)
          }), (0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`b`, {
              children: `Do not send a completion email for this assignment`
            }), (0, V.jsx)(`small`, {
              children: `Master Delivery and DTS posting still complete normally.`
            })]
          })]
        })]
      }), (0, V.jsxs)(`div`, {
        className: `completion-report-note`,
        children: [(0, V.jsx)(me, {
          size: 18
        }), (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`b`, {
            children: `Email content`
          }), (0, V.jsx)(`p`, {
            children: Qt
          })]
        })]
      })]
    }), (0, V.jsxs)(ft, {
      open: Ot,
      onClose: () => kt(!1),
      title: e.coneOfSilence ? `Confirm Confidential Delivery` : `Confirm Master Delivery`,
      subtitle: `OAB posts DTS usage first, recalculates the client account, then queues the client email using the new balance.`,
      wide: !0,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => kt(!1),
          children: `Cancel`
        }), (0, V.jsxs)(`button`, {
          className: `button ${e.coneOfSilence ? `danger` : `good`}`,
          onClick: Jt,
          disabled: l,
          children: [(0, V.jsx)(b, {
            size: 15
          }), e.coneOfSilence ? `Record Confidential Delivery` : `Master Deliver & Archive`]
        })]
      }),
      children: [e.coneOfSilence && (0, V.jsx)(G, {
        children: `Confirm that DSV has already completed the manual confidential delivery outside OAB. OAB does not transmit the production files.`
      }), (0, V.jsxs)(`div`, {
        className: `master-delivery-review`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`small`, {
            children: `ASSIGNMENT`
          }), (0, V.jsx)(`b`, {
            children: e.title
          })]
        }), (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`small`, {
            children: `MASTER POINTS`
          }), (0, V.jsx)(`b`, {
            children: e.masterPoints
          })]
        }), (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`small`, {
            children: `CLIENT EMAIL RECIPIENTS`
          }), (0, V.jsx)(`b`, {
            children: e.completionNotifyMode === `NONE` ? `Suppressed for this assignment` : e.effectiveCompletionRecipients.length ? e.effectiveCompletionRecipients.join(`, `) : `No recipients configured`
          })]
        }), (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`small`, {
            children: `EMAIL CONTENT`
          }), (0, V.jsx)(`b`, {
            children: e.completionNotifyMode === `NONE` || !e.effectiveCompletionRecipients.length ? `No client email will be sent` : Qt
          })]
        })]
      }), !e.clientUnlimited && e.revisionNumber === 0 && e.completionNotifyMode !== `NONE` && e.effectiveCompletionRecipients.length > 0 && (0, V.jsxs)(G, {
        children: [`The client email will use the account balance `, (0, V.jsx)(`b`, {
          children: `after`
        }), ` these Master Points are posted. It will show this project’s point usage, monthly usage, rollover activity, remaining points, open in-production points, and current overage.`]
      }), e.clientUnlimited && e.completionNotifyMode !== `NONE` && e.effectiveCompletionRecipients.length > 0 && (0, V.jsx)(G, {
        children: `This is an unlimited account. The client will receive only the project-completion confirmation; no DTS points report, remaining balance, rollover, or overage information will be included.`
      })]
    }), (0, V.jsxs)(ft, {
      open: !!x,
      onClose: () => S(null),
      title: x === `hold` ? `Put Assignment On Hold` : x === `resume` ? `Resume Assignment` : `Cancel Assignment`,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => S(null),
          children: `Back`
        }), (0, V.jsx)(`button`, {
          className: `button ${x === `cancel` ? `danger` : `primary`}`,
          onClick: Rt,
          disabled: !C.trim(),
          children: `Confirm`
        })]
      }),
      children: [(0, V.jsx)(G, {
        children: x === `hold` ? `Overdue escalation and reminders pause, but dates and history remain.` : x === `cancel` ? `Work stops, but the record, files, and history remain indefinitely.` : `Overdue escalation and reminders restart.`
      }), (0, V.jsxs)(`label`, {
        className: `field`,
        children: [(0, V.jsx)(`span`, {
          children: `Reason (required)`
        }), (0, V.jsx)(`textarea`, {
          rows: 4,
          value: C,
          onChange: e => {T(e.target.value);D(old=>({...old,reservePackageId:``}));},
          autoFocus: !0
        })]
      })]
    }), (0, V.jsx)(ft, {
      open: mt,
      onClose: () => W(!1),
      title: `CONE OF SILENCE / Confidential Handling`,
      subtitle: `Assignment-specific reference contacts only. OAB never transmits finished production files.`,
      wide: !0,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => W(!1),
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: Kt,
          disabled: l,
          children: `Save Confidential Handling`
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `confidential-box ${_t ? `active` : ``}`,
        children: [(0, V.jsxs)(`button`, {
          type: `button`,
          className: `cone-of-silence-toggle ${_t ? `critical-flash` : ``}`,
          "aria-pressed": _t,
          onClick: () => vt(e => !e),
          children: [(0, V.jsx)(fe, {
            size: 16
          }), (0, V.jsx)(`b`, {
            children: `CONE OF SILENCE / CONFIDENTIAL`
          })]
        }), (0, V.jsxs)(`p`, {
          className: `confidential-toggle-copy`,
          children: [`When enabled, at least one complete confidential contact is required on every save. `, (0, V.jsx)(H, {
            topic: `CONE OF SILENCE`,
            text: `Delivery is completed manually outside OAB, then CONFIDENTIAL DELIVERY records normal Master Delivery.`
          })]
        }), _t && (0, V.jsxs)(V.Fragment, {
          children: [(0, V.jsxs)(`p`, {
            children: [(0, V.jsx)(`b`, {
              children: `CONE OF SILENCE — Manual Confidential Delivery Required.`
            }), ` Normal delivery process must not be used.`]
          }), bt.map((e, t) => (0, V.jsxs)(`div`, {
            className: `form-grid`,
            children: [(0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Confidential Contact Name`
              }), (0, V.jsx)(`input`, {
                value: e.name,
                onChange: e => xt(n => n.map((n, r) => r === t ? {
                  ...n,
                  name: e.target.value
                } : n))
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Email(s)`
              }), (0, V.jsx)(`input`, {
                value: e.emails,
                placeholder: `name@example.com, backup@example.com`,
                onChange: e => xt(n => n.map((n, r) => r === t ? {
                  ...n,
                  emails: e.target.value
                } : n))
              })]
            })]
          }, t)), (0, V.jsx)(`button`, {
            type: `button`,
            className: `button secondary`,
            onClick: () => xt(e => [...e, {
              name: ``,
              emails: ``
            }]),
            children: `+ Add Another Confidential Contact`
          })]
        })]
      })
    }), (0, V.jsx)(ft, {
      open: ze,
      onClose: () => Be(!1),
      title: `Restore for Revision`,
      subtitle: `Only affected producers reopen; prior delivery history remains in the audit trail.`,
      wide: !0,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => Be(!1),
          children: `Cancel`
        }), (0, V.jsxs)(`button`, {
          className: `button primary`,
          onClick: Gt,
          disabled: l,
          children: [(0, V.jsx)(we, {
            size: 15
          }), `Restore Assignment`]
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [(0, V.jsxs)(`div`, {
          className: `field full`,
          children: [(0, V.jsx)(`label`, {
            children: `Revision reason (required)`
          }), (0, V.jsx)(`textarea`, {
            rows: 3,
            value: Ve,
            onChange: e => He(e.target.value)
          })]
        }), (0, V.jsxs)(`div`, {
          className: `field`,
          children: [(0, V.jsx)(`label`, {
            children: `New Current Due Date (Eastern)`
          }), (0, V.jsx)(`input`, {
            type: `datetime-local`,
            value: We,
            onChange: e => Ge(e.target.value)
          })]
        }), (0, V.jsxs)(`div`, {
          className: `field full`,
          children: [(0, V.jsx)(`label`, {
            children: `Affected Producers & Separate Revision Points`
          }), (0, V.jsx)(`div`, {
            className: `allocation-editor`,
            children: e.allocations.map(e => (0, V.jsxs)(`div`, {
              className: `allocation-edit-row extended`,
              children: [(0, V.jsx)(`input`, {
                type: `checkbox`,
                checked: Ke[e.producerId] || !1,
                onChange: t => Ye(n => ({
                  ...n,
                  [e.producerId]: t.target.checked
                }))
              }), (0, V.jsx)(`span`, {
                children: e.producerName
              }), (0, V.jsx)(U, {
                value: Xe[e.producerId] || 0,
                ariaLabel: `${e.producerName} revision points`,
                onChange: t => Ze(n => ({
                  ...n,
                  [e.producerId]: t
                }))
              }), (0, V.jsx)(`small`, {
                children: `pts`
              })]
            }, e.producerId))
          })]
        })]
      })
    }), (0, V.jsx)(ft, {
      open: Qe,
      onClose: () => tt(!1),
      title: `Duplicate Assignment`,
      subtitle: `Title, points, producers, priority, VO requirement, script, and confidential handling copy. Completion history and one-assignment completion-recipient overrides do not; the duplicate returns to Station Profile recipients.`,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => tt(!1),
          children: `Cancel`
        }), (0, V.jsxs)(`button`, {
          className: `button primary`,
          onClick: Xt,
          disabled: l,
          children: [(0, V.jsx)(M, {
            size: 15
          }), `Create Duplicate`]
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [h.createElement(CreditMonthField,{value:duplicateSessionMonth,onChange:setDuplicateSessionMonth,label:"Session month",help:"Controls session title/history; Date In remains independent."}),h.createElement(CreditMonthField,{value:duplicateCreditMonth,onChange:setDuplicateCreditMonth}),e.coneOfSilence && (0, V.jsx)(`div`, {
          className: `full`,
          children: (0, V.jsxs)(G, {
            children: [(0, V.jsx)(`b`, {
              children: `CONE OF SILENCE will remain enabled.`
            }), ` Confidential contacts will copy to the duplicate, and normal Master Delivery will remain blocked.`]
          })
        }), (0, V.jsxs)(`div`, {
          className: `field full`,
          children: [(0, V.jsx)(`label`, {
            children: `New Production Title`
          }), (0, V.jsx)(`input`, {
            value: ot,
            onChange: e => st(e.target.value)
          })]
        }), (0, V.jsxs)(`div`, {
          className: `field full`,
          children: [(0, V.jsx)(`label`, {
            children: `New Due Date & Time (Eastern)`
          }), (0, V.jsx)(`input`, {
            type: `datetime-local`,
            value: ct,
            onChange: e => lt(e.target.value)
          })]
        }), (0, V.jsxs)(`label`, {
          className: `check-line full`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: ut,
            onChange: e => dt(e.target.checked)
          }), `Copy all attachment versions (off by default)`]
        })]
      })
    })]
  });
}
function xt(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, `\\$&`);
}
function St(e, t, n) {
  let r = e.trim().toUpperCase(), i = (/^(\d{4})-(\d{2})$/).exec(t);
  if (!r || !i) return ``;
  let a = RegExp(`^${xt(r)}-(\\d{3,})(?:-|$)`, `i`), o = n.reduce((e, t) => {
    let n = a.exec(t.title.trim());
    return n ? Math.max(e, Number(n[1])) : e;
  }, 0);
  return `${r}-${String(o + 1).padStart(3, `0`)}-${`${i[2]}${i[1].slice(-2)}`}-`;
}
var Ct = vt.map(([e, t, n]) => [e, t, n, e === `STUDIO_TIME`]);
function wt() {
  return it(new Date().toISOString()).slice(0, 10);
}
function Tt(e) {
  let t = new Date(`${e}T12:00:00Z`);
  return Number.isNaN(t.getTime()) ? `—` : new Intl.DateTimeFormat(`en-US`, {
    month: `short`,
    day: `numeric`,
    timeZone: `UTC`
  }).format(t);
}
function Et(e) {
  let t = new Set(e.map(e => e.date)), n = new Date(`${wt()}T12:00:00Z`);
  do n.setUTCDate(n.getUTCDate() + 1); while (n.getUTCDay() === 0 || n.getUTCDay() === 6 || t.has(n.toISOString().slice(0, 10)));
  return `${n.toISOString().slice(0, 10)}T17:00`;
}
function Dt({open: e, onClose: t, producers: n, clients: r, holidays: i, onCreated: a, notify: o}) {
  const [creditMonth,setCreditMonth]=h.useState(currentCreditMonth),[sessionMonth,setSessionMonth]=h.useState(currentCreditMonth); h.useEffect(()=>{if(e){setCreditMonth(currentCreditMonth());setSessionMonth(currentCreditMonth())}},[e]);
  let s = n.filter(e => e.active), c = r.filter(e => e.active), l = (0, h.useMemo)(() => {
    let e = new Map();
    for (let t of c) {
      let n = t.clientAccountId || t.clientAccountName || t.id;
      e.has(n) || e.set(n, {
        id: n,
        name: t.clientAccountName || t.name
      });
    }
    return [...e.values()].sort((e, t) => e.name.localeCompare(t.name));
  }, [c]), [u, d] = (0, h.useState)(``), [f, p] = (0, h.useState)(``), [m, g] = (0, h.useState)(``), [_, v] = (0, h.useState)(``), [y, b] = (0, h.useState)(wt), [x, S] = (0, h.useState)(() => Et(i)), [C, w] = (0, h.useState)(`SWEEPER`), [T, E] = (0, h.useState)(1), [D, O] = (0, h.useState)({}), [k, ee] = (0, h.useState)(!1), [te, ne] = (0, h.useState)([{
    name: ``,
    emails: ``
  }]), [A, re] = (0, h.useState)(`STATION_PROFILE`), [ie, j] = (0, h.useState)(``), [M, N] = (0, h.useState)(`NOT_STARTED`), [P, F] = (0, h.useState)(!1), [I, L] = (0, h.useState)(`RECEIVED`), [R, ae] = (0, h.useState)(``), [oe, se] = (0, h.useState)(!1), [ce, le] = (0, h.useState)(``), [ue, pe] = (0, h.useState)(null), [he, ge] = (0, h.useState)({}), [_e, ve] = (0, h.useState)([]), [z, ye] = (0, h.useState)(0), [be, Se] = (0, h.useState)(!1), [we, Te] = (0, h.useState)(!1), [Ee, De] = (0, h.useState)(!1), [Oe, ke] = (0, h.useState)(() => wt().slice(0, 7)), [Ae, Me] = (0, h.useState)(null), Ne = (0, h.useRef)(null), Fe = (0, h.useRef)(!1), Ie = (0, h.useRef)(0), Le = c.filter(e => (e.clientAccountId || e.clientAccountName || e.id) === u), Re = c.find(e => e.id === f), [, , ze, Be] = Ct.find(([e]) => e === C) || Ct[0], Ve = Ct.map(([e, t, n, r]) => ({
    menuCode: e,
    description: t,
    rate: n,
    studio: r,
    quantity: Number(D[e] || 0)
  })).filter(e => e.quantity > 0), He = Number(Ve.reduce((e, t) => e + t.quantity * t.rate, 0).toFixed(1)), Ue = Object.values(he).reduce((e, t) => e + (Number(t) || 0), 0), We = Number((He - Ue).toFixed(1)), Ge = x.slice(0, 10), Ke = x.slice(11, 16), Xe = Ye(Re?.notifyWhenCompleted, Re?.primaryEmail), Ze = Re ? Re.unlimited ? `Completion confirmation only — no points report.` : `Completion confirmation plus the updated DTS monthly point-status report.` : `Select a Station / Client to confirm the email content.`, Qe = (0, h.useMemo)(() => s.filter(e => !e.isResource && e.workloadEligible).filter(e => {
    let t = he[e.id] || 0;
    if (!t) return !1;
    let n = e.dailyPoints + t, r = s.filter(t => !t.isResource && t.workloadEligible && t.id !== e.id).map(e => e.dailyPoints + (he[e.id] || 0));
    if (!r.length) return !1;
    let i = r.reduce((e, t) => e + t, 0) / r.length;
    return i === 0 ? n > 0 : n >= i * 1.5;
  }), [s, he]);
  (0, h.useEffect)(() => {
    e || S(Et(i));
  }, [i, e]);
  function tt() {
    (d(``), p(``), g(``), v(``), b(wt()), S(Et(i)), w(`SWEEPER`), E(1), O({}), ee(!1), ne([{
      name: ``,
      emails: ``
    }]), re(`STATION_PROFILE`), j(``), N(`NOT_STARTED`), F(!1), L(`RECEIVED`), ae(``), se(!1), le(``), pe(null), ge({}), ve([]), ye(0), Te(!1), De(!1), ke(wt().slice(0, 7)), Me(null), Fe.current = !1, Ie.current += 1, Ne.current && (Ne.current.innerHTML = ``));
  }
  function it() {
    if (we) {
      Te(!1);
      return;
    }
    be || (tt(), t());
  }
  function at(e) {
    (d(e), p(``), g(``), Te(!1), Me(null), Ie.current += 1, Fe.current || v(``));
  }
  async function ot(e, t, n = !1) {
    if (!e || !t) return;
    let r = ++Ie.current;
    De(!0);
    try {
      let i = new URLSearchParams({
        clientId: e,
        month: t
      }), a = await B.get(`/api/assignments/station-month-history?${i.toString()}`);
      if (r !== Ie.current) return;
      if ((Me(a), n && !Fe.current)) {
        let n = c.find(t => t.id === e);
        (v(St(n?.shortCode || ``, t, a.assignments)), ye(0));
      }
    } catch (e) {
      if (r !== Ie.current) return;
      (Me(null), o(e instanceof Error ? e.message : `Could not load this station's assignment history.`, `error`));
    } finally {
      r === Ie.current && De(!1);
    }
  }
  function st(e) {
    (Ie.current += 1, De(!1), p(e));
    let t = c.find(t => t.id === e);
    if ((g([t?.primaryContact, t?.primaryPhone].filter(Boolean).join(` · `)), re(`STATION_PROFILE`), j(``), e)) {
      let t = sessionMonth;
      (ke(t), Te(!0), ot(e, t, !0));
    } else (Te(!1), Me(null), Fe.current || v(``));
  }
  function ct() {
    f && (Te(!0), ot(f, Oe));
  }
  function lt(e) {
    (ke(e), f && ot(f, e));
  }
  function ut(e) {
    b(e);
  }
  function dt(e) {
    S(`${e}T${Ke || `17:00`}`);
  }
  function W(e) {
    S(`${Ge || wt()}T${e}`);
  }
  function ht() {
    let e = Number(T), t = Be ? .05 : 1, n = Math.abs(e / t - Math.round(e / t)) < 1e-4;
    if (!(e > 0) || !n) {
      o(Be ? `Studio Time quantity must use 0.05-hour increments.` : `Point Menu quantity must be a whole number.`, `error`);
      return;
    }
    (O(t => ({
      ...t,
      [C]: Number(((t[C] || 0) + e).toFixed(2))
    })), E(Be ? .05 : 1));
  }
  async function gt() {
    if (!_.trim()) return ye(0);
    try {
      let e = await B.get(`/api/assignments/duplicate-title?title=${encodeURIComponent(_.trim())}`);
      ye(e.count);
    } catch {
      ye(0);
    }
  }
  async function _t() {
    if (!u || !f) return o(`Choose both the Client / Agency and Station / Client.`, `error`);
    if (!_.trim() || !y || !Ge || !Ke) return o(`Production title, Date In, Date Out, and Due Time are required.`, `error`);
    if (!Ve.length || !et(He)) return o(`Add Point Menu line items whose total is greater than zero and uses half-point increments.`, `error`);
    if (Object.values(he).some(e => !et(e, !0))) return o(`Producer points must use half-point increments.`, `error`);
    if (We < 0) return o(`Producer allocations cannot exceed Master Points.`, `error`);
    if (oe && !R.trim()) return o(`Enter the comment assigned producers must acknowledge.`, `error`);
    if (k) {
      let e = te.filter(e => e.name.trim() || e.emails.trim());
      if (!e.length || e.some(e => !e.name.trim() || !qe(e.emails).length || Je(e.emails).length)) return o(`CONE OF SILENCE requires at least one complete confidential contact with a valid email address.`, `error`);
    }
    let e = Je(ie);
    if (!k && A === `CUSTOM` && e.length) return o(`Invalid completion email address${e.length === 1 ? `` : `es`}: ${e.join(`, `)}`, `error`);
    if (!k && A === `CUSTOM` && !qe(ie).length) return o(`Enter at least one custom completion email address.`, `error`);
    Se(!0);
    let n;
    try {
      n = await B.post(`/api/assignments`, {
        title: _.trim(),
        sessionMonth,
        pointCreditMonth:creditMonth+"-01",
        clientId: f,
        primaryContact: m.trim(),
        dateIn: y,
        dueAt: $e(x),
        masterPoints: He,
        allocations: Object.entries(he).filter(([, e]) => e > 0).map(([e, t]) => ({
          producerId: e,
          points: Number(t)
        })),
        status: M,
        urgent: P,
        voStatus: I,
        scriptHtml: ce,
        initialComment: R,
        requireCommentAcknowledgment: oe,
        orderLines: Ve.map(e => ({
          menuCode: e.menuCode,
          quantity: e.quantity
        })),
        coneOfSilence: k,
        confidentialContacts: k ? te.filter(e => e.name.trim() || e.emails.trim()).map(e => ({
          name: e.name.trim(),
          emails: qe(e.emails)
        })) : [],
        completionNotifyMode: k && A !== `NONE` ? `STATION_PROFILE` : A,
        completionNotifyEmails: !k && A === `CUSTOM` ? qe(ie) : []
      });
    } catch (e) {
      (o(e instanceof Error ? e.message : `Could not create the assignment.`, `error`), Se(!1));
      return;
    }
    let r = [];
    for (let e of [...ue ? [ue] : [], ..._e]) try {
      await B.upload(`/api/assignments/${n.id}/files?kind=ATTACHMENT&displayName=${encodeURIComponent(e.name)}`, e);
    } catch {
      r.push(e.name);
    }
    (tt(), t(), o(r.length ? `Assignment created, but ${r.length} file(s) did not upload. Open Files to add them manually.` : `Assignment created and assigned producers queued for notification.`, r.length ? `error` : `good`));
    try {
      await a(n.id);
    } finally {
      Se(!1);
    }
  }
  return (0, V.jsxs)(V.Fragment, {
    children: [(0, V.jsx)(ft, {
      open: e,
      onClose: it,
      title: `New Assignment + Production Order`,
      subtitle: `One workflow: build the client order from the official DSV Point Menu, then assign the production work.`,
      extraWide: !0,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: it,
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: _t,
          disabled: be,
          children: be ? (0, V.jsxs)(V.Fragment, {
            children: [(0, V.jsx)(de, {
              className: `spin`,
              size: 16
            }), `Creating…`]
          }) : (0, V.jsxs)(V.Fragment, {
            children: [(0, V.jsx)(xe, {
              size: 16
            }), `Create Assignment + Order`]
          })
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `new-assignment-approved`,
        children: [(0, V.jsx)(`div`, {
          className: `new-assignment-title-row`,
          children: (0, V.jsx)(`span`, {
            className: `pill good-pill`,
            children: `ORDER = ASSIGNMENT`
          })
        }), (0, V.jsxs)(`section`, {
          className: `order-flow-banner`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`strong`, {
              children: `1. Build the Production Order`
            }), (0, V.jsx)(`small`, {
              children: `This is the order that stays attached to the assignment. Choose the client and station, enter the assignment details, then build it from the official DSV Point Menu.`
            })]
          }), (0, V.jsx)(`span`, {
            className: `pill`,
            children: `Official DSV Point Menu`
          })]
        }), (0, V.jsxs)(`div`, {
          className: `form-grid new-assignment-identity`,
          children: [h.createElement(CreditMonthField,{value:sessionMonth,onChange:value=>{setSessionMonth(value);ke(value);if(f){Te(true);ot(f,value,true)}},label:"Session month",help:"Controls session title/history; Date In remains independent."}),h.createElement(CreditMonthField,{value:creditMonth,onChange:setCreditMonth}),(0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Client / Agency`
            }), (0, V.jsxs)(`select`, {
              value: u,
              onChange: e => at(e.target.value),
              children: [(0, V.jsx)(`option`, {
                value: ``,
                children: `Choose Client / Agency`
              }), l.map(e => (0, V.jsx)(`option`, {
                value: e.id,
                children: e.name
              }, e.id))]
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Station / Client`
            }), (0, V.jsxs)(`select`, {
              value: f,
              onChange: e => st(e.target.value),
              disabled: !u,
              children: [(0, V.jsx)(`option`, {
                value: ``,
                children: `Choose Station / Client`
              }), Le.map(e => (0, V.jsxs)(`option`, {
                value: e.id,
                children: [e.shortCode, ` / `, e.name]
              }, e.id))]
            }), f && (0, V.jsxs)(`button`, {
              type: `button`,
              className: `station-history-open`,
              onClick: ct,
              children: [(0, V.jsx)(Ce, {
                size: 14
              }), `View this station's monthly assignment history`]
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Primary Contact + Phone`
            }), (0, V.jsx)(`small`, {
              children: `Defaults from the selected Station / Client profile and may be changed for this assignment.`
            }), (0, V.jsx)(`input`, {
              value: m,
              onChange: e => g(e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Production Title / Session Name`
            }), (0, V.jsx)(`small`, {
              children: `Suggested from this station's assignments for the Session Month. The description after the final dash is yours to add or change.`
            }), (0, V.jsx)(`input`, {
              value: _,
              onChange: e => {
                (Fe.current = !0, v(e.target.value));
              },
              onBlur: gt,
              placeholder: `WABC-001-0826-New Stuff`
            }), z > 0 && (0, V.jsx)(G, {
              children: `A title matching this one already exists. You may continue, but check that this is not accidental.`
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Date In`
            }), (0, V.jsx)(`input`, {
              type: `date`,
              value: y,
              onChange: e => ut(e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsxs)(`span`, {
              children: [`Date Out / Current Due Date `, (0, V.jsx)(H, {
                topic: `Original and Current Due Dates`,
                text: `At creation, Original and Current Due are identical. Original is then permanent; later deadline changes update only Current and require a reason.`
              })]
            }), (0, V.jsx)(`input`, {
              type: `date`,
              value: Ge,
              onChange: e => dt(e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Due Time`
            }), (0, V.jsx)(`input`, {
              type: `time`,
              value: Ke,
              onChange: e => W(e.target.value)
            })]
          }), (0, V.jsxs)(`section`, {
            className: `field full confidential-box confidential-setup ${k ? `active` : ``}`,
            children: [(0, V.jsxs)(`button`, {
              type: `button`,
              className: `cone-of-silence-toggle ${k ? `critical-flash` : ``}`,
              "aria-pressed": k,
              onClick: () => ee(e => !e),
              children: [(0, V.jsx)(fe, {
                size: 16
              }), (0, V.jsx)(`b`, {
                children: `CONE OF SILENCE / CONFIDENTIAL`
              })]
            }), (0, V.jsxs)(`p`, {
              className: `confidential-toggle-copy`,
              children: [`Internal handling flag only. When selected, identify the confidential client contact(s) for this specific Assignment / Order. `, (0, V.jsx)(H, {
                topic: `CONE OF SILENCE`,
                text: `Confidential contacts are assignment-specific reference data; complete delivery manually outside OAB, then record CONFIDENTIAL DELIVERY.`
              })]
            }), k && (0, V.jsxs)(`div`, {
              className: `confidential-contact-list-editor`,
              children: [(0, V.jsx)(`b`, {
                children: `Confidential Contact(s) — Assignment Specific`
              }), (0, V.jsx)(`small`, {
                children: `These contacts belong only to this assignment and are not saved to the Station Profile.`
              }), te.map((e, t) => (0, V.jsxs)(`div`, {
                className: `confidential-contact-edit-row`,
                children: [(0, V.jsxs)(`label`, {
                  className: `field`,
                  children: [(0, V.jsx)(`span`, {
                    children: `Contact Name`
                  }), (0, V.jsx)(`input`, {
                    value: e.name,
                    placeholder: `Name`,
                    onChange: e => ne(n => n.map((n, r) => r === t ? {
                      ...n,
                      name: e.target.value
                    } : n))
                  })]
                }), (0, V.jsxs)(`label`, {
                  className: `field`,
                  children: [(0, V.jsx)(`span`, {
                    children: `Email Address(es)`
                  }), (0, V.jsx)(`input`, {
                    value: e.emails,
                    placeholder: `name@client.com, second@client.com`,
                    onChange: e => ne(n => n.map((n, r) => r === t ? {
                      ...n,
                      emails: e.target.value
                    } : n))
                  })]
                }), (0, V.jsxs)(`button`, {
                  type: `button`,
                  className: `button tertiary`,
                  disabled: te.length === 1,
                  onClick: () => ne(e => e.filter((e, n) => n !== t)),
                  children: [(0, V.jsx)(je, {
                    size: 14
                  }), `Remove`]
                })]
              }, t)), (0, V.jsx)(`button`, {
                type: `button`,
                className: `button secondary add-confidential-contact`,
                onClick: () => ne(e => [...e, {
                  name: ``,
                  emails: ``
                }]),
                children: `+ Add Another Confidential Contact`
              })]
            })]
          })]
        }), (0, V.jsxs)(`section`, {
          className: `new-assignment-detail-card order-builder`,
          children: [(0, V.jsxs)(`div`, {
            className: `new-assignment-section-head`,
            children: [(0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`b`, {
                children: `Point Menu Order Builder`
              }), (0, V.jsx)(`p`, {
                children: `Select each production item and quantity. Studio Time uses 0.05-hour increments so every derived total stays on a 0.5-point boundary.`
              })]
            }), (0, V.jsx)(`span`, {
              className: `pill good-pill`,
              children: `FULL POINT MENU`
            })]
          }), (0, V.jsxs)(`div`, {
            className: `form-grid`,
            children: [(0, V.jsxs)(`label`, {
              className: `field full`,
              children: [(0, V.jsx)(`span`, {
                children: `Point Menu Item`
              }), (0, V.jsx)(`select`, {
                value: C,
                onChange: e => {
                  let t = e.target.value;
                  (w(t), E(t === `STUDIO_TIME` ? .05 : 1));
                },
                children: Ct.map(([e, t, n]) => (0, V.jsxs)(`option`, {
                  value: e,
                  children: [t, ` — `, n, ` pt`, n === 1 ? `` : `s`]
                }, e))
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Quantity`
              }), (0, V.jsx)(`input`, {
                type: `number`,
                min: Be ? .05 : 1,
                step: Be ? .05 : 1,
                value: T,
                onChange: e => E(Number(e.target.value))
              })]
            }), (0, V.jsxs)(`div`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Point Rate`
              }), (0, V.jsxs)(`div`, {
                className: `point-rate-display`,
                children: [ze.toFixed(1), ` pts `, Be ? `per hour` : `each`]
              })]
            })]
          }), (0, V.jsx)(`div`, {
            className: `new-assignment-inline-actions`,
            children: (0, V.jsxs)(`button`, {
              type: `button`,
              className: `button primary`,
              onClick: ht,
              children: [(0, V.jsx)(xe, {
                size: 15
              }), `Add Line Item`]
            })
          }), (0, V.jsx)(`div`, {
            className: `table-scroll order-line-table`,
            children: (0, V.jsxs)(`table`, {
              children: [(0, V.jsx)(`thead`, {
                children: (0, V.jsxs)(`tr`, {
                  children: [(0, V.jsx)(`th`, {
                    children: `Production Item`
                  }), (0, V.jsx)(`th`, {
                    children: `Qty`
                  }), (0, V.jsx)(`th`, {
                    children: `Rate`
                  }), (0, V.jsx)(`th`, {
                    children: `Points`
                  }), (0, V.jsx)(`th`, {})]
                })
              }), (0, V.jsx)(`tbody`, {
                children: Ve.length ? Ve.map(e => (0, V.jsxs)(`tr`, {
                  children: [(0, V.jsx)(`td`, {
                    children: (0, V.jsx)(`b`, {
                      children: e.description
                    })
                  }), (0, V.jsx)(`td`, {
                    children: e.quantity
                  }), (0, V.jsxs)(`td`, {
                    children: [e.rate, ` pts `, e.studio ? `/ hour` : `each`]
                  }), (0, V.jsx)(`td`, {
                    children: (0, V.jsx)(`b`, {
                      children: Number((e.quantity * e.rate).toFixed(1))
                    })
                  }), (0, V.jsx)(`td`, {
                    children: (0, V.jsx)(`button`, {
                      type: `button`,
                      className: `button tertiary`,
                      onClick: () => O(t => {
                        let n = {
                          ...t
                        };
                        return (delete n[e.menuCode], n);
                      }),
                      children: `Remove`
                    })
                  })]
                }, e.menuCode)) : (0, V.jsx)(`tr`, {
                  children: (0, V.jsx)(`td`, {
                    colSpan: 5,
                    children: (0, V.jsx)(`small`, {
                      children: `No line items added yet.`
                    })
                  })
                })
              })]
            })
          }), (0, V.jsxs)(`div`, {
            className: `order-total-bar`,
            children: [(0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`small`, {
                children: `PRODUCTION ORDER TOTAL / MASTER POINTS`
              }), (0, V.jsxs)(`strong`, {
                children: [He.toFixed(1), ` points`]
              })]
            }), (0, V.jsx)(`button`, {
              type: `button`,
              className: `button secondary`,
              disabled: !Ve.length,
              onClick: () => O({}),
              children: `Clear Items`
            })]
          })]
        }), (0, V.jsx)(`section`, {
          className: `order-flow-banner secondary-flow`,
          children: (0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`strong`, {
              children: `2. Assign the Production Work`
            }), (0, V.jsx)(`small`, {
              children: `The point-menu total above is now the client-facing Master Points for this assignment. Allocate those points and choose who receives the completion email when Master Delivery occurs.`
            })]
          })
        }), (0, V.jsxs)(`div`, {
          className: `form-grid new-assignment-production`,
          children: [(0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsxs)(`span`, {
              children: [`Master Points (from order) `, (0, V.jsx)(H, {
                topic: `Master Points`,
                text: `Client-facing total calculated from the Point Menu order. It cannot drift from the order lines.`
              })]
            }), (0, V.jsx)(`input`, {
              value: He.toFixed(1),
              readOnly: !0
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Assignment State`
            }), (0, V.jsxs)(`select`, {
              value: M,
              onChange: e => N(e.target.value),
              children: [(0, V.jsx)(`option`, {
                value: `NOT_STARTED`,
                children: `Not Started`
              }), (0, V.jsx)(`option`, {
                value: `IN_PRODUCTION`,
                children: `In Production`
              }), (0, V.jsx)(`option`, {
                value: `WAITING_ON_CLIENT`,
                children: `Waiting on Client`
              }), (0, V.jsx)(`option`, {
                value: `READY_FOR_REVIEW`,
                children: `Ready for Review`
              })]
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsxs)(`span`, {
              children: [`VO Status `, (0, V.jsx)(H, {
                topic: `Voice Talent and VO Tracking`,
                text: `VO is tracked independently as either already received or still needed.`
              })]
            }), (0, V.jsxs)(`select`, {
              value: I,
              onChange: e => L(e.target.value),
              children: [(0, V.jsx)(`option`, {
                value: `RECEIVED`,
                children: `VO IS IN`
              }), (0, V.jsx)(`option`, {
                value: `NEEDED`,
                children: `WAITING ON VO`
              })]
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Priority`
            }), (0, V.jsxs)(`select`, {
              value: P ? `URGENT` : `NORMAL`,
              onChange: e => F(e.target.value === `URGENT`),
              children: [(0, V.jsx)(`option`, {
                value: `NORMAL`,
                children: `Normal`
              }), (0, V.jsx)(`option`, {
                value: `URGENT`,
                children: `Urgent`
              })]
            })]
          }), (0, V.jsxs)(`div`, {
            className: `field full`,
            children: [(0, V.jsxs)(`span`, {
              children: [`Producer Allocations `, (0, V.jsx)(H, {
                topic: `Producer Points and UNASSIGNED`,
                text: `Allocations may be uneven. Any remainder stays visibly UNASSIGNED.`
              })]
            }), (0, V.jsx)(`small`, {
              children: `Producer allocations plus UNASSIGNED must equal Master Points. Workload warnings never block assignment.`
            }), (0, V.jsx)(`div`, {
              className: `allocation-editor`,
              children: s.map(e => (0, V.jsxs)(`div`, {
                className: `allocation-edit-row extended`,
                children: [(0, V.jsx)(`span`, {
                  className: `producer-color`,
                  style: {
                    background: e.color
                  }
                }), (0, V.jsx)(`span`, {
                  children: e.name
                }), (0, V.jsx)(U, {
                  value: he[e.id] || 0,
                  ariaLabel: `${e.name} points`,
                  onChange: t => ge(n => ({
                    ...n,
                    [e.id]: t
                  }))
                }), (0, V.jsx)(`small`, {
                  children: e.isResource ? `Excluded from workload balancing` : e.workloadEligible ? `Eligible workload producer` : `Workload eligibility OFF`
                })]
              }, e.id))
            }), (0, V.jsxs)(`div`, {
              className: `reconcile ${We < 0 ? `bad` : `good`}`,
              children: [(0, V.jsxs)(`span`, {
                children: [`Master `, (0, V.jsx)(`b`, {
                  children: He.toFixed(1)
                })]
              }), (0, V.jsxs)(`span`, {
                children: [`Allocated `, (0, V.jsx)(`b`, {
                  children: Ue.toFixed(1)
                })]
              }), (0, V.jsxs)(`span`, {
                children: [`UNASSIGNED `, (0, V.jsx)(`b`, {
                  children: We.toFixed(1)
                })]
              })]
            }), Qe.length > 0 && (0, V.jsxs)(G, {
              children: [Qe.map(e => e.name).join(`, `), ` will be about 50% above the peer workload average. This is a warning only; OAB will not block assignment.`]
            })]
          }), (0, V.jsxs)(`section`, {
            className: `field full new-assignment-detail-card completion-notification new-assignment-completion`,
            children: [(0, V.jsxs)(`div`, {
              className: `new-assignment-section-head`,
              children: [(0, V.jsxs)(`div`, {
                children: [(0, V.jsxs)(`b`, {
                  children: [`Master Delivery Email Recipients `, (0, V.jsx)(H, {
                    topic: `Client Completion & DTS Point-Status Email`,
                    text: `After successful Master Delivery, OAB emails the selected recipients. Finite accounts receive the updated DTS point status. Unlimited clients receive completion confirmation only, with no point-account report.`
                  })]
                }), (0, V.jsx)(`p`, {
                  children: `Defaults to the selected station's primary contact. You may override it for this assignment without changing the Station Profile.`
                })]
              }), (0, V.jsx)(me, {
                size: 20
              })]
            }), k ? (0, V.jsxs)(`div`, {
              className: `form-stack`,
              children: [(0, V.jsxs)(G, {
                children: [(0, V.jsx)(`b`, {
                  children: `CONE OF SILENCE recipient rule:`
                }), ` completion notices use only the assignment-specific confidential contacts. Station Profile and custom recipients are not used.`]
              }), (0, V.jsxs)(`label`, {
                className: `radio-card`,
                children: [(0, V.jsx)(`input`, {
                  type: `radio`,
                  name: `new-completion-mode`,
                  checked: A !== `NONE`,
                  onChange: () => re(`STATION_PROFILE`)
                }), (0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: `Send to confidential contacts`
                  }), (0, V.jsx)(`small`, {
                    children: te.flatMap(e => qe(e.emails)).join(`, `) || `Enter the confidential contact email address above.`
                  })]
                })]
              }), (0, V.jsxs)(`label`, {
                className: `radio-card`,
                children: [(0, V.jsx)(`input`, {
                  type: `radio`,
                  name: `new-completion-mode`,
                  checked: A === `NONE`,
                  onChange: () => re(`NONE`)
                }), (0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: `Do not send a completion email for this assignment`
                  }), (0, V.jsx)(`small`, {
                    children: `Master Delivery and DTS posting still complete normally.`
                  })]
                })]
              })]
            }) : (0, V.jsxs)(`div`, {
              className: `form-stack`,
              children: [(0, V.jsxs)(`label`, {
                className: `radio-card`,
                children: [(0, V.jsx)(`input`, {
                  type: `radio`,
                  name: `new-completion-mode`,
                  checked: A === `STATION_PROFILE`,
                  onChange: () => re(`STATION_PROFILE`)
                }), (0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: `Use the Station Profile default`
                  }), (0, V.jsx)(`small`, {
                    children: Xe.length ? Xe.join(`, `) : Re ? `The selected station has no primary-contact email yet.` : `Select a Station / Client to load its primary-contact email.`
                  })]
                })]
              }), (0, V.jsxs)(`label`, {
                className: `radio-card`,
                children: [(0, V.jsx)(`input`, {
                  type: `radio`,
                  name: `new-completion-mode`,
                  checked: A === `CUSTOM`,
                  onChange: () => {
                    (re(`CUSTOM`), ie.trim() || j(Xe.join(`
`)));
                  }
                }), (0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: `Manually change recipients for this assignment`
                  }), (0, V.jsx)(`small`, {
                    children: `This assignment-only override does not change the Station Profile.`
                  })]
                })]
              }), A === `CUSTOM` && (0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsx)(`span`, {
                  children: `Custom Email Addresses`
                }), (0, V.jsx)(`textarea`, {
                  rows: 4,
                  value: ie,
                  placeholder: `programdirector@station.com
traffic@station.com`,
                  onChange: e => j(e.target.value)
                }), (0, V.jsx)(`small`, {
                  children: `Separate addresses with commas, semicolons, or new lines.`
                })]
              }), (0, V.jsxs)(`label`, {
                className: `radio-card`,
                children: [(0, V.jsx)(`input`, {
                  type: `radio`,
                  name: `new-completion-mode`,
                  checked: A === `NONE`,
                  onChange: () => re(`NONE`)
                }), (0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: `Do not send a completion email for this assignment`
                  }), (0, V.jsx)(`small`, {
                    children: `Master Delivery and DTS posting still complete normally.`
                  })]
                })]
              })]
            }), (0, V.jsxs)(`div`, {
              className: `completion-report-note`,
              children: [(0, V.jsx)(me, {
                size: 18
              }), (0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`b`, {
                  children: `Email content`
                }), (0, V.jsx)(`p`, {
                  children: Ze
                })]
              })]
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Comments`
            }), (0, V.jsx)(`textarea`, {
              rows: 4,
              value: R,
              onChange: e => ae(e.target.value),
              placeholder: `Add the first permanent assignment comment…`
            })]
          }), (0, V.jsxs)(`label`, {
            className: `check-line full new-assignment-ack`,
            children: [(0, V.jsx)(`input`, {
              type: `checkbox`,
              checked: oe,
              onChange: e => se(e.target.checked)
            }), `This comment must be acknowledged by assigned producers`]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsxs)(`span`, {
              children: [`Copy / Script — Paste Text `, (0, V.jsx)(H, {
                topic: `Scripts and Producer Colors`,
                text: `Paste rich text from Pages. Known producer colors are preserved; black/default/unrecognized text becomes UNASSIGNED.`
              })]
            }), (0, V.jsx)(`div`, {
              ref: Ne,
              className: `rich-editor`,
              contentEditable: !0,
              suppressContentEditableWarning: !0,
              onInput: e => {
                let t = e.currentTarget.innerHTML;
                le(t);
              }
            })]
          }), (0, V.jsxs)(`div`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Copy / Script — Upload File`
            }), (0, V.jsxs)(`label`, {
              className: `drop-control`,
              children: [(0, V.jsx)(Pe, {
                size: 18
              }), (0, V.jsx)(`span`, {
                children: ue ? ue.name : `Choose a copy or script file`
              }), (0, V.jsx)(`input`, {
                type: `file`,
                accept: `.txt,.rtf,.doc,.docx,.pages,.pdf`,
                onChange: e => pe(e.target.files?.[0] || null)
              })]
            })]
          }), (0, V.jsxs)(`div`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Attachments`
            }), (0, V.jsxs)(`label`, {
              className: `drop-control`,
              children: [(0, V.jsx)(Pe, {
                size: 18
              }), (0, V.jsx)(`span`, {
                children: _e.length ? `${_e.length} file(s) selected` : `Choose Pages, audio, PDFs, or other production files`
              }), (0, V.jsx)(`input`, {
                type: `file`,
                multiple: !0,
                onChange: e => ve(Array.from(e.target.files || []))
              })]
            }), (0, V.jsx)(`small`, {
              children: `Replacements create a new permanent version.`
            })]
          })]
        })]
      })
    }), (0, V.jsx)(ft, {
      open: we,
      onClose: () => Te(!1),
      title: Re ? `${Re.shortCode} / ${Re.name} — Assignment History` : `Station Assignment History`,
      subtitle: `Review this station's work for the selected month before creating another assignment.`,
      wide: !0,
      footer: (0, V.jsx)(`button`, {
        type: `button`,
        className: `button primary`,
        onClick: () => Te(!1),
        children: `Continue Creating Assignment`
      }),
      children: (0, V.jsxs)(`div`, {
        className: `station-history-modal`,
        children: [(0, V.jsxs)(`div`, {
          className: `station-history-toolbar`,
          children: [(0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `History Month`
            }), (0, V.jsx)(`input`, {
              type: `month`,
              value: Oe,
              onChange: e => lt(e.target.value)
            })]
          }), (0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`small`, {
              children: `ASSIGNMENTS`
            }), (0, V.jsx)(`b`, {
              children: Ae?.assignmentCount ?? 0
            })]
          }), (0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`small`, {
              children: `MASTER POINTS`
            }), (0, V.jsx)(`b`, {
              children: Ae?.masterPoints ?? 0
            })]
          })]
        }), Ee ? (0, V.jsx)(pt, {
          label: `Loading station history…`
        }) : Ae?.assignments.length ? (0, V.jsx)(`div`, {
          className: `table-scroll`,
          children: (0, V.jsxs)(`table`, {
            className: `station-history-table`,
            children: [(0, V.jsx)(`thead`, {
              children: (0, V.jsxs)(`tr`, {
                children: [(0, V.jsx)(`th`, {
                  children: `Date In`
                }), (0, V.jsx)(`th`, {
                  children: `Assignment / Session`
                }), (0, V.jsx)(`th`, {
                  children: `Due`
                }), (0, V.jsx)(`th`, {
                  children: `Master Points`
                }), (0, V.jsx)(`th`, {
                  children: `Producers`
                }), (0, V.jsx)(`th`, {
                  children: `Status`
                })]
              })
            }), (0, V.jsx)(`tbody`, {
              children: Ae.assignments.map(e => (0, V.jsxs)(`tr`, {
                children: [(0, V.jsx)(`td`, {
                  children: Tt(e.dateIn)
                }), (0, V.jsxs)(`td`, {
                  children: [(0, V.jsx)(`b`, {
                    children: e.title
                  }), e.revisionNumber > 0 && (0, V.jsxs)(`small`, {
                    children: [`Revision `, e.revisionNumber]
                  })]
                }), (0, V.jsx)(`td`, {
                  children: rt(e.currentDueAt)
                }), (0, V.jsx)(`td`, {
                  children: (0, V.jsx)(`b`, {
                    children: e.masterPoints
                  })
                }), (0, V.jsx)(`td`, {
                  children: e.producers
                }), (0, V.jsx)(`td`, {
                  children: (0, V.jsx)(`span`, {
                    className: `pill`,
                    children: nt[e.status]
                  })
                })]
              }, e.id))
            })]
          })
        }) : (0, V.jsx)(mt, {
          title: `No assignments in ${Oe}`,
          body: `This station has no assignments with a Session Month in the selected month.`
        }), (0, V.jsx)(`p`, {
          className: `station-history-note`,
          children: `History uses the assignment's Session Month and includes active, delivered, archived, and cancelled work.`
        })]
      })
    })]
  });
}
function Ot({assignment: e, onOpen: t, onRestore: n, currentProducerId: r, onAcknowledgeComment: i, onAddComment: a, compact = false, dashboard = false}) {
  let [o, s] = (0, h.useState)(null), [c, l] = (0, h.useState)(``), [u, d] = (0, h.useState)(!1), f = r ? e.allocations.find(e => e.producerId === r && e.points > 0) : null, p = f && !f.completedAt ? `Open & Sign Off${f ? ` ${f.points} Points` : ``}` : `Open Assignment`, m = e.voStatus === `RECEIVED` || e.voStatus === `NOT_NEEDED` ? `VO IS IN` : `WAITING ON VO`, g = e.recentComments?.[0];
  async function _() {
    let e = c.trim();
    if (!(!e || !a)) {
      d(!0);
      try {
        (await a(e), l(``));
      } finally {
        d(!1);
      }
    }
  }
  return (0, V.jsx)(`article`, {
    className: `assignment-card approved-assignment-tile compact-assignment-tile ${e.urgent ? `is-urgent` : ``} ${e.overdue ? `is-overdue` : ``} ${e.coneOfSilence ? `is-confidential` : ``}`,
    "aria-label": `${e.title} assignment`,
    children: (0, V.jsxs)(`div`, {
      className: `assignment-card-main`,
      children: [(0, V.jsxs)(`div`, {
        className: `assignment-compact-row`,
        children: [(0, V.jsxs)(`div`, {
          className: `assignment-compact-identity`,
          children: [(0, V.jsx)(`h3`, {
            className: `assignment-title`,
            children: (0, V.jsx)(`button`, {
              type: `button`,
              onClick: t,
              children: e.title
            })
          }), (0, V.jsxs)(`div`, {
            className: `assignment-identity-meta`,
            children: [(0, V.jsxs)(`div`, {
              className: `assignment-topline`,
              children: [(0, V.jsxs)(`span`, {
                className: `assignment-status ${ot(e.status)}`,
                children: [(0, V.jsx)(ne, {
                  size: 11
                }), nt[e.status]]
              }), e.urgent && (0, V.jsxs)(`span`, {
                className: `assignment-priority`,
                children: [(0, V.jsx)(Re, {
                  size: 11
                }), `Urgent`]
              }), e.coneOfSilence && (0, V.jsxs)(`button`, {
                type: `button`,
                className: `assignment-priority confidential critical-flash`,
                onClick: t,
                children: [(0, V.jsx)(fe, {
                  size: 11
                }), `Confidential`]
              }), e.overdue && (0, V.jsxs)(`span`, {
                className: `assignment-priority overdue`,
                children: [(0, V.jsx)(Me, {
                  size: 11
                }), `Overdue`]
              }), e.revisionNumber > 0 && (0, V.jsxs)(`span`, {
                className: `assignment-priority revision`,
                children: [(0, V.jsx)(we, {
                  size: 11
                }), `Rev `, e.revisionNumber]
              }), e.masterDeliveredAt && (0, V.jsxs)(`span`, {
                className: `assignment-status delivered`,
                children: [(0, V.jsx)(I, {
                  size: 11
                }), `Delivered`]
              })]
            }), (0, V.jsxs)(`p`, {
              className: `assignment-contact`,
              children: [(0, V.jsx)(`strong`, {
                children: e.clientAccountName || e.clientName
              }), ` — `, e.clientShortCode, e.primaryContact ? ` · ${e.primaryContact}` : ``]
            })]
          })]
        }), (0, V.jsxs)(`div`, {
          className: `assignment-detail-block compact-due`,
          children: [(0, V.jsx)(`span`, {
            children: e.archivedAt ? `Delivered` : `Due`
          }), (0, V.jsxs)(`b`, {
            className: e.overdue ? `assignment-due late` : `assignment-due`,
            children: [(0, V.jsx)(w, {
              size: 13
            }), rt(e.archivedAt ? e.masterDeliveredAt : e.currentDueAt)]
          })]
        }), (0, V.jsxs)(`div`, {
          className: `assignment-detail-block compact-progress`,
          children: [(0, V.jsxs)(`div`, {
            className: `assignment-point-bubble`,
            "aria-label": `${e.masterPoints} total points`,
            children: [(0, V.jsx)(`strong`, {
              children: e.masterPoints
            }), (0, V.jsx)(`span`, {
              children: `PTS`
            })]
          }), (0, V.jsxs)(`div`, {
            className: `assignment-compact-progress`,
            children: [(0, V.jsxs)(`div`, {
              className: `assignment-progress-copy`,
              children: [(0, V.jsxs)(`span`, {
                children: [e.completedPoints, `/`, e.masterPoints]
              }), (0, V.jsxs)(`b`, {
                children: [e.progressPercent, `%`]
              })]
            }), (0, V.jsx)(`div`, {
              className: `assignment-progress-track`,
              role: `progressbar`,
              "aria-label": `Assignment progress`,
              "aria-valuenow": e.progressPercent,
              "aria-valuemin": 0,
              "aria-valuemax": 100,
              children: (0, V.jsx)(`i`, {
                style: {
                  width: `${e.progressPercent}%`
                }
              })
            })]
          })]
        }), (0, V.jsxs)(`div`, {
          className: `assignment-detail-block compact-producers`,
          children: [(0, V.jsx)(`span`, {
            children: `Producers`
          }), (0, V.jsx)(`div`, {
            className: `assignment-producers`,
            children: e.allocations.map(e => h.createElement(ProducerBadge,{allocation:e,key:e.id}))
          })]
        }), (0, V.jsxs)(`div`, {
          className: `assignment-indicators`,
          "aria-label": `Assignment content and voice-over indicators`,
          children: [(0, V.jsxs)(`button`, {
            className: `assignment-quick-button`,
            type: `button`,
            onClick: t,
            "aria-label": `Open ${e.attachmentCount} attached files`,
            children: [(0, V.jsx)(ye, {
              size: 12
            }), (0, V.jsx)(`span`, {
              children: e.attachmentCount
            })]
          }), e.hasScript && (0, V.jsxs)(`button`, {
            className: `assignment-quick-button`,
            type: `button`,
            onClick: t,
            children: [(0, V.jsx)(ae, {
              size: 12
            }), (0, V.jsx)(`span`, {
              children: `Script`
            })]
          }), e.voStatus && !e.archivedAt && (0, V.jsxs)(`span`, {
            className: `assignment-vo ${m === `VO IS IN` ? `received` : `waiting`}`,
            children: [(0, V.jsx)(ve, {
              size: 12
            }), m === `VO IS IN` && (0, V.jsx)(D, {
              size: 11
            }), ` `, m]
          }), e.unassignedPoints > 0 && (0, V.jsxs)(`span`, {
            className: `assignment-priority unassigned`,
            children: [e.unassignedPoints, ` unassigned`]
          })]
        }), (0, V.jsxs)(`div`, {
          className: `assignment-tile-actions`,
          children: [(0, V.jsxs)(`a`, {
            className: `button secondary tile-pdf-button`,
            href: Ue(`/api/assignments/${e.id}/order.pdf`),
            target: `_blank`,
            rel: `noreferrer`,
            "aria-label": `Open Production Order PDF for ${e.title}`,
            title: `Open Production Order PDF`,
            children: [(0, V.jsx)(L, {
              size: 14
            }), (0, V.jsx)(`span`, {
              children: `PDF`
            })]
          }), (0, V.jsx)(`button`, {
            className: `button primary assignment-open-button`,
            type: `button`,
            onClick: t,
            "aria-label": p,
            children: `Open`
          }), n && (0, V.jsxs)(`button`, {
            className: `button secondary`,
            type: `button`,
            onClick: n,
            children: [(0, V.jsx)(b, {
              size: 14
            }), `Restore`]
          })]
        })]
      }), (!compact && h.createElement(TileComments,{assignment:e,currentProducerId:r,onAcknowledge:i,onAdd:a,compact:dashboard}))]
    })
  });
}
function kt({dashboard: e, sessions: t, role: n, currentProducerId: r, onOpen: i, onAcknowledgeComment: a, onAddComment: o, notify: s}) {
  let c = Math.max(1, ...e.workload.map(e => e.dailyPoints)), l = [{
    label: `Overdue`,
    value: e.metrics.overdue,
    tone: `danger`,
    assignment: e.needsAttention.find(e => e.overdue)
  }, {
    label: `Unassigned Points`,
    value: e.needsAttention.reduce((e, t) => e + t.unassignedPoints, 0),
    tone: `dark`,
    assignment: e.needsAttention.find(e => e.unassignedPoints > 0)
  }, {
    label: `Waiting on VO`,
    value: e.metrics.waitingOnVo,
    tone: `warning`,
    assignment: e.needsAttention.find(e => e.voStatus === `NEEDED` || e.voStatus === `ORDERED`)
  }, {
    label: `Ready to Deliver`,
    value: e.metrics.readyToDeliver,
    tone: `good`,
    assignment: e.needsAttention.find(e => e.status === `READY_TO_DELIVER`)
  }, {
    label: `Important Acks Pending`,
    value: e.needsAttention.reduce((e, t) => e + (t.recentComments || []).filter(e => e.important && e.acknowledgments.some(e => !e.acknowledgedAt)).length, 0),
    tone: `warning`,
    assignment: e.needsAttention.find(e => (e.recentComments || []).some(e => e.important && e.acknowledgments.some(e => !e.acknowledgedAt)))
  }, {
    label: `Revisions Open`,
    value: e.metrics.revisionsOpen,
    tone: `purple`,
    assignment: e.needsAttention.find(e => e.revisionNumber > 0)
  }];
  async function u(e) {
    try {
      s((await B.post(`/api/digests/send`, {
        period: e
      })).queued ? `${e === `week` ? `Weekly summary` : `Today's digest`} queued for Admin delivery.` : `That digest was already queued today.`);
    } catch (e) {
      s(e instanceof Error ? e.message : `Could not queue the digest.`, `error`);
    }
  }
  return (0, V.jsxs)(`div`, {
    className: `view-stack`,
    children: [(0, V.jsxs)(`section`, {
      className: `oab-dashboard-sessions`,
      children: [(0, V.jsx)(`div`, {
        className: `section-title`,
        children: (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Active Sessions`
          }), (0, V.jsx)(`p`, {
            children: `Live production first — full assignment detail is one tap away.`
          })]
        })
      }), (0,V.jsx)(SessionSortBoard, {items:t, renderSession:e=>(0,V.jsx)(Ot,{
 assignment:e,dashboard:true,onOpen:()=>i(e.id),currentProducerId:r,onAcknowledgeComment:t=>a(e.id,t),onAddComment:(t,important,requestId)=>o(e.id,t,important,requestId)
},e.id)})]
    }), (0, V.jsxs)(`section`, {
      children: [(0, V.jsx)(`div`, {
        className: `section-title`,
        children: (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Needs Attention`
          }), (0, V.jsx)(`p`, {
            children: `UNASSIGNED, overdue, VO waits, delivery queue, important items, and revisions.`
          })]
        })
      }), (0, V.jsx)(`div`, {
        className: `attention-grid`,
        children: l.map(e => (0, V.jsxs)(`button`, {
          type: `button`,
          className: `attention-card ${e.tone}`,
          onClick: () => e.assignment && i(e.assignment.id),
          children: [(0, V.jsx)(`span`, {
            children: e.label
          }), (0, V.jsx)(`strong`, {
            children: e.value
          }), (0, V.jsx)(`small`, {
            children: e.assignment ? `Review →` : `Clear`
          })]
        }, e.label))
      })]
    }), (0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Digest`
          }), (0, V.jsx)(`p`, {
            children: `Management snapshot after the live sessions and exceptions.`
          })]
        }), (0, V.jsx)(me, {
          size: 20
        })]
      }), (0, V.jsxs)(`div`, {
        className: `metric-grid six`,
        children: [(0, V.jsx)(W, {
          label: `Open Assignments`,
          value: e.metrics.openAssignments
        }), (0, V.jsx)(W, {
          label: `Open Points`,
          value: e.metrics.openPoints
        }), (0, V.jsx)(W, {
          label: `Overdue`,
          value: e.metrics.overdue,
          tone: e.metrics.overdue ? `danger` : `good`
        }), (0, V.jsx)(W, {
          label: `Waiting on VO`,
          value: e.metrics.waitingOnVo
        }), (0, V.jsx)(W, {
          label: `Ready to Deliver`,
          value: e.metrics.readyToDeliver
        }), (0, V.jsx)(W, {
          label: `Revisions Open`,
          value: e.metrics.revisionsOpen
        })]
      }), (0, V.jsxs)(`div`, {
        className: `producer-assignment-summary`,
        children: [(0, V.jsx)(`b`, {
          children: `Producer Assignment Summary`
        }), (0, V.jsx)(`div`, {
          children: e.workload.map(e => (0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`i`, {
              style: {
                background: e.color
              }
            }), (0, V.jsx)(`strong`, {
              children: e.name
            }), (0, V.jsxs)(`small`, {
              children: [e.dailyPoints, ` open points`]
            })]
          }, e.producerId))
        })]
      }), (0, V.jsx)(`p`, {
        children: e.digest.body
      }), n === `ADMIN` && (0, V.jsxs)(`div`, {
        className: `row-actions`,
        children: [(0, V.jsxs)(`button`, {
          className: `button secondary`,
          onClick: () => u(`today`),
          children: [(0, V.jsx)(De, {
            size: 15
          }), `Send Today's Digest`]
        }), (0, V.jsxs)(`button`, {
          className: `button secondary`,
          onClick: () => u(`week`),
          children: [(0, V.jsx)(De, {
            size: 15
          }), `Email Weekly Summary`]
        })]
      })]
    }), (0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsx)(`div`, {
        className: `panel-heading`,
        children: (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Producer Workload`
          }), (0, V.jsx)(`p`, {
            children: `Advisory only. Workload-ineligible producers and resources are excluded from peer warnings.`
          })]
        })
      }), (0, V.jsx)(`div`, {
        className: `workload-list`,
        children: e.workload.map(e => (0, V.jsxs)(`div`, {
          className: `workload-row`,
          children: [(0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`i`, {
              style: {
                background: e.color
              }
            }), e.name, e.warning && (0, V.jsx)(Me, {
              size: 14
            })]
          }), (0, V.jsx)(`div`, {
            children: (0, V.jsx)(`i`, {
              style: {
                background: e.color,
                width: `${Math.max(3, e.dailyPoints / c * 100)}%`
              }
            })
          }), (0, V.jsxs)(`b`, {
            children: [e.dailyPoints, ` pts`]
          })]
        }, e.producerId))
      })]
    })]
  });
}
function At({assignments: e, archive: t = !1, producers: n, currentProducerId: r, onOpen: i, onRestore: a, onAcknowledgeComment: o, onAddComment: s}) {
  let [c, l] = (0, h.useState)(``), [u, d] = (0, h.useState)(``), [f, p] = (0, h.useState)(``), [m, g] = (0, h.useState)(``), [_, v] = (0, h.useState)(null), [archiveFrom, setArchiveFrom] = (0, h.useState)(``), [archiveTo, setArchiveTo] = (0, h.useState)(``);
  let invalidArchiveRange = t && archiveFrom && archiveTo && archiveFrom > archiveTo;
  (0, h.useEffect)(() => {
    if (invalidArchiveRange) {
      v([]);
      return;
    }
    if (!c.trim() && !u && !f && !m && !(t && (archiveFrom || archiveTo))) {
      v(null);
      return;
    }
    let e = !1, n = window.setTimeout(async () => {
      let n = new URLSearchParams({
        state: t ? `archive` : `active`
      });
      (c.trim() && n.set(`search`, c.trim()), u && n.set(`producerId`, u), f && n.set(`status`, f), m && n.set(`urgent`, m === `urgent` ? `true` : `false`));
      t && archiveFrom && n.set(`archiveFrom`, archiveFrom);
      t && archiveTo && n.set(`archiveTo`, archiveTo);
      try {
        let t = await B.get(`/api/assignments?${n.toString()}`);
        e || v(t.assignments);
      } catch {
        e || v([]);
      }
    }, 250);
    return () => {
      (e = !0, window.clearTimeout(n));
    };
  }, [t, c, u, f, m, archiveFrom, archiveTo]);
  let y = _ || e, b = (0, h.useMemo)(() => y.filter(e => {
    let t = `${e.title} ${e.clientName} ${e.clientShortCode} ${e.allocations.map(e => e.producerName).join(` `)}`.toLowerCase();
    return (!c || t.includes(c.toLowerCase())) && (!u || e.allocations.some(e => e.producerId === u)) && (!f || e.status === f) && (!m || (m === `urgent` ? e.urgent : !e.urgent));
  }), [y, c, u, f, m]), x = t ? [] : b.filter(e => e.overdue), S = t ? b : b.filter(e => !e.overdue);
  return (0, V.jsxs)(`div`, {
    className: `view-stack`,
    children: [(0, V.jsxs)(`div`, {
      className: `board-toolbar`,
      children: [t && (0, V.jsxs)(`label`, {
        children: [`Archived from`, (0, V.jsx)(`input`, {
          type: `date`,
          value: archiveFrom,
          max: archiveTo || void 0,
          onChange: e => {
            v([]);
            setArchiveFrom(e.target.value);
          },
          "aria-label": `Archived from`
        })]
      }), t && (0, V.jsxs)(`label`, {
        children: [`Archived through`, (0, V.jsx)(`input`, {
          type: `date`,
          value: archiveTo,
          min: archiveFrom || void 0,
          onChange: e => {
            v([]);
            setArchiveTo(e.target.value);
          },
          "aria-label": `Archived through`
        })]
      }), t && (archiveFrom || archiveTo) && (0, V.jsx)(`button`, {
        type: `button`,
        className: `button secondary`,
        onClick: () => {
          v(null);
          setArchiveFrom(``);
          setArchiveTo(``);
        },
        children: `Clear dates`
      }), (0, V.jsxs)(`label`, {
        className: `search-control`,
        children: [(0, V.jsx)(Ee, {
          size: 17
        }), (0, V.jsx)(`input`, {
          value: c,
          onChange: e => l(e.target.value),
          placeholder: `Search ${t ? `archive` : `active work`}`
        })]
      }), (0, V.jsxs)(`select`, {
        value: u,
        onChange: e => d(e.target.value),
        children: [(0, V.jsx)(`option`, {
          value: ``,
          children: `All Producers`
        }), n.map(e => (0, V.jsx)(`option`, {
          value: e.id,
          children: e.name
        }, e.id))]
      }), (0, V.jsxs)(`select`, {
        value: f,
        onChange: e => p(e.target.value),
        children: [(0, V.jsx)(`option`, {
          value: ``,
          children: `All Statuses`
        }), tt.filter(e => e !== `WAITING_ON_VO`).map(e => (0, V.jsx)(`option`, {
          value: e,
          children: nt[e]
        }, e))]
      }), (0, V.jsxs)(`select`, {
        value: m,
        onChange: e => g(e.target.value),
        children: [(0, V.jsx)(`option`, {
          value: ``,
          children: `All Priorities`
        }), (0, V.jsx)(`option`, {
          value: `urgent`,
          children: `Urgent`
        }), (0, V.jsx)(`option`, {
          value: `normal`,
          children: `Normal`
        })]
      })]
    }), t && (0, V.jsx)(`p`, {
      role: invalidArchiveRange ? `alert` : void 0,
      children: invalidArchiveRange ? `Start date must be on or before end date.` : `Date range uses archive date (cancellation date for cancelled sessions), Eastern time. Both dates are included. Search returns up to 500 matches; narrow the range if needed.`
    }), !t ? (0,V.jsx)(SessionSortBoard,{items:b,allItems:e,groupOverdue:true,renderSession:e=>(0,V.jsx)(Ot,{
 assignment:e,currentProducerId:r,onOpen:()=>i(e.id),onAcknowledgeComment:t=>o(e.id,t),onAddComment:(t,important,requestId)=>s(e.id,t,important,requestId)
},e.id)}) : (0, V.jsxs)(`section`, {
      children: [(0, V.jsxs)(`div`, {
        className: `section-title`,
        children: [(0, V.jsx)(`h2`, {
          children: t ? `Master Delivered & Cancelled` : `Current & Upcoming`
        }), (0, V.jsx)(`span`, {
          children: S.length
        })]
      }), S.length ? S.map(e => (0, V.jsx)(Ot, {
        assignment: e,
        currentProducerId: r,
        onOpen: () => i(e.id),
        onRestore: t && a ? () => a(e.id) : void 0,
        onAcknowledgeComment: t => o(e.id, t),
        onAddComment: (t,important,requestId) => s(e.id,t,important,requestId)
      }, e.id)) : (0, V.jsx)(mt, {
        title: t ? `No archived matches` : `No active matches`,
        body: `Try clearing a filter or search term.`
      })]
    })]
  });
}
function jt({producers: e, role: t, refresh: n, notify: r}) {
  let [i, a] = (0, h.useState)(null), [o, s] = (0, h.useState)({
    name: ``,
    email: ``,
    phone: ``,
    color: `#1E88E5`,
    role: `PRODUCER`,
    active: !0,
    isResource: !1,
    notifyEmail: !0,
    notifyPush: !0,
    workloadEligible: !0
  }), c = e => {
    (a(e), s(e === `new` ? {
      name: ``,
      email: ``,
      phone: ``,
      color: `#1E88E5`,
      role: `PRODUCER`,
      active: !0,
      isResource: !1,
      notifyEmail: !0,
      notifyPush: !0,
      workloadEligible: !0
    } : {
      name: e.name,
      email: e.email || ``,
      phone: e.phone || ``,
      color: e.color,
      role: e.role,
      active: e.active,
      isResource: e.isResource,
      notifyEmail: e.notifyEmail,
      notifyPush: e.notifyPush,
      workloadEligible: e.workloadEligible
    }));
  };
  async function l() {
    try {
      let e = {
        ...o,
        email: o.email || null,
        phone: o.phone || null
      };
      (i === `new` ? await B.post(`/api/producers`, e) : await B.patch(`/api/producers/${i.id}`, e), a(null), r(`Producer record saved. Historical colors and ownership remain preserved.`), await n());
    } catch (e) {
      r(e instanceof Error ? e.message : `Could not save producer.`, `error`);
    }
  }
  async function u(e) {
    try {
      (await B.post(`/api/producers/${e.id}/invite`), r(`Account setup/reset email queued.`));
    } catch (e) {
      r(e instanceof Error ? e.message : `Could not queue account setup.`, `error`);
    }
  }
  return (0, V.jsxs)(V.Fragment, {
    children: [(0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsxs)(`h2`, {
            children: [`Producers `, (0, V.jsx)(H, {
              topic: `Producer Administration`,
              text: `Administrators can click or tap a Producer tile to edit the existing producer record. Producer-role users cannot save producer administration changes.`
            })]
          }), (0, V.jsx)(`p`, {
            children: `Contact info, display color, notifications, role, active status, and workload eligibility.`
          })]
        }), t === `ADMIN` && (0, V.jsxs)(`button`, {
          className: `button primary`,
          onClick: () => c(`new`),
          children: [(0, V.jsx)(xe, {
            size: 15
          }), `Add Producer`]
        })]
      }), (0, V.jsx)(`div`, {
        className: `producer-grid`,
        children: e.map(e => (0, V.jsxs)(`article`, {
          className: `producer-card ${t === `ADMIN` ? `clickable` : ``} ${e.active ? `` : `inactive`}`,
          onClick: () => t === `ADMIN` && c(e),
          role: t === `ADMIN` ? `button` : void 0,
          tabIndex: t === `ADMIN` ? 0 : void 0,
          onKeyDown: n => {
            t === `ADMIN` && (n.key === `Enter` || n.key === ` `) && c(e);
          },
          children: [(0, V.jsxs)(`div`, {
            className: `producer-card-head`,
            children: [(0, V.jsx)(`span`, {
              className: `producer-avatar`,
              style: {
                background: e.color
              },
              children: e.name.split(/\s+/).map(e => e[0]).join(``).slice(0, 2).toUpperCase()
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`h3`, {
                children: e.name
              }), (0, V.jsx)(`small`, {
                children: e.isResource ? `Logical resource · no login` : `${e.role === `ADMIN` ? `Administrator` : `Producer`} · ${e.active ? `Active` : `Inactive`}`
              })]
            })]
          }), (0, V.jsxs)(`div`, {
            className: `producer-card-meta`,
            children: [(0, V.jsx)(`span`, {
              children: e.email || `No email`
            }), (0, V.jsx)(`span`, {
              children: e.phone || `No mobile`
            }), (0, V.jsxs)(`span`, {
              children: [e.openPoints, ` open pts`]
            })]
          }), (0, V.jsxs)(`div`, {
            className: `producer-card-tags`,
            children: [e.notifyEmail && !e.isResource && (0, V.jsx)(`span`, {
              className: `status-tag delivered`,
              children: `HTML Email On`
            }), e.notifyPush && !e.isResource && (0, V.jsx)(`span`, {
              className: `status-tag delivered`,
              children: `Push On`
            }), (0, V.jsx)(`span`, {
              className: `status-tag ${e.workloadEligible && !e.isResource ? `in-production` : `cancelled`}`,
              children: e.workloadEligible && !e.isResource ? `Workload Eligible` : `Excluded from Workload`
            })]
          }), t === `ADMIN` && (0, V.jsxs)(`div`, {
            className: `producer-card-actions`,
            children: [(0, V.jsx)(`button`, {
              className: `button tertiary`,
              onClick: t => {
                (t.stopPropagation(), c(e));
              },
              children: `Edit`
            }), !e.isResource && (0, V.jsx)(`button`, {
              className: `button tertiary`,
              onClick: t => {
                (t.stopPropagation(), u(e));
              },
              children: e.hasLogin ? `Reset Login` : `Invite`
            })]
          })]
        }, e.id))
      }), (0, V.jsx)(`p`, {
        className: `panel-footnote`,
        children: `OUTSOURCE carries points/color/history but has no login by default. Deactivation is preferred over deletion so history remains intact.`
      })]
    }), (0, V.jsx)(ft, {
      open: !!i,
      onClose: () => a(null),
      title: i === `new` ? `Add Producer` : `Edit Producer`,
      subtitle: `Administrator only. Changes affect the current producer record; historical assignment and revision snapshots do not change.`,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => a(null),
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: l,
          children: `Save Producer`
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [(0, V.jsxs)(`label`, {
          className: `field full`,
          children: [(0, V.jsx)(`span`, {
            children: `Name`
          }), (0, V.jsx)(`input`, {
            value: o.name,
            onChange: e => s(t => ({
              ...t,
              name: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Email`
          }), (0, V.jsx)(`input`, {
            type: `email`,
            value: o.email,
            onChange: e => s(t => ({
              ...t,
              email: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Phone / Mobile`
          }), (0, V.jsx)(`input`, {
            value: o.phone,
            onChange: e => s(t => ({
              ...t,
              phone: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Producer Color`
          }), (0, V.jsx)(`input`, {
            type: `color`,
            value: o.color,
            onChange: e => s(t => ({
              ...t,
              color: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Role`
          }), (0, V.jsxs)(`select`, {
            value: o.role,
            onChange: e => s(t => ({
              ...t,
              role: e.target.value
            })),
            children: [(0, V.jsx)(`option`, {
              value: `PRODUCER`,
              children: `Producer`
            }), (0, V.jsx)(`option`, {
              value: `ADMIN`,
              children: `Admin`
            })]
          })]
        }), (0, V.jsxs)(`label`, {
          className: `check-line`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: o.active,
            onChange: e => s(t => ({
              ...t,
              active: e.target.checked
            }))
          }), `Active`]
        }), (0, V.jsxs)(`label`, {
          className: `check-line`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: o.notifyEmail,
            disabled: o.isResource,
            onChange: e => s(t => ({
              ...t,
              notifyEmail: e.target.checked
            }))
          }), `HTML email notifications`]
        }), (0, V.jsxs)(`label`, {
          className: `check-line`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: o.notifyPush,
            disabled: o.isResource,
            onChange: e => s(t => ({
              ...t,
              notifyPush: e.target.checked
            }))
          }), `Push notifications`]
        }), (0, V.jsxs)(`label`, {
          className: `check-line`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: o.workloadEligible,
            disabled: o.isResource,
            onChange: e => s(t => ({
              ...t,
              workloadEligible: e.target.checked
            }))
          }), `Workload eligible`]
        }), i === `new` && (0, V.jsxs)(`label`, {
          className: `check-line`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: o.isResource,
            onChange: e => s(t => ({
              ...t,
              isResource: e.target.checked
            }))
          }), `Logical resource (no login)`]
        })]
      })
    })]
  });
}
var Mt = [{
  value: `producer-productivity`,
  label: `Producer Productivity`
}, {
  value: `client-station`,
  label: `Client / Station`
}, {
  value: `revisions`,
  label: `Revision Work`
}, {
  value: `late-assignments`,
  label: `Late Assignments`
}, {
  value: `delivery-time`,
  label: `Delivery Turnaround`
}];
function LegacyNt({notify: e}) {
  let t = it(new Date().toISOString()).slice(0, 10), n = new Date(`${t}T12:00:00Z`);
  n.setUTCDate(n.getUTCDate() - 30);
  let r = n.toISOString().slice(0, 10), [i, a] = (0, h.useState)(`producer-productivity`), [o, s] = (0, h.useState)(r), [c, l] = (0, h.useState)(t), [u, d] = (0, h.useState)(null), [f, p] = (0, h.useState)(!1), [m, g] = (0, h.useState)([]), [_, v] = (0, h.useState)(``);
  (0, h.useEffect)(() => {
    (async () => {
      try {
        let e = await B.get(`/api/reports/client-accounts`);
        (g(e.accounts), e.accounts[0] && v(t => t || e.accounts[0].id));
      } catch {}
    })();
  }, []);
  async function y() {
    if (i !== `client-production`) {
      p(!0);
      try {
        d(await B.get(`/api/reports?type=${i}&from=${o}&to=${c}&format=json`));
      } catch (t) {
        e(t instanceof Error ? t.message : `Report failed.`, `error`);
      } finally {
        p(!1);
      }
    }
  }
  (0, h.useEffect)(() => {
    y();
  }, []);
  let b = _ ? Ue(`/api/reports/client-production.pdf?accountId=${encodeURIComponent(_)}&from=${o}&to=${c}`) : `#`;
  return (0, V.jsxs)(`div`, {
    className: `view-stack`,
    children: [(0, V.jsxs)(`div`, {
      className: `report-toolbar`,
      children: [(0, V.jsxs)(`select`, {
        value: i,
        onChange: e => {
          (a(e.target.value), d(null));
        },
        children: [(0, V.jsx)(`option`, {
          value: `client-production`,
          children: `Client Production Activity PDF`
        }), Mt.map(e => (0, V.jsx)(`option`, {
          value: e.value,
          children: e.label
        }, e.value))]
      }), (0, V.jsxs)(`label`, {
        children: [`From `, (0, V.jsx)(`input`, {
          type: `date`,
          value: o,
          onChange: e => s(e.target.value)
        })]
      }), (0, V.jsxs)(`label`, {
        children: [`To `, (0, V.jsx)(`input`, {
          type: `date`,
          value: c,
          onChange: e => l(e.target.value)
        })]
      }), i === `client-production` ? (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsxs)(`select`, {
          value: _,
          onChange: e => v(e.target.value),
          "aria-label": `Client / Agency`,
          children: [(0, V.jsx)(`option`, {
            value: ``,
            children: `Choose Client / Agency`
          }), m.map(e => (0, V.jsxs)(`option`, {
            value: e.id,
            children: [e.name, e.unlimited ? ` · UNLIMITED` : ``]
          }, e.id))]
        }), (0, V.jsxs)(`a`, {
          className: `button primary ${_ ? `` : `disabled-link`}`,
          "aria-disabled": !_,
          href: b,
          children: [(0, V.jsx)(P, {
            size: 15
          }), `Generate Client PDF`]
        })]
      }) : (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsxs)(`button`, {
          className: `button primary`,
          onClick: y,
          disabled: f,
          children: [f ? (0, V.jsx)(de, {
            className: `spin`,
            size: 15
          }) : (0, V.jsx)(Se, {
            size: 15
          }), `Run Report`]
        }), (0, V.jsxs)(`a`, {
          className: `button secondary`,
          href: Ue(`/api/reports?type=${i}&from=${o}&to=${c}&format=csv`),
          children: [(0, V.jsx)(P, {
            size: 15
          }), `CSV`]
        }), (0, V.jsxs)(`a`, {
          className: `button secondary`,
          href: Ue(`/api/reports?type=${i}&from=${o}&to=${c}&format=pdf`),
          children: [(0, V.jsx)(P, {
            size: 15
          }), `PDF`]
        })]
      })]
    }), i === `client-production` ? (0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsxs)(`h2`, {
            children: [`Client Production Activity `, (0, V.jsx)(H, {
              topic: `Client Production Activity PDF`,
              text: `Creates a client-facing PDF for the selected Client / Agency and date range. Each assignment is counted once by initial Master Delivery and only client-facing Master Points are totaled.`
            })]
          }), (0, V.jsx)(`p`, {
            children: `Delivered sessions and Master Points for a client-requested date range.`
          })]
        }), (0, V.jsx)(F, {
          size: 20
        })]
      }), (0, V.jsx)(G, {
        children: `Revision Points and Producer Points are excluded from this client-facing total. A restored revision does not create a second session or second Master Point charge. Historical delivery dates marked uncertain are visibly identified instead of presented as exact.`
      }), (0, V.jsx)(`p`, {
        className: `panel-footnote`,
        children: `Choose the parent Client / Agency above. Multi-station accounts are aggregated under the parent while each session identifies its Station / Client.`
      })]
    }) : f ? (0, V.jsx)(pt, {
      label: `Running report…`
    }) : u?.rows?.length ? (0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsx)(`div`, {
        className: `panel-heading`,
        children: (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: Mt.find(e => e.value === i)?.label
          }), (0, V.jsxs)(`p`, {
            children: [u.rows.length, ` row(s); Master, producer, and Revision Points remain distinct.`]
          })]
        })
      }), (0, V.jsx)(`div`, {
        className: `table-scroll`,
        children: (0, V.jsxs)(`table`, {
          children: [(0, V.jsx)(`thead`, {
            children: (0, V.jsx)(`tr`, {
              children: Object.keys(u.rows[0]).map(e => (0, V.jsx)(`th`, {
                children: e.replace(/_/g, ` `)
              }, e))
            })
          }), (0, V.jsx)(`tbody`, {
            children: u.rows.map((e, t) => (0, V.jsx)(`tr`, {
              children: Object.keys(u.rows[0]).map(t => (0, V.jsx)(`td`, {
                children: e[t] == null ? `—` : typeof e[t] == `boolean` ? e[t] ? `Yes` : `No` : String(e[t])
              }, t))
            }, t))
          })]
        })
      })]
    }) : (0, V.jsx)(mt, {
      title: `No report results`,
      body: `Try a wider date range.`
    })]
  });
}
function Nt(props){return h.createElement(h.Fragment,null,h.createElement(LegacyNt,props),h.createElement(Productivity));}

function Pt({settings: e, vapidPublicKey: t, role: n, notify: r, refresh: i}) {
  let [a, o] = (0, h.useState)(e.notification_digest || ({
    morning: `08:00`,
    endOfDay: `17:30`,
    weekly: `FRIDAY 16:00`
  })), [s, c] = (0, h.useState)({
    current: ``,
    next: ``,
    confirm: ``
  }), [l, u] = (0, h.useState)(!1);
  async function d() {
    try {
      (await B.patch(`/api/settings/notification_digest`, {
        value: a
      }), r(`Digest settings saved.`), await i());
    } catch (e) {
      r(e instanceof Error ? e.message : `Could not save settings.`, `error`);
    }
  }
  async function f() {
    try {
      if (!t) throw Error(`Push keys are not configured yet.`);
      let e = await navigator.serviceWorker.ready;
      if (await Notification.requestPermission() !== `granted`) throw Error(`Notification permission was not granted.`);
      let n = `=`.repeat((4 - t.length % 4) % 4), i = atob((t + n).replace(/-/g, `+`).replace(/_/g, `/`)), a = Uint8Array.from([...i].map(e => e.charCodeAt(0))), o = await e.pushManager.subscribe({
        userVisibleOnly: !0,
        applicationServerKey: a
      });
      (await B.post(`/api/push/subscribe`, o.toJSON()), r(`Push notifications enabled on this device.`));
    } catch (e) {
      r(e instanceof Error ? e.message : `Could not enable push.`, `error`);
    }
  }
  async function p() {
    if (s.next !== s.confirm) return r(`New passwords do not match.`, `error`);
    u(!0);
    try {
      (await B.post(`/api/auth/password`, {
        currentPassword: s.current,
        newPassword: s.next
      }), c({
        current: ``,
        next: ``,
        confirm: ``
      }), r(`Password changed. Other signed-in devices were logged out.`));
    } catch (e) {
      r(e instanceof Error ? e.message : `Could not change password.`, `error`);
    } finally {
      u(!1);
    }
  }
  return (0, V.jsxs)(`div`, {
    className: `dashboard-grid`,
    children: [(0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Notification & Digest Settings`
          }), (0, V.jsx)(`p`, {
            children: `Email is the fallback. Rapid edits are consolidated.`
          })]
        }), (0, V.jsx)(x, {
          size: 20
        })]
      }), (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [(0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Morning Snapshot`
          }), (0, V.jsx)(`input`, {
            type: `time`,
            value: a.morning || ``,
            disabled: n !== `ADMIN`,
            onChange: e => o(t => ({
              ...t,
              morning: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `End-of-Day Digest`
          }), (0, V.jsx)(`input`, {
            type: `time`,
            value: a.endOfDay || ``,
            disabled: n !== `ADMIN`,
            onChange: e => o(t => ({
              ...t,
              endOfDay: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field full`,
          children: [(0, V.jsx)(`span`, {
            children: `Weekly Digest`
          }), (0, V.jsx)(`input`, {
            value: a.weekly || ``,
            disabled: n !== `ADMIN`,
            onChange: e => o(t => ({
              ...t,
              weekly: e.target.value
            }))
          })]
        })]
      }), n === `ADMIN` ? (0, V.jsxs)(`button`, {
        className: `button primary`,
        onClick: d,
        children: [(0, V.jsx)(Oe, {
          size: 15
        }), `Save Settings`]
      }) : (0, V.jsx)(`p`, {
        className: `panel-footnote`,
        children: `Digest schedules are managed by an OAB administrator.`
      })]
    }), (0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `PWA & Push`
          }), (0, V.jsx)(`p`, {
            children: `Install the same OAB on iPhone, iPad, Mac, or Windows.`
          })]
        }), (0, V.jsx)(Ae, {
          size: 20
        })]
      }), (0, V.jsxs)(`ol`, {
        className: `instruction-list`,
        children: [(0, V.jsx)(`li`, {
          children: `Open OAB over HTTPS.`
        }), (0, V.jsx)(`li`, {
          children: `On iPhone/iPad, use Share → Add to Home Screen.`
        }), (0, V.jsx)(`li`, {
          children: `Open the installed OAB and enable push below.`
        })]
      }), (0, V.jsxs)(`button`, {
        className: `button primary`,
        onClick: f,
        disabled: !t,
        children: [(0, V.jsx)(x, {
          size: 15
        }), `Enable Push on This Device`]
      }), !t && (0, V.jsx)(`p`, {
        className: `panel-footnote`,
        children: `Jeff can generate VAPID keys with the included setup script.`
      })]
    }), (0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Password`
          }), (0, V.jsx)(`p`, {
            children: `Change your password without email or IT assistance.`
          })]
        }), (0, V.jsx)(ke, {
          size: 20
        })]
      }), (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [(0, V.jsxs)(`label`, {
          className: `field full`,
          children: [(0, V.jsx)(`span`, {
            children: `Current Password`
          }), (0, V.jsx)(`input`, {
            type: `password`,
            autoComplete: `current-password`,
            value: s.current,
            onChange: e => c(t => ({
              ...t,
              current: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `New Password (12+ characters)`
          }), (0, V.jsx)(`input`, {
            type: `password`,
            autoComplete: `new-password`,
            minLength: 12,
            value: s.next,
            onChange: e => c(t => ({
              ...t,
              next: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Confirm New Password`
          }), (0, V.jsx)(`input`, {
            type: `password`,
            autoComplete: `new-password`,
            minLength: 12,
            value: s.confirm,
            onChange: e => c(t => ({
              ...t,
              confirm: e.target.value
            }))
          })]
        })]
      }), (0, V.jsxs)(`button`, {
        className: `button primary`,
        onClick: p,
        disabled: l || !s.current || s.next.length < 12 || !s.confirm,
        children: [(0, V.jsx)(ke, {
          size: 15
        }), l ? `Changing…` : `Change Password`]
      })]
    })]
  });
}
function LegacyFt({settings: e, notify: t}) {
  let [n, r] = (0, h.useState)(null), [i, a] = (0, h.useState)([]), [o, s] = (0, h.useState)([]), [c, l] = (0, h.useState)(!1), [u, d] = (0, h.useState)({
    date: ``,
    name: ``
  }), f = e.feature_flags || ({});
  async function p() {
    l(!0);
    try {
      let [e, t, n] = await Promise.all([B.get(`/api/system/health`), B.get(`/api/system/backups`), B.get(`/api/holidays`)]);
      (r(e), a(t.backups), s(n.holidays));
    } catch (e) {
      t(e instanceof Error ? e.message : `Could not load system health.`, `error`);
    } finally {
      l(!1);
    }
  }
  (0, h.useEffect)(() => {
    p();
  }, []);
  async function m() {
    l(!0);
    try {
      (await B.post(`/api/system/backups`), t(`Full-system backup created.`), await p());
    } catch (e) {
      (t(e instanceof Error ? e.message : `Backup failed.`, `error`), await p());
    } finally {
      l(!1);
    }
  }
  async function g() {
    try {
      (await B.post(`/api/holidays`, u), d({
        date: ``,
        name: ``
      }), t(`Holiday/closure saved.`), await p());
    } catch (e) {
      t(e instanceof Error ? e.message : `Could not save holiday.`, `error`);
    }
  }
  async function _(e) {
    try {
      (await B.delete(`/api/holidays/${e}`), await p());
    } catch (e) {
      t(e instanceof Error ? e.message : `Could not remove holiday.`, `error`);
    }
  }
  return c && !n ? (0, V.jsx)(pt, {
    label: `Checking OAB services…`
  }) : (0, V.jsxs)(`div`, {
    className: `view-stack`,
    children: [(0, V.jsxs)(`div`, {
      className: `metric-grid four`,
      children: [(0, V.jsx)(W, {
        label: `Database`,
        value: n?.database?.ok ? `Healthy` : `Problem`,
        note: n?.database?.latencyMs == null ? n?.database?.message : `${n.database.latencyMs} ms`,
        tone: n?.database?.ok ? `good` : `danger`
      }), (0, V.jsx)(W, {
        label: `File Storage`,
        value: n?.storage?.missingFiles ? `${n.storage.missingFiles} missing` : `Healthy`,
        note: `${at(n?.storage?.freeBytes)} free`,
        tone: n?.storage?.missingFiles ? `danger` : `good`
      }), (0, V.jsx)(W, {
        label: `Scheduler`,
        value: n?.scheduler?.ok ? `Running` : `Check worker`,
        note: n?.scheduler?.heartbeat ? rt(n.scheduler.heartbeat) : `No heartbeat`,
        tone: n?.scheduler?.ok ? `good` : `danger`
      }), (0, V.jsx)(W, {
        label: `Last Backup`,
        value: n?.lastBackup?.status || `None`,
        note: rt(n?.lastBackup?.completedAt),
        tone: n?.lastBackup?.status === `SUCCEEDED` ? `good` : `warning`
      })]
    }), n?.email?.totalFailed > 0 && (0, V.jsxs)(G, {
      children: [(0, V.jsx)(`b`, {
        children: `Email delivery needs attention:`
      }), ` `, n.email.totalFailed, ` failed message`, n.email.totalFailed === 1 ? `` : `s`, ` across the producer and client queues. Review the worker log before re-queuing individual failures.`]
    }), (0, V.jsxs)(`div`, {
      className: `dashboard-grid`,
      children: [(0, V.jsxs)(`section`, {
        className: `panel`,
        children: [(0, V.jsxs)(`div`, {
          className: `panel-heading`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`h2`, {
              children: `Emergency Export & Backups`
            }), (0, V.jsx)(`p`, {
              children: `PostgreSQL dump, every file version, manifest, and CSV fallbacks.`
            })]
          }), (0, V.jsx)(F, {
            size: 20
          })]
        }), (0, V.jsxs)(`div`, {
          className: `row-actions`,
          children: [(0, V.jsxs)(`button`, {
            className: `button primary`,
            onClick: m,
            disabled: c,
            children: [(0, V.jsx)(j, {
              size: 15
            }), `Generate Full-System ZIP`]
          }), (0, V.jsxs)(`button`, {
            className: `button secondary`,
            onClick: p,
            children: [(0, V.jsx)(Se, {
              size: 15
            }), `Refresh Health`]
          })]
        }), (0, V.jsx)(`div`, {
          className: `backup-list`,
          children: i.map(e => (0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`span`, {
              children: [(0, V.jsx)(`b`, {
                children: e.filename
              }), (0, V.jsxs)(`small`, {
                children: [e.status, ` · `, at(e.bytes), ` · `, rt(e.completedAt || e.startedAt)]
              }), e.status === `FAILED` && e.error && (0, V.jsxs)(`small`, {
                className: `backup-error`,
                children: [`Reason: `, e.error]
              })]
            }), e.status === `SUCCEEDED` && (0, V.jsxs)(`a`, {
              className: `button tertiary`,
              href: Ue(`/api/system/backups/${e.id}`),
              children: [(0, V.jsx)(P, {
                size: 14
              }), `Download`]
            })]
          }, e.id))
        })]
      }), (0, V.jsxs)(`section`, {
        className: `panel`,
        children: [(0, V.jsxs)(`div`, {
          className: `panel-heading`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`h2`, {
              children: `Business Days & Holidays`
            }), (0, V.jsx)(`p`, {
              children: `Saturday, Sunday, and these closures are non-working days.`
            })]
          }), (0, V.jsx)(T, {
            size: 20
          })]
        }), (0, V.jsxs)(`div`, {
          className: `holiday-add`,
          children: [(0, V.jsx)(`input`, {
            type: `date`,
            value: u.date,
            onChange: e => d(t => ({
              ...t,
              date: e.target.value
            }))
          }), (0, V.jsx)(`input`, {
            placeholder: `Holiday / closure name`,
            value: u.name,
            onChange: e => d(t => ({
              ...t,
              name: e.target.value
            }))
          }), (0, V.jsxs)(`button`, {
            className: `button primary`,
            onClick: g,
            children: [(0, V.jsx)(xe, {
              size: 15
            }), `Add`]
          })]
        }), (0, V.jsx)(`div`, {
          className: `holiday-list`,
          children: o.map(e => (0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`span`, {
              children: [(0, V.jsx)(`b`, {
                children: e.name
              }), (0, V.jsx)(`small`, {
                children: e.date
              })]
            }), (0, V.jsx)(`button`, {
              className: `icon-button`,
              onClick: () => _(e.id),
              children: (0, V.jsx)(je, {
                size: 15
              })
            })]
          }, e.id))
        })]
      })]
    }), (0, V.jsxs)(`section`, {
      className: `panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Version 1.3.9.1 Scope & Feature Flags`
          }), (0, V.jsx)(`p`, {
            children: `Future capabilities remain off until intentionally introduced in code.`
          })]
        }), (0, V.jsx)(ke, {
          size: 20
        })]
      }), (0, V.jsx)(G, {
        children: `Digital Traffic System is integrated and Administrator-only. Client Portal, SMS/Twilio, and OCR remain deferred unless explicitly enabled in a later release.`
      }), (0, V.jsx)(`div`, {
        className: `feature-flags`,
        children: Object.entries(f).map(([e, t]) => (0, V.jsxs)(`label`, {
          children: [(0, V.jsx)(`span`, {
            children: e.replace(/([A-Z])/g, ` $1`).replace(/^./, e => e.toUpperCase())
          }), (0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: !!t,
            readOnly: !0,
            disabled: !0
          })]
        }, e))
      })]
    }), (0, V.jsxs)(`section`, {
      className: `panel service-grid`,
      children: [(0, V.jsxs)(`div`, {
        children: [(0, V.jsx)(N, {}), (0, V.jsx)(`b`, {
          children: `PostgreSQL`
        }), (0, V.jsx)(`span`, {
          children: n?.database?.ok ? `Connected` : `Unavailable`
        })]
      }), (0, V.jsxs)(`div`, {
        children: [(0, V.jsx)(ce, {}), (0, V.jsx)(`b`, {
          children: `NAS Files`
        }), (0, V.jsxs)(`span`, {
          children: [n?.storage?.missingFiles || 0, ` missing`]
        })]
      }), (0, V.jsxs)(`div`, {
        children: [(0, V.jsx)(me, {}), (0, V.jsx)(`b`, {
          children: `Email`
        }), (0, V.jsx)(`span`, {
          children: n?.email?.configured ? `Producer: ${n?.email?.producer?.pending || 0} pending / ${n?.email?.producer?.failed || 0} failed · Client: ${n?.email?.clientCompletion?.pending || 0} pending / ${n?.email?.clientCompletion?.failed || 0} failed` : `Not configured`
        })]
      }), (0, V.jsxs)(`div`, {
        children: [(0, V.jsx)(x, {}), (0, V.jsx)(`b`, {
          children: `Push`
        }), (0, V.jsx)(`span`, {
          children: n?.push?.configured ? `Configured` : `Not configured`
        })]
      }), (0, V.jsxs)(`div`, {
        children: [(0, V.jsx)(Ie, {}), (0, V.jsx)(`b`, {
          children: `Operational Time`
        }), (0, V.jsx)(`span`, {
          children: `America/New_York`
        })]
      }), (0, V.jsxs)(`div`, {
        children: [(0, V.jsx)(le, {}), (0, V.jsx)(`b`, {
          children: `Application`
        }), (0, V.jsxs)(`span`, {
          children: [`Version `, n?.version || `1.3.9.1`]
        })]
      })]
    })]
  });
}
function Ft(props){return h.createElement(h.Fragment,null,h.createElement(LegacyFt,props),h.createElement(EmailSettings));}

var It = {
  station_call_letters: ``,
  station_name: ``,
  positioning_statement: ``,
  primary_contact: ``,
  primary_email: ``,
  primary_phone: ``,
  secondary_contact: ``,
  secondary_email: ``,
  secondary_phone: ``,
  default_delivery: ``,
  notify_when_completed: ``,
  voice_talents: ``,
  voice_contact: ``,
  format_description: ``,
  target_audience: ``,
  sound_avoid: ``,
  sound_use: ``,
  tv_film_drops: null,
  tv_film_notes: ``,
  voice_read_preferences: ``,
  other_sound_notes: ``
}, Lt = {
  name: ``,
  shortCode: ``,
  clientAccountId: ``,
  clientAccountName: ``,
  unlimited: !1,
  notes: ``,
  active: !0
};
function Rt(e) {
  return e.name.toLowerCase().includes(e.shortCode.toLowerCase()) ? e.name : `${e.shortCode} · ${e.name}`;
}
function zt({clients: e, role: t, refresh: n, notify: r}) {
  let [i, a] = (0, h.useState)(`client`), [o, s] = (0, h.useState)({}), [c, l] = (0, h.useState)(null), [u, d] = (0, h.useState)(Lt), [f, p] = (0, h.useState)(!1), [m, g] = (0, h.useState)(``), [_, v] = (0, h.useState)(null), [y, b] = (0, h.useState)(!1), [x, S] = (0, h.useState)(``), [C, w] = (0, h.useState)(null), [T, E] = (0, h.useState)({
    ...It
  }), [D, O] = (0, h.useState)(!1), k = (0, h.useMemo)(() => new Intl.Collator(void 0, {
    sensitivity: `base`,
    numeric: !0
  }), []), ee = (0, h.useMemo)(() => Array.from(new Map(e.map(e => [e.clientAccountId || e.id, {
    id: e.clientAccountId || e.id,
    name: e.clientAccountName || e.name,
    unlimited: !!e.unlimited
  }])).values()).sort((e, t) => k.compare(e.name, t.name)), [e, k]), te = (0, h.useMemo)(() => {
    let t = new Map();
    for (let n of e) {
      let e = n.clientAccountId || n.id, r = t.get(e) || ({
        id: e,
        name: n.clientAccountName || n.name,
        unlimited: !!n.unlimited,
        clients: []
      });
      (r.clients.push(n), t.set(e, r));
    }
    return [...t.values()].map(e => ({
      ...e,
      clients: e.clients.sort((e, t) => k.compare(e.shortCode, t.shortCode) || k.compare(e.name, t.name))
    })).sort((e, t) => k.compare(e.name, t.name));
  }, [e, k]), ne = (0, h.useMemo)(() => [...e].sort((e, t) => k.compare(Rt(e), Rt(t))), [e, k]);
  function A(e) {
    (l(e), g(``), d(e === `new` ? {
      ...Lt
    } : {
      name: e.name,
      shortCode: e.shortCode,
      clientAccountId: e.clientAccountId || ``,
      clientAccountName: e.clientAccountName || e.name,
      unlimited: !!e.unlimited,
      notes: e.notes,
      active: e.active
    }));
  }
  async function re() {
    let e = u.name.trim(), t = u.clientAccountName.trim();
    if (!e || c === `new` && !u.clientAccountId && !t) {
      g(!t && !u.clientAccountId ? `Enter the Client / Agency Name.` : `Enter the Station / Client Name.`);
      return;
    }
    (p(!0), g(``));
    try {
      let i = {
        name: e,
        shortCode: c === `new` ? void 0 : u.shortCode.trim(),
        clientAccountId: u.clientAccountId || null,
        monthlyAllowance: null,
        notes: u.notes,
        active: u.active,
        needsReview: !1,
        ...c === `new` ? {
          clientAccountName: t || null,
          unlimited: u.unlimited
        } : {}
      };
      (c === `new` ? await B.post(`/api/clients`, i) : await B.patch(`/api/clients/${c.id}`, i), l(null), r(`Client / Station record saved.`), await n());
    } catch (e) {
      let t = e instanceof Error ? e.message : `Could not save client.`;
      (g(t), r(t, `error`));
    } finally {
      p(!1);
    }
  }
  async function ie() {
    if (!_) return;
    let e = _.name.trim();
    if (!e) {
      S(`Enter the Client / Agency Name.`);
      return;
    }
    (b(!0), S(``));
    try {
      (await B.patch(`/api/client-accounts/${_.id}`, {
        name: e,
        unlimited: _.unlimited
      }), v(null), r(`Client / Agency information saved.`), await n());
    } catch (e) {
      let t = e instanceof Error ? e.message : `Could not save Client / Agency information.`;
      (S(t), r(t, `error`));
    } finally {
      b(!1);
    }
  }
  async function j(e) {
    (w(e), O(!0));
    try {
      let t = (await B.get(`/api/clients/${e.id}/profile`)).profile || ({});
      E({
        ...It,
        ...t,
        notify_when_completed: Array.isArray(t.notify_when_completed) ? t.notify_when_completed.join(`
`) : String(t.notify_when_completed || ``)
      });
    } catch (e) {
      r(e instanceof Error ? e.message : `Could not load profile.`, `error`);
    } finally {
      O(!1);
    }
  }
  async function M() {
    if (C) {
      O(!0);
      try {
        (await B.patch(`/api/clients/${C.id}/profile`, T), r(`Station / Client profile saved.`), w(null), await n());
      } catch (e) {
        r(e instanceof Error ? e.message : `Could not save profile.`, `error`);
      } finally {
        O(!1);
      }
    }
  }
  let N = e => String(T[e] || ``), P = (e, t) => E(n => ({
    ...n,
    [e]: t
  })), F = (e, t = !1) => e.primaryContact || e.primaryEmail || e.primaryPhone ? t ? `Edit Profile` : `Edit Station Profile` : t ? `Add Profile` : `Add Station Profile`, I = e => e.notifyWhenCompleted?.length ? e.notifyWhenCompleted.join(`, `) : e.primaryEmail ? `${e.primaryEmail} (primary contact default)` : `Not entered`;
  return (0, V.jsxs)(V.Fragment, {
    children: [(0, V.jsxs)(`div`, {
      className: `clients-approved-view`,
      children: [(0, V.jsxs)(`div`, {
        className: `clients-approved-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `Clients`
          }), (0, V.jsx)(`p`, {
            children: `Each Client / Agency appears once. Its Station / Client bubbles and the selected station profile appear underneath.`
          })]
        }), (0, V.jsxs)(`button`, {
          className: `button primary`,
          onClick: () => A(`new`),
          children: [(0, V.jsx)(xe, {
            size: 15
          }), `Add Client`]
        })]
      }), (0, V.jsxs)(`div`, {
        className: `client-sort-bar`,
        children: [(0, V.jsx)(`span`, {
          children: (0, V.jsx)(`b`, {
            children: `Sort by`
          })
        }), (0, V.jsxs)(`select`, {
          value: i,
          "aria-label": `Sort clients`,
          onChange: e => a(e.target.value),
          children: [(0, V.jsx)(`option`, {
            value: `client`,
            children: `Client / Agency`
          }), (0, V.jsx)(`option`, {
            value: `station`,
            children: `Station`
          })]
        })]
      }), i === `client` ? (0, V.jsx)(`div`, {
        className: `client-account-list`,
        children: te.map(e => {
          let n = e.clients.find(t => t.id === o[e.id]) || e.clients[0];
          return (0, V.jsxs)(`article`, {
            className: `client-account-tile`,
            children: [(0, V.jsxs)(`div`, {
              className: `client-account-head`,
              children: [(0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`h3`, {
                  children: e.name
                }), (0, V.jsxs)(`p`, {
                  children: [`Client / Agency`, e.unlimited ? ` · Unlimited account` : ``]
                })]
              }), (0, V.jsxs)(`div`, {
                className: `client-account-actions`,
                children: [(0, V.jsxs)(`span`, {
                  className: `client-count-pill`,
                  children: [e.clients.length, ` station`, e.clients.length === 1 ? `` : `s`, ` / client`, e.clients.length === 1 ? `` : `s`]
                }), t === `ADMIN` && (0, V.jsx)(`button`, {
                  className: `button secondary`,
                  type: `button`,
                  onClick: () => {
                    (S(``), v({
                      id: e.id,
                      name: e.name,
                      unlimited: e.unlimited
                    }));
                  },
                  children: `Edit Client / Agency`
                })]
              })]
            }), (0, V.jsxs)(`div`, {
              className: `station-bubble-area`,
              children: [(0, V.jsx)(`span`, {
                className: `station-bubble-label`,
                children: `Stations / Clients`
              }), (0, V.jsx)(`div`, {
                className: `station-bubbles`,
                children: e.clients.map(t => (0, V.jsx)(`button`, {
                  className: `station-bubble ${t.id === n.id ? `active` : ``}`,
                  type: `button`,
                  onClick: () => s(n => ({
                    ...n,
                    [e.id]: t.id
                  })),
                  children: t.stationName ? (t.stationCallLetters || t.shortCode) && !t.stationName.toLowerCase().includes((t.stationCallLetters || t.shortCode).toLowerCase()) ? `${t.stationCallLetters || t.shortCode} · ${t.stationName}` : t.stationName : t.stationCallLetters || t.shortCode || t.name
                }, t.id))
              })]
            }), (0, V.jsxs)(`div`, {
              className: `client-profile-area`,
              "data-station-id": n.id,
              children: [(0, V.jsxs)(`div`, {
                className: `client-profile-head`,
                children: [(0, V.jsxs)(`div`, {
                  children: [(0, V.jsx)(`h3`, {
                    children: Rt(n)
                  }), (0, V.jsx)(`p`, {
                    children: `Station / Client Profile`
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `row-actions`,
                  children: [t === `ADMIN` && (0, V.jsx)(`button`, {
                    className: `button secondary`,
                    onClick: () => A(n),
                    children: `Edit Station`
                  }), (0, V.jsx)(`button`, {
                    className: `button primary`,
                    onClick: () => void j(n),
                    children: F(n)
                  })]
                })]
              }), (0, V.jsxs)(`div`, {
                className: `client-profile-grid`,
                children: [(0, V.jsxs)(`div`, {
                  className: `client-profile-field`,
                  children: [(0, V.jsx)(`small`, {
                    children: `Primary contact`
                  }), (0, V.jsx)(`strong`, {
                    children: n.primaryContact || `Not entered`
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `client-profile-field`,
                  children: [(0, V.jsx)(`small`, {
                    children: `Phone`
                  }), n.primaryPhone ? (0, V.jsx)(`a`, {
                    href: `tel:${n.primaryPhone}`,
                    children: n.primaryPhone
                  }) : (0, V.jsx)(`strong`, {
                    children: `Not entered`
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `client-profile-field`,
                  children: [(0, V.jsx)(`small`, {
                    children: `Email`
                  }), n.primaryEmail ? (0, V.jsx)(`a`, {
                    href: `mailto:${n.primaryEmail}`,
                    children: n.primaryEmail
                  }) : (0, V.jsx)(`strong`, {
                    children: `Not entered`
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `client-profile-field`,
                  children: [(0, V.jsx)(`small`, {
                    children: `Default delivery`
                  }), (0, V.jsx)(`strong`, {
                    children: n.defaultDelivery || `Not entered`
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `client-profile-field`,
                  children: [(0, V.jsx)(`small`, {
                    children: `Completion notice`
                  }), (0, V.jsx)(`strong`, {
                    children: I(n)
                  })]
                }), (0, V.jsxs)(`div`, {
                  className: `client-profile-field`,
                  children: [(0, V.jsx)(`small`, {
                    children: `Profile status`
                  }), (0, V.jsx)(`strong`, {
                    children: n.active ? n.primaryContact || n.primaryEmail || n.primaryPhone ? `Active` : `Needs profile` : `Inactive`
                  })]
                })]
              })]
            })]
          }, e.id);
        })
      }) : (0, V.jsx)(`div`, {
        className: `station-sort-grid`,
        children: ne.map(e => (0, V.jsxs)(`article`, {
          className: `station-profile-card`,
          children: [(0, V.jsxs)(`div`, {
            className: `client-profile-head`,
            children: [(0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`h3`, {
                children: Rt(e)
              }), (0, V.jsx)(`p`, {
                children: e.clientAccountName || e.name
              })]
            }), (0, V.jsx)(`span`, {
              className: `pill ${e.active ? `good-pill` : `muted-pill`}`,
              children: e.active ? `Active` : `Inactive`
            })]
          }), (0, V.jsxs)(`dl`, {
            children: [(0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`dt`, {
                children: `Primary contact`
              }), (0, V.jsxs)(`dd`, {
                children: [e.primaryContact || `Not entered`, e.primaryPhone ? (0, V.jsxs)(V.Fragment, {
                  children: [` · `, (0, V.jsx)(`a`, {
                    href: `tel:${e.primaryPhone}`,
                    children: e.primaryPhone
                  })]
                }) : null]
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`dt`, {
                children: `Email`
              }), (0, V.jsx)(`dd`, {
                children: e.primaryEmail ? (0, V.jsx)(`a`, {
                  href: `mailto:${e.primaryEmail}`,
                  children: e.primaryEmail
                }) : `Not entered`
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`dt`, {
                children: `Default delivery`
              }), (0, V.jsx)(`dd`, {
                children: e.defaultDelivery || `Not entered`
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`dt`, {
                children: `Completion notice`
              }), (0, V.jsx)(`dd`, {
                children: I(e)
              })]
            })]
          }), (0, V.jsxs)(`div`, {
            className: `row-actions`,
            children: [t === `ADMIN` && (0, V.jsx)(`button`, {
              className: `button secondary`,
              onClick: () => A(e),
              children: `Edit Station`
            }), (0, V.jsx)(`button`, {
              className: `button primary`,
              onClick: () => void j(e),
              children: F(e, !0)
            })]
          })]
        }, e.id))
      })]
    }), (0, V.jsx)(ft, {
      open: !!_,
      onClose: () => v(null),
      title: `Edit Client / Agency`,
      subtitle: `Update the parent client everywhere it currently appears. Historical assignment snapshots remain unchanged.`,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => v(null),
          disabled: y,
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: () => void ie(),
          disabled: y,
          children: y ? `Saving…` : `Save Client / Agency`
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [(0, V.jsxs)(`label`, {
          className: `field full`,
          children: [(0, V.jsx)(`span`, {
            children: `Client / Agency Name`
          }), (0, V.jsx)(`input`, {
            autoFocus: !0,
            value: _?.name || ``,
            onChange: e => v(t => t && ({
              ...t,
              name: e.target.value
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `check-line full`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: !!_?.unlimited,
            onChange: e => v(t => t && ({
              ...t,
              unlimited: e.target.checked
            }))
          }), `UNLIMITED point treatment`]
        }), (0, V.jsxs)(`div`, {
          className: `full edit-scope-note`,
          children: [(0, V.jsx)(`b`, {
            children: `Station information stays separate.`
          }), ` Use Edit Station for its name, call letters, status, and notes. Use Edit Station Profile for contacts, delivery details, and format information.`]
        }), x && (0, V.jsx)(`div`, {
          className: `full`,
          role: `alert`,
          children: (0, V.jsx)(G, {
            children: x
          })
        })]
      })
    }), (0, V.jsx)(ft, {
      open: !!c,
      onClose: () => l(null),
      title: c === `new` ? `Add Client / Station` : `Edit Client / Station`,
      subtitle: c === `new` ? `Create the parent Client / Agency and its first Station / Client record.` : `Update this Station / Client record.`,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => l(null),
          disabled: f,
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: () => void re(),
          disabled: f,
          children: f ? `Saving…` : `Save Client`
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [c === `new` ? (0, V.jsxs)(V.Fragment, {
          children: [(0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsxs)(`span`, {
              children: [`Parent Client / Agency `, (0, V.jsx)(H, {
                text: `Points and package configuration belong to the parent Client / Agency. Choose an existing parent or enter a new parent name.`
              })]
            }), (0, V.jsxs)(`select`, {
              value: u.clientAccountId,
              onChange: e => {
                let t = e.target.value, n = ee.find(e => e.id === t);
                d(e => ({
                  ...e,
                  clientAccountId: t,
                  clientAccountName: n?.name || e.clientAccountName,
                  unlimited: n?.unlimited ?? e.unlimited
                }));
              },
              children: [(0, V.jsx)(`option`, {
                value: ``,
                children: `Create / use parent name below`
              }), ee.map(e => (0, V.jsx)(`option`, {
                value: e.id,
                children: e.name
              }, e.id))]
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Client / Agency Name`
            }), (0, V.jsx)(`input`, {
              value: u.clientAccountName,
              disabled: !!u.clientAccountId,
              onChange: e => d(t => ({
                ...t,
                clientAccountName: e.target.value
              }))
            })]
          })]
        }) : (0, V.jsxs)(`div`, {
          className: `full edit-scope-note`,
          children: [(0, V.jsx)(`b`, {
            children: `Parent Client / Agency:`
          }), ` `, u.clientAccountName, (0, V.jsx)(`br`, {}), `To rename the parent client, close this window and use its Edit Client / Agency button.`]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Station / Client Name`
          }), (0, V.jsx)(`input`, {
            value: u.name,
            onChange: e => d(t => ({
              ...t,
              name: e.target.value
            }))
          })]
        }), c !== `new` && (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Call Letters / Short Code`
          }), (0, V.jsx)(`input`, {
            value: u.shortCode,
            maxLength: 30,
            onChange: e => d(t => ({
              ...t,
              shortCode: e.target.value.toUpperCase()
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `check-line`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: u.unlimited,
            disabled: !!u.clientAccountId && c === `new`,
            onChange: e => d(t => ({
              ...t,
              unlimited: e.target.checked
            }))
          }), `UNLIMITED point treatment`]
        }), (0, V.jsxs)(`label`, {
          className: `check-line`,
          children: [(0, V.jsx)(`input`, {
            type: `checkbox`,
            checked: u.active,
            onChange: e => d(t => ({
              ...t,
              active: e.target.checked
            }))
          }), `Active`]
        }), (0, V.jsxs)(`label`, {
          className: `field full`,
          children: [(0, V.jsx)(`span`, {
            children: `Notes`
          }), (0, V.jsx)(`textarea`, {
            rows: 4,
            value: u.notes,
            onChange: e => d(t => ({
              ...t,
              notes: e.target.value
            }))
          })]
        }), c === `new` && (0, V.jsx)(`div`, {
          className: `full`,
          children: (0, V.jsx)(`small`, {
            children: `Call letters / short code will be generated from the Station / Client name and can be changed later.`
          })
        }), m && (0, V.jsx)(`div`, {
          className: `full`,
          role: `alert`,
          children: (0, V.jsx)(G, {
            children: m
          })
        })]
      })
    }), (0, V.jsx)(ft, {
      open: !!C,
      onClose: () => w(null),
      title: `Profile — ${C ? Rt(C) : ``}`,
      subtitle: `Living Station / Client profile. Current edits do not rewrite historical assignment snapshots.`,
      wide: !0,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => w(null),
          children: `Close`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: () => void M(),
          disabled: D,
          children: `Save Profile`
        })]
      }),
      children: (0, V.jsx)(`div`, {
        className: `form-grid`,
        children: D ? (0, V.jsx)(pt, {
          label: `Loading profile…`
        }) : (0, V.jsxs)(V.Fragment, {
          children: [(0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Station Call Letters`
            }), (0, V.jsx)(`input`, {
              value: N(`station_call_letters`),
              onChange: e => P(`station_call_letters`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Station Name`
            }), (0, V.jsx)(`input`, {
              value: N(`station_name`),
              onChange: e => P(`station_name`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Positioning Statement`
            }), (0, V.jsx)(`input`, {
              value: N(`positioning_statement`),
              onChange: e => P(`positioning_statement`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Primary Contact`
            }), (0, V.jsx)(`input`, {
              value: N(`primary_contact`),
              onChange: e => P(`primary_contact`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Primary Contact Phone`
            }), (0, V.jsx)(`input`, {
              value: N(`primary_phone`),
              onChange: e => P(`primary_phone`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Primary Contact Email`
            }), (0, V.jsx)(`input`, {
              type: `email`,
              value: N(`primary_email`),
              onChange: e => P(`primary_email`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Default Delivery`
            }), (0, V.jsx)(`input`, {
              value: N(`default_delivery`),
              placeholder: `Client FTP, email link, etc.`,
              onChange: e => P(`default_delivery`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Notify When Completed`
            }), (0, V.jsx)(`textarea`, {
              rows: 3,
              value: T.notify_when_completed,
              placeholder: `programdirector@station.com
traffic@station.com`,
              onChange: e => P(`notify_when_completed`, e.target.value)
            }), (0, V.jsx)(`small`, {
              children: `Enter multiple addresses separated by commas, semicolons, or new lines.`
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Secondary Contact`
            }), (0, V.jsx)(`input`, {
              value: N(`secondary_contact`),
              onChange: e => P(`secondary_contact`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Secondary Phone`
            }), (0, V.jsx)(`input`, {
              value: N(`secondary_phone`),
              onChange: e => P(`secondary_phone`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Secondary Email`
            }), (0, V.jsx)(`input`, {
              type: `email`,
              value: N(`secondary_email`),
              onChange: e => P(`secondary_email`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Format Description`
            }), (0, V.jsx)(`input`, {
              value: N(`format_description`),
              onChange: e => P(`format_description`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `Target Audience`
            }), (0, V.jsx)(`input`, {
              value: N(`target_audience`),
              onChange: e => P(`target_audience`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Sound Elements to AVOID`
            }), (0, V.jsx)(`textarea`, {
              value: N(`sound_avoid`),
              onChange: e => P(`sound_avoid`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Sound Elements to USE`
            }), (0, V.jsx)(`textarea`, {
              value: N(`sound_use`),
              onChange: e => P(`sound_use`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `TV / Film Drops?`
            }), (0, V.jsxs)(`select`, {
              value: T.tv_film_drops === !0 ? `yes` : T.tv_film_drops === !1 ? `no` : ``,
              onChange: e => E(t => ({
                ...t,
                tv_film_drops: e.target.value === `yes` || e.target.value !== `no` && null
              })),
              children: [(0, V.jsx)(`option`, {
                value: ``,
                children: `Not specified`
              }), (0, V.jsx)(`option`, {
                value: `yes`,
                children: `Yes`
              }), (0, V.jsx)(`option`, {
                value: `no`,
                children: `No`
              })]
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field`,
            children: [(0, V.jsx)(`span`, {
              children: `TV / Film Notes`
            }), (0, V.jsx)(`input`, {
              value: N(`tv_film_notes`),
              onChange: e => P(`tv_film_notes`, e.target.value)
            })]
          }), (0, V.jsxs)(`label`, {
            className: `field full`,
            children: [(0, V.jsx)(`span`, {
              children: `Other Production Sound Information`
            }), (0, V.jsx)(`textarea`, {
              value: N(`other_sound_notes`),
              onChange: e => P(`other_sound_notes`, e.target.value)
            })]
          })]
        })
      })
    })]
  });
}
function Bt(e) {
  let t = new Date(`${e}-01T00:00:00Z`);
  return (t.setUTCMonth(t.getUTCMonth() + 1), t.toISOString().slice(0, 7));
}
function Vt(e) {
  return new Intl.DateTimeFormat(`en-US`, {
    timeZone: `UTC`,
    month: `long`,
    year: `numeric`
  }).format(new Date(`${e}-01T12:00:00Z`));
}
function Ht(e) {
  return e == null ? `UNLIMITED` : String(e);
}
function Ut(e) {
  return e ? new Intl.DateTimeFormat(`en-US`, {
    timeZone: `UTC`,
    month: `short`,
    day: `numeric`,
    year: `numeric`
  }).format(new Date(`${String(e).slice(0, 10)}T12:00:00Z`)) : `—`;
}
function Wt(e, t) {
  let n = new Map();
  for (let r of t.filter(t => t.clientAccountId === e.id && t.active)) n.set(r.id, {
    id: r.id,
    station: r.shortCode,
    name: r.name,
    used: 0,
    pending: 0
  });
  for (let t of e.stationUsage || []) {
    let e = t.stationId || t.station, r = n.get(e) || ({
      id: e,
      station: t.station,
      name: t.name,
      used: 0,
      pending: 0
    });
    (r.used += Number(t.used || 0), n.set(e, r));
  }
  for (let t of e.productionJobs || []) {
    let e = t.stationId || t.station, r = n.get(e) || ({
      id: e,
      station: t.station,
      name: t.name,
      used: 0,
      pending: 0
    });
    (r.pending += Number(t.points || 0), n.set(e, r));
  }
  return [...n.values()].sort((e, t) => e.station.localeCompare(t.station, void 0, {
    numeric: !0
  }));
}
function Gt({decisions: e, emptyText: t}) {
  return e.length ? (0, V.jsx)(`div`, {
    className: `table-scroll`,
    children: (0, V.jsxs)(`table`, {
      className: `recon-decision-table`,
      children: [(0, V.jsx)(`thead`, {
        children: (0, V.jsxs)(`tr`, {
          children: [(0, V.jsx)(`th`, {
            children: `Date`
          }), (0, V.jsx)(`th`, {
            children: `Client / Agency`
          }), (0, V.jsx)(`th`, {
            children: `Action`
          }), (0, V.jsx)(`th`, {
            children: `Points`
          }), (0, V.jsx)(`th`, {
            children: `Effect`
          }), (0, V.jsx)(`th`, {
            children: `Reason`
          }), (0, V.jsx)(`th`, {
            children: `By`
          })]
        })
      }), (0, V.jsx)(`tbody`, {
        children: e.map(e => (0, V.jsxs)(`tr`, {
          children: [(0, V.jsx)(`td`, {
            children: rt(e.performedAt)
          }), (0, V.jsxs)(`td`, {
            children: [(0, V.jsx)(`b`, {
              children: e.accountName
            }), e.postArchive && (0, V.jsx)(`small`, {
              className: `pill`,
              children: `POST-ARCHIVE`
            })]
          }), (0, V.jsx)(`td`, {
            children: (0, V.jsx)(`span`, {
              className: `pill`,
              children: e.actionLabel
            })
          }), (0, V.jsx)(`td`, {
            children: e.points
          }), (0, V.jsxs)(`td`, {
            children: [e.primaryEffect > 0 ? `+` : ``, e.primaryEffect, ` this month`, e.targetEffect != null && e.targetMonth ? ` · ${e.targetEffect > 0 ? `+` : ``}${e.targetEffect} ${Vt(e.targetMonth)}` : ``, (0, V.jsxs)(`small`, {
              children: [Ht(e.balanceBefore), ` → `, Ht(e.balanceAfter)]
            })]
          }), (0, V.jsx)(`td`, {
            children: e.reason
          }), (0, V.jsx)(`td`, {
            children: e.performedBy
          })]
        }, e.id))
      })]
    })
  }) : (0, V.jsx)(mt, {
    title: `No decisions recorded`,
    body: t
  });
}
var Kt = [{
  value: `USE_PREPAID`,symbol: `▣`,label: `Use Prepaid Points`,description: `Cover overage from a prepaid reserve package`,help: `Moves points from the selected prepaid reserve into this month to cover its deficit. Each package is tracked separately.`
}, {
  value: `BORROW`,
  symbol: `↔`,
  label: `Borrow`,
  description: `Bring points from next month into this month`,
  help: `Adds points to the selected month and reduces next month's regular allocation by the same amount.`
}, {
  value: `BONUS`,
  symbol: `★`,
  label: `Bonus / Courtesy`,
  description: `Current month by default · next month optional`,
  help: `Adds courtesy points to the selected month unless the next month is explicitly chosen.`
}, {
  value: `DONATE`,
  symbol: `⇄`,
  label: `Donate / Transfer`,
  description: `Transfer unused points between parents this month`,
  help: `Moves unused points between parent Client / Agency accounts in the selected month.`
}, {
  value: `BILL_OVERAGE`,
  symbol: `$`,
  label: `Bill / Overage`,
  description: `Close this month's deficit as billable overage`,
  help: `Designates all or part of an actual parent deficit as billable overage for the selected month.`
}, {
  value: `REFUND_REVERSE`,
  symbol: `↶`,
  label: `Refund / Reverse`,
  description: `Return points by reversing current-month usage`,
  help: `Returns points to the selected month by reversing usage already posted there.`
}, {
  value: `MANUAL_CORRECTION`,
  symbol: `±`,
  label: `Manual Correction`,
  description: `Current-month administrative correction`,
  help: `Adds or removes points through an explicit administrative correction in the selected month.`
}], qt = {
  clientMode: `existing`,
  clientAccountId: ``,
  newClientAgencyName: ``,
  newStationClientName: ``,
  newStationShortCode: ``,
  packageType: `RETAINER`,
  name: ``,
  regularPoints: 0,
  unlimited: !1,
  rnbEnabled: !1,
  monthlyRate: ``,
  overageRate: ``,
  purchaseDate: ``,
  startDate: ``,
  endDate: ``
}, Jt = {
  accountId: ``,
  regularAllocation: 0,
  rolloverPoints: 0,
  borrowedReduction: 0,
  usageAlreadyIncurred: 0,
  notes: ``,
  changeReason: ``
};
function Yt({section: e, packages: t, usage: n, onBack: r, onAdd: i}) {
  let a = t.filter(t => t.packageType === e), o = e === `ONE_OFF` ? {
    title: `Packages · One Off`,
    description: `Non-recurring client work and individual projects.`,
    button: `+ New One Off`
  } : e === `PREPAID` ? {
    title: `Packages · Prepaid`,
    description: `Package balances, purchase dates, and one-year expiration behavior.`,
    button: `+ New Prepaid Package`
  } : {
    title: `Packages · Retainer`,
    description: `Recurring client agreements and their monthly point structure.`,
    button: `+ New Retainer`
  }, s = e => n?.accounts.find(t => t.id === e.clientAccountId);
  return (0, V.jsxs)(`div`, {
    className: `view-stack package-detail-view`,
    children: [(0, V.jsxs)(`div`, {
      className: `package-section-heading`,
      children: [(0, V.jsxs)(`div`, {
        children: [(0, V.jsx)(`button`, {
          className: `button tertiary package-back`,
          onClick: r,
          children: `← All Packages`
        }), (0, V.jsxs)(`h2`, {
          children: [o.title, ` `, (0, V.jsx)(`span`, {
            className: `pill danger`,
            children: `ADMIN ONLY`
          })]
        }), (0, V.jsx)(`p`, {
          children: o.description
        })]
      }), (0, V.jsx)(`button`, {
        className: `button primary`,
        onClick: i,
        children: o.button
      })]
    }), (0, V.jsx)(`section`, {
      className: `panel package-list-panel`,
      children: (0, V.jsxs)(`div`, {
        className: `table-scroll`,
        children: [e === `ONE_OFF` && (0, V.jsxs)(`table`, {
          children: [(0, V.jsx)(`thead`, {
            children: (0, V.jsxs)(`tr`, {
              children: [(0, V.jsx)(`th`, {
                children: `Client`
              }), (0, V.jsx)(`th`, {
                children: `Project / Order`
              }), (0, V.jsx)(`th`, {
                children: `Date`
              }), (0, V.jsx)(`th`, {
                children: `Points`
              }), (0, V.jsx)(`th`, {
                children: `Billing Status`
              }), (0, V.jsx)(`th`, {
                children: `Status`
              })]
            })
          }), (0, V.jsx)(`tbody`, {
            children: a.map(e => (0, V.jsxs)(`tr`, {
              children: [(0, V.jsx)(`td`, {
                children: (0, V.jsx)(`b`, {
                  children: e.accountName
                })
              }), (0, V.jsx)(`td`, {
                children: e.name
              }), (0, V.jsx)(`td`, {
                children: Ut(e.purchaseDate || e.startDate)
              }), (0, V.jsx)(`td`, {
                children: e.regularPoints
              }), (0, V.jsx)(`td`, {
                children: e.active ? `Open` : `Closed`
              }), (0, V.jsx)(`td`, {
                children: (0, V.jsx)(`span`, {
                  className: `pill ${e.active ? `good-pill` : `muted-pill`}`,
                  children: e.active ? `Active` : `Inactive`
                })
              })]
            }, e.id))
          })]
        }), e === `PREPAID` && (0, V.jsxs)(`table`, {
          children: [(0, V.jsx)(`thead`, {
            children: (0, V.jsxs)(`tr`, {
              children: [(0, V.jsx)(`th`, {
                children: `Client`
              }), (0, V.jsx)(`th`, {
                children: `Purchased`
              }), (0, V.jsx)(`th`, {
                children: `Original Points`
              }), (0, V.jsx)(`th`, {
                children: `Remaining`
              }), (0, V.jsx)(`th`, {
                children: `Expires`
              }), (0, V.jsx)(`th`, {
                children: `Status`
              })]
            })
          }), (0, V.jsx)(`tbody`, {
            children: a.map(e => {
              let t = e.isReserve ? e.reserveAvailable : e.active ? s(e)?.remaining : null, n = e.expiresAt ? Math.ceil((new Date(`${e.expiresAt}T23:59:59Z`).getTime() - Date.now()) / 864e5) : null;
              return (0, V.jsxs)(`tr`, {
                children: [(0, V.jsx)(`td`, {
                  children: (0, V.jsx)(`b`, {
                    children: e.accountName
                  })
                }), (0, V.jsx)(`td`, {
                  children: `${Ut(e.purchaseDate)} · ${e.name}${e.isReserve ? ` (reserve)` : ``}`
                }), (0, V.jsx)(`td`, {
                  children: e.regularPoints
                }), (0, V.jsx)(`td`, {
                  children: t ?? `—`
                }), (0, V.jsx)(`td`, {
                  children: Ut(e.expiresAt)
                }), (0, V.jsx)(`td`, {
                  children: (0, V.jsx)(`span`, {
                    className: `pill ${n != null && n <= 30 ? `warning-pill` : `good-pill`}`,
                    children: e.active ? n != null && n <= 30 ? `Expires in ${Math.max(0, n)} days` : `Active` : `Inactive`
                  })
                })]
              }, e.id);
            })
          })]
        }), e === `RETAINER` && (0, V.jsxs)(`table`, {
          children: [(0, V.jsx)(`thead`, {
            children: (0, V.jsxs)(`tr`, {
              children: [(0, V.jsx)(`th`, {
                children: `Client`
              }), (0, V.jsx)(`th`, {
                children: `Monthly Points`
              }), (0, V.jsx)(`th`, {
                children: `R&B`
              }), (0, V.jsx)(`th`, {
                children: `Used This Month`
              }), (0, V.jsx)(`th`, {
                children: `Remaining`
              }), (0, V.jsx)(`th`, {
                children: `Status`
              })]
            })
          }), (0, V.jsx)(`tbody`, {
            children: a.map(e => {
              let t = s(e);
              return (0, V.jsxs)(`tr`, {
                children: [(0, V.jsx)(`td`, {
                  children: (0, V.jsx)(`b`, {
                    children: e.accountName
                  })
                }), (0, V.jsx)(`td`, {
                  children: e.unlimited ? `Unlimited` : e.regularPoints
                }), (0, V.jsx)(`td`, {
                  children: (0, V.jsx)(`span`, {
                    className: `pill ${e.rnbEnabled ? `good-pill` : `muted-pill`}`,
                    children: e.rnbEnabled ? `Enabled` : `No`
                  })
                }), (0, V.jsxs)(`td`, {
                  children: [t?.used ?? 0, e.unlimited ? ` tracked` : ``]
                }), (0, V.jsx)(`td`, {
                  children: e.unlimited ? `Unlimited` : t?.remaining ?? 0
                }), (0, V.jsx)(`td`, {
                  children: (0, V.jsx)(`span`, {
                    className: `pill ${e.unlimited ? `dark-pill` : e.active ? `good-pill` : `muted-pill`}`,
                    children: e.unlimited ? `UNLIMITED` : e.active ? `Active` : `Inactive`
                  })
                })]
              }, e.id);
            })
          })]
        }), !a.length && (0, V.jsx)(mt, {
          title: `No ${e === `ONE_OFF` ? `One Off` : e === `PREPAID` ? `Prepaid` : `Retainer`} packages`,
          body: `Use ${o.button.replace(`+ `, ``)} to add the first one.`
        })]
      })
    }), e === `PREPAID` && (0, V.jsx)(G, {
      children: `If a client buys a new package before the current package expires, remaining points blend into the new package and the blended balance receives a new one-year expiration from the new purchase date.`
    }), e === `RETAINER` && (0, V.jsxs)(G, {
      children: [(0, V.jsx)(`b`, {
        children: `Retainer allowance:`
      }), ` A retainer may use a defined monthly point allowance or be UNLIMITED. Unlimited clients still track actual production usage but do not carry a finite remaining balance, rollover, or borrowing requirement.`, (0, V.jsx)(`br`, {}), (0, V.jsx)(`br`, {}), (0, V.jsx)(`b`, {
        children: `R&B rules:`
      }), ` Usage is client-level across associated stations. Unused regular points roll to the next month only. Usage consumes Regular first, then Rollover, then borrowed credit. Borrowing is an explicit reconciliation action, and an over-20% borrow is flagged rather than blocked.`]
    })]
  });
}
function Xt({notify: e, section: t, clients: n, onNavigate: r}) {
  let i = new Intl.DateTimeFormat(`en-CA`, {
    timeZone: `America/New_York`,
    year: `numeric`,
    month: `2-digit`
  }).format(new Date()), [a, o] = (0, h.useState)(i), [s, c] = (0, h.useState)(null), [l, u] = (0, h.useState)([]), [d, f] = (0, h.useState)([]), [p, m] = (0, h.useState)([]), [g, _] = (0, h.useState)(null), [v, y] = (0, h.useState)(!1), [b, x] = (0, h.useState)(new Set()), [S, C] = (0, h.useState)(`all`), [w, T] = (0, h.useState)(``), [E, D] = (0, h.useState)({
    action: `BORROW`,
    reservePackageId: ``,
    points: 0,
    reason: ``,
    donorAccountId: ``,
    targetAccountId: ``,
    targetMonth: a,
    direction: `ADD`
  }), [ee, te] = (0, h.useState)(null), [ne, A] = (0, h.useState)(!1), [re, ie] = (0, h.useState)(!1), [j, M] = (0, h.useState)(`menu`), [N, F] = (0, h.useState)({
    ...qt
  }), [I, L] = (0, h.useState)({
    ...Jt
  }), [R, ae] = (0, h.useState)(null), [oe, se] = (0, h.useState)(Number(i.slice(0, 4))), [ce, le] = (0, h.useState)([]), [fe, pe] = (0, h.useState)(null), me = Bt(a);
  const reconcileRequest=(0,h.useRef)(null);
  async function he() {
    y(!0);
    try {
      let [e, t, n, r] = await Promise.all([B.get(`/api/dts/usage?month=${a}`), B.get(`/api/dts/accounts`), B.get(`/api/dts/packages`), B.get(`/api/dts/reconciliation-decisions?month=${a}`)]);
      (c(e), u(t.accounts || []), f(n.packages || []), m(r.decisions || []), _(r.archive || null));
      let i = e.accounts.find(e => !e.unlimited && (e.remaining ?? 0) < 0)?.id || t.accounts?.[0]?.id || ``;
      (T(e => e && t.accounts.some(t => t.id === e) ? e : i), L(e => e.accountId ? e : {
        ...e,
        accountId: i
      }), x(t => t.size ? t : new Set(e.accounts.map(e => e.id))));
    } catch (t) {
      e(t instanceof Error ? t.message : `Could not load DTS.`, `error`);
    } finally {
      y(!1);
    }
  }
  ((0, h.useEffect)(() => {
    (D(e => ({
      ...e,
      targetMonth: a
    })), he());
  }, [a]), (0, h.useEffect)(() => {
    t === `history` && Ne();
  }, [t, oe]), (0, h.useEffect)(() => {
    t === `opening` && I.accountId && Le(I.accountId);
  }, [t, I.accountId, a]), (0, h.useEffect)(() => {
    t === `packages` ? M(`menu`) : t === `package-oneoff` ? M(`ONE_OFF`) : t === `package-prepaid` ? M(`PREPAID`) : t === `package-retainer` && M(`RETAINER`);
  }, [t]), (0, h.useEffect)(() => {
    let e = s?.accounts.find(e => e.id === w);
    !e || e.unlimited || (e.remaining ?? 0) >= 0 || D(t => t.points > 0 ? t : {
      ...t,
      points: Math.abs(e.remaining || 0),
      reason: `Resolve ${Vt(a)} point deficit`
    });
  }, [w, a, s]));
  let ge = (0, h.useMemo)(() => ({
    regular: (s?.accounts || []).filter(e => !e.unlimited).reduce((e, t) => e + t.regular, 0),
    rollover: (s?.accounts || []).filter(e => !e.unlimited).reduce((e, t) => e + t.rollover, 0),
    borrowedByPrior: (s?.accounts || []).filter(e => !e.unlimited).reduce((e, t) => e + t.borrowedByPrior, 0),
    starting: (s?.accounts || []).filter(e => !e.unlimited).reduce((e, t) => e + t.startingAvailable, 0),
    used: (s?.accounts || []).reduce((e, t) => e + t.used, 0),
    production: (s?.accounts || []).reduce((e, t) => e + t.inProduction, 0),
    deficits: (s?.accounts || []).filter(e => e.remaining != null && e.remaining < 0).length,
    unlimited: (s?.accounts || []).filter(e => e.unlimited).length
  }), [s]), _e = (0, h.useMemo)(() => {
    let e = Date.now(), t = e + 2592e6;
    return d.filter(n => {
      if (!n.active || n.packageType !== `PREPAID` || !n.expiresAt) return !1;
      let r = new Date(n.expiresAt).getTime();
      return Number.isFinite(r) && r >= e && r <= t;
    });
  }, [d]), ve = (s?.accounts || []).filter(e => S === `all` || S === `unlimited` ? S === `all` || e.unlimited : !e.unlimited && (e.remaining ?? 0) <= 0), z = s?.accounts.find(e => e.id === w), ye = Kt.find(e => e.value === E.action) || Kt[0], be = z?.remaining ?? 0, xe = s?.accounts.find(e => e.id === E.donorAccountId), Ce = s?.accounts.find(e => e.id === E.targetAccountId), we = E.action === `MANUAL_CORRECTION` && E.direction === `REMOVE` ? -E.points : E.action === `DONATE` ? w === E.donorAccountId ? -E.points : w === E.targetAccountId ? E.points : 0 : E.action === `BONUS` && E.targetMonth !== a ? 0 : E.points, Te = z?.remaining == null ? null : be + we, Ee = E.action === `BORROW` ? `+${E.points} ${Vt(a)} · -${E.points} ${Vt(me)}` : E.action === `BONUS` && E.targetMonth !== a ? `+${E.points} ${Vt(E.targetMonth)} · ${Vt(a)} unchanged` : E.action === `DONATE` ? `-${E.points} from ${xe?.name || `donor parent`} · +${E.points} to ${Ce?.name || `recipient parent`}` : E.action === `USE_PREPAID` ? `${E.points} points from the selected prepaid reserve to ${Vt(a)}` : E.action === `BILL_OVERAGE` ? `${E.points} ${Vt(a)} points designated as billable overage` : E.action === `REFUND_REVERSE` ? `+${E.points} points returned to ${Vt(a)}` : `${we >= 0 ? `+` : ``}${we} administrative correction to ${Vt(a)}`;
  function De(e) {
    x(t => {
      let n = new Set(t);
      return (n.has(e) ? n.delete(e) : n.add(e), n);
    });
  }
  function Oe(e) {
    (T(e), D(old=>({...old,reservePackageId:``})), requestAnimationFrame(() => document.querySelector(`.recon-workspace`)?.scrollIntoView({
      behavior: `smooth`,
      block: `start`
    })));
  }
  function ke(e) {
    if (e !== `DONATE`) {
      D(t => ({
        ...t,
        action: e
      }));
      return;
    }
    let t = (s?.accounts || []).filter(e => !e.unlimited), n = z && !z.unlimited ? z.id : t[0]?.id || ``, r = (s?.accounts || []).find(e => !e.unlimited && (e.remaining ?? 0) > 0 && e.id !== n)?.id || ``;
    D(t => ({
      ...t,
      action: e,
      donorAccountId: r,
      targetAccountId: n
    }));
  }
  async function Ae() {
    if (!w || E.points <= 0 || !E.reason.trim()) return e(`Choose a parent Client / Agency, points, and a reason.`, `error`);
    if (E.action === `DONATE` && (!E.donorAccountId || !E.targetAccountId)) return e(`Choose both the donation donor and recipient.`, `error`);
    if (E.action === `DONATE` && E.donorAccountId === E.targetAccountId) return e(`Choose different donor and recipient accounts.`, `error`);
    if (E.action === `DONATE` && E.points > (xe?.remaining || 0)) return e(`Donation points cannot exceed the donor's current-month remaining balance.`, `error`);
    if (E.action === `USE_PREPAID` && !E.reservePackageId) return e(`Choose a prepaid reserve package.`, `error`);
    y(!0);
    try {
      const payload={
        month: a,
        action: E.action,
        accountId: E.action === `DONATE` ? E.donorAccountId : w,
        points: E.points,
        reason: E.reason,
        targetAccountId: E.action === `DONATE` ? E.targetAccountId : void 0,
        targetMonth: E.action === `BORROW` ? me : E.action === `BONUS` ? E.targetMonth : void 0,
        reservePackageId: E.action === `USE_PREPAID` ? E.reservePackageId : void 0,
        direction: E.action === `MANUAL_CORRECTION` ? E.direction : void 0
       };
      const signature=JSON.stringify(payload);
      if(!reconcileRequest.current||reconcileRequest.current.signature!==signature)reconcileRequest.current={signature,requestId:crypto.randomUUID()};
      const t=await B.post(`/api/dts/reconcile`,{...payload,requestId:reconcileRequest.current.requestId});
      reconcileRequest.current=null;

      (e(t.overGuideline ? `Reconciliation posted and flagged above the ${t.guidelinePoints}-point borrow guideline.` : `Parent reconciliation posted to the point ledger.`), D(e => ({
        ...e,
        points: 0,
        reason: ``
      })), await he());
    } catch (t) {
      e(t instanceof Error ? t.message : `Reconciliation failed.`, `error`);
    } finally {
      y(!1);
    }
  }
  async function je(t) {
    (T(t), y(!0));
    try {
      te(await B.get(`/api/dts/accounts/${t}?month=${a}`));
    } catch (t) {
      e(t instanceof Error ? t.message : `Could not open Point Account.`, `error`);
    } finally {
      y(!1);
    }
  }
  async function Me() {
    y(!0);
    try {
      let t = await B.post(`/api/dts/reconciliation-history/archive`, {
        month: a
      });
      (_(t.archive), e(t.alreadyArchived ? `This month was already archived.` : `Month archived to permanent Reconciliation History.`), await Ne());
    } catch (t) {
      e(t instanceof Error ? t.message : `Could not archive this month.`, `error`);
    } finally {
      y(!1);
    }
  }
  async function Ne() {
    try {
      let e = await B.get(`/api/dts/reconciliation-history?year=${oe}`);
      le(e.months || []);
    } catch (t) {
      e(t instanceof Error ? t.message : `Could not load Reconciliation History.`, `error`);
    }
  }
  async function Pe(t) {
    y(!0);
    try {
      pe(await B.get(`/api/dts/reconciliation-history/${t}`));
    } catch (t) {
      e(t instanceof Error ? t.message : `Could not open history.`, `error`);
    } finally {
      y(!1);
    }
  }
  function Fe(e) {
    let t = new Intl.DateTimeFormat(`en-CA`, {
      timeZone: `America/New_York`,
      year: `numeric`,
      month: `2-digit`,
      day: `2-digit`
    }).format(new Date());
    (ie(!1), F({
      ...qt,
      packageType: e,
      clientMode: l.length ? `existing` : `new`,
      clientAccountId: l[0]?.id || ``,
      startDate: `${a}-01`,
      purchaseDate: t
    }), A(!0));
  }
  async function Ie() {
    if (N.packageType === `ONE_OFF` && !N.name.trim()) {
      e(`Project / Order is required.`, `error`);
      return;
    }
    if (N.clientMode === `existing` && !N.clientAccountId) {
      e(`Choose an existing Client / Agency or switch to New Client.`, `error`);
      return;
    }
    if (N.clientMode === `new` && (!N.newClientAgencyName.trim() || !N.newStationClientName.trim())) {
      e(`Enter both the Client / Agency Name and Station / Client Name.`, `error`);
      return;
    }
    y(!0);
    try {
      let t = N.packageType === `PREPAID` ? `${N.regularPoints}-Point Prepaid Package` : N.unlimited ? `Unlimited Retainer` : `Monthly Retainer`, n = {
        packageType: N.packageType,
        name: N.name.trim() || t,
        regularPoints: N.unlimited ? null : N.regularPoints,
        unlimited: N.unlimited,
        rnbEnabled: N.rnbEnabled,
        monthlyRate: N.monthlyRate ? Number(N.monthlyRate) : null,
        overageRate: N.overageRate ? Number(N.overageRate) : null,
        purchaseDate: [`ONE_OFF`, `PREPAID`].includes(N.packageType) && N.purchaseDate || null,
        startDate: N.packageType === `RETAINER` && N.startDate || null,
        endDate: N.packageType === `RETAINER` && N.endDate || null
      };
      (N.clientMode === `existing` ? n.clientAccountId = N.clientAccountId : Object.assign(n, {
        newClientAgencyName: N.newClientAgencyName,
        newStationClientName: N.newStationClientName
      }), await B.post(`/api/dts/packages`, n), e(`Package saved to the parent Client / Agency.`), A(!1), M(N.packageType), await he());
    } catch (t) {
      e(t instanceof Error ? t.message : `Package save failed.`, `error`);
    } finally {
      y(!1);
    }
  }
  async function Le(t) {
    try {
      let e = await B.get(`/api/dts/opening-state?accountId=${t}&month=${a}`);
      ae(e);
      let n = e.state;
      L(e => ({
        ...e,
        accountId: t,
        regularAllocation: n?.regularAllocation || 0,
        rolloverPoints: n?.rolloverPoints || 0,
        borrowedReduction: n?.borrowedReduction || 0,
        usageAlreadyIncurred: n?.usageAlreadyIncurred || 0,
        notes: n?.notes || ``,
        changeReason: ``
      }));
    } catch (t) {
      e(t instanceof Error ? t.message : `Could not load Opening Account State.`, `error`);
    }
  }
  async function Re() {
    if (I.accountId) {
      y(!0);
      try {
        (await B.post(`/api/dts/opening-state`, {
          ...I,
          month: a
        }), e(`Parent Opening Account State saved.`), await Le(I.accountId), await he());
      } catch (t) {
        e(t instanceof Error ? t.message : `Opening state failed.`, `error`);
      } finally {
        y(!1);
      }
    }
  }
  function ze() {
    I.accountId && (T(I.accountId), D(e => ({
      ...e,
      action: `MANUAL_CORRECTION`,
      direction: `ADD`,
      points: 0,
      reason: `Correct archived Starting State for ${Vt(a)}`
    })), r(`usage`), requestAnimationFrame(() => document.querySelector(`.recon-workspace`)?.scrollIntoView({
      behavior: `smooth`,
      block: `start`
    })));
  }
  return v && !s ? (0, V.jsx)(pt, {
    label: `Loading DTS…`
  }) : (0, V.jsxs)(`div`, {
    className: `view-stack dts-approved-view`,
    children: [t === `dashboard` && (0, V.jsxs)(V.Fragment, {
      children: [(0, V.jsxs)(G, {
        children: [(0, V.jsx)(`b`, {
          children: `DTS is Administrator-only.`
        }), ` OAB Master Delivery posts usage automatically; Producers never enter DTS usage.`]
      }), (0, V.jsxs)(`div`, {
        className: `metric-grid four`,
        children: [(0, V.jsx)(W, {
          label: `Used This Month`,
          value: ge.used
        }), (0, V.jsx)(W, {
          label: `In Production`,
          value: ge.production,
          tone: `warning`
        }), (0, V.jsx)(W, {
          label: `Parent Accounts in Deficit`,
          value: ge.deficits,
          tone: ge.deficits ? `danger` : `good`
        }), (0, V.jsx)(W, {
          label: `Unlimited Parents`,
          value: ge.unlimited
        })]
      }), (0, V.jsxs)(`div`, {
        className: `dashboard-grid dts-dashboard-grid`,
        children: [(0, V.jsxs)(`section`, {
          className: `panel`,
          children: [(0, V.jsxs)(`div`, {
            className: `panel-heading`,
            children: [(0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`h2`, {
                children: `Quick Links`
              }), (0, V.jsx)(`p`, {
                children: `Go directly to the point-account task you need.`
              })]
            }), (0, V.jsxs)(`button`, {
              className: `button secondary`,
              onClick: () => void he(),
              children: [(0, V.jsx)(Se, {
                size: 15
              }), `Refresh`]
            })]
          }), (0, V.jsxs)(`div`, {
            className: `dts-link-list`,
            children: [(0, V.jsxs)(`button`, {
              onClick: () => r(`usage`),
              children: [(0, V.jsxs)(`span`, {
                children: [(0, V.jsx)(`b`, {
                  children: `USAGE Stats / Reconciliation`
                }), (0, V.jsx)(`small`, {
                  children: `Review parent balances and finish the month.`
                })]
              }), (0, V.jsx)(k, {
                size: 17
              })]
            }), (0, V.jsxs)(`button`, {
              onClick: () => r(`packages`),
              children: [(0, V.jsxs)(`span`, {
                children: [(0, V.jsx)(`b`, {
                  children: `Packages`
                }), (0, V.jsx)(`small`, {
                  children: `One Off · Prepaid · Retainer`
                })]
              }), (0, V.jsx)(k, {
                size: 17
              })]
            }), (0, V.jsxs)(`button`, {
              onClick: () => r(`opening`),
              children: [(0, V.jsxs)(`span`, {
                children: [(0, V.jsx)(`b`, {
                  children: `Opening Account State`
                }), (0, V.jsx)(`small`, {
                  children: `Parent-level cutover initialization only.`
                })]
              }), (0, V.jsx)(k, {
                size: 17
              })]
            })]
          })]
        }), (0, V.jsxs)(`section`, {
          className: `panel`,
          children: [(0, V.jsx)(`div`, {
            className: `panel-heading`,
            children: (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`h2`, {
                children: `Account Alerts`
              }), (0, V.jsx)(`p`, {
                children: `Finite deficits and prepaid expirations needing attention.`
              })]
            })
          }), (0, V.jsxs)(`div`, {
            className: `dts-alert-list`,
            children: [(s?.accounts || []).filter(e => !e.unlimited && (e.remaining ?? 0) < 0).map(e => (0, V.jsxs)(`button`, {
              className: `dts-alert danger`,
              onClick: () => {
                (T(e.id), r(`usage`));
              },
              children: [(0, V.jsxs)(`span`, {
                children: [(0, V.jsx)(`b`, {
                  children: e.name
                }), (0, V.jsxs)(`small`, {
                  children: [Math.abs(e.remaining || 0), ` points over allocation`]
                })]
              }), (0, V.jsx)(`strong`, {
                children: e.remaining
              })]
            }, `deficit-${e.id}`)), _e.map(e => {
              let t = Math.max(0, Math.ceil((new Date(e.expiresAt).getTime() - Date.now()) / 864e5));
              return (0, V.jsxs)(`button`, {
                className: `dts-alert warning`,
                onClick: () => r(`packages`),
                children: [(0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: e.accountName
                  }), (0, V.jsxs)(`small`, {
                    children: [e.name, ` expires `, new Date(e.expiresAt).toLocaleDateString()]
                  })]
                }), (0, V.jsxs)(`strong`, {
                  children: [t, ` days`]
                })]
              }, `expiry-${e.id}`);
            }), !ge.deficits && !_e.length && (0, V.jsx)(mt, {
              title: `No account alerts`,
              body: `No deficits or prepaid expirations need attention.`
            })]
          })]
        })]
      }), (0, V.jsxs)(`section`, {
        className: `panel`,
        children: [(0, V.jsx)(`div`, {
          className: `panel-heading`,
          children: (0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`h2`, {
              children: `DTS Account Rules`
            }), (0, V.jsx)(`p`, {
              children: `Every balance belongs to one parent Client / Agency. Stations supply usage detail only.`
            })]
          })
        }), (0, V.jsxs)(`div`, {
          className: `dts-rule-grid`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`b`, {
              children: `ONE PARENT BALANCE`
            }), (0, V.jsxs)(`span`, {
              children: [s?.accounts.length || 0, ` Client / Agency accounts`]
            })]
          }), (0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`b`, {
              children: `STATION ATTRIBUTION`
            }), (0, V.jsxs)(`span`, {
              children: [n.filter(e => e.active).length, ` Station / Client profiles`]
            })]
          }), (0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`b`, {
              children: `MASTER DELIVERY`
            }), (0, V.jsx)(`span`, {
              children: `Posts usage once, automatically`
            })]
          })]
        })]
      })]
    }), t === `usage` && (0, V.jsxs)(V.Fragment, {
      children: [(0, V.jsxs)(`div`, {
        className: `report-toolbar dts-toolbar`,
        children: [(0, V.jsxs)(`label`, {
          children: [`Month `, (0, V.jsx)(`input`, {
            type: `month`,
            value: a,
            onChange: e => o(e.target.value)
          })]
        }), (0, V.jsxs)(`label`, {
          children: [`Show `, (0, V.jsxs)(`select`, {
            value: S,
            onChange: e => C(e.target.value),
            children: [(0, V.jsx)(`option`, {
              value: `all`,
              children: `All Clients`
            }), (0, V.jsx)(`option`, {
              value: `reconcile`,
              children: `Needs Reconciliation`
            }), (0, V.jsx)(`option`, {
              value: `unlimited`,
              children: `Unlimited`
            })]
          })]
        }), (0, V.jsxs)(`a`, {
          className: `button secondary`,
          href: Ue(`/api/dts/billing-pdf?month=${a}`),
          children: [(0, V.jsx)(P, {
            size: 15
          }), `Month-End Billing PDF`]
        })]
      }), (0, V.jsxs)(`section`, {
        className: `dts-closeout`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsxs)(`b`, {
            children: [`Make `, Vt(a), ` right before the calendar rolls.`]
          }), (0, V.jsx)(`p`, {
            children: `Parent totals are reconciled once. Current-month action is the default; a future-month effect must be explicit. Station rows show attribution only and never create separate balances or reconciliations.`
          })]
        }), (0, V.jsxs)(`div`, {
          className: `dts-closeout-badges`,
          children: [(0, V.jsx)(`span`, {
            children: `CURRENT MONTH DEFAULT`
          }), (0, V.jsx)(`span`, {
            children: `FUTURE MONTH = EXPLICIT`
          })]
        })]
      }), (0, V.jsxs)(`section`, {
        className: `dts-billing-reference`,
        children: [(0, V.jsx)(`b`, {
          children: `QuickBooks Billing Reference — Overages to Bill`
        }), (0, V.jsx)(`p`, {
          children: `The PDF uses finalized Bill / Overage decisions for the selected month. A raw negative balance is not a billing instruction. Parent Client / Agency owns the balance; station usage is supporting detail.`
        }), (0, V.jsx)(`div`, {
          className: `billing-overage-list`,
          children: p.filter(e => e.actionLabel.toLowerCase().includes(`overage`) || e.actionLabel.toLowerCase().includes(`bill`)).length ? p.filter(e => e.actionLabel.toLowerCase().includes(`overage`) || e.actionLabel.toLowerCase().includes(`bill`)).map(e => (0, V.jsxs)(`span`, {
            children: [(0, V.jsx)(`b`, {
              children: e.accountName
            }), e.points, ` billable points · `, e.reason]
          }, `billing-${e.id}`)) : (0, V.jsxs)(`span`, {
            children: [`No finalized Bill / Overage entries for `, Vt(a), `.`]
          })
        })]
      }), (0, V.jsxs)(`div`, {
        className: `metric-grid eight dts-usage-metrics`,
        children: [(0, V.jsx)(W, {
          label: `Parent Clients`,
          value: s?.accounts.length || 0,
          note: `${ge.unlimited} unlimited`
        }), (0, V.jsx)(W, {
          label: `Total Regular`,
          value: ge.regular
        }), (0, V.jsx)(W, {
          label: `Rollover In`,
          value: ge.rollover
        }), (0, V.jsx)(W, {
          label: `Borrowed by Prior Month`,
          value: ge.borrowedByPrior,
          tone: ge.borrowedByPrior ? `danger` : void 0
        }), (0, V.jsx)(W, {
          label: `Starting Available`,
          value: ge.starting
        }), (0, V.jsx)(W, {
          label: `Used This Month`,
          value: ge.used
        }), (0, V.jsx)(W, {
          label: `In Production`,
          value: ge.production,
          tone: `warning`
        }), (0, V.jsx)(W, {
          label: `Needs Reconciliation`,
          value: (s?.accounts || []).filter(e => !e.unlimited && (e.remaining ?? 0) <= 0).length,
          tone: `warning`
        })]
      }), (0, V.jsxs)(`section`, {
        className: `dts-production-notice`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`small`, {
            children: `OPEN PRODUCTION DUE THIS MONTH`
          }), (0, V.jsx)(`b`, {
            children: ge.production ? `${ge.production} points pending Master Delivery` : `No current-month production points pending`
          }), (0, V.jsx)(`p`, {
            children: `Informational only. DTS does not count these points as Used until the assignment is Master Delivered.`
          })]
        }), (0, V.jsxs)(`span`, {
          children: [(s?.accounts || []).reduce((e, t) => e + t.productionJobs.length, 0), ` open assignments`]
        }), ge.production > 0 && (0, V.jsx)(`div`, {
          className: `dts-production-jobs`,
          children: (s?.accounts || []).flatMap(e => e.productionJobs.map(e => (0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`b`, {
              children: [e.station, ` · `, e.title]
            }), (0, V.jsxs)(`span`, {
              children: [e.points, ` points · due `, rt(e.dueAt)]
            })]
          }, e.assignmentId)))
        })]
      }), (0, V.jsxs)(`section`, {
        className: `panel`,
        children: [(0, V.jsxs)(`div`, {
          className: `panel-heading`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`h2`, {
              children: [`USAGE — `, Vt(a), ` `, (0, V.jsx)(H, {
                text: `Each parent appears once. Expand it for Station / Client usage and open production.`
              })]
            }), (0, V.jsx)(`p`, {
              children: `Used posts only when an assignment is Master Delivered. Station rows are attribution detail only.`
            })]
          }), (0, V.jsxs)(`button`, {
            className: `button secondary`,
            onClick: () => void he(),
            children: [(0, V.jsx)(Se, {
              size: 15
            }), `Refresh`]
          })]
        }), (0, V.jsx)(`div`, {
          className: `table-scroll`,
          children: (0, V.jsxs)(`table`, {
            className: `dts-usage-table`,
            children: [(0, V.jsx)(`thead`, {
              children: (0, V.jsxs)(`tr`, {
                children: [(0, V.jsx)(`th`, {
                  children: `Client / Agency and Stations`
                }), (0, V.jsx)(`th`, {
                  children: `Regular This Month`
                }), (0, V.jsx)(`th`, {
                  children: `Rollover In`
                }), (0, V.jsx)(`th`, {
                  children: `Borrowed by Prior Month`
                }), (0, V.jsx)(`th`, {
                  children: `Starting Available`
                }), (0, V.jsx)(`th`, {
                  children: `Used This Month`
                }), (0, V.jsx)(`th`, {
                  children: `In Production`
                }), (0, V.jsx)(`th`, {
                  children: `Remaining`
                }), (0, V.jsx)(`th`, {
                  children: `% Remaining`
                }), (0, V.jsx)(`th`, {
                  children: `Status`
                }), (0, V.jsx)(`th`, {
                  children: `Action`
                })]
              })
            }), (0, V.jsx)(`tbody`, {
              children: ve.map(e => {
                let t = e.unlimited || !e.startingAvailable || e.remaining == null ? null : Math.round(e.remaining / e.startingAvailable * 100), r = e.unlimited ? `UNLIMITED` : (e.remaining ?? 0) < 0 ? `OVERAGE` : e.remaining === 0 ? `EXHAUSTED` : t != null && t <= 15 ? `LOW` : `GOOD`;
                return (0, V.jsxs)(h.Fragment, {
                  children: [(0, V.jsxs)(`tr`, {
                    className: `usage-parent-row ${w === e.id ? `selected-row` : ``} ${r === `OVERAGE` || r === `EXHAUSTED` ? `negative-row` : ``}`,
                    children: [(0, V.jsx)(`td`, {
                      children: (0, V.jsxs)(`button`, {
                        className: `usage-expand`,
                        onClick: () => De(e.id),
                        children: [b.has(e.id) ? (0, V.jsx)(O, {
                          size: 15
                        }) : (0, V.jsx)(k, {
                          size: 15
                        }), (0, V.jsxs)(`span`, {
                          children: [(0, V.jsx)(`b`, {
                            children: e.name
                          }), (0, V.jsxs)(`small`, {
                            children: [Wt(e, n).length, ` stations / clients`, e.unlimited ? ` · UNLIMITED` : ``]
                          })]
                        })]
                      })
                    }), (0, V.jsx)(`td`, {
                      children: e.unlimited ? `—` : e.regular
                    }), (0, V.jsx)(`td`, {
                      children: e.unlimited ? `—` : e.rollover
                    }), (0, V.jsx)(`td`, {
                      className: e.borrowedByPrior ? `late` : ``,
                      children: e.unlimited ? `—` : e.borrowedByPrior ? `-${e.borrowedByPrior}` : `0`
                    }), (0, V.jsx)(`td`, {
                      children: (0, V.jsx)(`b`, {
                        children: e.unlimited ? `UNLIMITED` : e.startingAvailable
                      })
                    }), (0, V.jsx)(`td`, {
                      children: (0, V.jsx)(`b`, {
                        children: e.used
                      })
                    }), (0, V.jsx)(`td`, {
                      className: e.inProduction ? `amber-text` : ``,
                      children: e.inProduction || `—`
                    }), (0, V.jsx)(`td`, {
                      className: e.remaining != null && e.remaining < 0 ? `late` : ``,
                      children: (0, V.jsx)(`b`, {
                        children: [Ht(e.remaining), e.reservePackages?.length ? (0,V.jsx)(`small`,{style:{display:`block`,fontWeight:600},children:`Prepaid ${e.reservePoints} · Total bank ${e.pointsInBank}`}) : null]
                      })
                    }), (0, V.jsx)(`td`, {
                      className: t != null && t < 0 ? `late` : ``,
                      children: t == null ? `—` : `${t}%`
                    }), (0, V.jsx)(`td`, {
                      children: (0, V.jsx)(`span`, {
                        className: `usage-status status-${r.toLowerCase()}`,
                        children: r
                      })
                    }), (0, V.jsx)(`td`, {
                      children: (0, V.jsxs)(`div`, {
                        className: `row-actions`,
                        children: [(0, V.jsx)(`button`, {
                          className: `button tertiary`,
                          onClick: () => void je(e.id),
                          children: `Point Account`
                        }), !e.unlimited && (0, V.jsx)(`button`, {
                          className: `button ${(e.remaining ?? 0) <= 0 ? `primary` : `tertiary`}`,
                          onClick: () => Oe(e.id),
                          children: (e.remaining ?? 0) <= 0 ? `Reconcile` : `View / Adjust`
                        })]
                      })
                    })]
                  }), b.has(e.id) && Wt(e, n).map(t => (0, V.jsxs)(`tr`, {
                    className: `usage-station-row`,
                    children: [(0, V.jsx)(`td`, {
                      children: (0, V.jsxs)(`span`, {
                        className: `station-indent`,
                        children: [(0, V.jsx)(`b`, {
                          children: t.station
                        }), ` · `, t.name]
                      })
                    }), (0, V.jsx)(`td`, {
                      colSpan: 4,
                      children: (0, V.jsx)(`small`, {
                        children: `Station attribution only — parent owns the balance`
                      })
                    }), (0, V.jsx)(`td`, {
                      children: t.used || `—`
                    }), (0, V.jsx)(`td`, {
                      children: t.pending || `—`
                    }), (0, V.jsx)(`td`, {
                      children: `—`
                    }), (0, V.jsx)(`td`, {
                      children: `—`
                    }), (0, V.jsx)(`td`, {
                      children: (0, V.jsx)(`span`, {
                        className: `usage-status status-attribution`,
                        children: `ATTRIBUTION`
                      })
                    }), (0, V.jsx)(`td`, {
                      children: (0, V.jsx)(`small`, {
                        children: `No separate reconciliation`
                      })
                    })]
                  }, `${e.id}-${t.id}`))]
                }, e.id);
              })
            })]
          })
        }), (0, V.jsxs)(`p`, {
          className: `dts-usage-equation-note`,
          children: [(0, V.jsx)(`b`, {
            children: `Starting Available = Regular Allocation + Rollover In − Borrowed by Prior Month.`
          }), ` Used This Month includes Master Delivered assignments only. In Production stays out of the balance until Master Delivery.`]
        })]
      }), (0, V.jsxs)(`section`, {
        className: `panel recon-workspace`,
        children: [(0, V.jsxs)(`div`, {
          className: `recon-hero`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`small`, {
              children: `SELECTED CLIENT`
            }), (0, V.jsxs)(`h2`, {
              children: [z?.name || `Choose a parent`, ` · `, Vt(a)]
            }), (0, V.jsx)(`p`, {
              children: z?.unlimited ? `Delivered usage is tracked without a finite balance.` : be < 0 ? `This account is ${Math.abs(be)} points over its current-month availability.` : be === 0 ? `This account has exhausted its current-month availability.` : `This account has ${be} points remaining.`
            })]
          }), (0, V.jsx)(`span`, {
            className: `recon-flag ${z?.unlimited ? `unlimited` : be < 0 ? `danger` : be === 0 ? `warning` : `good`}`,
            children: z?.unlimited ? `UNLIMITED` : be < 0 ? `NEEDS RECONCILIATION · ${Math.abs(be)} PTS` : be === 0 ? `EXHAUSTED` : `${be} PTS REMAINING`
          })]
        }), !z?.unlimited && (0, V.jsxs)(V.Fragment, {
          children: [(0, V.jsxs)(`div`, {
            className: `recon-kpis`,
            children: [(0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`span`, {
                children: `Regular`
              }), (0, V.jsx)(`b`, {
                children: z?.regular ?? 0
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`span`, {
                children: `Rollover In`
              }), (0, V.jsx)(`b`, {
                children: z?.rollover ?? 0
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`span`, {
                children: `Borrowed by Prior Month`
              }), (0, V.jsx)(`b`, {
                className: z?.borrowedByPrior ? `late` : ``,
                children: z?.borrowedByPrior ? `-${z.borrowedByPrior}` : `0`
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`span`, {
                children: `Starting Available`
              }), (0, V.jsx)(`b`, {
                children: z?.startingAvailable ?? 0
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`span`, {
                children: `Used`
              }), (0, V.jsx)(`b`, {
                children: z?.used ?? 0
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`span`, {
                children: `Reconciliation Net`
              }), (0, V.jsx)(`b`, {
                children: z?.adjustments ?? 0
              })]
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`span`, {
                children: `Remaining`
              }), (0, V.jsx)(`b`, {
                className: be < 0 ? `late` : ``,
                children: be
              })]
            })]
          }), (0, V.jsxs)(`div`, {
            className: `recon-equation`,
            children: [z?.regular ?? 0, ` regular + `, z?.rollover ?? 0, ` rollover − `, z?.borrowedByPrior ?? 0, ` previously borrowed − `, z?.used ?? 0, ` used + `, z?.adjustments ?? 0, ` reconciliation = `, (0, V.jsxs)(`b`, {
              className: be < 0 ? `late` : ``,
              children: [be, ` remaining`]
            })]
          })]
        })]
      }), z?.unlimited ? (0, V.jsx)(G, {
        children: `This parent is UNLIMITED. Delivered usage is tracked, but no finite-balance reconciliation applies.`
      }) : (0, V.jsxs)(`div`, {
        className: `reconciliation-grid`,
        children: [(0, V.jsxs)(`section`, {
          className: `panel reconciliation-actions-panel`,
          children: [(0, V.jsx)(`div`, {
            className: `panel-heading`,
            children: (0, V.jsxs)(`div`, {
              children: [(0, V.jsxs)(`h2`, {
                children: [`Choose Reconciliation Action `, (0, V.jsx)(H, {
                  text: `Each action creates a permanent parent-account ledger entry.`
                })]
              }), (0, V.jsx)(`p`, {
                children: `The action applies to the selected parent Client / Agency above.`
              })]
            })
          }), (0, V.jsx)(`div`, {
            className: `reconciliation-palette`,
            children: Kt.map(e => (0, V.jsxs)(`button`, {
              type: `button`,
              className: E.action === e.value ? `active` : ``,
              onClick: () => ke(e.value),
              children: [(0, V.jsxs)(`strong`, {
                children: [e.symbol, ` `, e.label]
              }), (0, V.jsx)(`span`, {
                children: e.description
              })]
            }, e.value))
          }), (0, V.jsxs)(`div`, {
            className: `reconciliation-help`,
            children: [(0, V.jsx)(`b`, {
              children: ye.label
            }), (0, V.jsx)(`span`, {
              children: ye.help
            })]
          })]
        }), (0, V.jsxs)(`section`, {
          className: `panel reconciliation-form-panel`,
          children: [(0, V.jsx)(`div`, {
            className: `panel-heading`,
            children: (0, V.jsxs)(`div`, {
              children: [(0, V.jsxs)(`h2`, {
                children: [`Record `, ye.label]
              }), (0, V.jsx)(`p`, {
                children: `Current-month closeout entry for one parent account.`
              })]
            })
          }), (0, V.jsxs)(`div`, {
            className: `reconciliation-target`,
            children: [(0, V.jsxs)(`b`, {
              children: [`Applies to `, Vt(a), `.`]
            }), ` A future-month effect occurs only where shown below.`]
          }), E.action === `DONATE` ? (0, V.jsxs)(`div`, {
            className: `donation-fields show`,
            children: [(0, V.jsxs)(`div`, {
              className: `donation-banner`,
              children: [(0, V.jsxs)(`div`, {
                children: [(0, V.jsx)(`b`, {
                  children: `Current-Month Point Donation`
                }), (0, V.jsx)(`span`, {
                  children: `Move unused points from one parent account to another while closing this month.`
                })]
              }), (0, V.jsx)(`span`, {
                className: `pill good-pill`,
                children: Vt(a).toUpperCase()
              })]
            }), (0, V.jsxs)(`div`, {
              className: `donation-flow`,
              children: [(0, V.jsxs)(`div`, {
                className: `donation-account`,
                children: [(0, V.jsx)(`small`, {
                  children: `DONOR PARENT ACCOUNT`
                }), (0, V.jsxs)(`select`, {
                  value: E.donorAccountId,
                  onChange: e => D(t => ({
                    ...t,
                    donorAccountId: e.target.value
                  })),
                  children: [(0, V.jsx)(`option`, {
                    value: ``,
                    children: `Choose donor…`
                  }), (s?.accounts || []).filter(e => !e.unlimited && (e.remaining ?? 0) > 0 && e.id !== E.targetAccountId).map(e => (0, V.jsxs)(`option`, {
                    value: e.id,
                    children: [e.name, ` — `, e.remaining, ` available`]
                  }, e.id))]
                }), (0, V.jsxs)(`div`, {
                  className: `donation-balance`,
                  children: [(0, V.jsxs)(`div`, {
                    children: [(0, V.jsx)(`small`, {
                      children: `Available to donate`
                    }), (0, V.jsx)(`b`, {
                      className: `good-text`,
                      children: xe?.remaining ?? 0
                    })]
                  }), (0, V.jsxs)(`span`, {
                    children: [`points remaining`, (0, V.jsx)(`br`, {}), `this month`]
                  })]
                })]
              }), (0, V.jsx)(`div`, {
                className: `donation-arrow`,
                children: `→`
              }), (0, V.jsxs)(`div`, {
                className: `donation-account`,
                children: [(0, V.jsx)(`small`, {
                  children: `RECIPIENT PARENT ACCOUNT`
                }), (0, V.jsxs)(`select`, {
                  value: E.targetAccountId,
                  onChange: e => D(t => ({
                    ...t,
                    targetAccountId: e.target.value
                  })),
                  children: [(0, V.jsx)(`option`, {
                    value: ``,
                    children: `Choose recipient…`
                  }), l.filter(e => !e.unlimited && e.id !== E.donorAccountId).map(e => (0, V.jsxs)(`option`, {
                    value: e.id,
                    children: [e.name, ` — `, s?.accounts.find(t => t.id === e.id)?.remaining ?? 0, ` remaining`]
                  }, e.id))]
                }), (0, V.jsxs)(`div`, {
                  className: `donation-balance`,
                  children: [(0, V.jsxs)(`div`, {
                    children: [(0, V.jsx)(`small`, {
                      children: `Current balance`
                    }), (0, V.jsx)(`b`, {
                      className: (Ce?.remaining ?? 0) <= 0 ? `late` : `good-text`,
                      children: Ce?.remaining ?? 0
                    })]
                  }), (0, V.jsxs)(`span`, {
                    children: [(Ce?.remaining ?? 0) < 0 ? `over allocation` : Ce?.remaining === 0 ? `exhausted` : `can receive`, (0, V.jsx)(`br`, {}), `this month`]
                  })]
                })]
              })]
            }), (0, V.jsxs)(`div`, {
              className: `donation-entry`,
              children: [(0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsx)(`span`, {
                  children: `Points to Donate`
                }), (0, V.jsx)(U, {
                  value: E.points,
                  onChange: e => D(t => ({
                    ...t,
                    points: e
                  }))
                })]
              }), (0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsx)(`span`, {
                  children: `Reason / Note`
                }), (0, V.jsx)(`input`, {
                  value: E.reason,
                  onChange: e => D(t => ({
                    ...t,
                    reason: e.target.value
                  }))
                })]
              })]
            }), (0, V.jsxs)(`div`, {
              className: `donation-preview`,
              children: [(0, V.jsxs)(`div`, {
                children: [(0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: xe?.name || `Donor`
                  }), ` after donation`]
                }), (0, V.jsxs)(`strong`, {
                  children: [Number(((xe?.remaining || 0) - E.points).toFixed(1)), ` pts`]
                })]
              }), (0, V.jsxs)(`div`, {
                children: [(0, V.jsxs)(`span`, {
                  children: [(0, V.jsx)(`b`, {
                    children: Ce?.name || `Recipient`
                  }), ` after donation`]
                }), (0, V.jsxs)(`strong`, {
                  children: [Number(((Ce?.remaining || 0) + E.points).toFixed(1)), ` pts`]
                })]
              }), (0, V.jsxs)(`small`, {
                children: [`Two linked `, Vt(a), ` ledger entries will be created: Donation Out and Donation In.`]
              })]
            })]
          }) : (0, V.jsxs)(`div`, {
            className: `form-grid`,
            children: [(0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Parent Client / Agency`
              }), (0, V.jsx)(`select`, {
                value: w,
                onChange: e => T(e.target.value),
                children: l.filter(e => !e.unlimited).map(e => (0, V.jsx)(`option`, {
                  value: e.id,
                  children: e.name
                }, e.id))
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Points`
              }), (0, V.jsx)(U, {
                value: E.points,
                onChange: e => D(t => ({
                  ...t,
                  points: e
                }))
              })]
            }), E.action === `BONUS` && (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Apply To`
              }), (0, V.jsxs)(`select`, {
                value: E.targetMonth,
                onChange: e => D(t => ({
                  ...t,
                  targetMonth: e.target.value
                })),
                children: [(0, V.jsxs)(`option`, {
                  value: a,
                  children: [Vt(a), ` — current month`]
                }), (0, V.jsxs)(`option`, {
                  value: me,
                  children: [Vt(me), ` — explicit future month`]
                })]
              })]
            }), E.action === `USE_PREPAID` && (0,V.jsx)(ReservePackageField,{packages:z?.reservePackages||[],value:E.reservePackageId,onChange:value=>D(old=>({...old,reservePackageId:value}))}), E.action === `BORROW` && (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Borrow From`
              }), (0, V.jsx)(`input`, {
                value: Vt(me),
                readOnly: !0
              })]
            }), E.action === `MANUAL_CORRECTION` && (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Direction`
              }), (0, V.jsxs)(`select`, {
                value: E.direction,
                onChange: e => D(t => ({
                  ...t,
                  direction: e.target.value
                })),
                children: [(0, V.jsx)(`option`, {
                  value: `ADD`,
                  children: `Add Points`
                }), (0, V.jsx)(`option`, {
                  value: `REMOVE`,
                  children: `Remove Points`
                })]
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field full`,
              children: [(0, V.jsx)(`span`, {
                children: `Reason / Note`
              }), (0, V.jsx)(`input`, {
                value: E.reason,
                onChange: e => D(t => ({
                  ...t,
                  reason: e.target.value
                }))
              })]
            })]
          }), E.action === `BORROW` && (0, V.jsxs)(`div`, {
            className: `reconciliation-check`,
            children: [(0, V.jsx)(`b`, {
              children: `Borrow check:`
            }), ` The normal R&B guideline is 20% of next month's regular allocation (`, Math.round((z?.regular || 0) * .2 * 10) / 10, ` points). A larger borrow is allowed but flagged.`]
          }), (0,V.jsx)(ReserveBank,{account:z}), E.action === `USE_PREPAID` && (0,V.jsx)(`p`,{children:`Apply up to ${Math.max(0,-be)} points to this month’s deficit. This is a transfer from the reserve, not a new point purchase.`}), E.action === `BILL_OVERAGE` && (0, V.jsxs)(`div`, {
            className: `reconciliation-check`,
            children: [(0, V.jsx)(`b`, {
              children: `Bill / Overage check:`
            }), ` The amount must be a positive half-point increment and cannot exceed the current `, Math.max(0, Math.abs(Math.min(0, be))), `-point deficit.`]
          }), (0, V.jsxs)(`div`, {
            className: `reconciliation-preview`,
            children: [(0, V.jsx)(`span`, {
              children: `Preview`
            }), (0, V.jsx)(`b`, {
              children: Ee
            }), (0, V.jsxs)(`small`, {
              children: [`Selected parent balance: `, be, ` → `, Te ?? `UNLIMITED`]
            })]
          }), (0, V.jsxs)(`button`, {
            className: `button primary reconciliation-submit`,
            disabled: v || !w || E.action === `DONATE` && (!E.donorAccountId || !E.targetAccountId),
            onClick: () => void Ae(),
            children: [v && (0, V.jsx)(de, {
              className: `spin`,
              size: 15
            }), `Record `, ye.label]
          })]
        })]
      }), (0, V.jsxs)(`section`, {
        className: `panel`,
        children: [(0, V.jsxs)(`div`, {
          className: `panel-heading`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`h2`, {
              children: [`Current Reconciliation Decision List — `, Vt(a)]
            }), (0, V.jsx)(`p`, {
              children: `Updates immediately after every recorded parent decision.`
            })]
          }), g ? (0, V.jsx)(`span`, {
            className: `pill`,
            children: `ARCHIVED`
          }) : (0, V.jsx)(`button`, {
            className: `button primary`,
            onClick: () => void Me(),
            children: `Archive to Reconciliation History`
          })]
        }), (0, V.jsx)(Gt, {
          decisions: p,
          emptyText: `No manual decisions have been posted for this month.`
        })]
      })]
    }), t === `history` && (0, V.jsxs)(V.Fragment, {
      children: [(0, V.jsx)(`div`, {
        className: `report-toolbar dts-toolbar`,
        children: (0, V.jsxs)(`label`, {
          children: [`Year `, (0, V.jsx)(`input`, {
            type: `number`,
            min: `2000`,
            max: `2200`,
            value: oe,
            onChange: e => se(Number(e.target.value))
          })]
        })
      }), (0, V.jsxs)(`section`, {
        className: `panel`,
        children: [(0, V.jsx)(`div`, {
          className: `panel-heading`,
          children: (0, V.jsxs)(`div`, {
            children: [(0, V.jsx)(`h2`, {
              children: `Reconciliation History`
            }), (0, V.jsx)(`p`, {
              children: `Permanent month-end snapshots; later corrections are append-only.`
            })]
          })
        }), ce.length ? (0, V.jsx)(`div`, {
          className: `history-card-grid`,
          children: ce.map(e => (0, V.jsxs)(`button`, {
            className: `history-card`,
            onClick: () => void Pe(e.month),
            children: [(0, V.jsx)(`b`, {
              children: Vt(e.month)
            }), (0, V.jsxs)(`span`, {
              children: [e.decisionCount, ` decisions`]
            }), (0, V.jsxs)(`small`, {
              children: [`Archived `, rt(e.archivedAt), ` by `, e.archivedBy]
            })]
          }, e.id))
        }) : (0, V.jsx)(mt, {
          title: `No archived months`,
          body: `No Reconciliation History snapshots exist for ${oe}.`
        })]
      })]
    }), (t === `packages` || t.startsWith(`package-`)) && (0, V.jsxs)(V.Fragment, {
      children: [(0, V.jsxs)(`div`, {
        className: `dts-admin-banner`,
        children: [(0, V.jsx)(`b`, {
          children: `ADMIN ONLY.`
        }), ` DTS package/account management is restricted to Administrator-role users.`]
      }), j === `menu` ? (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsxs)(`div`, {
          className: `package-section-heading`,
          children: [(0, V.jsxs)(`div`, {
            children: [(0, V.jsxs)(`h2`, {
              children: [`Packages `, (0, V.jsx)(`span`, {
                className: `pill danger`,
                children: `ADMIN ONLY`
              })]
            }), (0, V.jsx)(`p`, {
              children: `Choose the kind of client/package you want to review or manage.`
            })]
          }), (0, V.jsx)(`button`, {
            className: `button primary`,
            onClick: () => ie(!0),
            children: `+ Add Package / Account`
          })]
        }), (0, V.jsxs)(`div`, {
          className: `package-menu-grid`,
          id: `package-options`,
          tabIndex: -1,
          children: [(0, V.jsxs)(`article`, {
            className: `package-type-card`,
            children: [(0, V.jsx)(`span`, {
              className: `pill muted-pill`,
              children: `ONE OFF`
            }), (0, V.jsx)(`h3`, {
              children: `One Off`
            }), (0, V.jsx)(`p`, {
              children: `Non-recurring client work and individual projects. Keep these separate from prepaid balances and monthly retainer allocations.`
            }), (0, V.jsx)(`button`, {
              className: `button primary`,
              onClick: () => r(`package-oneoff`),
              children: `Open One Off →`
            })]
          }), (0, V.jsxs)(`article`, {
            className: `package-type-card`,
            children: [(0, V.jsx)(`span`, {
              className: `pill good-pill`,
              children: `PREPAID`
            }), (0, V.jsx)(`h3`, {
              children: `Prepaid`
            }), (0, V.jsx)(`p`, {
              children: `A pool of purchased points available for up to one year, with the approved renewal and blended-balance behavior.`
            }), (0, V.jsx)(`button`, {
              className: `button primary`,
              onClick: () => r(`package-prepaid`),
              children: `Open Prepaid →`
            })]
          }), (0, V.jsxs)(`article`, {
            className: `package-type-card`,
            children: [(0, V.jsx)(`span`, {
              className: `pill`,
              children: `RETAINER`
            }), (0, V.jsx)(`h3`, {
              children: `Retainer`
            }), (0, V.jsx)(`p`, {
              children: `Recurring monthly client point allocations, including regular points, rollover and borrow rules, usage, and overages.`
            }), (0, V.jsx)(`button`, {
              className: `button primary`,
              onClick: () => r(`package-retainer`),
              children: `Open Retainers →`
            })]
          })]
        })]
      }) : (0, V.jsx)(Yt, {
        section: j,
        packages: d,
        usage: s,
        onBack: () => r(`packages`),
        onAdd: () => Fe(j)
      })]
    }), t === `opening` && (0, V.jsxs)(`section`, {
      className: `panel opening-state-panel`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsxs)(`h2`, {
            children: [`Opening Account State `, (0, V.jsx)(H, {
              text: `Enter one opening state for the parent Client / Agency. Before archive, correct a saved state here with a reason. After archive, use an append-only Manual Correction.`
            })]
          }), (0, V.jsx)(`p`, {
            children: `One-time migration starting totals at the parent level. Open assignments remain in production and post on Master Delivery.`
          })]
        }), (0, V.jsx)(ue, {
          size: 20
        })]
      }), (0, V.jsxs)(G, {
        children: [(0, V.jsx)(`b`, {
          children: `Parent only.`
        }), ` Choose the Client / Agency once and enter its combined opening usage. There is no station usage entry on this screen.`]
      }), R?.state && !R.archived && (0, V.jsxs)(`div`, {
        className: `opening-edit-banner`,
        children: [(0, V.jsx)(`b`, {
          children: `Saved Starting State — corrections are allowed`
        }), (0, V.jsx)(`span`, {
          children: `Change the incorrect value below, enter why it is being corrected, then save. Every correction remains in Revision History.`
        })]
      }), R?.archived && (0, V.jsxs)(`div`, {
        className: `opening-archived-banner`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`b`, {
            children: `This month is already in Reconciliation History`
          }), (0, V.jsx)(`span`, {
            children: `The original Starting State stays permanent. Correct the balance with an append-only Manual Correction.`
          })]
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          type: `button`,
          onClick: ze,
          children: `Open Manual Correction`
        })]
      }), (0, V.jsxs)(`div`, {
        className: `form-grid`,
        children: [(0, V.jsxs)(`label`, {
          className: `field full`,
          children: [(0, V.jsx)(`span`, {
            children: `Parent Client / Agency`
          }), (0, V.jsxs)(`select`, {
            value: I.accountId,
            onChange: e => L(t => ({
              ...t,
              accountId: e.target.value
            })),
            children: [(0, V.jsx)(`option`, {
              value: ``,
              children: `Choose…`
            }), l.map(e => (0, V.jsx)(`option`, {
              value: e.id,
              children: e.name
            }, e.id))]
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Regular allocation`
          }), (0, V.jsx)(U, {
            value: I.regularAllocation,
            disabled: !!R?.archived,
            onChange: e => L(t => ({
              ...t,
              regularAllocation: e
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Rollover`
          }), (0, V.jsx)(U, {
            value: I.rolloverPoints,
            disabled: !!R?.archived,
            onChange: e => L(t => ({
              ...t,
              rolloverPoints: e
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Borrowed reduction`
          }), (0, V.jsx)(U, {
            value: I.borrowedReduction,
            disabled: !!R?.archived,
            onChange: e => L(t => ({
              ...t,
              borrowedReduction: e
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Combined usage already incurred`
          }), (0, V.jsx)(U, {
            value: I.usageAlreadyIncurred,
            disabled: !!R?.archived,
            onChange: e => L(t => ({
              ...t,
              usageAlreadyIncurred: e
            }))
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field full`,
          children: [(0, V.jsx)(`span`, {
            children: `Notes`
          }), (0, V.jsx)(`textarea`, {
            value: I.notes,
            disabled: !!R?.archived,
            onChange: e => L(t => ({
              ...t,
              notes: e.target.value
            }))
          })]
        }), R?.state && !R.archived && (0, V.jsxs)(`label`, {
          className: `field full correction-reason`,
          children: [(0, V.jsx)(`span`, {
            children: `Correction reason (required)`
          }), (0, V.jsx)(`input`, {
            value: I.changeReason,
            placeholder: `What was wrong, and what are you correcting?`,
            onChange: e => L(t => ({
              ...t,
              changeReason: e.target.value
            }))
          })]
        })]
      }), (0, V.jsxs)(`div`, {
        className: `opening-preview`,
        children: [(0, V.jsx)(`b`, {
          children: `Calculated opening remaining`
        }), (0, V.jsx)(`strong`, {
          children: I.regularAllocation + I.rolloverPoints - I.borrowedReduction - I.usageAlreadyIncurred
        })]
      }), !R?.archived && (0, V.jsx)(`button`, {
        className: `button primary`,
        onClick: () => void Re(),
        disabled: !I.accountId || v || !!(R?.state && !I.changeReason.trim()),
        children: R?.state ? `Save Starting-State Correction` : `Save Parent Starting State`
      }), R?.revisions?.length > 0 && (0, V.jsxs)(`details`, {
        className: `workload-details`,
        children: [(0, V.jsxs)(`summary`, {
          children: [`Revision history (`, R.revisions.length, `)`]
        }), R.revisions.map(e => (0, V.jsxs)(`p`, {
          children: [(0, V.jsx)(`b`, {
            children: e.changeKind
          }), ` · `, e.changedBy, ` · `, rt(e.changedAt), ` · `, e.reason]
        }, e.id))]
      })]
    }), (0, V.jsx)(ft, {
      open: ne,
      onClose: () => A(!1),
      title: `New ${N.packageType === `ONE_OFF` ? `One Off` : N.packageType === `PREPAID` ? `Prepaid Package` : `Retainer`}`,
      wide: !0,
      footer: (0, V.jsxs)(V.Fragment, {
        children: [(0, V.jsx)(`button`, {
          className: `button secondary`,
          onClick: () => A(!1),
          children: `Cancel`
        }), (0, V.jsx)(`button`, {
          className: `button primary`,
          onClick: () => void Ie(),
          disabled: v,
          children: N.packageType === `ONE_OFF` ? `Create One Off` : N.packageType === `PREPAID` ? `Create Prepaid Package` : `Create Retainer`
        })]
      }),
      children: (0, V.jsxs)(`div`, {
        className: `view-stack`,
        children: [(0, V.jsxs)(`div`, {
          className: `package-client-tabs`,
          children: [(0, V.jsx)(`button`, {
            type: `button`,
            className: N.clientMode === `existing` ? `active` : ``,
            onClick: () => F(e => ({
              ...e,
              clientMode: `existing`
            })),
            children: `Existing Client`
          }), (0, V.jsx)(`button`, {
            type: `button`,
            className: N.clientMode === `new` ? `active` : ``,
            onClick: () => F(e => ({
              ...e,
              clientMode: `new`
            })),
            children: `New Client`
          })]
        }), (0, V.jsx)(`section`, {
          className: `package-form-card`,
          children: N.clientMode === `existing` ? (0, V.jsxs)(V.Fragment, {
            children: [(0, V.jsx)(`b`, {
              children: `Use an existing client`
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Parent Client / Agency`
              }), (0, V.jsxs)(`select`, {
                value: N.clientAccountId,
                onChange: e => F(t => ({
                  ...t,
                  clientAccountId: e.target.value
                })),
                children: [(0, V.jsx)(`option`, {
                  value: ``,
                  children: `Choose Client / Agency…`
                }), l.map(e => (0, V.jsx)(`option`, {
                  value: e.id,
                  children: e.name
                }, e.id))]
              })]
            })]
          }) : (0, V.jsxs)(V.Fragment, {
            children: [(0, V.jsx)(`b`, {
              children: `Create a new client`
            }), (0, V.jsxs)(`div`, {
              className: `form-grid`,
              children: [(0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsx)(`span`, {
                  children: `Client / Agency Name`
                }), (0, V.jsx)(`input`, {
                  value: N.newClientAgencyName,
                  onChange: e => F(t => ({
                    ...t,
                    newClientAgencyName: e.target.value
                  }))
                })]
              }), (0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsx)(`span`, {
                  children: `Station / Client Name`
                }), (0, V.jsx)(`input`, {
                  value: N.newStationClientName,
                  onChange: e => F(t => ({
                    ...t,
                    newStationClientName: e.target.value
                  }))
                })]
              })]
            }), (0, V.jsx)(`small`, {
              children: `Call letters / short code will be generated automatically and can be changed later in Clients.`
            })]
          })
        }), N.packageType === `ONE_OFF` && (0, V.jsxs)(`section`, {
          className: `package-form-card`,
          children: [(0, V.jsx)(`b`, {
            children: `One Off Details`
          }), (0, V.jsxs)(`div`, {
            className: `form-grid`,
            children: [(0, V.jsxs)(`label`, {
              className: `field full`,
              children: [(0, V.jsx)(`span`, {
                children: `Project / Order`
              }), (0, V.jsx)(`input`, {
                value: N.name,
                onChange: e => F(t => ({
                  ...t,
                  name: e.target.value
                }))
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Date`
              }), (0, V.jsx)(`input`, {
                type: `date`,
                value: N.purchaseDate,
                onChange: e => F(t => ({
                  ...t,
                  purchaseDate: e.target.value
                }))
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Points`
              }), (0, V.jsx)(U, {
                value: N.regularPoints,
                onChange: e => F(t => ({
                  ...t,
                  regularPoints: e
                }))
              })]
            })]
          })]
        }), N.packageType === `PREPAID` && (0, V.jsxs)(V.Fragment, {
          children: [(0, V.jsxs)(`section`, {
            className: `package-form-card`,
            children: [(0, V.jsx)(`b`, {
              children: `Package Details`
            }), (0, V.jsxs)(`div`, {
              className: `form-grid`,
              children: [(0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsx)(`span`, {
                  children: `Package Points`
                }), (0, V.jsx)(U, {
                  value: N.regularPoints,
                  onChange: e => F(t => ({
                    ...t,
                    regularPoints: e
                  }))
                })]
              }), (0, V.jsxs)(`label`, {
                className: `field`,
                children: [(0, V.jsx)(`span`, {
                  children: `Purchase Date`
                }), (0, V.jsx)(`input`, {
                  type: `date`,
                  value: N.purchaseDate,
                  onChange: e => F(t => ({
                    ...t,
                    purchaseDate: e.target.value
                  }))
                })]
              }), (0, V.jsxs)(`label`, {
                className: `field full`,
                children: [(0, V.jsx)(`span`, {
                  children: `Expiration`
                }), (0, V.jsxs)(`div`, {
                  className: `package-calculation`,
                  children: [`One year from purchase date · `, Ut(N.purchaseDate ? `${Number(N.purchaseDate.slice(0, 4)) + 1}${N.purchaseDate.slice(4)}` : null)]
                })]
              })]
            })]
          }), (0, V.jsx)(G, {
            children: `Choose an existing Client / Agency to add points. For retainer clients this creates a separate prepaid reserve package; monthly allowance and R&B stay unchanged. For prepaid clients the new purchase adds to their existing bank and renews its expiration.`
          })]
        }), N.packageType === `RETAINER` && (0, V.jsxs)(`section`, {
          className: `package-form-card`,
          children: [(0, V.jsx)(`b`, {
            children: `Retainer Details`
          }), (0, V.jsx)(`p`, {
            children: `Choose a normal monthly point allowance or make the parent client UNLIMITED.`
          }), (0, V.jsxs)(`div`, {
            className: `retainer-allowance-choice`,
            children: [(0, V.jsxs)(`button`, {
              type: `button`,
              className: N.unlimited ? `` : `active`,
              onClick: () => F(e => ({
                ...e,
                unlimited: !1
              })),
              children: [(0, V.jsx)(`b`, {
                children: `Monthly Points`
              }), (0, V.jsx)(`span`, {
                children: `Use a defined monthly point allowance.`
              })]
            }), (0, V.jsxs)(`button`, {
              type: `button`,
              className: N.unlimited ? `active` : ``,
              onClick: () => F(e => ({
                ...e,
                unlimited: !0,
                rnbEnabled: !1
              })),
              children: [(0, V.jsx)(`b`, {
                children: `UNLIMITED`
              }), (0, V.jsx)(`span`, {
                children: `Track usage with no finite monthly balance.`
              })]
            })]
          }), N.unlimited ? (0, V.jsx)(G, {
            children: `Usage is still counted and reported, but there is no finite balance, depletion warning, rollover, or borrowing requirement.`
          }) : (0, V.jsxs)(`div`, {
            className: `form-grid`,
            children: [(0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Monthly Points`
              }), (0, V.jsx)(U, {
                value: N.regularPoints,
                onChange: e => F(t => ({
                  ...t,
                  regularPoints: e
                }))
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Rollover & Borrow`
              }), (0, V.jsxs)(`select`, {
                value: N.rnbEnabled ? `enabled` : `no`,
                onChange: e => F(t => ({
                  ...t,
                  rnbEnabled: e.target.value === `enabled`
                })),
                children: [(0, V.jsx)(`option`, {
                  value: `no`,
                  children: `No`
                }), (0, V.jsx)(`option`, {
                  value: `enabled`,
                  children: `Enabled`
                })]
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `Start Date`
              }), (0, V.jsx)(`input`, {
                type: `date`,
                value: N.startDate,
                onChange: e => F(t => ({
                  ...t,
                  startDate: e.target.value
                }))
              })]
            }), (0, V.jsxs)(`label`, {
              className: `field`,
              children: [(0, V.jsx)(`span`, {
                children: `End Date`
              }), (0, V.jsx)(`input`, {
                type: `date`,
                value: N.endDate,
                onChange: e => F(t => ({
                  ...t,
                  endDate: e.target.value
                }))
              })]
            })]
          })]
        })]
      })
    }), (0, V.jsx)(ft, {
      open: re,
      onClose: () => ie(!1),
      title: `Add Package / Account`,
      subtitle: `Choose the package type to create.`,
      children: (0, V.jsxs)(`div`, {
        className: `package-menu-grid package-chooser-grid`,
        children: [(0, V.jsxs)(`button`, {
          className: `package-type-card package-type-choice`,
          type: `button`,
          onClick: () => Fe(`ONE_OFF`),
          children: [(0, V.jsx)(`span`, {
            className: `pill muted-pill`,
            children: `ONE OFF`
          }), (0, V.jsx)(`b`, {
            children: `New One Off`
          }), (0, V.jsx)(`small`, {
            children: `Non-recurring client work or an individual project.`
          })]
        }), (0, V.jsxs)(`button`, {
          className: `package-type-card package-type-choice`,
          type: `button`,
          onClick: () => Fe(`PREPAID`),
          children: [(0, V.jsx)(`span`, {
            className: `pill good-pill`,
            children: `PREPAID`
          }), (0, V.jsx)(`b`, {
            children: `New Prepaid Package`
          }), (0, V.jsx)(`small`, {
            children: `Purchased points with a one-year expiration.`
          })]
        }), (0, V.jsxs)(`button`, {
          className: `package-type-card package-type-choice`,
          type: `button`,
          onClick: () => Fe(`RETAINER`),
          children: [(0, V.jsx)(`span`, {
            className: `pill`,
            children: `RETAINER`
          }), (0, V.jsx)(`b`, {
            children: `New Retainer`
          }), (0, V.jsx)(`small`, {
            children: `Monthly points or unlimited service.`
          })]
        })]
      })
    }), (0, V.jsx)(ft, {
      open: !!ee,
      onClose: () => te(null),
      title: ee ? `Point Account — ${ee.account.name}` : `Point Account`,
      wide: !0,
      children: ee && (0, V.jsxs)(`div`, {
        className: `view-stack`,
        children: [(0, V.jsxs)(`div`, {
          className: `metric-grid four`,
          children: [(0, V.jsx)(W, {
            label: `Starting`,
            value: Ht(ee.current?.unlimited ? null : ee.current?.startingAvailable ?? 0)
          }), (0, V.jsx)(W, {
            label: `Used`,
            value: ee.current?.used ?? 0
          }), (0, V.jsx)(W, {
            label: `In Production`,
            value: ee.current?.inProduction ?? 0,
            tone: `warning`
          }), (0, V.jsx)(W, {
            label: `Total points in bank`,
            value: Ht(ee.current?.pointsInBank ?? ee.current?.remaining ?? null)
          })]
        }), (0,V.jsx)(ReserveBank,{account:ee.current}), (0, V.jsx)(`div`, {
          className: `table-scroll`,
          children: (0, V.jsxs)(`table`, {
            children: [(0, V.jsx)(`thead`, {
              children: (0, V.jsxs)(`tr`, {
                children: [(0, V.jsx)(`th`, {
                  children: `Month`
                }), (0, V.jsx)(`th`, {
                  children: `Date`
                }), (0, V.jsx)(`th`, {
                  children: `Event`
                }), (0, V.jsx)(`th`, {
                  children: `Station`
                }), (0, V.jsx)(`th`, {
                  children: `Points`
                }), (0, V.jsx)(`th`, {
                  children: `Reason`
                }), (0, V.jsx)(`th`, {
                  children: `By`
                })]
              })
            }), (0, V.jsx)(`tbody`, {
              children: ee.ledger.map(e => (0, V.jsxs)(`tr`, {
                children: [(0, V.jsx)(`td`, {
                  children: String(e.month).slice(0, 7)
                }), (0, V.jsx)(`td`, {
                  children: rt(e.createdAt)
                }), (0, V.jsx)(`td`, {
                  children: e.eventType.replace(/_/g, ` `)
                }), (0, V.jsx)(`td`, {
                  children: e.station || `—`
                }), (0, V.jsxs)(`td`, {
                  children: [e.pointsDelta > 0 ? `+` : ``, e.pointsDelta]
                }), (0, V.jsx)(`td`, {
                  children: e.reason || `—`
                }), (0, V.jsx)(`td`, {
                  children: e.createdBy || `System`
                })]
              }, e.id))
            })]
          })
        })]
      })
    }), (0, V.jsx)(ft, {
      open: !!fe,
      onClose: () => pe(null),
      title: fe ? `Reconciliation History — ${Vt(fe.archive.month)}` : `Reconciliation History`,
      wide: !0,
      children: fe && (0, V.jsxs)(`div`, {
        className: `view-stack`,
        children: [(0, V.jsxs)(`a`, {
          className: `button secondary`,
          href: Ue(`/api/dts/reconciliation-history/${fe.archive.month}/pdf`),
          children: [(0, V.jsx)(P, {
            size: 15
          }), `Download History PDF`]
        }), (0, V.jsx)(`h3`, {
          children: `Permanent archived decisions`
        }), (0, V.jsx)(Gt, {
          decisions: fe.archive.snapshot?.decisions || [],
          emptyText: `No manual decisions were required.`
        }), (0, V.jsx)(`h3`, {
          children: `Post-archive corrections`
        }), (0, V.jsx)(Gt, {
          decisions: fe.postArchiveDecisions || [],
          emptyText: `No post-archive corrections.`
        })]
      })
    })]
  });
}
var Zt = [{
  id: `overview`,
  title: `What OAB + DTS Does`,
  audience: `ALL`,
  terms: `overview purpose online assignment board digital traffic system`,
  body: `DSV OAB + DTS is one internal application. OAB tracks assignments from creation through production, revision, delivery and archive. DTS tracks parent-client point entitlements, usage, reconciliation and billing support. Enter or change information once; every screen reads the same underlying record, while historical snapshots remain historical.`
}, {
  id: `roles`,
  title: `Roles & Permissions`,
  audience: `ALL`,
  terms: `producer administrator admin permissions security`,
  body: `Producer/User accounts perform authorized production work. Administrators also manage clients, producers, System functions and the entire DTS area. Hiding a menu is not the security boundary: Administrator-only server routes return 403 to Producer-role requests.`
}, {
  id: `dashboard`,
  title: `Dashboard`,
  audience: `ALL`,
  terms: `dashboard active sessions needs attention digest comments`,
  body: `The Dashboard is ordered Active Sessions first (with recent comments visible in the tiles), then Needs Attention, then Digest and workload. It is an operational snapshot, not a replacement for Active Assignments.`
}, {
  id: `active`,
  title: `Active Assignments`,
  audience: `ALL`,
  terms: `active board search filter auto refresh 30 seconds`,
  body: `Active Assignments shows live work with overdue work first, then urgency and due date. Search covers production title, client/station, producer snapshots, script/notes, comments, filenames/extracted attachment text and audit details. The board refreshes about every 30 seconds; it never replaces an open form with unsaved edits.`
}, {
  id: `assignment`,
  title: `Assignment Detail — One Home for the Job`,
  audience: `ALL`,
  terms: `assignment detail overview production activity`,
  body: `Assignment Detail is the permanent home for due dates, Master/Producer/UNASSIGNED/Revision Points, VO, notes, script, files/versions, comments, acknowledgments, producer completion/delivery, Master Delivery and audit history.`
}, {
  id: `rename-title`,
  title: `Rename Assignment / Production Title`,
  audience: `ALL`,
  terms: `rename title typo correction pencil duplicate warning client inference`,
  body: `Use the pencil beside the Assignment Drawer title to correct a Production Title without duplicating the job. Rename changes only the title, preserves the assigned Client / Agency and Station / Client, points, files, confidentiality, completion/delivery, revisions and history, and records old/new title in the immutable audit trail. A matching title produces a non-blocking advisory. Archived or cancelled work must be restored before renaming. A title-only rename sends no producer notification.`
}, {
  id: `new-assignment`,
  title: `New Assignment`,
  audience: `ALL`,
  terms: `new assignment point menu master points`,
  body: `Select the Station / Client (and therefore its parent Client / Agency), set the due date and production details, choose items from the official DSV Point Menu, allocate producer points, and save one assignment record.`
}, {
  id: `point-menu`,
  title: `Official DSV Point Menu`,
  audience: `ALL`,
  terms: `update sweeper shotgun promo mini jingle music hook beat mesh studio time rates`,
  body: `The locked v1.2 menu is: Update .5; Sweeper 2; Sweeper Revision 1; Rush Sweeper 3; Dry Produced Sweeper/Shotgun .5; Shotgun 1.5; Rush Shotgun 3; Jingle Mix 1.5; Promo 10; Rush Promo 15; Promo Revision 3; Extended Promo 15; Music Hook Sweeper 4; Beat Mesh Sweeper 4; Mini Promo 5; Rush Mini Promo 7.5; Studio Time 10 points/hour.`
}, {
  id: `studio-time`,
  title: `Studio Time Fractional Hours`,
  audience: `ALL`,
  terms: `studio time fractional 0.05 1.15 half point`,
  body: `Studio Time accepts 0.05-hour increments only. At 10 points/hour this always resolves to a half-point value: 1.15 hours = 11.5 points. Invalid quantities such as 1.12 are rejected rather than rounded.`
}, {
  id: `points`,
  title: `Master Points, Producer Points & UNASSIGNED`,
  audience: `ALL`,
  terms: `master producer unassigned reconcile points`,
  body: `Master Points are client-facing job value. Producer Points are individual allocations. Any remainder is explicitly UNASSIGNED. Active producer allocations plus UNASSIGNED must reconcile to Master Points; OAB never silently redistributes work. UNASSIGNED must be zero before Master Delivery.`
}, {
  id: `point-changes`,
  title: `Changing Points`,
  audience: `ALL`,
  terms: `point change reason keep complete reopen`,
  body: `Every meaningful point change requires a reason and creates immutable point-change/audit history. If a completed producer allocation changes, explicitly choose Keep Complete for an administrative correction or Reopen Producer when more work is required.`
}, {
  id: `revision-points`,
  title: `Revision Points`,
  audience: `ALL`,
  terms: `revision work points separate history activity`,
  body: `Reasonable revision effort is tracked as Revision Points and never increases client-facing Master Points. Restoring an archived job reopens only the affected producers. Assignment Activity displays Revision Work History with the recorded revision number, producer snapshot, points, reason and timestamp. Later producer edits do not rewrite that history.`
}, {
  id: `due`,
  title: `Original Due Date vs Current Due Date`,
  audience: `ALL`,
  terms: `due date original current client delay business day`,
  body: `Original Due Date is immutable. Current Due Date is the live deadline and may change only with a reason. Client Delay is identified separately so it does not penalize producer on-time reporting. Saturday, Sunday and configured DSV holidays/closures are non-working days. Operational timezone is America/New_York.`
}, {
  id: `hold`,
  title: `On Hold`,
  audience: `ALL`,
  terms: `hold pause overdue reminders resume`,
  body: `On Hold pauses overdue escalation and reminders without rewriting due dates. A hold requires a reason; Resume closes the hold period and records who resumed it and why.`
}, {
  id: `cancel`,
  title: `Cancelled Assignments`,
  audience: `ALL`,
  terms: `cancel cancelled restore history`,
  body: `Cancellation stops work but preserves the assignment, files and history. Cancelled work is excluded from normal productivity/on-time reporting and remains read-only until restored or duplicated.`
}, {
  id: `completion`,
  title: `Producer Complete / Sign Off`,
  audience: `ALL`,
  terms: `producer complete sign off points produced`,
  body: `Each producer signs off only their own production allocation unless an Administrator performs the action. Completion means the assigned production work is complete; it is not the same as delivery.`
}, {
  id: `producer-delivery`,
  title: `Producer Delivered`,
  audience: `ALL`,
  terms: `producer delivery delivered`,
  body: `Producer Delivered records that one producer's portion has been delivered/handled. Other producers may still be working. Producer Delivered does not archive the assignment.`
}, {
  id: `master-delivery`,
  title: `Master Delivery`,
  audience: `ALL`,
  terms: `master delivered archive gate canmasterdeliver accounting`,
  body: `Only Master Delivered closes and archives the assignment. It is blocked while On Hold/Cancelled, while UNASSIGNED is nonzero, when no allocation exists, or while any active positive-point allocation is incomplete. The initial Master Delivery posts Master Points to DTS exactly once in the selected Points month. An administrator can correct that month in the session Overview, with a reason and an audit trail.`
}, {
  id: `client-completion-email`,
  title: `Client Completion & DTS Point-Status Email`,
  audience: `ALL`,
  terms: `notify when completed station profile recipient override email unlimited rollover overage master delivery`,
  body: `Version 1.3.9.1 queues a branded client completion email after successful Master Delivery. Default recipients come from the Station / Client Profile's Notify When Completed field; an assignment can use custom recipients or suppress the notice. Finite accounts receive the post-delivery DTS status, including assignment points, monthly usage, rollover, remaining/in-production points and current overage. Unlimited accounts receive completion confirmation only and never receive a point report. CONE OF SILENCE uses only assignment-specific confidential contacts. Email failure never reverses Master Delivery or DTS posting.`
}, {
  id: `redelivery`,
  title: `Restore / Revision Redelivery & DTS`,
  audience: `ALL`,
  terms: `restore revision redelivery double charge master delivery event`,
  body: `Every Master Delivery is stored in append-only delivery-event history. Only the initial event posts Master Points to DTS and counts as the client-facing delivered session. Later delivery after Restore for Revision archives the job again without charging Master Points a second time.`
}, {
  id: `cos`,
  title: `CONE OF SILENCE`,
  audience: `ALL`,
  terms: `confidential cone silence contact confidential delivery manual`,
  body: `CONE OF SILENCE is an internal confidential-handling flag. OAB does not transmit finished audio, email it, or FTP/SFTP it. When enabled, at least one assignment-specific confidential contact with name and valid email is required on every save. Complete confidential delivery outside OAB using DSV's approved procedure, then use CONFIDENTIAL DELIVERY to record normal Master Delivery.`
}, {
  id: `confidential-delivery`,
  title: `CONFIDENTIAL DELIVERY`,
  audience: `ALL`,
  terms: `confidential delivery gate master`,
  body: `CONFIDENTIAL DELIVERY is a manual-delivery confirmation, not a file-transfer action. It uses the exact same Master Delivery gates as ordinary Master Delivery, writes Master Delivery/audit history, archives the assignment, and posts initial DTS usage only when applicable.`
}, {
  id: `comments`,
  title: `Comments, @Mentions & Important Comments`,
  audience: `ALL`,
  terms: `comments mentions important pinned acknowledge`,
  body: `Comments are append-only and cannot be edited or deleted. Important/Pinned Comments require acknowledgment only from producers assigned to that job. OAB records each assigned producer's acknowledgment and timestamp; non-assigned users may read the comment but have no acknowledgment obligation.`
}, {
  id: `files`,
  title: `Files & Version History`,
  audience: `ALL`,
  terms: `file upload attachment version`,
  body: `Replacing a file creates a new permanent attachment version; prior bytes are retained. Attachments remain tied to the assignment and searchable by filename or extracted text where supported.`
}, {
  id: `vo`,
  title: `VO Tracking`,
  audience: `ALL`,
  terms: `voice vo needed ordered received talent`,
  body: `VO is tracked independently of assignment status: Not Needed → Needed → Ordered → Received. Talent, ordered/expected/received dates and notes may be stored without changing the core assignment lifecycle.`
}, {
  id: `duplicate`,
  title: `Duplicate Assignment`,
  audience: `ALL`,
  terms: `duplicate copy attachments confidential cone silence`,
  body: `Duplicate copies appropriate editable production fields (title as edited, Master Points, producers/allocations, notes, priority, VO requirement and script). A CONE OF SILENCE source also copies its confidentiality flag and confidential contacts, so normal Master Delivery remains blocked on the duplicate. Due date, comments, audit, acknowledgment, completion/delivery and revision history do not copy. Attachments copy only when explicitly selected.`
}, {
  id: `concurrency`,
  title: `Concurrent Editing & Conflict Protection`,
  audience: `ALL`,
  terms: `live presence optimistic locking conflict refresh merge stale save`,
  body: `OAB shows who else is actively editing as an advisory live-presence notice. Optimistic record-version checks are the real safety rule. If another user saves first, a stale save is stopped rather than overwriting their work; refresh/review/merge is required. Board auto-refresh never replaces unsaved form edits.`
}, {
  id: `notifications`,
  title: `Notifications`,
  audience: `ALL`,
  terms: `email push new assignment points changed reassignment important comment html`,
  body: `Newly added producer = NEW ASSIGNMENT. Existing assigned allocation change = POINTS CHANGED. Producer removal/replacement = REASSIGNMENT. Important Comment and restored revisions have their own classifications. Email uses DSV-branded responsive HTML with plain-text fallback; push is optional. Rapid related edits consolidate where practical.`
}, {
  id: `mobile`,
  title: `Mobile / iPhone / PWA`,
  audience: `ALL`,
  terms: `mobile iphone ipad pwa bottom navigation responsive`,
  body: `Mobile uses the same database, API, workflow, permissions and business rules as desktop. It is a responsive interface rather than a separate app. Cards retain due/status/points/progress/actions; navigation and forms adapt for touch. On iPhone/iPad, push requires the HTTPS PWA installed to the Home Screen.`
}, {
  id: `clients`,
  title: `Client / Agency → Station / Client Hierarchy`,
  audience: `ALL`,
  terms: `client agency parent station child hierarchy`,
  body: `Points belong to the parent Client / Agency account and may be shared across child Station / Client records. Operational assignments reference the Station / Client while DTS aggregates usage at the parent. Existing legacy child UUIDs are preserved through migration; relationships are never guessed with fuzzy name matching.`
}, {
  id: `profiles`,
  title: `Client & Station Profiles`,
  audience: `ALL`,
  terms: `profile call letters positioning contact voice format audience sound`,
  body: `Profiles are living reference documents. Station / Client profiles can store call letters/name, positioning, normal contacts, voice talent/contact, format, audience, sound-use/avoid guidance, TV/film drop guidance, VO read preferences and other sound notes. Optional parent profiles are supported. CONE OF SILENCE contacts do not belong in profiles.`
}, {
  id: `producer-admin`,
  title: `Producer Administration`,
  audience: `ADMIN`,
  terms: `producer edit tile name email phone color active role notification workload eligible`,
  body: `Administrators can click/tap any Producer row/tile to edit the existing producer record: name, email, mobile, color, Active/Inactive, role, HTML email, push and Workload Eligible. OUTSOURCE remains a no-login resource. Server-side authorization protects producer mutations, and the last active Administrator cannot be accidentally demoted/deactivated. Historical producer snapshots are not rewritten.`
}, {
  id: `workload`,
  title: `Producer Workload Warning`,
  audience: `ALL`,
  terms: `workload average 50 percent eligible outsource ed`,
  body: `The warning is advisory and never blocks assignment. It compares a workload-eligible active human producer with the average of other workload-eligible active humans and warns around 50% above that peer average. OUTSOURCE and any producer with Workload Eligible turned off are excluded from the average but may still appear on the board.`
}, {
  id: `reports`,
  title: `OAB Reports`,
  audience: `ALL`,
  terms: `reports productivity client station revision late delivery vo`,
  body: `Reports include Producer Productivity, Client/Station activity, revisions, late assignments, delivery turnaround and VO turnaround. Producer productivity uses completed individual Producer Points; Revision Points remain separate; UNASSIGNED never counts as producer productivity.`
}, {
  id: `client-pdf`,
  title: `Client Production Activity PDF`,
  audience: `ALL`,
  terms: `client production pdf sessions date range master points`,
  body: `Choose Client / Agency and start/end dates. The PDF includes assignments whose initial Master Delivery falls in the range, counts each assignment once, totals Master Points only and identifies the Station / Client for each line. Revision redelivery never creates a second client-facing session or charge. Any legacy fallback delivery date is visibly flagged uncertain.`
}, {
  id: `dts-access`,
  title: `DTS Access`,
  audience: `ADMIN`,
  terms: `digital traffic system admin only 403`,
  body: `The entire Digital Traffic System area is Administrator-only: Dashboard, USAGE Stats & Reconciliation, Point Account drill-down, Packages and Opening Account State. Producer-triggered OAB Master Delivery can still post DTS usage internally without granting the Producer DTS access.`
}, {
  id: `usage`,
  title: `USAGE Stats & Reconciliation`,
  audience: `ADMIN`,
  terms: `usage reconciliation regular rollover borrow used remaining in production`,
  body: `USAGE is parent Client / Agency level. For finite retainers it shows Regular, Rollover, prior-month Borrow reduction, current Borrow credit, Used, In Production and Remaining. In Production is open Master Points assigned to the selected points month and is informational only until initial Master Delivery. Revision work is excluded from this pending client charge. Station-level delivered and pending production are shown beneath the parent balance.`
}, {
  id: `unlimited`,
  title: `UNLIMITED Accounts`,
  audience: `ADMIN`,
  terms: `unlimited summit media usage`,
  body: `UNLIMITED is a first-class parent account treatment. Actual delivered usage is still recorded and reportable, but no finite Remaining value, depletion percentage, low-balance warning, Rollover or Borrow applies.`
}, {
  id: `point-account`,
  title: `Point Account Drill-Down`,
  audience: `ADMIN`,
  terms: `point account ledger bank statement drill down`,
  body: `Click the Client / Agency in USAGE to open its Point Account. This is the permanent ledger/bank-statement view of every point credit/debit and linked reconciliation event. Point Account is a drill-down from USAGE rather than a separate top-level navigation area.`
}, {
  id: `reconciliation`,
  title: `Reconciliation Philosophy`,
  audience: `ADMIN`,
  terms: `month end close current month reconcile`,
  body: `Reconciliation exists to finish the selected current month correctly before close. Every action requires a reason and becomes a ledger entry. Current month is the default; future effects are explicit exceptions such as Borrow and an intentionally next-month Bonus.`
}, {
  id: `rnb`,
  title: `R&B — Rollover & Borrow`,
  audience: `ADMIN`,
  terms: `rollover borrow r&b 20 percent regular rollover borrowed`,
  body: `For R&B retainers, consumption order is Regular → Rollover → Borrowed Credit. Unused current-month regular points automatically roll into the immediately following month and must be used there. Borrow is explicit: current-month credit plus a debit to the immediately following month. The 20% guideline is flagged but not hard-blocked when an authorized reconciliation with reason exceeds it.`
}, {
  id: `donation`,
  title: `Donate / Transfer`,
  audience: `ADMIN`,
  terms: `donate transfer donor recipient current month`,
  body: `Donation moves unused current-month points from a donor to another exhausted finite account in the same month. The donor decreases and recipient increases immediately through linked ledger events that preserve both sides, user, timestamp and reason.`
}, {
  id: `bonus`,
  title: `Bonus / Courtesy`,
  audience: `ADMIN`,
  terms: `bonus courtesy current next month`,
  body: `Bonus/Courtesy defaults to the selected month. An explicit option may target only the immediately following month. The preview/ledger target must make the affected month unambiguous.`
}, {
  id: `bill-overage`,
  title: `Bill / Overage`,
  audience: `ADMIN`,
  terms: `bill overage quickbooks billing additional points`,
  body: `Bill / Overage is the explicit reconciliation action that identifies additional points to bill. A raw negative balance alone is not a billing instruction. Finalized Bill / Overage ledger events drive the Month-End Billing Reconciliation PDF used as a QuickBooks reference.`
}, {
  id: `month-end-pdf`,
  title: `Month-End Billing Reconciliation PDF`,
  audience: `ADMIN`,
  terms: `month end pdf reconciliation quickbooks stations overage billing points only`,
  body: `Generate this PDF from USAGE after the month is reconciled. OVERAGES TO BILL includes only finalized Bill / Overage ledger events, grouped by parent Client / Agency, with points, reason/reference and Station / Client delivered usage breakdown. A reconciliation-activity appendix supports billing review. Version 1.2 is deliberately points-only: rates, barter/custom terms and invoice totals require manual QuickBooks review.`
}, {
  id: `manual-correction`,
  title: `Refund / Reverse & Manual Correction`,
  audience: `ADMIN`,
  terms: `refund reverse manual correction add remove`,
  body: `Refund / Reverse posts a negative correction to reverse/return points. Manual Correction requires an explicit Add or Remove direction. Every entry requires a reason and remains visible in the point ledger.`
}, {
  id: `packages`,
  title: `Packages`,
  audience: `ADMIN`,
  terms: `package one off prepaid retainer`,
  body: `DTS supports One Off, Prepaid and Retainer packages. Package entitlement belongs to the parent Client / Agency. New package flows can use an existing parent or create a new parent plus its initial Station / Client in one transaction.`
}, {
  id: `prepaid`,
  title: `Prepaid Packages`,
  audience: `ADMIN`,
  terms: `prepaid 12 months expiration blend renew`,
  body: `Prepaid points form a flexible pool valid for one year from purchase. If a new prepaid package is purchased before the current one expires, remaining points stay in the pool and inherit the new one-year expiration while the new purchase adds its points. If no timely renewal occurs, remaining points expire and the expiration is recorded in the ledger.`
}, {
  id: `retainer`,
  title: `Retainer Packages`,
  audience: `ADMIN`,
  terms: `retainer monthly points extra unlimited rnb`,
  body: `Retainers supply a monthly regular allocation and can be numeric or UNLIMITED. Finite retainers may enable R&B. Extra point needs can be resolved through approved reconciliation without rewriting the underlying retainer contract/package.`
}, {
  id: `opening-state`,
  title: `Opening Account State / Migration`,
  audience: `ADMIN`,
  terms: `opening account state start state cutover migration usage already incurred`,
  body: `Use only for cutover initialization. Enter one combined Start State for the parent Client / Agency: regular allocation, rollover, prior-month borrow reduction, already-incurred settled usage, and notes. Do not enter startup usage for each station. Do not include assignments still open at cutover; they remain In Production and post normally on initial Master Delivery.`
}, {
  id: `system-health`,
  title: `System Health`,
  audience: `ADMIN`,
  terms: `system health database storage scheduler email push`,
  body: `System Health surfaces database status, NAS storage/free space, last backup, email/push configuration, scheduler heartbeat and database/file consistency so routine health checks do not require DSM access.`
}, {
  id: `backup`,
  title: `Full-System Backup & Restore Readiness`,
  audience: `ADMIN`,
  terms: `backup export restore zip postgres files versions csv synology`,
  body: `A full-system ZIP contains a PostgreSQL dump, all attachment versions, configuration/manifest data and human-readable CSV fallbacks. Backups should be copied away from the production volume and restore-tested periodically. Before upgrades, create/verify a fresh backup or Synology snapshot.`
}, {
  id: `synology`,
  title: `Synology Deployment`,
  audience: `ADMIN`,
  terms: `synology nas rs815 docker container manager install update`,
  body: `The v1.2 release ships a Synology-first deployment path with precompiled verified dist, Docker Compose, automatic append-only migrations, setup/update/smoke-test scripts and a Start Here guide. Jeff configures DSM reverse proxy/HTTPS/DNS, SMTP credentials and backup coverage; he should not need to edit application source or run SQL by hand.`
}, {
  id: `troubleshooting`,
  title: `Troubleshooting Quick Reference`,
  audience: `ALL`,
  terms: `troubleshooting cannot deliver conflict missing file notification`,
  body: `Cannot Master Deliver: check On Hold/Cancelled, UNASSIGNED, allocation reconciliation and producer completion. Save conflict: another user changed the record; review/refresh/merge rather than overwrite. Missing file: check System Health database/file consistency. Missing notification: check producer notification status/channel and outbox delivery logs.`
}];
function Qt({role: e, initialQuery: t = ``}) {
  let [n, r] = (0, h.useState)(t);
  (0, h.useEffect)(() => r(t), [t]);
  let i = (0, h.useMemo)(() => Zt.filter(t => (t.audience === `ALL` || t.audience === e) && (!n || `${t.title} ${t.terms} ${t.body}`.toLowerCase().includes(n.toLowerCase()))), [n, e]);
  return (0, V.jsxs)(`div`, {
    className: `view-stack`,
    children: [(0, V.jsxs)(`section`, {
      className: `panel manual-hero`,
      children: [(0, V.jsxs)(`div`, {
        className: `panel-heading`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h2`, {
            children: `DSV OAB + DTS Software Manual`
          }), (0, V.jsx)(`p`, {
            children: `Owners / Operators Manual · Version 1.2 · Searchable and versioned with the deployed application.`
          })]
        }), (0, V.jsx)(S, {
          size: 26
        })]
      }), (0, V.jsxs)(`div`, {
        className: `manual-search-row`,
        children: [(0, V.jsxs)(`label`, {
          className: `search-control manual-search`,
          children: [(0, V.jsx)(Ee, {
            size: 18
          }), (0, V.jsx)(`input`, {
            value: n,
            onChange: e => r(e.target.value),
            placeholder: `Search any screen, field, action, rule, report, or workflow…`,
            autoFocus: !!t
          })]
        }), n && (0, V.jsxs)(`button`, {
          className: `button tertiary`,
          onClick: () => r(``),
          children: [(0, V.jsx)(Le, {
            size: 15
          }), `Clear Search`]
        })]
      }), (0, V.jsxs)(`small`, {
        children: [i.length, ` topic`, i.length === 1 ? `` : `s`, ` shown · Administrator-only topics are hidden from Producer users.`]
      })]
    }), (0, V.jsx)(`div`, {
      className: `help-grid`,
      children: i.map(e => (0, V.jsxs)(`article`, {
        className: `help-card`,
        id: `manual-${e.id}`,
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(S, {
            size: 19
          }), (0, V.jsx)(`span`, {
            children: e.audience === `ALL` ? `All Users` : `Administrator Only`
          })]
        }), (0, V.jsx)(`h3`, {
          children: e.title
        }), (0, V.jsx)(`p`, {
          children: e.body
        })]
      }, e.id))
    }), !i.length && (0, V.jsxs)(`div`, {
      className: `empty-state`,
      children: [(0, V.jsx)(Ee, {
        size: 28
      }), (0, V.jsxs)(`h3`, {
        children: [`No manual topics match “`, n, `”`]
      }), (0, V.jsx)(`p`, {
        children: `Try a screen name, field name, action, or common term such as Master Delivery, R&B, QuickBooks, CONE OF SILENCE, or backup.`
      }), (0, V.jsx)(`button`, {
        className: `button secondary`,
        onClick: () => r(``),
        children: `Clear Search`
      })]
    })]
  });
}
var $t = [{
  id: `dashboard`,
  label: `Dashboard`,
  icon: se
}, {
  id: `active`,
  label: `Active Assignments`,
  icon: ie
}, {
  id: `archive`,
  label: `Archive`,
  icon: b
}, {
  id: `clients`,
  label: `Clients`,
  icon: C
}, {
  id: `reports`,
  label: `Reports`,
  icon: E
}, {
  id: `producers`,
  label: `Producers`,
  icon: Fe
}], en = [{
  id: `rumpus-mapping`,label: `Rumpus Mapping`,icon: b,admin: !0
}, {
  id: `settings`,
  label: `Settings`,
  icon: Oe
}, {
  id: `system`,
  label: `System`,
  icon: ke,
  admin: !0
}, {
  id: `manual`,
  label: `Software Manual`,
  icon: S
}], tn = [{
  id: `dts-dashboard`,
  label: `DTS Dashboard`,
  icon: ue,
  admin: !0
}, {
  id: `dts-usage`,
  label: `USAGE / Reconciliation`,
  icon: ue,
  admin: !0
}, {
  id: `dts-history`,
  label: `Reconciliation History`,
  icon: b,
  admin: !0
}, {
  id: `dts-packages`,
  label: `Packages`,
  icon: ie,
  admin: !0
}, {
  id: `dts-opening`,
  label: `Opening Account State`,
  icon: ue,
  admin: !0
}], nn = [{
  id: `dts-package-oneoff`,
  label: `One Off`
}, {
  id: `dts-package-prepaid`,
  label: `Prepaid`
}, {
  id: `dts-package-retainer`,
  label: `Retainer`
}], rn = [...$t, ...en, ...tn], an = {
  dashboard: {
    title: `Dashboard`,
    subtitle: `Active sessions first · comments in the tiles · Needs Attention · Digest`
  },
  active: {
    title: `Active Assignments`,
    subtitle: `Earliest due and overdue production work first.`
  },
  archive: {
    title: `Archive`,
    subtitle: `Permanent delivered, cancelled, and revision history.`
  },
  "rumpus-mapping": {title: `Rumpus Mapping`,subtitle: `Browse the Rumpus share and manage destinations for each station.`},
  clients: {
    title: `Clients`,
    subtitle: `Client / Agency accounts with their Station / Client records.`
  },
  reports: {
    title: `Reports`,
    subtitle: `Production, client, delivery, revision, and point reporting.`
  },
  producers: {
    title: `Producers`,
    subtitle: `People, workload eligibility, colors, and notifications.`
  },
  settings: {
    title: `Settings`,
    subtitle: `Notifications, push access, and your password.`
  },
  system: {
    title: `System`,
    subtitle: `Health, backups, holidays, and release information.`
  },
  manual: {
    title: `Software Manual`,
    subtitle: `Search the working rules and how-to guidance.`
  },
  "dts-dashboard": {
    title: `DTS Dashboard`,
    subtitle: `Administrator-only client point accounting.`
  },
  "dts-usage": {
    title: `USAGE Stats / Reconciliation`,
    subtitle: `Review balances, make decisions, and close the month.`
  },
  "dts-history": {
    title: `Reconciliation History`,
    subtitle: `Permanent month-end decision snapshots by month and year.`
  },
  "dts-packages": {
    title: `Packages`,
    subtitle: `One Off · Prepaid · Retainer`
  },
  "dts-package-oneoff": {
    title: `Packages · One Off`,
    subtitle: `Non-recurring client work and individual projects.`
  },
  "dts-package-prepaid": {
    title: `Packages · Prepaid`,
    subtitle: `One-year prepaid point package tracking.`
  },
  "dts-package-retainer": {
    title: `Packages · Retainer`,
    subtitle: `Recurring monthly client point agreements.`
  },
  "dts-opening": {
    title: `Opening Account State`,
    subtitle: `Migration and go-live starting balances.`
  }
};
function on({onLogin: e, notify: t}) {
  let [n, r] = (0, h.useState)(``), [i, a] = (0, h.useState)(``), [o, s] = (0, h.useState)(!1);
  async function c(r) {
    (r.preventDefault(), s(!0));
    try {
      (await B.post(`/api/auth/login`, {
        email: n,
        password: i
      }), await e());
    } catch (e) {
      t(e instanceof Error ? e.message : `Could not sign in.`, `error`);
    } finally {
      s(!1);
    }
  }
  return (0, V.jsx)(`main`, {
    className: `auth-page`,
    children: (0, V.jsxs)(`section`, {
      className: `auth-card`,
      children: [(0, V.jsxs)(`div`, {
        className: `auth-brand`,
        children: [(0, V.jsx)(`img`, {
          src: Ue(`/dsv-one-wordmark.svg`),
          alt: `Digital Sound & Video`
        }), (0, V.jsxs)(`span`, {
          children: [(0, V.jsx)(`b`, {
            children: `Online Assignment Board`
          }), (0, V.jsx)(`small`, {
            children: `Production workload, delivery, and reporting.`
          })]
        })]
      }), (0, V.jsxs)(`form`, {
        onSubmit: c,
        children: [(0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Email`
          }), (0, V.jsx)(`input`, {
            type: `email`,
            autoComplete: `username`,
            value: n,
            onChange: e => r(e.target.value),
            required: !0,
            autoFocus: !0
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Password`
          }), (0, V.jsx)(`input`, {
            type: `password`,
            autoComplete: `current-password`,
            value: i,
            onChange: e => a(e.target.value),
            required: !0
          })]
        }), (0, V.jsx)(`button`, {
          className: `button primary auth-submit`,
          disabled: o,
          children: o ? `Signing in…` : `Sign In`
        })]
      }), (0, V.jsx)(`p`, {
        className: `auth-note`,
        children: `Internal DSV system · Operational timezone: America/New_York`
      })]
    })
  });
}
function sn({token: e, done: t, notify: n}) {
  let [r, i] = (0, h.useState)(``), [a, o] = (0, h.useState)(``), [s, c] = (0, h.useState)(!1);
  async function l(i) {
    if ((i.preventDefault(), r !== a)) return n(`Passwords do not match.`, `error`);
    c(!0);
    try {
      (await B.post(`/api/auth/reset/complete`, {
        token: e,
        password: r
      }), history.replaceState({}, ``, Ue(`/`)), n(`Password set. You can sign in now.`), t());
    } catch (e) {
      n(e instanceof Error ? e.message : `Could not set password.`, `error`);
    } finally {
      c(!1);
    }
  }
  return (0, V.jsx)(`main`, {
    className: `auth-page`,
    children: (0, V.jsxs)(`section`, {
      className: `auth-card`,
      children: [(0, V.jsxs)(`div`, {
        className: `auth-brand`,
        children: [(0, V.jsx)(`img`, {
          src: Ue(`/dsv-one-wordmark.svg`),
          alt: `Digital Sound & Video`
        }), (0, V.jsxs)(`span`, {
          children: [(0, V.jsx)(`b`, {
            children: `Set OAB Password`
          }), (0, V.jsx)(`small`, {
            children: `This link can be used once.`
          })]
        })]
      }), (0, V.jsxs)(`form`, {
        onSubmit: l,
        children: [(0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `New password (12+ characters)`
          }), (0, V.jsx)(`input`, {
            type: `password`,
            minLength: 12,
            value: r,
            onChange: e => i(e.target.value),
            required: !0,
            autoFocus: !0
          })]
        }), (0, V.jsxs)(`label`, {
          className: `field`,
          children: [(0, V.jsx)(`span`, {
            children: `Confirm password`
          }), (0, V.jsx)(`input`, {
            type: `password`,
            minLength: 12,
            value: a,
            onChange: e => o(e.target.value),
            required: !0
          })]
        }), (0, V.jsx)(`button`, {
          className: `button primary auth-submit`,
          disabled: s,
          children: s ? `Saving…` : `Set Password`
        })]
      })]
    })
  });
}
function cn() {
  let [e, t] = (0, h.useState)(null), [n, r] = (0, h.useState)(!0), [i, a] = (0, h.useState)(!0), [o, s] = (0, h.useState)(`dashboard`), [c, l] = (0, h.useState)(!1), [u, d] = (0, h.useState)(!1), [f, p] = (0, h.useState)(null), [m, g] = (0, h.useState)([]), [_, v] = (0, h.useState)(``), [y, b] = (0, h.useState)(null), x = new URLSearchParams(window.location.search).get(`token`), S = (0, h.useCallback)((e, t = `good`) => b({
    message: e,
    tone: t
  }), []), C = (0, h.useCallback)(async (e = {}) => {
    e.silent || r(!0);
    try {
      let e = await B.get(`/api/bootstrap`);
      (t(e), a(!0));
    } catch (e) {
      e instanceof We && e.status === 401 ? (a(!1), t(null)) : S(e instanceof Error ? e.message : `OAB could not load.`, `error`);
    } finally {
      e.silent || r(!1);
    }
  }, [S]);
  (0, h.useEffect)(() => {
    x ? r(!1) : C();
  }, [C, x]);
  let w = !!e;
  (0, h.useEffect)(() => {
    if (!i || !w || x) return;
    let e = () => {
      document.visibilityState === `visible` && C({
        silent: !0
      });
    }, t = window.setInterval(e, 3e4);
    return (document.addEventListener(`visibilitychange`, e), () => {
      (window.clearInterval(t), document.removeEventListener(`visibilitychange`, e));
    });
  }, [i, w, x, C]);
  let T = (0, h.useCallback)(async e => {
    try {
      await B.post(`/api/assignments/${e}/acknowledge`).catch(() => void 0);
      let t = await B.get(`/api/assignments/${e}`);
      p(t.assignment);
      let n = await B.post(`/api/assignments/${e}/presence`).catch(() => ({
        editors: []
      }));
      (g(n.editors || []), history.replaceState({}, ``, Ue(`/?assignment=${e}`)));
    } catch (e) {
      S(e instanceof Error ? e.message : `Could not open assignment.`, `error`);
    }
  }, [S]);
  (0, h.useEffect)(() => {
    if (!e || f) return;
    let t = new URLSearchParams(window.location.search).get(`assignment`);
    t && T(t);
  }, [e, f, T]);
  function E() {
    (f && B.delete(`/api/assignments/${f.id}/presence`).catch(() => void 0), g([]), p(null), history.replaceState({}, ``, Ue(`/`)));
  }
  useCommentDeepLink(e?.user, O, S);
  async function D() {
    (await B.post(`/api/auth/logout`), t(null), a(!1), E());
  }
  async function O(e) {
    let t = await B.get(`/api/assignments/${e}`);
    p(t.assignment);
  }
  async function k(e, t) {
    try {
      (await B.post(`/api/assignments/${e}/comments/${t}/acknowledge`), S(`Important Comment acknowledged.`), await C({
        silent: !0
      }));
    } catch (e) {
      S(e instanceof Error ? e.message : `Could not acknowledge the Important Comment.`, `error`);
    }
  }
  async function ee(e,t,important=false,requestId) {
    try {
      (await B.post(`/api/assignments/${e}/comments`, {
        body:t, important, requestId
      }), S(`Comment posted.`), await C({
        silent: !0
      }));
    } catch (e) {
      throw (S(e instanceof Error ? e.message : `Could not post the Comment.`, `error`), e);
    }
  }
  if (((0, h.useEffect)(() => {
    if (!f) return;
    let e = !1, t = async () => {
      if (document.visibilityState === `visible`) try {
        let t = await B.post(`/api/assignments/${f.id}/presence`);
        e || g(t.editors || []);
      } catch {}
    };
    t();
    let n = window.setInterval(t, 3e4);
    return () => {
      (e = !0, window.clearInterval(n), B.delete(`/api/assignments/${f.id}/presence`).catch(() => void 0));
    };
  }, [f?.id]), (0, h.useEffect)(() => {
    let e = e => {
      let t = e.detail;
      (v(t?.query || ``), s(`manual`), l(!1));
    };
    window.addEventListener(`oab-open-manual`, e);
    let t = new URLSearchParams(window.location.search).get(`manual`);
    return (t && (v(t), s(`manual`)), () => window.removeEventListener(`oab-open-manual`, e));
  }, []), x)) return (0, V.jsxs)(V.Fragment, {
    children: [(0, V.jsx)(sn, {
      token: x,
      done: () => window.location.reload(),
      notify: S
    }), y && (0, V.jsx)(_t, {
      ...y,
      onClose: () => b(null)
    })]
  });
  if (n && !e) return (0, V.jsx)(pt, {});
  if (!i || !e) return (0, V.jsxs)(V.Fragment, {
    children: [(0, V.jsx)(on, {
      onLogin: C,
      notify: S
    }), y && (0, V.jsx)(_t, {
      ...y,
      onClose: () => b(null)
    })]
  });
  let te = rn.filter(t => !t.admin || e.user.role === `ADMIN`), ne = an[o], A = (e, t = !1) => {
    let n = e.icon, r = o === e.id || e.id === `dts-packages` && o.startsWith(`dts-package-`);
    return (0, V.jsxs)(`button`, {
      className: r ? `active` : ``,
      onClick: () => {
        (s(e.id), t && l(!1));
      },
      children: [(0, V.jsx)(n, {
        size: 17
      }), (0, V.jsx)(`span`, {
        children: e.label
      })]
    }, e.id);
  };
  return (0, V.jsxs)(`div`, {
    className: `app-shell redesigned-shell`,
    children: [(0, V.jsxs)(`aside`, {
      className: `desktop-sidebar`,
      children: [(0, V.jsx)(`div`, {
        className: `sidebar-brand`,
        children: (0, V.jsx)(`img`, {
          src: Ue(`/dsv-one-wordmark.svg`),
          alt: `Digital Sound & Video`
        })
      }), (0, V.jsx)(`div`, {
        className: `sidebar-product`,
        children: `Version 1.3.9.1`
      }), (0, V.jsxs)(`div`, {
        className: `sidebar-scroll`,
        children: [(0, V.jsx)(`p`, {
          className: `nav-group-label`,
          children: `Online Assignment Board`
        }), (0, V.jsx)(`nav`, {
          className: `sidebar-nav`,
          children: [...$t, ...en.filter(t => t.id !== `settings` && (!t.admin || e.user.role === `ADMIN`))].map(e => A(e))
        }), (0, V.jsxs)(`section`, {
          className: `quick-create`,
          children: [(0, V.jsx)(`b`, {
            children: `Quick Create`
          }), (0, V.jsx)(`p`, {
            children: `Create and assign production work.`
          }), (0, V.jsxs)(`button`, {
            className: `button primary`,
            onClick: () => d(!0),
            children: [(0, V.jsx)(xe, {
              size: 16
            }), `New Assignment`]
          })]
        }), h.createElement(QuickDeliveryBox), e.user.role === `ADMIN` && (0, V.jsxs)(V.Fragment, {
          children: [(0, V.jsxs)(`p`, {
            className: `nav-group-label dts-label`,
            children: [`Digital Traffic System `, (0, V.jsx)(`span`, {
              children: `ADMIN ONLY`
            })]
          }), (0, V.jsx)(`nav`, {
            className: `sidebar-nav dts-nav`,
            children: tn.map(e => (0, V.jsxs)(h.Fragment, {
              children: [A(e), e.id === `dts-packages` && (0, V.jsx)(`div`, {
                className: `package-sidebar-subnav`,
                children: nn.map(e => (0, V.jsxs)(`button`, {
                  className: o === e.id ? `active` : ``,
                  onClick: () => s(e.id),
                  children: [(0, V.jsx)(`i`, {}), ` `, (0, V.jsx)(`span`, {
                    children: e.label
                  })]
                }, e.id))
              })]
            }, e.id))
          })]
        })]
      })]
    }), (0, V.jsxs)(`div`, {
      className: `workspace-shell`,
      children: [(0, V.jsxs)(`header`, {
        className: `workspace-topbar`,
        children: [(0, V.jsx)(`button`, {
          className: `mobile-menu-button`,
          onClick: () => l(!0),
          children: (0, V.jsx)(he, {
            size: 21
          })
        }), (0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`h1`, {
            children: ne.title
          }), (0, V.jsx)(`p`, {
            children: ne.subtitle
          })]
        }), (0, V.jsxs)(`div`, {
          className: `topbar-user-group`,
          children: [(0, V.jsxs)(`button`, {
            className: `topbar-user`,
            onClick: () => s(`settings`),
            title: `Open settings`,
            children: [(0, V.jsx)(`span`, {
              children: e.user.name.split(/\s+/).map(e => e[0]).join(``).slice(0, 2).toUpperCase()
            }), (0, V.jsxs)(`div`, {
              children: [(0, V.jsx)(`b`, {
                children: e.user.name
              }), (0, V.jsxs)(`small`, {
                children: [e.user.role === `ADMIN` ? `Administrator` : `Producer`, ` · America/New_York`]
              })]
            })]
          }), (0, V.jsx)(`button`, {
            className: `icon-button topbar-logout`,
            onClick: D,
            title: `Sign out`,
            children: (0, V.jsx)(pe, {
              size: 17
            })
          })]
        })]
      }), (0, V.jsxs)(`main`, {
        className: `main-content`,
        children: [o === `dashboard` && (0, V.jsx)(kt, {
          dashboard: e.dashboard,
          sessions: e.activeAssignments,
          role: e.user.role,
          currentProducerId: e.user.producerId,
          onOpen: T,
          onAcknowledgeComment: k,
          onAddComment: ee,
          notify: S
        }), o === `active` && (0, V.jsx)(At, {
          assignments: e.activeAssignments,
          producers: e.producers,
          currentProducerId: e.user.producerId,
          onOpen: T,
          onAcknowledgeComment: k,
          onAddComment: ee
        }), o === `archive` && (0, V.jsx)(At, {
          archive: !0,
          assignments: e.archiveAssignments,
          producers: e.producers,
          currentProducerId: e.user.producerId,
          onOpen: T,
          onRestore: T,
          onAcknowledgeComment: k,
          onAddComment: ee
        }), o === `clients` && (0, V.jsx)(zt, {
          clients: e.clients,
          role: e.user.role,
          refresh: C,
          notify: S
        }), o === `reports` && (0, V.jsx)(Nt, {
          notify: S
        }), o.startsWith(`dts-`) && e.user.role === `ADMIN` && (0, V.jsx)(Xt, {
          notify: S,
          clients: e.clients,
          section: o.slice(4),
          onNavigate: e => s(`dts-${e}`)
        }), o === `producers` && (0, V.jsx)(jt, {
          producers: e.producers,
          role: e.user.role,
          refresh: C,
          notify: S
        }), o === `settings` && (0, V.jsx)(Pt, {
          settings: e.settings,
          vapidPublicKey: e.vapidPublicKey,
          role: e.user.role,
          refresh: C,
          notify: S
        }), o === `rumpus-mapping` && e.user.role === `ADMIN` && (0,V.jsx)(RumpusMapping,{}), o === `system` && e.user.role === `ADMIN` && (0, V.jsx)(Ft, {
          settings: e.settings,
          notify: S
        }), o === `manual` && (0, V.jsx)(Qt, {
          role: e.user.role,
          initialQuery: _
        })]
      })]
    }), (0, V.jsx)(`nav`, {
      className: `mobile-bottom-nav`,
      children: te.filter(e => [`dashboard`, `active`, `archive`, `reports`, `producers`].includes(e.id)).map(e => {
        let t = e.icon;
        return (0, V.jsxs)(`button`, {
          className: o === e.id ? `active` : ``,
          onClick: () => s(e.id),
          children: [(0, V.jsx)(t, {
            size: 19
          }), (0, V.jsx)(`span`, {
            children: e.label.split(` `)[0]
          })]
        }, e.id);
      })
    }), c && (0, V.jsx)(`div`, {
      className: `mobile-drawer-backdrop`,
      onClick: () => l(!1),
      children: (0, V.jsxs)(`nav`, {
        className: `mobile-drawer`,
        onClick: e => e.stopPropagation(),
        children: [(0, V.jsxs)(`div`, {
          children: [(0, V.jsx)(`b`, {
            children: `OAB Navigation`
          }), (0, V.jsx)(`button`, {
            className: `icon-button`,
            onClick: () => l(!1),
            children: (0, V.jsx)(Le, {
              size: 19
            })
          })]
        }), (0, V.jsx)(`p`, {
          className: `nav-group-label`,
          children: `Online Assignment Board`
        }), $t.map(e => A(e, !0)), h.createElement("section",{className:"quick-create"},h.createElement("b",null,"Quick Create"),h.createElement("button",{className:"button primary",onClick:()=>{d(true);l(false)}},"New Assignment")),h.createElement(QuickDeliveryBox), e.user.role === `ADMIN` && (0, V.jsxs)(V.Fragment, {
          children: [(0, V.jsx)(`p`, {
            className: `nav-group-label dts-label`,
            children: `Digital Traffic System`
          }), tn.map(e => (0, V.jsxs)(h.Fragment, {
            children: [A(e, !0), e.id === `dts-packages` && (0, V.jsx)(`div`, {
              className: `package-sidebar-subnav mobile-package-subnav`,
              children: nn.map(e => (0, V.jsxs)(`button`, {
                className: o === e.id ? `active` : ``,
                onClick: () => {
                  (s(e.id), l(!1));
                },
                children: [(0, V.jsx)(`i`, {}), ` `, (0, V.jsx)(`span`, {
                  children: e.label
                })]
              }, e.id))
            })]
          }, e.id))]
        }), (0, V.jsx)(`p`, {
          className: `nav-group-label`,
          children: `Support & System`
        }), en.filter(t => !t.admin || e.user.role === `ADMIN`).map(e => A(e, !0))]
      })
    }), (0, V.jsx)(`button`, {
      className: `mobile-fab`,
      onClick: () => d(!0),
      children: (0, V.jsx)(xe, {
        size: 24
      })
    }), (0, V.jsx)(Dt, {
      open: u,
      onClose: () => d(!1),
      producers: e.producers,
      clients: e.clients,
      holidays: e.holidays,
      notify: S,
      onCreated: async e => {
        (await C(), await T(e));
      }
    }), (0, V.jsx)(bt, {
      assignment: f,
      editingPresence: m,
      user: e.user,
      producers: e.producers,
      onClose: E,
      onRefresh: O,
      onChanged: C,
      onOpenNew: T,
      notify: S
    }), y && (0, V.jsx)(_t, {
      ...y,
      onClose: () => b(null)
    })]
  });
}
((0, ze.createRoot)(document.getElementById(`root`)).render((0, V.jsx)(h.StrictMode, {
  children: (0, V.jsx)(cn, {})
})), (`serviceWorker` in navigator) && window.addEventListener(`load`, () => navigator.serviceWorker.register(Ue(`/sw.js`)).catch(console.error)));

export {h,B,ft,Ue};
